[
  {
    "id": "freshtrak-1",
    "name": "Lutheran Social Services Choice Pantry - Franklin",
    "latitude": 39.9349941,
    "longitude": -82.9709149,
    "address": "1460 S CHAMPION AVENUE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3",
    "name": "Lutheran Social Services Choice Pantry - Noble",
    "latitude": 39.74678237,
    "longitude": -81.51515905,
    "address": "49014 Outpost Rd",
    "city": "CALDWELL",
    "state": "OH",
    "zip_code": "43724",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4",
    "name": "LSS Fairfield County Food Pantry",
    "latitude": 39.71601077,
    "longitude": -82.55344969,
    "address": "2045 E MAIN ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5",
    "name": "Lutheran Social Services ChoicePantry - SE Ohio Mobile",
    "latitude": 39.7156962,
    "longitude": -82.5535849,
    "address": "2045 E MAIN ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-6",
    "name": "Mid-Ohio Market at Gantz Rd",
    "latitude": 39.8802158,
    "longitude": -83.0565945,
    "address": "4041 Gantz Rd",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-7",
    "name": "Grove City Food Pantry and Emergency Services",
    "latitude": 39.88141144,
    "longitude": -83.07530178,
    "address": "2710 COLUMBUS ST",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-8",
    "name": "Gladden Pantry",
    "latitude": 39.95210397,
    "longitude": -83.02903567,
    "address": "318 S GLENWOOD AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-10",
    "name": "Southside Community Ministries",
    "latitude": 39.93738789,
    "longitude": -82.98953659,
    "address": "225 E GATES ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-11",
    "name": "Brice UMC Food Pantry",
    "latitude": 39.913745,
    "longitude": -82.83250762,
    "address": "3160 Brice Road",
    "city": "BRICE",
    "state": "OH",
    "zip_code": "43109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-12",
    "name": "Greater Cleveland Food Bank",
    "latitude": 41.5669006,
    "longitude": -81.5724759,
    "address": "13815 Coit Road",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-14",
    "name": "May Dugan Center",
    "latitude": 41.4811443,
    "longitude": -81.7145796,
    "address": "4115 BRIDGE AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-18",
    "name": "Pickerington Food Pantry",
    "latitude": 39.88586833,
    "longitude": -82.75580366,
    "address": "70 CROSS ST",
    "city": "PICKERINGTON",
    "state": "OH",
    "zip_code": "43147",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-19",
    "name": "Community Mission Outreach",
    "latitude": 38.433136,
    "longitude": -82.429378,
    "address": "3748 STATE ROUTE 7",
    "city": "CHESAPEAKE",
    "state": "OH",
    "zip_code": "45619",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-21",
    "name": "Athens County Food Pantry",
    "latitude": 39.3294803,
    "longitude": -82.10001652,
    "address": "9 N COLLEGE ST",
    "city": "ATHENS",
    "state": "OH",
    "zip_code": "45701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-47",
    "name": "Bellville Neighborhood Outreach Center ",
    "latitude": 40.6216509,
    "longitude": -82.5115063,
    "address": "84 MAIN ST",
    "city": "BELLVILLE",
    "state": "OH",
    "zip_code": "44813",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-48",
    "name": "The Community for Better Living",
    "latitude": 41.3871965,
    "longitude": -81.9039816,
    "address": "7074 COLUMBIA RD",
    "city": "OLMSTED TWP",
    "state": "OH",
    "zip_code": "44138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-49",
    "name": "Smith Chapel Food and Clothing Mission",
    "latitude": 39.5338815,
    "longitude": -82.3871118,
    "address": "1333 E FRONT ST",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-50",
    "name": "Torch - Feed my Sheep Food Pantry",
    "latitude": 39.23902048,
    "longitude": -81.74394745,
    "address": "29023 TORCH RD",
    "city": "COOLVILLE",
    "state": "OH",
    "zip_code": "45723",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-51",
    "name": "Bishopville Church of Christ Food Pantry",
    "latitude": 39.5130141,
    "longitude": -82.0476528,
    "address": "6555 S STATE ROUTE 78",
    "city": "GLOUSTER",
    "state": "OH",
    "zip_code": "45732",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-53",
    "name": "Jesus in the Hills, LLC",
    "latitude": 39.12553875,
    "longitude": -82.74857164,
    "address": "44 Savageville Road",
    "city": "JACKSON",
    "state": "OH",
    "zip_code": "45640",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-54",
    "name": "Golden Harvest",
    "latitude": 39.1036671,
    "longitude": -81.748587,
    "address": "64936 STATE ROUTE 124",
    "city": "REEDSVILLE",
    "state": "OH",
    "zip_code": "45772",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-55",
    "name": "The Food Program and Clothesline of Jackson",
    "latitude": 39.0515459,
    "longitude": -82.6361638,
    "address": "323 E. Broadway St.",
    "city": "JACKSON",
    "state": "OH",
    "zip_code": "45640",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-57",
    "name": "Pataskala LEADS",
    "latitude": 39.997481,
    "longitude": -82.7239579,
    "address": "12536 ADAMS LN SW",
    "city": "PATASKALA",
    "state": "OH",
    "zip_code": "43062",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-58",
    "name": "2nd Presbyterian Church - Newark",
    "latitude": 40.05971448,
    "longitude": -82.40191782,
    "address": "42 E CHURCH ST",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-59",
    "name": "Buckeye Lake LEADS",
    "latitude": 39.9329099,
    "longitude": -82.4814454,
    "address": "41 W 1ST ST",
    "city": "BUCKEYE LAKE",
    "state": "OH",
    "zip_code": "43008",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-60",
    "name": "Market Street Pantry",
    "latitude": 40.05625704,
    "longitude": -82.40388154,
    "address": "37 S 4th Street",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-61",
    "name": "Adventist Community Services",
    "latitude": 40.07885354,
    "longitude": -82.26430051,
    "address": "122 E MAIN ST",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-62",
    "name": "The Open Pantry",
    "latitude": 40.06337711,
    "longitude": -82.38806439,
    "address": "310 EVERETT AVE",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-63",
    "name": "Wright Memorial UMC",
    "latitude": 40.07661942,
    "longitude": -82.41541417,
    "address": "735 MOUNT VERNON RD",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-66",
    "name": "Utica LEADS",
    "latitude": 40.22853079,
    "longitude": -82.45139635,
    "address": "308 W Main Street",
    "city": "UTICA",
    "state": "OH",
    "zip_code": "43080",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-68",
    "name": "Morgan County United Ministries Food Pantry",
    "latitude": 39.60292742,
    "longitude": -81.90241931,
    "address": "20 4th Street",
    "city": "MALTA",
    "state": "OH",
    "zip_code": "43758",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-70",
    "name": "St. Francis Center",
    "latitude": 39.2445935,
    "longitude": -82.4849886,
    "address": "404 W SOUTH ST",
    "city": "MC ARTHUR",
    "state": "OH",
    "zip_code": "45651",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-72",
    "name": "New Hope Assembly of God Food Pantry",
    "latitude": 39.69684102,
    "longitude": -82.64212517,
    "address": "2020 CINCINNATI ZANESVILLE RD SW",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-75",
    "name": "Dayspring Community Church Food Pantry",
    "latitude": 39.89181974,
    "longitude": -82.834718,
    "address": "3919 BRICE RD",
    "city": "CANAL WINCHESTER",
    "state": "OH",
    "zip_code": "43110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-77",
    "name": "Laurelville Community Food Pantry Inc.",
    "latitude": 39.4715296,
    "longitude": -82.7371726,
    "address": "16138 PIKE ST",
    "city": "LAURELVILLE",
    "state": "OH",
    "zip_code": "43135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-78",
    "name": "Vinton Baptist Church",
    "latitude": 38.9577748,
    "longitude": -82.2989156,
    "address": "11818 STATE ROUTE 160",
    "city": "VINTON",
    "state": "OH",
    "zip_code": "45686",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-81",
    "name": "Newark Nazarene - Firehouse Food Pantry",
    "latitude": 40.05093139,
    "longitude": -82.42284722,
    "address": "71 MAHOLM ST",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-82",
    "name": "Marne United Methodist Church",
    "latitude": 40.0716915,
    "longitude": -82.2967904,
    "address": "1019 LICKING VALLEY RD",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-84",
    "name": "St. Vincent de Paul Center",
    "latitude": 40.0537589,
    "longitude": -82.4097954,
    "address": "135 WILSON ST",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-85",
    "name": "Jacksontown United Methodist Church",
    "latitude": 39.9578234,
    "longitude": -82.4139482,
    "address": "9350 Jacksontown Road",
    "city": "JACKSONTOWN",
    "state": "OH",
    "zip_code": "43030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-86",
    "name": "Salvation Army (The Emergency Pantry)",
    "latitude": 40.05576023,
    "longitude": -82.41200946,
    "address": "250 E MAIN ST",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-87",
    "name": "Croton Church of Christ",
    "latitude": 40.23825779,
    "longitude": -82.68496221,
    "address": "7 Hartford Avenue",
    "city": "CROTON",
    "state": "OH",
    "zip_code": "43013",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-88",
    "name": "Food Pantry Network of Licking Co.",
    "latitude": 40.04522842,
    "longitude": -82.43857919,
    "address": "1035 Brice Street",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-91",
    "name": "World Global Ministries",
    "latitude": 40.06601743,
    "longitude": -82.4235328,
    "address": "69 KING AVE",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-95",
    "name": "Our Lady of Mt. Carmel",
    "latitude": 41.6106685,
    "longitude": -81.46583665,
    "address": "1730 MOUNT CARMEL DR",
    "city": "WICKLIFFE",
    "state": "OH",
    "zip_code": "44092",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-96",
    "name": "New Matamoras Food Pantry",
    "latitude": 39.5209641,
    "longitude": -81.0680015,
    "address": "1000 Stover Drive",
    "city": "NEW MATAMORAS",
    "state": "OH",
    "zip_code": "45767",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-97",
    "name": "Urban Mission, God's Pantry",
    "latitude": 40.36385092,
    "longitude": -80.6147761,
    "address": "311 N 6TH ST",
    "city": "STEUBENVILLE",
    "state": "OH",
    "zip_code": "43952",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-98",
    "name": "Newport Community Food Pantry",
    "latitude": 39.39143465,
    "longitude": -81.22949824,
    "address": "245 Greene Street",
    "city": "NEWPORT",
    "state": "OH",
    "zip_code": "45768",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-99",
    "name": "The Daily Bread Center",
    "latitude": 40.09548322,
    "longitude": -80.72474514,
    "address": "100 N Zane Hwy",
    "city": "MARTINS FERRY",
    "state": "OH",
    "zip_code": "43935",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-100",
    "name": "Good Samaritan Food Pantry",
    "latitude": 39.9441091,
    "longitude": -83.2676705,
    "address": "36 S CENTER ST",
    "city": "WEST JEFFERSON",
    "state": "OH",
    "zip_code": "43162",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-102",
    "name": "First Church of the Nazarene",
    "latitude": 38.8167546,
    "longitude": -82.18951,
    "address": "1110 1ST AVE",
    "city": "GALLIPOLIS",
    "state": "OH",
    "zip_code": "45631",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-103",
    "name": "WARM Westerville Area Resource Ministry",
    "latitude": 40.12964333,
    "longitude": -82.92627453,
    "address": "150 HEATHERDOWN DR",
    "city": "WESTERVILLE",
    "state": "OH",
    "zip_code": "43081",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-104",
    "name": "Millersport Community Food Pantry",
    "latitude": 39.90037882,
    "longitude": -82.53778996,
    "address": "2315 WEAKLY AVE",
    "city": "MILLERSPORT",
    "state": "OH",
    "zip_code": "43046",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-105",
    "name": "3-C Food Pantry",
    "latitude": 39.404374,
    "longitude": -81.770012,
    "address": "4554 Two Mile Road",
    "city": "CUTLER",
    "state": "OH",
    "zip_code": "45724",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-106",
    "name": "St John's Food Pantry",
    "latitude": 39.95200858,
    "longitude": -82.97122201,
    "address": "640 S OHIO AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-107",
    "name": "Our Lady of Guadalupe Center",
    "latitude": 39.96319896,
    "longitude": -83.08958348,
    "address": "3631 Soldano Blvd",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-109",
    "name": "SE Ohio Foodbank",
    "latitude": 39.5356914,
    "longitude": -82.3929233,
    "address": "1005 C I C DR",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-110",
    "name": "The Foodbank",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 ARMOR PL",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-114",
    "name": "BOGG Ministries Montgomery",
    "latitude": 39.6177986,
    "longitude": -84.2091039,
    "address": "9095 WASHINGTON CHURCH RD",
    "city": "MIAMISBURG",
    "state": "OH",
    "zip_code": "45342",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-115",
    "name": "Canal Winchester Human Services",
    "latitude": 39.85154897,
    "longitude": -82.81668127,
    "address": "80 Covenant Way",
    "city": "CANAL WINCHESTER",
    "state": "OH",
    "zip_code": "43110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-117",
    "name": "Fairborn FISH",
    "latitude": 39.7908525,
    "longitude": -84.0387708,
    "address": "480 W Funderburg Rd",
    "city": "FAIRBORN",
    "state": "OH",
    "zip_code": "45324",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-120",
    "name": "Delaware City Vineyard",
    "latitude": 40.2861106,
    "longitude": -83.0680595,
    "address": "32 Troy Rd",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-121",
    "name": "Community Corner Hunger Center",
    "latitude": 41.48119563,
    "longitude": -81.74157682,
    "address": "8302 DETROIT AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-125",
    "name": "Vineyard Community Church ",
    "latitude": 41.6069892,
    "longitude": -81.46213,
    "address": "1928 E 300TH ST",
    "city": "WICKLIFFE",
    "state": "OH",
    "zip_code": "44092",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-126",
    "name": "Brookside Family Center",
    "latitude": 41.4519583,
    "longitude": -81.7017997,
    "address": "3784 PEARL RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-127",
    "name": "Mt. Sinai Baptist Church ",
    "latitude": 41.4877702,
    "longitude": -81.6358808,
    "address": "7510 WOODLAND AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-128",
    "name": "Abundance Food Pantry",
    "latitude": 41.5195639,
    "longitude": -81.5693868,
    "address": "3031 MONTICELLO BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-130",
    "name": "Prince of Peace",
    "latitude": 41.4546559,
    "longitude": -81.7216759,
    "address": "4800 DENISON AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-132",
    "name": "Harvest For The Hungry",
    "latitude": 38.5366657,
    "longitude": -82.68345184,
    "address": "101 N 5TH ST",
    "city": "IRONTON",
    "state": "OH",
    "zip_code": "45638",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-142",
    "name": "Bridge of Hope Community Center",
    "latitude": 41.4519084,
    "longitude": -81.5646512,
    "address": "3949 LEE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-143",
    "name": "First Lutheran Community Food Pantry",
    "latitude": 40.88311306,
    "longitude": -82.65638233,
    "address": "33 BROADWAY ST",
    "city": "SHELBY",
    "state": "OH",
    "zip_code": "44875",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-145",
    "name": "West Ohio Food Bank",
    "latitude": 40.7304288,
    "longitude": -84.0806806,
    "address": "1380 E KIBBY ST",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-146",
    "name": "Emergency Clearing House",
    "latitude": 39.59274311,
    "longitude": -82.93983721,
    "address": "722 Clinton St",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-149",
    "name": "The Church C.O.G.I.C.",
    "latitude": 41.4783937,
    "longitude": -81.6349305,
    "address": "7541 KINSMAN RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-151",
    "name": "First Church of God",
    "latitude": 39.91695974,
    "longitude": -82.9046222,
    "address": "3480 REFUGEE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-152",
    "name": "Nelsonville Food Cupboard",
    "latitude": 39.45647581,
    "longitude": -82.22707196,
    "address": "Mary Hill Center 1950 Mount Saint Marys Drive",
    "city": "NELSONVILLE",
    "state": "OH",
    "zip_code": "45764",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-153",
    "name": "Our Savior Lutheran Church Pantry",
    "latitude": 41.5018424,
    "longitude": -81.4396067,
    "address": "2154 SOM CENTER RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44124",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-154",
    "name": "Lakewood Community Outreach",
    "latitude": 41.4847068,
    "longitude": -81.822295,
    "address": "1375 W CLIFTON BLVD",
    "city": "LAKEWOOD",
    "state": "OH",
    "zip_code": "44107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-158",
    "name": "Northwest Dayton SVDP FP",
    "latitude": 39.81354945,
    "longitude": -84.26959189,
    "address": "4825 SALEM AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45416",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-159",
    "name": "SCAN Hunger Center Pantry",
    "latitude": 41.3730097,
    "longitude": -81.8678781,
    "address": "398 W BAGLEY RD",
    "city": "BEREA",
    "state": "OH",
    "zip_code": "44017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-161",
    "name": "Shepherd of the Valley",
    "latitude": 39.5445666,
    "longitude": -82.4250863,
    "address": "297 RIFF AVE",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-163",
    "name": "Mount Zion Fellowship Church Food Pantry",
    "latitude": 41.4444542,
    "longitude": -81.5275496,
    "address": "4265 NORTHFIELD RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-165",
    "name": "Camden FISH",
    "latitude": 39.6272309,
    "longitude": -84.6498911,
    "address": "100 S LAFAYETTE ST",
    "city": "CAMDEN",
    "state": "OH",
    "zip_code": "45311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-166",
    "name": "Emmanuel Lutheran Church",
    "latitude": 39.6710652,
    "longitude": -84.1136916,
    "address": "4865 WILMINGTON PIKE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45440",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-170",
    "name": "Miamisburg Helping Hand ",
    "latitude": 39.64220251,
    "longitude": -84.28610606,
    "address": "224 W. Maple Street",
    "city": "MIAMISBURG",
    "state": "OH",
    "zip_code": "45342",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-173",
    "name": "University Settlement",
    "latitude": 41.4730712,
    "longitude": -81.6581499,
    "address": "4800 BROADWAY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-174",
    "name": "Ann George Food Pantry",
    "latitude": 41.3887259,
    "longitude": -81.7621485,
    "address": "6285 PEARL RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-175",
    "name": "Willow Praise Church",
    "latitude": 41.6426602,
    "longitude": -81.4538905,
    "address": "32901 VINE ST",
    "city": "WILLOWICK",
    "state": "OH",
    "zip_code": "44095",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-176",
    "name": "Salvation Army - Ashland",
    "latitude": 40.8646259,
    "longitude": -82.3219685,
    "address": "527 E LIBERTY ST",
    "city": "ASHLAND",
    "state": "OH",
    "zip_code": "44805",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-178",
    "name": "St. Martin de Porres Family Center",
    "latitude": 41.5239618,
    "longitude": -81.6013979,
    "address": "1264 E 123RD ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-180",
    "name": "Euclid Hunger Center",
    "latitude": 41.6070832,
    "longitude": -81.5259756,
    "address": "291 E 222ND ST",
    "city": "EUCLID",
    "state": "OH",
    "zip_code": "44123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-181",
    "name": "Mentor Church of Christ",
    "latitude": 41.6745705,
    "longitude": -81.3303253,
    "address": "7201 BURRIDGE AVE",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-182",
    "name": "St. John Baptist Church",
    "latitude": 41.7198429,
    "longitude": -81.2543528,
    "address": "361 W JACKSON ST",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-183",
    "name": "St. Noel Food Pantry",
    "latitude": 41.5881899,
    "longitude": -81.4344908,
    "address": "35200 CHARDON RD",
    "city": "WILLOUGHBY HILLS",
    "state": "OH",
    "zip_code": "44094",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-184",
    "name": "Manna House Recovery Resource & Referral Center",
    "latitude": 41.5001825,
    "longitude": -81.6317886,
    "address": "8019 CEDAR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-186",
    "name": "St. Patrick's Hunger Center",
    "latitude": 41.4830505,
    "longitude": -81.71132056,
    "address": "3610 BRIDGE AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-187",
    "name": "Thea Bowman Center",
    "latitude": 41.4627424,
    "longitude": -81.5997704,
    "address": "11901 OAKFIELD AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-189",
    "name": "Northeast Churches",
    "latitude": 39.7750601,
    "longitude": -84.1762037,
    "address": "359 MARYLAND AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45404",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-191",
    "name": "St. Mary's SVDP Food Pantry",
    "latitude": 39.7533795,
    "longitude": -84.1681228,
    "address": "310 ALLEN ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45410",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-192",
    "name": "Friendship Missionary Baptist Church",
    "latitude": 39.95623724,
    "longitude": -83.04941501,
    "address": "1775 W BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-194",
    "name": "Greenmont-Oak Park Neighbor to Neighbor Food Pantry",
    "latitude": 39.720179,
    "longitude": -84.124779,
    "address": "1921 WOODMAN DR",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-195",
    "name": "Feeding Friends",
    "latitude": 39.6656024,
    "longitude": -84.1255301,
    "address": "5737 BIGGER RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45440",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-198",
    "name": "Woodville Grace Brethren Church",
    "latitude": 40.7421307,
    "longitude": -82.5039025,
    "address": "580 WOODVILLE RD",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44907",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-200",
    "name": "Columbus Christian Center Food Pantry",
    "latitude": 40.01917774,
    "longitude": -82.9287181,
    "address": "2300 N CASSADY AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-201",
    "name": "Garfield Human Development",
    "latitude": 41.4291482,
    "longitude": -81.620021,
    "address": "9403 GARFIELD BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-202",
    "name": "LSS Delaware",
    "latitude": 40.2897075,
    "longitude": -83.0713261,
    "address": "300 Chelsea St",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-203",
    "name": "St. Mary/St. Mark Pantry",
    "latitude": 39.71239377,
    "longitude": -82.63162193,
    "address": "331 GAY ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-205",
    "name": "St. Vincent Depaul Food Pantry",
    "latitude": 40.7305958,
    "longitude": -84.10512305,
    "address": "928 S Main Street",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-206",
    "name": "Ottawa Food Pantry",
    "latitude": 41.0196302,
    "longitude": -84.0374338,
    "address": "137 N PRATT ST",
    "city": "OTTAWA",
    "state": "OH",
    "zip_code": "45875",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-207",
    "name": "Salvation Army Food Pantry Lima",
    "latitude": 40.7399518,
    "longitude": -84.0973658,
    "address": "614 E MARKET ST",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-208",
    "name": "Agape Ministries Food Pantry",
    "latitude": 40.5463757,
    "longitude": -84.3703354,
    "address": "1220 E SPRING ST",
    "city": "SAINT MARYS",
    "state": "OH",
    "zip_code": "45885",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-209",
    "name": "Van Wert CO-OP Food Pantry",
    "latitude": 40.8687102,
    "longitude": -84.5836663,
    "address": "113 W CENTRAL AVE",
    "city": "VAN WERT",
    "state": "OH",
    "zip_code": "45891",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-211",
    "name": "Brookside Church Pantry",
    "latitude": 39.3756243,
    "longitude": -83.0240759,
    "address": "2215 EGYPT PIKE",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-212",
    "name": "In Faith Ministries Food Pantry",
    "latitude": 40.7416173,
    "longitude": -84.080925,
    "address": "1575 E HIGH ST",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-214",
    "name": "Greene County Food Pantry",
    "latitude": 39.6665975,
    "longitude": -83.94308155,
    "address": "774 Cincinnati Ave",
    "city": "XENIA",
    "state": "OH",
    "zip_code": "45385",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-217",
    "name": "Community Action Mission Program",
    "latitude": 39.68049531,
    "longitude": -84.42511736,
    "address": "115 E WALNUT ST",
    "city": "FARMERSVILLE",
    "state": "OH",
    "zip_code": "45325",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-218",
    "name": "Evangel Church of God - Compass",
    "latitude": 39.7690559,
    "longitude": -84.137032,
    "address": "132 N SMITHVILLE RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45403",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-219",
    "name": "The Hearth @ East Dayton Christian Church",
    "latitude": 39.7480199,
    "longitude": -84.1340744,
    "address": "3415 LINDEN AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45410",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-220",
    "name": "Lewisburg Food Pantry - Lewisburg Area Outreach",
    "latitude": 39.850632,
    "longitude": -84.5384814,
    "address": "106 West Dayton Street",
    "city": "LEWISBURG",
    "state": "OH",
    "zip_code": "45338",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-223",
    "name": "Heart To Heart Pantry",
    "latitude": 39.98287731,
    "longitude": -83.05805473,
    "address": "1320 CAMBRIDGE BLVD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-224",
    "name": "Good Samaritan Food Network",
    "latitude": 39.3344704,
    "longitude": -83.0042998,
    "address": "255 North Woodbridge Avenue",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-226",
    "name": "Pantry Plus of Seneca County",
    "latitude": 41.1569901,
    "longitude": -83.414242,
    "address": "115 S MAIN ST",
    "city": "FOSTORIA",
    "state": "OH",
    "zip_code": "44830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-227",
    "name": "Circle Of Friends Food Pantry",
    "latitude": 41.10073987,
    "longitude": -84.26595596,
    "address": "300 N. Main St",
    "city": "CONTINENTAL",
    "state": "OH",
    "zip_code": "45831",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-228",
    "name": "Tri-County Food Pantry",
    "latitude": 39.56123466,
    "longitude": -81.3971455,
    "address": "101 Main Street",
    "city": "LOWER SALEM",
    "state": "OH",
    "zip_code": "45745",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-230",
    "name": "Catholic Charities of Toledo - Mansfield",
    "latitude": 40.7582638,
    "longitude": -82.4933217,
    "address": "523 PARK AVE E",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-231",
    "name": "Mt. Carmel Missionary Baptist Church",
    "latitude": 39.7311583,
    "longitude": -84.2794674,
    "address": "5370 DAYTON LIBERTY RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-235",
    "name": "A.C.E. Ministry",
    "latitude": 41.4382883,
    "longitude": -81.5564125,
    "address": "4411 E 175TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-236",
    "name": "Liberty Life Church",
    "latitude": 39.6804668,
    "longitude": -83.9796819,
    "address": "1180 UPPER BELLBROOK RD",
    "city": "XENIA",
    "state": "OH",
    "zip_code": "45385",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-238",
    "name": "Lancaster Fairfield CAA",
    "latitude": 39.71572989,
    "longitude": -82.56288162,
    "address": "1743 E MAIN ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-239",
    "name": "Victory Center Lancaster Pantry",
    "latitude": 39.7214559,
    "longitude": -82.6174809,
    "address": "625 Garfield Ave",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-240",
    "name": "TFI Traditional Mobiles-Montgomery",
    "latitude": 39.7528545,
    "longitude": -84.1978538,
    "address": "427 WASHINGTON ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-241",
    "name": "TFI Traditional Mobiles-Greene",
    "latitude": 39.67827374,
    "longitude": -83.92172739,
    "address": "427 WASHINGTON ST",
    "city": "Xenia",
    "state": "OH",
    "zip_code": "45385",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-244",
    "name": "Huber Heights FISH Food Pantry",
    "latitude": 39.8529472,
    "longitude": -84.1308925,
    "address": "5950 LONGFORD RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45424",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-245",
    "name": "ACTS Community Center",
    "latitude": 40.4119505,
    "longitude": -82.4701023,
    "address": "474 WOOSTER RD",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-246",
    "name": "WEBA Outreach Food Pantry",
    "latitude": 40.4752257,
    "longitude": -80.92349899,
    "address": "348 N MAIN ST ",
    "city": "AMSTERDAM",
    "state": "OH",
    "zip_code": "43903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-247",
    "name": "Vineyard Church Delaware County Pantry",
    "latitude": 40.25307858,
    "longitude": -82.87544153,
    "address": "1001 W CHERRY ST",
    "city": "SUNBURY",
    "state": "OH",
    "zip_code": "43074",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-248",
    "name": "Akron-Canton Regional Foodbank",
    "latitude": 41.07220273,
    "longitude": -81.53614953,
    "address": "350 OPPORTUNITY PKWY",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-250",
    "name": "Wesley Community Center, Inc.",
    "latitude": 39.7577351,
    "longitude": -84.2498313,
    "address": "3730 DELPHOS AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-251",
    "name": "Green Giving / Together Jamestown",
    "latitude": 39.6579472,
    "longitude": -83.7334282,
    "address": "260 S. Charleston Rd",
    "city": "JAMESTOWN",
    "state": "OH",
    "zip_code": "45335",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-252",
    "name": "AFL-CIO Labor Food Pantry",
    "latitude": 39.8446464,
    "longitude": -84.187919,
    "address": "6550 POE AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45414",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-254",
    "name": "Shepherd's Hands ",
    "latitude": 39.830717,
    "longitude": -84.4282442,
    "address": "665 WESTBROOK RD",
    "city": "BROOKVILLE",
    "state": "OH",
    "zip_code": "45309",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-255",
    "name": "Middlefield United Methodist Food Pantry",
    "latitude": 41.46011628,
    "longitude": -81.07246622,
    "address": "14999 S STATE AVE",
    "city": "MIDDLEFIELD",
    "state": "OH",
    "zip_code": "44062",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-260",
    "name": "Mid-Ohio Food Collective - Admin",
    "latitude": 39.8820028,
    "longitude": -83.0500477,
    "address": "3960 BROOKHAM DR",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-264",
    "name": "St. Paul UMC",
    "latitude": 39.7613114,
    "longitude": -84.1672098,
    "address": "101 HUFFMAN AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45403",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-268",
    "name": "Cardington Food Pantry",
    "latitude": 40.49662633,
    "longitude": -82.89395097,
    "address": "128 Flint St",
    "city": "CARDINGTON",
    "state": "OH",
    "zip_code": "43315",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-270",
    "name": "United AME Church",
    "latitude": 39.6878498,
    "longitude": -83.924307,
    "address": "286 E CHURCH ST",
    "city": "XENIA",
    "state": "OH",
    "zip_code": "45385",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-272",
    "name": "Wayman AME Church",
    "latitude": 39.76159775,
    "longitude": -84.24392784,
    "address": "3317 HOOVER AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-274",
    "name": "FISH Southeast",
    "latitude": 39.6430641,
    "longitude": -84.1587342,
    "address": "7001 FAR HILLS AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45459",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-276",
    "name": "St. John's UCC",
    "latitude": 39.6245557,
    "longitude": -84.3734489,
    "address": "201 W MARKET ST",
    "city": "GERMANTOWN",
    "state": "OH",
    "zip_code": "45327",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-280",
    "name": "Daybreak, Inc.- Off Site Pantry",
    "latitude": 39.7505088,
    "longitude": -84.1902293,
    "address": "157 Medford St",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45410",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-281",
    "name": "Zion Baptist Church",
    "latitude": 39.7751634,
    "longitude": -84.2341241,
    "address": "1684 EARLHAM DR",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-283",
    "name": "People's Community Church",
    "latitude": 41.3828663,
    "longitude": -81.8580514,
    "address": "628 WESLEY DR",
    "city": "BEREA",
    "state": "OH",
    "zip_code": "44017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-284",
    "name": "Eagle Ministries Chapel, Inc.",
    "latitude": 41.01615429,
    "longitude": -81.55440607,
    "address": "830 Rood Dr",
    "city": "Coventry Township",
    "state": "OH",
    "zip_code": "44319",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-285",
    "name": "Lake Township FISH",
    "latitude": 40.96822058,
    "longitude": -81.3484623,
    "address": "13155 Market Ave N",
    "city": "Hartville",
    "state": "OH",
    "zip_code": "44632",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-286",
    "name": "St. Vitus",
    "latitude": 41.52228148,
    "longitude": -81.64934505,
    "address": "6019 LAUSCHE AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-287",
    "name": "All Peoples Fresh Market",
    "latitude": 39.94429553,
    "longitude": -82.98286338,
    "address": "945 PARSONS AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-290",
    "name": "God's House of Prayer",
    "latitude": 41.4869608,
    "longitude": -81.61607358,
    "address": "2654 WOODHILL RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-292",
    "name": "Start Right Community Development Corporation",
    "latitude": 41.5333305,
    "longitude": -81.56222184,
    "address": "977 CALEDONIA AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-293",
    "name": "North Olmsted Oxcart Pantry",
    "latitude": 41.409299,
    "longitude": -81.9133256,
    "address": "26272 BUTTERNUT RIDGE RD",
    "city": "NORTH OLMSTED",
    "state": "OH",
    "zip_code": "44070",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-295",
    "name": "Calvary CME Church",
    "latitude": 41.7312391,
    "longitude": -81.2556424,
    "address": "556 LAWNVIEW AVE",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-299",
    "name": "Attica Food Pantry",
    "latitude": 41.06711012,
    "longitude": -82.88900149,
    "address": "25 Venice",
    "city": "ATTICA",
    "state": "OH",
    "zip_code": "44807",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-302",
    "name": "Pilgrim Congregational Church",
    "latitude": 41.4770774,
    "longitude": -81.6919114,
    "address": "2592 W 14TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-303",
    "name": "Journey's End Ministries",
    "latitude": 40.273091,
    "longitude": -81.6086527,
    "address": "205 S River St",
    "city": "Newcomerstown",
    "state": "OH",
    "zip_code": "43832",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-304",
    "name": "Blessed Trinity Parish Food Pantry",
    "latitude": 41.10211232,
    "longitude": -81.50434639,
    "address": "300 E Tallmadge Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-309",
    "name": "Word of Life Outreach Center",
    "latitude": 40.99530672,
    "longitude": -81.45719762,
    "address": "1878 Killian Rd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44312",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-310",
    "name": "Middlebury Assembly",
    "latitude": 41.07012587,
    "longitude": -81.49099411,
    "address": "82 S Arlington St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-311",
    "name": "St. John's United Church of Christ - Glenmont Food Pantry",
    "latitude": 40.51999832,
    "longitude": -82.09896587,
    "address": "108 Main St",
    "city": "Glenmont",
    "state": "OH",
    "zip_code": "44628",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-314",
    "name": "Lancaster Vineyard Food Pantry",
    "latitude": 39.7153153,
    "longitude": -82.6106588,
    "address": "423 W WHEELING ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-316",
    "name": "C.U.P. Food Pantry",
    "latitude": 40.7390282,
    "longitude": -84.1092161,
    "address": "129 S PIERCE ST",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-317",
    "name": "SVDP de Paul Center",
    "latitude": 39.7595265,
    "longitude": -84.1884202,
    "address": "15 S SAINT CLAIR ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-320",
    "name": "Helping Hands Network",
    "latitude": 40.66700458,
    "longitude": -81.25711108,
    "address": "126 S Main St",
    "city": "Waynesburg",
    "state": "OH",
    "zip_code": "44688",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-321",
    "name": "The Salvation Army (Orrville)",
    "latitude": 40.8437261,
    "longitude": -81.7685731,
    "address": "401 W High St",
    "city": "Orrville",
    "state": "OH",
    "zip_code": "44667",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-322",
    "name": "Yorkville Methodist Church",
    "latitude": 40.15892506,
    "longitude": -80.70466433,
    "address": "121 3RD ST",
    "city": "YORKVILLE",
    "state": "OH",
    "zip_code": "43971",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-324",
    "name": "York United Methodist Church",
    "latitude": 41.16715545,
    "longitude": -81.92394405,
    "address": "6566 Norwalk Rd",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-325",
    "name": "Fayette County Food Pantry",
    "latitude": 39.53605468,
    "longitude": -83.44217978,
    "address": "214 N HINDE ST",
    "city": "WASHINGTON COURT HOUSE",
    "state": "OH",
    "zip_code": "43160",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-326",
    "name": "Mt. Vernon AME Food Pantry",
    "latitude": 39.97235569,
    "longitude": -82.97156875,
    "address": "1147 MOUNT VERNON AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-329",
    "name": "St. Boniface Church",
    "latitude": 41.45729432,
    "longitude": -81.72471286,
    "address": "3545 w.54th St",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-333",
    "name": "Leipsic Food Pantry",
    "latitude": 41.0999693,
    "longitude": -83.9867319,
    "address": "7 W MAIN ST",
    "city": "LEIPSIC",
    "state": "OH",
    "zip_code": "45856",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-334",
    "name": "Faithcare Food Pantry",
    "latitude": 40.15286494,
    "longitude": -82.68400127,
    "address": "25 S MAIN ST",
    "city": "JOHNSTOWN",
    "state": "OH",
    "zip_code": "43031",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-335",
    "name": "Love Center Food Pantry",
    "latitude": 40.5671444,
    "longitude": -81.9031856,
    "address": "1291 Massillon Rd",
    "city": "Millersburg",
    "state": "OH",
    "zip_code": "44654",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-336",
    "name": "Roseville Community Food Pantry",
    "latitude": 39.80701512,
    "longitude": -82.07249948,
    "address": "146 N MAIN ST",
    "city": "ROSEVILLE",
    "state": "OH",
    "zip_code": "43777",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-337",
    "name": "Prince of Peace Church",
    "latitude": 41.67602666,
    "longitude": -81.37735994,
    "address": "7193 REYNOLDS RD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-340",
    "name": "Salvation Army Tiffin",
    "latitude": 41.11936649,
    "longitude": -83.16484682,
    "address": "505 E MARKET ST",
    "city": "TIFFIN",
    "state": "OH",
    "zip_code": "44883",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-342",
    "name": "Caring & Sharing Food Pantry",
    "latitude": 41.1365864,
    "longitude": -84.5793951,
    "address": "119 S MAIN ST",
    "city": "PAULDING",
    "state": "OH",
    "zip_code": "45879",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-344",
    "name": "Athens Catholic Community Food Pantry",
    "latitude": 39.32868305,
    "longitude": -82.09436067,
    "address": "75 STEWART ST",
    "city": "ATHENS",
    "state": "OH",
    "zip_code": "45701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-345",
    "name": "Agape Distribution ",
    "latitude": 40.2837715,
    "longitude": -84.1491035,
    "address": "209 BROOKLYN AVE",
    "city": "SIDNEY",
    "state": "OH",
    "zip_code": "45365",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-346",
    "name": "G.O. Community Development Corporation",
    "latitude": 41.872055,
    "longitude": -80.7902503,
    "address": "3703 STATION AVE",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-348",
    "name": "Mt. Sterling Community Food Pantry",
    "latitude": 39.72206629,
    "longitude": -83.26295982,
    "address": "164 E MAIN ST",
    "city": "MOUNT STERLING",
    "state": "OH",
    "zip_code": "43143",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-349",
    "name": "Karla's Kupboard -Trinity Friends Food Pantry",
    "latitude": 40.8763675,
    "longitude": -84.5719394,
    "address": "605 N FRANKLIN ST",
    "city": "VAN WERT",
    "state": "OH",
    "zip_code": "45891",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-351",
    "name": "St. Paul Lutheran Church",
    "latitude": 41.096464,
    "longitude": -81.73563224,
    "address": "6462 Ridge Rd",
    "city": "Sharon Center",
    "state": "OH",
    "zip_code": "44281",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-352",
    "name": "St. Paul Holiness Church of God",
    "latitude": 41.06348575,
    "longitude": -81.52018703,
    "address": "734 GRANT ST",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-353",
    "name": "St. Bernard Food Pantry (St. Bernard Parish)",
    "latitude": 41.07870375,
    "longitude": -81.51835458,
    "address": "44 University Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44308",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-355",
    "name": "Broad Street Presbyterian Pantry",
    "latitude": 39.96564,
    "longitude": -82.97989,
    "address": "760 E BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-356",
    "name": "Sarah's House Inc",
    "latitude": 41.07721873,
    "longitude": -81.52934226,
    "address": "414 Pine St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-357",
    "name": "Brunswick Food Pantry Inc.",
    "latitude": 41.2524781,
    "longitude": -81.8404583,
    "address": "835 Pearl Rd.",
    "city": "Brunswick",
    "state": "OH",
    "zip_code": "44212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-358",
    "name": "Paint Valley Ministries Pantry",
    "latitude": 39.22710442,
    "longitude": -83.26816239,
    "address": "204 E 2ND ST",
    "city": "BAINBRIDGE",
    "state": "OH",
    "zip_code": "45612",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-359",
    "name": "Shadyside Fellowship Pantry",
    "latitude": 39.97188927,
    "longitude": -80.74599822,
    "address": "3838 LINCOLN AVE",
    "city": "SHADYSIDE",
    "state": "OH",
    "zip_code": "43947",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-360",
    "name": "Belpre Church of Christ",
    "latitude": 39.2798018,
    "longitude": -81.6241239,
    "address": "2932 WASHINGTON BLVD",
    "city": "BELPRE",
    "state": "OH",
    "zip_code": "45714",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-362",
    "name": "SVDP Southwest Ozanam Food Pantry",
    "latitude": 41.43799644,
    "longitude": -81.69919692,
    "address": "2145 BROADVIEW RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-363",
    "name": "Southeast Seventh Day Adventist",
    "latitude": 41.4313703,
    "longitude": -81.56400285,
    "address": "16602 Tarkington Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-364",
    "name": "Lee Seville Miles Hunger Center",
    "latitude": 41.4392658,
    "longitude": -81.5630944,
    "address": "16718 MILES AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-365",
    "name": "St. Andrew Episcopal Church",
    "latitude": 41.6530765,
    "longitude": -81.3273965,
    "address": "7989 LITTLE MOUNTAIN RD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-366",
    "name": "Benevolent Love Ministry",
    "latitude": 41.44523504,
    "longitude": -81.60872133,
    "address": "10917 MILES AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-367",
    "name": "Akron Bible Church/Hope Cafe",
    "latitude": 41.06153403,
    "longitude": -81.51511653,
    "address": "340 E South St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-368",
    "name": "Heart 4 the City",
    "latitude": 41.08816279,
    "longitude": -81.46363725,
    "address": "954 Eastland Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-370",
    "name": "TFI Traditional Mobiles-Preble",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 ARMOR PL",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-374",
    "name": "Lockwood United Methodist Church",
    "latitude": 41.00010556,
    "longitude": -81.55723146,
    "address": "3680 Manchester Rd",
    "city": "Coventry Township",
    "state": "OH",
    "zip_code": "44319",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-375",
    "name": "The Sanctuary",
    "latitude": 41.05615159,
    "longitude": -81.55695488,
    "address": "847 Lakewood Blvd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44314",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-376",
    "name": "The Lord's Pantry at Trinity Lutheran Church",
    "latitude": 41.148199,
    "longitude": -81.3584514,
    "address": "600 S Water St",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-380",
    "name": "Greater Dover New Philadelphia Food Pantry",
    "latitude": 40.5182772,
    "longitude": -81.4801698,
    "address": "422 W 3rd St",
    "city": "Dover",
    "state": "OH",
    "zip_code": "44622",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-383",
    "name": "Country Neighbor",
    "latitude": 41.5340686,
    "longitude": -80.8677043,
    "address": "39 S MAPLE ST",
    "city": "ORWELL",
    "state": "OH",
    "zip_code": "44076",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-384",
    "name": "Messiah Lend-A-Hand",
    "latitude": 41.8686059,
    "longitude": -80.7871973,
    "address": "615 W PROSPECT RD",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-385",
    "name": "Lighthouse Harvest Foundation",
    "latitude": 41.8822342,
    "longitude": -80.7722907,
    "address": "2710 STATE RD",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-386",
    "name": "The Vine - Eagleville Bible Church",
    "latitude": 41.6972822,
    "longitude": -80.8540649,
    "address": "1981 STATE ROUTE 45  N",
    "city": "ROCK CREEK",
    "state": "OH",
    "zip_code": "44084",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-388",
    "name": "Madison Food Center",
    "latitude": 41.8209458,
    "longitude": -81.0487392,
    "address": "1954 HUBBARD RD",
    "city": "MADISON",
    "state": "OH",
    "zip_code": "44057",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-389",
    "name": "Vineyard Church - Parma Heights",
    "latitude": 41.3808957,
    "longitude": -81.7592754,
    "address": "6735 YORK RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-391",
    "name": "Temple Baptist Church",
    "latitude": 41.54156938,
    "longitude": -81.56646748,
    "address": "1862 NOBLE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-395",
    "name": "Manna Project",
    "latitude": 41.7363615,
    "longitude": -80.765245,
    "address": "89 E SATIN ST",
    "city": "JEFFERSON",
    "state": "OH",
    "zip_code": "44047",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-396",
    "name": "Maple Heights Pantry",
    "latitude": 41.408016,
    "longitude": -81.560412,
    "address": "17100 BROADWAY AVE",
    "city": "MAPLE HEIGHTS",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-398",
    "name": "St. Timothy Missionary Baptist Church",
    "latitude": 41.5020173,
    "longitude": -81.639302,
    "address": "7101 CARNEGIE AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-399",
    "name": "St. Gabriel",
    "latitude": 41.6781301,
    "longitude": -81.283272,
    "address": "9925 JOHNNYCAKE RIDGE RD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-402",
    "name": "St. John Vianney / St. Vincent de Paul",
    "latitude": 41.6876936,
    "longitude": -81.3690023,
    "address": "7575 BELLFLOWER RD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-403",
    "name": "St. Bede's",
    "latitude": 41.7205549,
    "longitude": -81.3123853,
    "address": "9114 LAKE SHORE BLVD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-404",
    "name": "Living Water Food Pantry",
    "latitude": 39.96972394,
    "longitude": -81.29461663,
    "address": "287 Fair Street",
    "city": "QUAKER CITY",
    "state": "OH",
    "zip_code": "43773",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-406",
    "name": "Faith Lutheran Church Food Pantry",
    "latitude": 41.8966561,
    "longitude": -80.8046427,
    "address": "504 LAKE AVE",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-407",
    "name": "The Fathers House International Pantry",
    "latitude": 39.871558,
    "longitude": -82.78033673,
    "address": "9670 SCHOOLHOUSE RD",
    "city": "CANAL WINCHESTER",
    "state": "OH",
    "zip_code": "43110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-409",
    "name": "Conneaut Human Resource Center",
    "latitude": 41.9450645,
    "longitude": -80.5604232,
    "address": "327 MILL ST",
    "city": "CONNEAUT",
    "state": "OH",
    "zip_code": "44030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-411",
    "name": "Christian Cupboard/Center of Hope",
    "latitude": 41.1584564,
    "longitude": -81.2603656,
    "address": "1081 W Main St",
    "city": "Ravenna",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-412",
    "name": "Nelson Garrettsville Community Cupboard",
    "latitude": 41.2822959,
    "longitude": -81.0975379,
    "address": "8233 Park Ave",
    "city": "Garrettsville",
    "state": "OH",
    "zip_code": "44231",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-413",
    "name": "Alliance Community Pantry",
    "latitude": 40.9208249,
    "longitude": -81.1022568,
    "address": "215 E Market St",
    "city": "Alliance",
    "state": "OH",
    "zip_code": "44601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-416",
    "name": "City of Cleveland Dept of Health--MCCAFFERTY",
    "latitude": 41.540344,
    "longitude": -81.6070642,
    "address": "4242 Lorain Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-417",
    "name": "Lewisville Community Center Food Pantry",
    "latitude": 39.76408194,
    "longitude": -81.2173979,
    "address": "33261 Back Street",
    "city": "LEWISVILLE",
    "state": "OH",
    "zip_code": "43754",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-418",
    "name": "Storehouse for Jesus Pataskala Nazarene Church",
    "latitude": 39.9747445,
    "longitude": -82.6825199,
    "address": "8100 HAZELTON ETNA RD SW",
    "city": "PATASKALA",
    "state": "OH",
    "zip_code": "43062",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-419",
    "name": "Westland Ecumenical Community Food Pantry",
    "latitude": 39.93555666,
    "longitude": -83.1583819,
    "address": "775 GALLOWAY RD",
    "city": "GALLOWAY",
    "state": "OH",
    "zip_code": "43119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-420",
    "name": "United Presbyterian Church Food Pantry",
    "latitude": 41.14910266,
    "longitude": -81.47328406,
    "address": "2819 Hudson Dr",
    "city": "Cuyahoga Falls",
    "state": "OH",
    "zip_code": "44221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-421",
    "name": "TOSM",
    "latitude": 40.7874468,
    "longitude": -81.5109124,
    "address": "1600 Main Ave. W",
    "city": "MASSILLON",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-423",
    "name": "Minerva Community Outreach",
    "latitude": 40.7274557,
    "longitude": -81.0951008,
    "address": "515 E Line St",
    "city": "Minerva",
    "state": "OH",
    "zip_code": "44657",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-426",
    "name": "C.O.B. Outreach",
    "latitude": 41.044124,
    "longitude": -81.55088758,
    "address": "754 Kenmore Blvd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44314",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-428",
    "name": "The Emergency Assistance Center",
    "latitude": 41.3164823,
    "longitude": -81.5382337,
    "address": "9433 Olde Eight Rd",
    "city": "Northfield",
    "state": "OH",
    "zip_code": "44067",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-429",
    "name": "Lafayette United Methodist Church",
    "latitude": 41.10486957,
    "longitude": -81.93158182,
    "address": "6201 Lafayette Rd",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-430",
    "name": "JoAnn's Pantry",
    "latitude": 41.07084299,
    "longitude": -81.47283943,
    "address": "1424 SPRAGUE ST",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-431",
    "name": "Harvest Food Pantry",
    "latitude": 41.1430389,
    "longitude": -81.5083553,
    "address": "2543 State Rd",
    "city": "Cuyahoga Falls",
    "state": "OH",
    "zip_code": "44223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-432",
    "name": "Mid-Ohio Market at HEART",
    "latitude": 39.9530805,
    "longitude": -82.8242702,
    "address": "6475 E MAIN ST",
    "city": "REYNOLDSBURG",
    "state": "OH",
    "zip_code": "43068",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-434",
    "name": "St. Vincent de Paul (Logan)",
    "latitude": 39.5407043,
    "longitude": -82.4039056,
    "address": "321 E. HUNTER ST",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-435",
    "name": "Greek Orthodox Church of Annunciation",
    "latitude": 41.07926437,
    "longitude": -81.50883172,
    "address": "129 S Union St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44304",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-436",
    "name": "Kent Social Services",
    "latitude": 41.1438677,
    "longitude": -81.3585074,
    "address": "1066 S Water St",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-437",
    "name": "Community Bible Church",
    "latitude": 41.0996673,
    "longitude": -81.2598468,
    "address": "3671 Tallmadge Rd",
    "city": "Rootstown",
    "state": "OH",
    "zip_code": "44272",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-438",
    "name": "The Salvation Army (Alliance)",
    "latitude": 40.9218752,
    "longitude": -81.1070826,
    "address": "57 W Main St",
    "city": "Alliance",
    "state": "OH",
    "zip_code": "44601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-440",
    "name": "People to People Ministries",
    "latitude": 40.8050097,
    "longitude": -81.9350331,
    "address": "454 E Bowman St",
    "city": "Wooster",
    "state": "OH",
    "zip_code": "44691",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-441",
    "name": "Akron Christian Reformed Church",
    "latitude": 41.09602878,
    "longitude": -81.53859306,
    "address": "50 Marshall Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44303",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-442",
    "name": "Feeding Hope Food Pantry",
    "latitude": 41.08134156,
    "longitude": -81.50867789,
    "address": "292 E Market St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44308",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-444",
    "name": "Stark County Hunger Task Force",
    "latitude": 40.79230377,
    "longitude": -81.38024667,
    "address": "408 9th St SW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44707",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-446",
    "name": "Heritage Memorial Food Pantry",
    "latitude": 39.54493967,
    "longitude": -83.44388593,
    "address": "412 ROSE AVE",
    "city": "WASHINGTON COURT HOUSE",
    "state": "OH",
    "zip_code": "43160",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-447",
    "name": "Sardis Manna",
    "latitude": 39.62266755,
    "longitude": -80.910236,
    "address": "37240 5TH AVE",
    "city": "SARDIS",
    "state": "OH",
    "zip_code": "43946",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-449",
    "name": "H.E.L.P. House",
    "latitude": 39.88468243,
    "longitude": -83.44066987,
    "address": "122 E CENTER ST",
    "city": "LONDON",
    "state": "OH",
    "zip_code": "43140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-451",
    "name": "River of Life Assembly of God",
    "latitude": 40.974794,
    "longitude": -81.49678748,
    "address": "133 5th St SE",
    "city": "Barberton",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-452",
    "name": "Marysville Food Pantry",
    "latitude": 40.2335101,
    "longitude": -83.37155069,
    "address": "333 ASH ST",
    "city": "MARYSVILLE",
    "state": "OH",
    "zip_code": "43040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-454",
    "name": "Minerva Methodist Church",
    "latitude": 40.7293843,
    "longitude": -81.1046978,
    "address": "204 N Main St",
    "city": "Minerva",
    "state": "OH",
    "zip_code": "44657",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-455",
    "name": "Minerva Methodist Church Direct Distribution",
    "latitude": 40.7293843,
    "longitude": -81.1046978,
    "address": "204 N Main St",
    "city": "Minerva",
    "state": "OH",
    "zip_code": "44657",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-456",
    "name": "Cuyahoga Falls Good Neighbors",
    "latitude": 41.13776233,
    "longitude": -81.48541537,
    "address": "1742 2nd St",
    "city": "Cuyahoga Falls",
    "state": "OH",
    "zip_code": "44221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-458",
    "name": "He Brought Us Out Ministry",
    "latitude": 41.09988766,
    "longitude": -81.51551204,
    "address": "526 N Howard St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-459",
    "name": "Open M Direct Distribution",
    "latitude": 41.0611434,
    "longitude": -81.5340395,
    "address": "941 Princeton St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-460",
    "name": "Open M ",
    "latitude": 41.0611434,
    "longitude": -81.5340395,
    "address": "941 Princeton St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-461",
    "name": "The Harvard Square Center",
    "latitude": 41.4489712,
    "longitude": -81.5877976,
    "address": "13510 HARVARD AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-462",
    "name": "Bridgeport Council of Churches Pantry",
    "latitude": 40.07086398,
    "longitude": -80.75457464,
    "address": "630 Main St",
    "city": "BRIDGEPORT",
    "state": "OH",
    "zip_code": "43912",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-464",
    "name": "St. Clairsville Food Pantry",
    "latitude": 40.07939777,
    "longitude": -80.90273753,
    "address": "102 ST Patrick",
    "city": "SAINT CLAIRSVILLE",
    "state": "OH",
    "zip_code": "43950",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-466",
    "name": "Bread of Life Choice Pantry (New Salem Baptist)",
    "latitude": 40.0277774,
    "longitude": -82.9619821,
    "address": "1880 Agler Road",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-468",
    "name": "Bountiful Basement",
    "latitude": 41.4354846,
    "longitude": -81.7913704,
    "address": "4370 W 140TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-469",
    "name": "Livingston Avenue UMC Food Pantry",
    "latitude": 39.95273262,
    "longitude": -82.99313415,
    "address": "200 E LIVINGSTON AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-473",
    "name": "McKinley Food Pantry",
    "latitude": 41.6932183,
    "longitude": -81.399704,
    "address": "1200 LOST NATION RD",
    "city": "WILLOUGHBY",
    "state": "OH",
    "zip_code": "44094",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-475",
    "name": "The Second Harvest Food Bank of Clark, Champaign, and Logan Counties",
    "latitude": 39.9250823,
    "longitude": -83.7997572,
    "address": "20 North Murray Street",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-477",
    "name": "Toledo Northwestern Ohio Food Bank",
    "latitude": 41.6599362,
    "longitude": -83.5442542,
    "address": "24 E WOODRUFF AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43604",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-478",
    "name": "Second Harvest Food Bank of NCO- LORAIN CO",
    "latitude": 41.42431876,
    "longitude": -82.28100103,
    "address": "5510 BAUMHART RD",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44053",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-479",
    "name": "Victory Ministries Pantry",
    "latitude": 39.99551561,
    "longitude": -82.92829614,
    "address": "3964 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-481",
    "name": "St. Vincent depaul Society- Lancaster",
    "latitude": 39.70957779,
    "longitude": -82.59529603,
    "address": "424 E LOCUST ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-482",
    "name": "Trinity Evangelical Lutheran Church",
    "latitude": 41.4822206,
    "longitude": -81.7066068,
    "address": "2031 W 30TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-483",
    "name": "Scio Community Food Pantry   ",
    "latitude": 40.39942866,
    "longitude": -81.08984417,
    "address": "117 MAPLE AVENUE    ",
    "city": "SCIO",
    "state": "OH",
    "zip_code": "43988",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-484",
    "name": "Grace Pantry",
    "latitude": 40.0261231,
    "longitude": -81.584546,
    "address": "1101 STEUBENVILLE AVE",
    "city": "CAMBRIDGE",
    "state": "OH",
    "zip_code": "43725",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-490",
    "name": "St. Michael the Archangel - St. Procop Pantry",
    "latitude": 41.4697335,
    "longitude": -81.6975069,
    "address": "3114 SCRANTON RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-491",
    "name": "St. Paul's Community Outreach",
    "latitude": 41.4849883,
    "longitude": -81.71744,
    "address": "4427 FRANKLIN BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-492",
    "name": "Putnam County Community Thrift Pantry",
    "latitude": 41.0190751,
    "longitude": -84.0478413,
    "address": "101 W MAIN ST",
    "city": "OTTAWA",
    "state": "OH",
    "zip_code": "45875",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-493",
    "name": "Smithfield Friends Pantry",
    "latitude": 40.26851856,
    "longitude": -80.78303164,
    "address": "1599 Main St",
    "city": "SMITHFIELD",
    "state": "OH",
    "zip_code": "43948",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-494",
    "name": "Harcatus Pantry",
    "latitude": 40.27110213,
    "longitude": -80.99777939,
    "address": "122 S Main St",
    "city": "CADIZ",
    "state": "OH",
    "zip_code": "43907",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-496",
    "name": "Second Harvest Foodbank of the Mahoning Valley",
    "latitude": 41.1286691,
    "longitude": -80.706146,
    "address": "2805 SALT SPRINGS RD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44509",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-497",
    "name": "Fellowship Christian Church",
    "latitude": 39.9497104,
    "longitude": -83.848522,
    "address": "2301 VALLEY LOOP RD",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45504",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-498",
    "name": "St John's Lutheran Church Pantry",
    "latitude": 39.9258101,
    "longitude": -83.8143487,
    "address": "27 N WITTENBERG AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45502",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-499",
    "name": "Cadiz Food Pantry",
    "latitude": 40.26382165,
    "longitude": -80.98027903,
    "address": "730 Peppard Ave",
    "city": "CADIZ",
    "state": "OH",
    "zip_code": "43907",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-502",
    "name": "Salvation Army East Main Choice FP ",
    "latitude": 39.95800777,
    "longitude": -82.97354855,
    "address": "966 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-505",
    "name": "Salvation Army Hilltop Pantry",
    "latitude": 39.93951283,
    "longitude": -83.05929646,
    "address": "2300 W MOUND ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-506",
    "name": "Central College Church Pantry  ",
    "latitude": 40.10187988,
    "longitude": -82.8886526,
    "address": "975 S SUNBURY RD",
    "city": "WESTERVILLE",
    "state": "OH",
    "zip_code": "43081",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-508",
    "name": "CRC Clintonville/Beechwold",
    "latitude": 40.02754977,
    "longitude": -83.01511704,
    "address": "14 W LAKEVIEW AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43202",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-515",
    "name": "NNEMAP       ",
    "latitude": 39.99388104,
    "longitude": -82.98828972,
    "address": "677 E 11TH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-516",
    "name": "Epworth UMC",
    "latitude": 40.07185337,
    "longitude": -82.97637046,
    "address": "5100 KARL RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-517",
    "name": "Creekside Christian Pantry",
    "latitude": 40.07119532,
    "longitude": -82.92865065,
    "address": "4938 WESTERVILLE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43231",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-518",
    "name": "Garden City Church Pantry",
    "latitude": 39.92966881,
    "longitude": -83.09992248,
    "address": "3880 CLIME RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-521",
    "name": "Salvation Army Southside Pantry ",
    "latitude": 39.94565081,
    "longitude": -82.98275989,
    "address": "888 PARSONS AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-523",
    "name": "National Youth Advocate Food Pantry ",
    "latitude": 39.95765458,
    "longitude": -82.96463992,
    "address": "1303 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-526",
    "name": "St JAMES THE LESS FOOD PANTRY",
    "latitude": 40.03162033,
    "longitude": -82.96894095,
    "address": "1652 OAKLAND PARK AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-528",
    "name": "St. Philip Lutheran Church Pantry    ",
    "latitude": 39.96888833,
    "longitude": -82.96109987,
    "address": "1506 E LONG ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-529",
    "name": "St. Philip's Episcopal Food Pantry",
    "latitude": 39.97095639,
    "longitude": -82.95713225,
    "address": "166 WOODLAND AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-530",
    "name": "St. Matthew Catholic Church   ",
    "latitude": 40.01754862,
    "longitude": -82.8526724,
    "address": "807 HAVENS CORNERS RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-531",
    "name": "Helping Hands Food Pantry-Christian Assembly",
    "latitude": 40.0514212,
    "longitude": -82.9783817,
    "address": "4099 KARL RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-532",
    "name": "Hilliard Food Pantry Plus",
    "latitude": 40.0349632,
    "longitude": -83.15930665,
    "address": "3691 Main Street",
    "city": "HILLIARD",
    "state": "OH",
    "zip_code": "43026",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-533",
    "name": "St. Thomas Catholic Pantry",
    "latitude": 39.98519749,
    "longitude": -82.93171064,
    "address": "2692 E 5TH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-541",
    "name": "New Birth Christian Ministries Pantry      ",
    "latitude": 39.91676837,
    "longitude": -82.904415,
    "address": "3475 REFUGEE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-543",
    "name": "Total Life Ministries Food Pantry   ",
    "latitude": 39.98588451,
    "longitude": -82.94405866,
    "address": "2260 E 5TH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-545",
    "name": "Northside Food Pantry/Vineyard Church",
    "latitude": 40.0646857,
    "longitude": -82.95251079,
    "address": "6000 Cooper Road",
    "city": "Westerville",
    "state": "OH",
    "zip_code": "43081",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-549",
    "name": "Dublin Food Pantry  ",
    "latitude": 40.09925045,
    "longitude": -83.11541705,
    "address": "6608 Dublin Center Drive",
    "city": "DUBLIN",
    "state": "OH",
    "zip_code": "43017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-556",
    "name": "Huron Helping Hands Food Pantry",
    "latitude": 41.39045706,
    "longitude": -82.55934159,
    "address": "607 Main St",
    "city": "HURON",
    "state": "OH",
    "zip_code": "44839",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-557",
    "name": "Lower Lights Community Church Food Pantry   ",
    "latitude": 39.95134983,
    "longitude": -83.02748826,
    "address": "1066 BELLOWS AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-560",
    "name": "Imani Church ( Euclid )",
    "latitude": 41.5897901,
    "longitude": -81.5021104,
    "address": "1505 E 260TH ST",
    "city": "EUCLID",
    "state": "OH",
    "zip_code": "44132",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-564",
    "name": "Madison County Food Pantry      ",
    "latitude": 39.886754,
    "longitude": -83.4383547,
    "address": "125 S. Oak Street",
    "city": "LONDON",
    "state": "OH",
    "zip_code": "43140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-568",
    "name": "Zion Lutheran Church",
    "latitude": 41.7176248,
    "longitude": -81.2543913,
    "address": "508 MENTOR AVE",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-571",
    "name": "St. Mary of Egypt Orthodox",
    "latitude": 41.4361483,
    "longitude": -81.7066768,
    "address": "4345 STATE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-572",
    "name": "Audrey's Outreach",
    "latitude": 41.3952778,
    "longitude": -81.8164632,
    "address": "16845 HOLLAND RD",
    "city": "BROOKPARK",
    "state": "OH",
    "zip_code": "44142",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-574",
    "name": "City of Solon and Solon Rotary Club",
    "latitude": 41.4100479,
    "longitude": -81.4523085,
    "address": "32001 CANNON RD",
    "city": "SOLON",
    "state": "OH",
    "zip_code": "44139",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-576",
    "name": "St. Paul's Lutheran Church - Prospect ",
    "latitude": 40.45060165,
    "longitude": -83.18825216,
    "address": "200 E. WATER STREET",
    "city": "PROSPECT",
    "state": "OH",
    "zip_code": "43342",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-577",
    "name": "Eastside Community Ministry Food Pantry",
    "latitude": 39.9360363,
    "longitude": -82.0013535,
    "address": "221 STILLWELL ST",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-579",
    "name": "Salvation Army Delaware",
    "latitude": 40.30790042,
    "longitude": -83.05628937,
    "address": "89 Cheshire St.",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-580",
    "name": "SVDP-Supportive Housing",
    "latitude": 39.7595265,
    "longitude": -84.1884202,
    "address": "15 S SAINT CLAIR ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-581",
    "name": "We Care We Share",
    "latitude": 41.4444714,
    "longitude": -82.14135183,
    "address": "1888 E.31st",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-582",
    "name": "Bellevue Fish and Loaves",
    "latitude": 41.2782901,
    "longitude": -82.8487854,
    "address": "203 Maple St.",
    "city": "BELLEVUE",
    "state": "OH",
    "zip_code": "44811",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-583",
    "name": "ST AUGUSTINE & GABRIEL/ST.VINCENT DEPAUL",
    "latitude": 40.01379892,
    "longitude": -82.9684542,
    "address": "1550 E HUDSON ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-585",
    "name": "Gallatin County Food Pantry",
    "latitude": 38.78113036,
    "longitude": -84.90339467,
    "address": "205 W PEARL ST",
    "city": "WARSAW",
    "state": "KY",
    "zip_code": "41095",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-586",
    "name": "FCC Owen County Food Pantry",
    "latitude": 38.53640327,
    "longitude": -84.83603792,
    "address": "113 Main Street",
    "city": "OWENTON",
    "state": "KY",
    "zip_code": "40359",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-589",
    "name": "Free Pentecostal Holiness Church Pantry      ",
    "latitude": 40.311603,
    "longitude": -82.047764,
    "address": "24136 TOWNSHIP ROAD 113",
    "city": "WARSAW",
    "state": "OH",
    "zip_code": "43844",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-590",
    "name": "First Christian Church - Canton",
    "latitude": 40.8823258,
    "longitude": -81.3634159,
    "address": "6900 Market Ave N",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44721",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-591",
    "name": "Sagrada Familia Church",
    "latitude": 41.4817013,
    "longitude": -81.7381434,
    "address": "7719 DETROIT AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-594",
    "name": "New Zion Gospel Church",
    "latitude": 41.4840454,
    "longitude": -81.624093,
    "address": "2747 E 90TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-596",
    "name": "Saint John Paul Ozanam Center",
    "latitude": 41.449626,
    "longitude": -81.6291981,
    "address": "8328 BROADWAY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-597",
    "name": "Circleville Church of Christ  ",
    "latitude": 39.6295446,
    "longitude": -82.94384502,
    "address": "1555 N COURT ST",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-603",
    "name": "Heights Emergency Food Center",
    "latitude": 41.5210739,
    "longitude": -81.549106,
    "address": "3663 MAYFIELD RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-606",
    "name": "Crossroads UMC Food Pantry",
    "latitude": 39.93260535,
    "longitude": -83.07574285,
    "address": "1100 S HAGUE AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-607",
    "name": "Limestone Valley FP-E. Fultonham UMC  ",
    "latitude": 39.8510081,
    "longitude": -82.12216263,
    "address": "6939 ELM ST",
    "city": "EAST FULTONHAM",
    "state": "OH",
    "zip_code": "43735",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-609",
    "name": "Center Road Church of Christ Pantry",
    "latitude": 41.457762,
    "longitude": -81.5907688,
    "address": "264 Center Rd",
    "city": "Bedford",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-611",
    "name": "San Antonio Food Bank",
    "latitude": 29.41742781,
    "longitude": -98.59140409,
    "address": "5200 Historic, Old Hwy 90 W",
    "city": "San Antonio",
    "state": "TX",
    "zip_code": "78227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-613",
    "name": "Salvation Army-Ohio City",
    "latitude": 41.4700115,
    "longitude": -81.7169297,
    "address": "4400 Clark Avenue",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-614",
    "name": "Hope and a Future Food Pantry at St. Peters",
    "latitude": 41.8625958,
    "longitude": -80.784371,
    "address": "4901 MAIN AVE",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-615",
    "name": "Corinthian Missionary Baptist Choice FP   ",
    "latitude": 39.98460665,
    "longitude": -82.91922267,
    "address": "3161 E 5TH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-616",
    "name": "Riverwood Community Chapel ",
    "latitude": 41.1657048,
    "longitude": -81.3888332,
    "address": "1407 Fairchild Ave",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-618",
    "name": "Ashtabula Dream Center (retail pick-up only)",
    "latitude": 41.8565628,
    "longitude": -80.7885521,
    "address": "604 W 57TH ST",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-619",
    "name": "Church on the Rise Food Pantry",
    "latitude": 40.34495368,
    "longitude": -82.46965844,
    "address": "7512 Newark RD",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-621",
    "name": "Father's Pantry",
    "latitude": 40.3984975,
    "longitude": -82.4631719,
    "address": "723 COSHOCTON AVE",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-623",
    "name": "Macedonia Baptist Church",
    "latitude": 39.95550985,
    "longitude": -82.96825892,
    "address": "492 OAKWOOD AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-625",
    "name": "Faith Temple Church",
    "latitude": 41.05313655,
    "longitude": -81.49329116,
    "address": "701 Sylvan Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-632",
    "name": "The Salvation Army (Akron)",
    "latitude": 41.08618695,
    "longitude": -81.52886251,
    "address": "190 S Maple St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-634",
    "name": "The Salvation Army (Akron) Direct Distribution",
    "latitude": 41.05465029,
    "longitude": -81.58061946,
    "address": "2207 ROMIG RD",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-635",
    "name": "Unity Holiness Ministries ",
    "latitude": 41.04539931,
    "longitude": -81.56348355,
    "address": "1019 Harpster Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44314",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-636",
    "name": "Calvary Apostolic/ Love Thy Neighbor ",
    "latitude": 41.02661439,
    "longitude": -81.54624951,
    "address": "2693 Nesbitt Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44319",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-637",
    "name": "Kings Kitchen ",
    "latitude": 41.02514497,
    "longitude": -81.42133878,
    "address": "1551 Canton Rd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44312",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-640",
    "name": "The Salvation Army (Canton)",
    "latitude": 40.8008087,
    "longitude": -81.3736766,
    "address": "420 Market Ave S",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44702",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-641",
    "name": "Geneva Food Pantry",
    "latitude": 41.8024643,
    "longitude": -80.956181,
    "address": "505 W MAIN ST",
    "city": "GENEVA",
    "state": "OH",
    "zip_code": "44041",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-642",
    "name": "Annie's Pantry ",
    "latitude": 41.5172164,
    "longitude": -81.6090252,
    "address": "11005 ASHBURY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-644",
    "name": "Good Shepherd Evangelical Lutheran Church Food Pantry",
    "latitude": 39.933263,
    "longitude": -83.8093823,
    "address": "712 N FOUNTAIN AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45504",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-646",
    "name": "Interchurch Social Service - Knox Co.  ",
    "latitude": 40.39168618,
    "longitude": -82.48964151,
    "address": "306 W GAMBIER ST",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-647",
    "name": "Edison Baptist Church",
    "latitude": 40.56055453,
    "longitude": -82.87170552,
    "address": "3055 STATE ROUTE 95",
    "city": "EDISON",
    "state": "OH",
    "zip_code": "43320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-648",
    "name": "Morrow County Food Pantry",
    "latitude": 40.54920577,
    "longitude": -82.84946255,
    "address": "619 W MARION RD",
    "city": "MOUNT GILEAD",
    "state": "OH",
    "zip_code": "43338",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-651",
    "name": "St.Vincent de Paul-Marion",
    "latitude": 40.59372436,
    "longitude": -83.12872238,
    "address": "342 N MAIN ST",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-652",
    "name": "Food Share, Inc",
    "latitude": 34.2561134,
    "longitude": -119.1624304,
    "address": "4156 SOUTHBANK RD",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93036",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-655",
    "name": "The Father's House ",
    "latitude": 41.04780117,
    "longitude": -81.67403263,
    "address": "4061 Wadsworth Rd",
    "city": "Norton",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-659",
    "name": "Northeast Jefferson Food Pantry",
    "latitude": 40.56301263,
    "longitude": -80.87155071,
    "address": "11182 State Route 164",
    "city": "Salineville",
    "state": "OH",
    "zip_code": "43945",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-661",
    "name": "Bell Chapel United Methodist Food Pantry",
    "latitude": 40.42267547,
    "longitude": -80.65983995,
    "address": "3427 STATE ROUTE 213",
    "city": "STEUBENVILLE",
    "state": "OH",
    "zip_code": "43952",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-663",
    "name": "Open Door Ministries",
    "latitude": 39.1245514,
    "longitude": -84.4873684,
    "address": "2366 KEMPER LN",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-664",
    "name": "Felicity Community Mission",
    "latitude": 39.43956156,
    "longitude": -83.82733492,
    "address": "420 Walnut Street",
    "city": "FELICITY",
    "state": "OH",
    "zip_code": "45120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-665",
    "name": "Samaritan Outreach Services",
    "latitude": 39.2078723,
    "longitude": -83.6078363,
    "address": "537 N EAST ST",
    "city": "HILLSBORO",
    "state": "OH",
    "zip_code": "45133",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-666",
    "name": "Son Ministries",
    "latitude": 39.2324809,
    "longitude": -84.5914663,
    "address": "8871 COLERAIN AVE",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45251",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-667",
    "name": "Community Matters",
    "latitude": 39.1024183,
    "longitude": -84.5511815,
    "address": "2104 SAINT MICHAEL ST",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-669",
    "name": "North Lewisburg United Methodist Church ",
    "latitude": 40.2215691,
    "longitude": -83.5521103,
    "address": "245 E TOWNSEND ST",
    "city": "NORTH LEWISBURG",
    "state": "OH",
    "zip_code": "43060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-670",
    "name": "Johnson/Rudd Community Pantry",
    "latitude": 40.5862514,
    "longitude": -83.2987785,
    "address": "6342 MARION AGOSTA RD",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-673",
    "name": "St. Paul AME Food Pantry ",
    "latitude": 41.44175531,
    "longitude": -81.78387392,
    "address": "4118 BROOKSIDE BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-674",
    "name": "Stephanie Tubbs Jones Health Center",
    "latitude": 41.5269071,
    "longitude": -81.5852165,
    "address": "13944 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-676",
    "name": "St. John's Outreach Ministries",
    "latitude": 39.0954229,
    "longitude": -84.4892491,
    "address": "415 PARK AVE",
    "city": "NEWPORT",
    "state": "KY",
    "zip_code": "41071",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-677",
    "name": "Reynoldsburg Community of Care",
    "latitude": 39.95070196,
    "longitude": -82.79591726,
    "address": "1649 GRAHAM RD",
    "city": "REYNOLDSBURG",
    "state": "OH",
    "zip_code": "43068",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-678",
    "name": "Maywood Mission Pantry",
    "latitude": 39.69956758,
    "longitude": -82.60343293,
    "address": "1025 S BROAD ST",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-679",
    "name": "Calvary Lutheran Church",
    "latitude": 41.52057361,
    "longitude": -81.59199999,
    "address": "13101 Euclid Ave.",
    "city": "EAST CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-680",
    "name": "Helping Hands Ministry ",
    "latitude": 41.06669514,
    "longitude": -81.73578544,
    "address": "7615 Ridge Rd",
    "city": "Wadsworth",
    "state": "OH",
    "zip_code": "44281",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-681",
    "name": "Bread Basket Food Pantry",
    "latitude": 39.96903247,
    "longitude": -82.97698609,
    "address": "186 N 17TH ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-682",
    "name": "Blessed Trinity Parish ",
    "latitude": 41.4336191,
    "longitude": -81.790968,
    "address": "14040 PURITAS AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-683",
    "name": "Interfaith House",
    "latitude": 38.7963296,
    "longitude": -83.5404625,
    "address": "503 E NORTH ST",
    "city": "WEST UNION",
    "state": "OH",
    "zip_code": "45693",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-684",
    "name": "Greenfield Area Christian Center",
    "latitude": 39.346947,
    "longitude": -83.602314,
    "address": "912 North 5th Street",
    "city": "Highland",
    "state": "OH",
    "zip_code": "45132",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-685",
    "name": "Pike County Outreach Council",
    "latitude": 39.1258654,
    "longitude": -82.9846164,
    "address": "107 W 2ND ST",
    "city": "WAVERLY",
    "state": "OH",
    "zip_code": "45690",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-686",
    "name": "Mt. Zion Apostolic Church Pantry",
    "latitude": 38.7632534,
    "longitude": -83.0388803,
    "address": "1514 16TH ST",
    "city": "WEST PORTSMOUTH",
    "state": "OH",
    "zip_code": "45663",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-688",
    "name": "Somerset Area Food Pantry",
    "latitude": 39.808268,
    "longitude": -82.29748452,
    "address": "139 E Main St",
    "city": "SOMERSET",
    "state": "OH",
    "zip_code": "43783",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-689",
    "name": "Hopewell/Madison Food Pantry",
    "latitude": 39.939027,
    "longitude": -82.274937,
    "address": "11701 Gower Rd",
    "city": "GLENFORD",
    "state": "OH",
    "zip_code": "43739",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-690",
    "name": "TLC Ministries",
    "latitude": 39.1162276,
    "longitude": -82.5369453,
    "address": "901 S RAILROAD AVE",
    "city": "WELLSTON",
    "state": "OH",
    "zip_code": "45692",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-691",
    "name": "INPREM Holistic Comm. Resource Ctr. FP",
    "latitude": 40.08513995,
    "longitude": -82.97553662,
    "address": "5757 KARL RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-693",
    "name": "Vineyard Christian Fellowship - Mobile (Montgomery)",
    "latitude": 39.7759874,
    "longitude": -84.2008341,
    "address": "Alders Gate United Methodist",
    "city": "Huber Heights",
    "state": "OH",
    "zip_code": "45424",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-694",
    "name": "Vineyard Christian Fellowship - Mobile (Greene)",
    "latitude": 39.7759874,
    "longitude": -84.2008341,
    "address": "Fairborn First Church of Christ",
    "city": "Fairborn",
    "state": "OH",
    "zip_code": "45324",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-695",
    "name": "Cleveland Kosher Food Pantry",
    "latitude": 41.5050167,
    "longitude": -81.519866,
    "address": "2004 S GREEN RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-697",
    "name": "Mid-Ohio Farm",
    "latitude": 39.89978117,
    "longitude": -82.96310102,
    "address": "116 N Wheatland Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-698",
    "name": "The WORD Church",
    "latitude": 41.4309767,
    "longitude": -81.546702,
    "address": "18903 S MILES RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-700",
    "name": "Sherrick Road Church of God",
    "latitude": 40.7851819,
    "longitude": -81.3661799,
    "address": "1121 Sherrick Rd SE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44707",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-702",
    "name": "Commons at Livingston/MASH Pantry",
    "latitude": 39.95823141,
    "longitude": -83.03272876,
    "address": "1205 W BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43222",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-704",
    "name": "Lodi Family Center ",
    "latitude": 41.03334035,
    "longitude": -82.0078185,
    "address": "301 Mill St",
    "city": "Lodi",
    "state": "OH",
    "zip_code": "44254",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-707",
    "name": "Church Triumphant",
    "latitude": 39.95998938,
    "longitude": -83.01801407,
    "address": "1001 Vera Place",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-708",
    "name": "Franklin Station Food Pantry",
    "latitude": 39.96062234,
    "longitude": -83.01438026,
    "address": "524 W BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-709",
    "name": "Angel Food Pantry",
    "latitude": 40.40240343,
    "longitude": -82.81073068,
    "address": "8 N MAIN ST",
    "city": "MARENGO",
    "state": "OH",
    "zip_code": "43334",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-710",
    "name": "Common Ground Food Pantry",
    "latitude": 39.9311316,
    "longitude": -82.9646174,
    "address": "2330 Briggs Rd",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-714",
    "name": "City of Bedford Heights",
    "latitude": 41.4070806,
    "longitude": -81.4973037,
    "address": "5615 PERKINS RD",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-716",
    "name": "Emerging Autism Solutions",
    "latitude": 40.00043244,
    "longitude": -82.97976579,
    "address": "1043 E 17TH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-718",
    "name": "Good Samaritan Outreach Center",
    "latitude": 39.92260401,
    "longitude": -83.81906273,
    "address": "427 W WASHINGTON ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-719",
    "name": "Daybreak - Lindy's On-Site Pantry Program",
    "latitude": 39.7505088,
    "longitude": -84.1902293,
    "address": "605 S PATTERSON BLVD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-720",
    "name": "Mt. Haven Missionary Baptist Church ",
    "latitude": 41.4638399,
    "longitude": -81.6074701,
    "address": "3484 MARTIN LUTHER KING JR DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-721",
    "name": "Vineyard Christian Fellowship - Pantry (Greene)",
    "latitude": 39.6952184,
    "longitude": -84.0871427,
    "address": "4051 INDIAN RIPPLE RD",
    "city": "BEAVERCREEK",
    "state": "OH",
    "zip_code": "45440",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-723",
    "name": "Neighborhood Services Inc. (NSI)",
    "latitude": 40.00325219,
    "longitude": -82.99841315,
    "address": "1950 N 4TH ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-724",
    "name": "Corinthian Baptist Food Pantry",
    "latitude": 41.5141438,
    "longitude": -81.6514909,
    "address": "1643 E 55TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-726",
    "name": "Leave a Mark Church Food Pantry",
    "latitude": 39.86412,
    "longitude": -82.98329,
    "address": "4818 PARSONS AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-731",
    "name": "Caring Kitchen",
    "latitude": 40.1084078,
    "longitude": -83.7557215,
    "address": "300 MIAMI ST",
    "city": "URBANA",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-732",
    "name": "Urbana Champaign County Senior Center",
    "latitude": 40.1005972,
    "longitude": -83.7547768,
    "address": "701 S WALNUT ST",
    "city": "URBANA",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-733",
    "name": "Stepping Stones",
    "latitude": 40.1261657,
    "longitude": -83.7473602,
    "address": "142 DELLINGER RD",
    "city": "URBANA",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-739",
    "name": "Faith United Methodist Church Produce Market",
    "latitude": 40.01880269,
    "longitude": -81.5909195,
    "address": "518 S 8TH ST",
    "city": "CAMBRIDGE",
    "state": "OH",
    "zip_code": "43725",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-740",
    "name": "Southfield Baptist",
    "latitude": 39.89864255,
    "longitude": -82.95791209,
    "address": "1399 AUGMONT AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-742",
    "name": "Mt.Olivet Food Pantry",
    "latitude": 39.95767542,
    "longitude": -82.98690866,
    "address": "428 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-743",
    "name": "Church Triumphant",
    "latitude": 39.43827536,
    "longitude": -82.87789985,
    "address": "4496 STATE ROUTE 180",
    "city": "KINGSTON",
    "state": "OH",
    "zip_code": "45644",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-744",
    "name": "Greater Groveport Human Needs Food Pantry",
    "latitude": 39.87732226,
    "longitude": -82.8826968,
    "address": "595  Cherry St.",
    "city": "GROVEPORT",
    "state": "OH",
    "zip_code": "43125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-745",
    "name": "Hoge Food Pantry",
    "latitude": 39.9548133,
    "longitude": -83.07872871,
    "address": "2930 W BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-750",
    "name": "Imani Temple",
    "latitude": 41.51779792,
    "longitude": -81.55568019,
    "address": "1513 North Taylor Road",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-751",
    "name": "Life Link Food Pantry",
    "latitude": 40.58542785,
    "longitude": -83.13754494,
    "address": "248 OLNEY AVE",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-752",
    "name": "Evangel Baptist",
    "latitude": 41.045246,
    "longitude": -80.6581178,
    "address": "5248 SOUTHERN BLVD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-754",
    "name": "Open Hands Free Pantry",
    "latitude": 39.9198389,
    "longitude": -83.7404139,
    "address": "151 S. Bird Rd.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-755",
    "name": "Bethel Churches United",
    "latitude": 39.9347534,
    "longitude": -84.0247657,
    "address": "226 S PIKE ST",
    "city": "NEW CARLISLE",
    "state": "OH",
    "zip_code": "45344",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-756",
    "name": "Christ Episcopal Church",
    "latitude": 39.9227735,
    "longitude": -83.8037135,
    "address": "409 E HIGH ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-757",
    "name": "Life In Christ Community Church",
    "latitude": 39.9057046,
    "longitude": -83.794304,
    "address": "1100 SUNSET AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-759",
    "name": "Risen Christ",
    "latitude": 39.875596,
    "longitude": -83.8162616,
    "address": "41 E POSSUM RD",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45502",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-760",
    "name": "Family Needs",
    "latitude": 39.9120418,
    "longitude": -83.810192,
    "address": "36 E GRAND AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-761",
    "name": "Military Veterans Resource Center - Columbus",
    "latitude": 40.08729579,
    "longitude": -82.98056689,
    "address": "188 Heatherdown Dr",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43081",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-764",
    "name": "J. Jireh Ministries Food Pantry    ",
    "latitude": 39.95762219,
    "longitude": -82.95423388,
    "address": "1670 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-767",
    "name": "Military Veterans Resource Center - Chillicothe",
    "latitude": 39.37270317,
    "longitude": -82.97579957,
    "address": "1786 N BRIDGE ST",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-768",
    "name": "SVDP /St. Joseph's Catholic Church",
    "latitude": 40.800417,
    "longitude": -81.5206145,
    "address": "322 3rd St SE",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-773",
    "name": "United Christian Services of Indian Lake",
    "latitude": 40.46655542,
    "longitude": -83.89259846,
    "address": "733 State Route 708",
    "city": "Russells Point",
    "state": "OH",
    "zip_code": "43348",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-774",
    "name": "Five Loaves Food Pantry",
    "latitude": 40.318945,
    "longitude": -83.974251,
    "address": "46 PO BOX",
    "city": "QUINCY",
    "state": "OH",
    "zip_code": "43343",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-776",
    "name": "St. Vincent de Paul Russells Point",
    "latitude": 40.46660139,
    "longitude": -83.89030355,
    "address": "463 Madison Ave.",
    "city": "RUSSELLS POINT",
    "state": "OH",
    "zip_code": "43348",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-777",
    "name": "St Vincent de Paul St Patrick",
    "latitude": 40.3567123,
    "longitude": -83.7549131,
    "address": "328 E PATTERSON AVE",
    "city": "BELLEFONTAINE",
    "state": "OH",
    "zip_code": "43311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-778",
    "name": "Buckeye Gospel",
    "latitude": 40.2987605,
    "longitude": -83.9734124,
    "address": "206 Liberty St",
    "city": "QUINCY",
    "state": "OH",
    "zip_code": "43343",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-779",
    "name": "Christ the King ",
    "latitude": 41.10211232,
    "longitude": -81.50434639,
    "address": "300 E Tallmadge Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-780",
    "name": "Beverly Waterford Food Pantry",
    "latitude": 39.54964668,
    "longitude": -81.63530281,
    "address": "307 7th Street",
    "city": "BEVERLY",
    "state": "OH",
    "zip_code": "45715",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-781",
    "name": "Canal Lewisville Church",
    "latitude": 40.30124102,
    "longitude": -81.83793188,
    "address": "198 E CHURCH ST",
    "city": "COSHOCTON",
    "state": "OH",
    "zip_code": "43812",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-785",
    "name": "New Faith Ministries Food Pantry",
    "latitude": 39.920211,
    "longitude": -82.832104,
    "address": "2879 BRICE Rd",
    "city": "BRICE",
    "state": "OH",
    "zip_code": "43109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-786",
    "name": "Southwestern Church of Christ Pantry",
    "latitude": 39.88194561,
    "longitude": -83.10114476,
    "address": "3767 GROVE CITY RD",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-787",
    "name": "Word of God Community Church",
    "latitude": 39.80000691,
    "longitude": -82.07160343,
    "address": "5445 Third St",
    "city": "ROSEVILLE",
    "state": "OH",
    "zip_code": "43777",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-788",
    "name": "Barberton Area Community Ministries ",
    "latitude": 41.02564168,
    "longitude": -81.62353814,
    "address": "939 Norton Ave",
    "city": "Barberton",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-789",
    "name": "Zion Lutheran Church - Lord's Pantry",
    "latitude": 41.0813426,
    "longitude": -81.51713936,
    "address": "139 S High St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44308",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-790",
    "name": "The Salvation Army (Creston)",
    "latitude": 40.9837891,
    "longitude": -81.8910324,
    "address": "121 FACTORY ST",
    "city": "CRESTON",
    "state": "OH",
    "zip_code": "44217",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-794",
    "name": "St. John's Missionary Baptist Church",
    "latitude": 39.919016,
    "longitude": -83.8119669,
    "address": "34 W PLEASANT ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-795",
    "name": "Clifton Avenue Church of God",
    "latitude": 39.908291,
    "longitude": -83.807696,
    "address": "1408 CLIFTON AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-796",
    "name": "Seeds of Hope ",
    "latitude": 39.8845886,
    "longitude": -84.0477256,
    "address": "2550 S DAYTON LAKEVIEW RD",
    "city": "NEW CARLISLE",
    "state": "OH",
    "zip_code": "45344",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-797",
    "name": "Give and Take",
    "latitude": 40.40078288,
    "longitude": -83.54447212,
    "address": "115 South Main St.",
    "city": "WEST MANSFIELD",
    "state": "OH",
    "zip_code": "43358",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-798",
    "name": "Mobile Pantry Clark County",
    "latitude": 39.9250823,
    "longitude": -83.7997572,
    "address": "701 E COLUMBIA ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-799",
    "name": "Mobile Pantry Champaign County",
    "latitude": 40.0994519,
    "longitude": -83.7457849,
    "address": "384 Park Ave",
    "city": "Urbana",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-800",
    "name": "Mobile Pantry Logan County",
    "latitude": 40.3472405,
    "longitude": -83.757813,
    "address": "301 E. Lake Ave",
    "city": "Bellefontaine",
    "state": "OH",
    "zip_code": "43311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-801",
    "name": "United Way of Ross County",
    "latitude": 39.33485948,
    "longitude": -82.98080624,
    "address": "69 E Water St",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-802",
    "name": "People In Need",
    "latitude": 40.2811891,
    "longitude": -83.088794,
    "address": "138 JOHNSON DR",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-803",
    "name": "Salvation Army Worthington ",
    "latitude": 40.11883083,
    "longitude": -82.99518375,
    "address": "760 WORTHINGTON WOODS BLVD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43085",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-804",
    "name": "Salvation Army Citadel    ",
    "latitude": 40.04129181,
    "longitude": -82.97733298,
    "address": "3662 KARL RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-805",
    "name": "Greenfield Place",
    "latitude": 39.84887045,
    "longitude": -82.89342777,
    "address": "283 GREEN AVE",
    "city": "GROVEPORT",
    "state": "OH",
    "zip_code": "43125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-807",
    "name": "Village Place (LSS)",
    "latitude": 39.92556817,
    "longitude": -83.05573623,
    "address": "1489 OCTOBER RIDGE CT",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-810",
    "name": "Hilltop Senior Village",
    "latitude": 39.94683978,
    "longitude": -83.09714587,
    "address": "300 OVERSTREET WAY",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-812",
    "name": "Hope Clinic",
    "latitude": 39.335907,
    "longitude": -83.0030319,
    "address": "475 WESTERN AVE",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-813",
    "name": "Eastland Manor",
    "latitude": 39.92359378,
    "longitude": -82.88329677,
    "address": "4225 MACSWAY AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-814",
    "name": "Cambridge Arms",
    "latitude": 39.96512272,
    "longitude": -82.97617217,
    "address": "926 E BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-815",
    "name": "Michigan Ave Apartments",
    "latitude": 39.98519022,
    "longitude": -83.01666468,
    "address": "1200 MICHIGAN AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-816",
    "name": "Nottingham Food Pantry ",
    "latitude": 41.5714762,
    "longitude": -81.5506843,
    "address": "18316 SAINT CLAIR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-817",
    "name": "The Perry Center",
    "latitude": 41.7692595,
    "longitude": -81.1354018,
    "address": "4261 MANCHESTER RD",
    "city": "PERRY",
    "state": "OH",
    "zip_code": "44081",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-818",
    "name": "Jeffersonville Church of Christ",
    "latitude": 39.66222408,
    "longitude": -83.5729783,
    "address": "83 N MAIN ST",
    "city": "JEFFERSONVILLE",
    "state": "OH",
    "zip_code": "43128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-824",
    "name": "Maplewood Hgts",
    "latitude": 39.97115423,
    "longitude": -82.9025265,
    "address": "91 MAPLEWOOD AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-833",
    "name": "Calvary Christian Fellowship",
    "latitude": 39.93530471,
    "longitude": -82.90575059,
    "address": "3601 BEXVIE AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-834",
    "name": "Andrews House",
    "latitude": 40.28045998,
    "longitude": -83.06188589,
    "address": "795 POLLOCK RD",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-835",
    "name": "Change of Direction",
    "latitude": 41.4805939,
    "longitude": -81.6008097,
    "address": "11802 BUCKEYE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-836",
    "name": "BOGG Ministries- Greene",
    "latitude": 39.6177986,
    "longitude": -84.2091039,
    "address": "9095 WASHINGTON CHURCH RD",
    "city": "MIAMISBURG",
    "state": "OH",
    "zip_code": "45342",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-838",
    "name": "Stonehouse",
    "latitude": 40.06989178,
    "longitude": -80.80229657,
    "address": "54385 NATIONAL RD",
    "city": "BRIDGEPORT",
    "state": "OH",
    "zip_code": "43912",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-840",
    "name": "Linworth Road Church Food Pantry",
    "latitude": 40.0703098,
    "longitude": -83.04201801,
    "address": "5400 LINWORTH RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43235",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-841",
    "name": "One Step A LA Vez",
    "latitude": 34.40079012,
    "longitude": -118.91355473,
    "address": "421 SESPE AVE",
    "city": "FILLMORE",
    "state": "CA",
    "zip_code": "93015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-842",
    "name": "Louisville Community Cupboard",
    "latitude": 40.8320523,
    "longitude": -81.2503517,
    "address": "1022 W Main St",
    "city": "Louisville",
    "state": "OH",
    "zip_code": "44641",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-844",
    "name": "My Brother's Place",
    "latitude": 39.12465219,
    "longitude": -82.53506872,
    "address": "116 S Railroad Ave",
    "city": "WELLSTON",
    "state": "OH",
    "zip_code": "45692",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-845",
    "name": "Worthington Resource Pantry",
    "latitude": 40.08823298,
    "longitude": -83.00406836,
    "address": "500 Schrock Road",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-848",
    "name": "Reynoldsburg Helping Hands Pantry  ",
    "latitude": 39.95536306,
    "longitude": -82.80197517,
    "address": "7453 E MAIN ST",
    "city": "REYNOLDSBURG",
    "state": "OH",
    "zip_code": "43068",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-852",
    "name": "Burton Congregational United Church",
    "latitude": 41.47238422,
    "longitude": -81.14639771,
    "address": "14558 W PARK ST",
    "city": "BURTON",
    "state": "OH",
    "zip_code": "44021",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-853",
    "name": "Mid-South Food Bank",
    "latitude": 35.1357808,
    "longitude": -90.0297553,
    "address": "3865 S PERKINS",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-855",
    "name": "Oaks Family Care Center",
    "latitude": 41.23783024,
    "longitude": -81.83701499,
    "address": "4196 Center Rd",
    "city": "Brunswick",
    "state": "OH",
    "zip_code": "44242",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-857",
    "name": "CEDC - Valle Naranjal Farmworker Apts.",
    "latitude": 34.41448202,
    "longitude": -118.78661146,
    "address": "4268 Center Street",
    "city": "PIRU",
    "state": "CA",
    "zip_code": "93040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-864",
    "name": "We C.A.R.E. Community Outreach",
    "latitude": 41.5342741,
    "longitude": -81.5999547,
    "address": "4004 E 131st St",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-866",
    "name": "Fatima Family Center",
    "latitude": 41.5106503,
    "longitude": -81.6440211,
    "address": "6600 LEXINGTON AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-867",
    "name": "St. Michael Catholic Church",
    "latitude": 40.08086435,
    "longitude": -83.01844757,
    "address": "5750 N HIGH ST",
    "city": "WORTHINGTON",
    "state": "OH",
    "zip_code": "43085",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-869",
    "name": "YWCA Wings",
    "latitude": 39.96089145,
    "longitude": -82.99598924,
    "address": "65 S 4TH ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-870",
    "name": "Rivertree Christian Church ",
    "latitude": 40.8792762,
    "longitude": -81.4872184,
    "address": "7373 Portage St NW",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-871",
    "name": "Concord Community Food Pantry",
    "latitude": 40.156792,
    "longitude": -83.8423938,
    "address": "2963 N STATE ROUTE 560",
    "city": "URBANA",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-873",
    "name": "Covenant Food Pantry",
    "latitude": 40.3897303,
    "longitude": -82.5094539,
    "address": "13360 NEW DELAWARE RD",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-875",
    "name": "Emmanuel SVDP Conference",
    "latitude": 39.7531262,
    "longitude": -84.1943653,
    "address": "155 FRANKLIN ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-876",
    "name": "LSS Northern Counties",
    "latitude": 40.1018124,
    "longitude": -82.9851137,
    "address": "1105 Schrock Rd",
    "city": "Columbus",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-877",
    "name": "Christ Memorial Baptist Church",
    "latitude": 39.94755511,
    "longitude": -82.90628887,
    "address": "1223 BARNETT RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-879",
    "name": "Temple of Praise Assembly of God",
    "latitude": 41.2941875,
    "longitude": -84.3643831,
    "address": "505 ELBERT ST",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-880",
    "name": "Mission Family Ministries",
    "latitude": 39.2014279,
    "longitude": -82.81494507,
    "address": "989 MAIN ST",
    "city": "RICHMOND DALE",
    "state": "OH",
    "zip_code": "45673",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-882",
    "name": "St. Mary Catholic Church",
    "latitude": 41.46403299,
    "longitude": -82.17626929,
    "address": "309 W 7TH ST",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-884",
    "name": "The Friendship House",
    "latitude": 32.97892228,
    "longitude": -96.89009728,
    "address": "2400 N JOSEY LN",
    "city": "CARROLLTON",
    "state": "TX",
    "zip_code": "75006",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-893",
    "name": "Homeport Produce Markets",
    "latitude": 39.92408169,
    "longitude": -82.89380124,
    "address": "2393 CANAL BAY WAY",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-900",
    "name": "Oberlin Community Services",
    "latitude": 41.28251469,
    "longitude": -82.22023268,
    "address": "500 E. Lorain street",
    "city": "OBERLIN",
    "state": "OH",
    "zip_code": "44074",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-901",
    "name": "Anthony Wayne Community Food Ministry Inc.",
    "latitude": 41.521025,
    "longitude": -83.7365989,
    "address": "8217 DUTCH RD",
    "city": "WATERVILLE",
    "state": "OH",
    "zip_code": "43566",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-905",
    "name": "Salvation Army - Miles Park",
    "latitude": 41.4464334,
    "longitude": -81.6210084,
    "address": "4139 E 93RD ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-906",
    "name": "Dodge Multi-Generational Center",
    "latitude": 39.95388652,
    "longitude": -83.01760061,
    "address": "667 SULLIVANT AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-907",
    "name": "Salvation Army - East Cleveland Corps",
    "latitude": 41.5335223,
    "longitude": -81.58657878,
    "address": "1507 DOAN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-908",
    "name": "Salvation Army Belmont County",
    "latitude": 40.01939784,
    "longitude": -80.74131093,
    "address": "315 37TH ST",
    "city": "BELLAIRE",
    "state": "OH",
    "zip_code": "43906",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-909",
    "name": "Salvation Army - Temple Corps",
    "latitude": 41.5765644,
    "longitude": -81.5570688,
    "address": "17625 GROVEWOOD AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-910",
    "name": "Salvation Army - West Park",
    "latitude": 41.45922841,
    "longitude": -81.77618418,
    "address": "12645 LORAIN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-915",
    "name": "Elim Manor",
    "latitude": 39.9242085,
    "longitude": -82.9083598,
    "address": "3180 ELIM MANOR CT",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-917",
    "name": "Care and Share of Erie County",
    "latitude": 41.45511418,
    "longitude": -82.71312071,
    "address": "249 Jackson Street",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-918",
    "name": "New Day Family Resource Center",
    "latitude": 41.4477155,
    "longitude": -82.699395,
    "address": "1135 WARREN ST",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-919",
    "name": "Norwalk Area Foodbank",
    "latitude": 41.2452291,
    "longitude": -82.6189653,
    "address": "99 WHITTLESEY AVE",
    "city": "NORWALK",
    "state": "OH",
    "zip_code": "44857",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-921",
    "name": "Crown Hill Food Pantry",
    "latitude": 40.9179044,
    "longitude": -81.7822523,
    "address": "9693 Benner Rd",
    "city": "Rittman",
    "state": "OH",
    "zip_code": "44270",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-922",
    "name": "Crestview Churches Community Concerns",
    "latitude": 40.8478349,
    "longitude": -80.62041376,
    "address": "46469 STATE ROUTE 46",
    "city": "NEW WATERFORD",
    "state": "OH",
    "zip_code": "44445",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-923",
    "name": "St. Paul's Free Farmers Markert",
    "latitude": 41.13922804,
    "longitude": -81.8601895,
    "address": "317 E Liberty St",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-924",
    "name": "Kenton Full Gospel Church",
    "latitude": 40.6491427,
    "longitude": -83.6067431,
    "address": "129 N WAYNE ST",
    "city": "KENTON",
    "state": "OH",
    "zip_code": "43326",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-940",
    "name": "RIVERSIDE MISSIONARY BAPTIST CHURCH",
    "latitude": 35.0510405,
    "longitude": -90.0606533,
    "address": "3560 S 3RD ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-942",
    "name": "Streetsboro Community Pantry",
    "latitude": 41.2345823,
    "longitude": -81.3453564,
    "address": "8940 State Rt 43",
    "city": "Streetsboro",
    "state": "OH",
    "zip_code": "44241",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-944",
    "name": "ABERDEEN LOAVES AND FISHES",
    "latitude": 33.82668895,
    "longitude": -88.54156406,
    "address": "200 E CANAL ST",
    "city": "ABERDEEN",
    "state": "MS",
    "zip_code": "39730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-945",
    "name": "ST. LUKE FOOD PANTRY - TUPELO",
    "latitude": 34.23643124,
    "longitude": -88.66942938,
    "address": "2653 Eason Blvd.",
    "city": "TUPELO",
    "state": "MS",
    "zip_code": "38804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-949",
    "name": "Mid-Ohio Market at CSCC",
    "latitude": 39.9704974,
    "longitude": -82.9912394,
    "address": "400 GROVE ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-954",
    "name": "Salvation Army-Mt.Vernon",
    "latitude": 40.39038151,
    "longitude": -82.48197938,
    "address": "206 E OHIO AVE",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-956",
    "name": "Because He Lives",
    "latitude": 39.2413421,
    "longitude": -83.7900011,
    "address": "220 Washington Street",
    "city": "LYNCHBURG",
    "state": "OH",
    "zip_code": "45142",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-959",
    "name": "Mount Sinai Baptist Church",
    "latitude": 40.7701356,
    "longitude": -82.5052179,
    "address": "275 GRACE ST",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44902",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-963",
    "name": "College Drive Presbyterian Pantry",
    "latitude": 39.99458993,
    "longitude": -81.73757959,
    "address": "2 W HIGH ST",
    "city": "NEW CONCORD",
    "state": "OH",
    "zip_code": "43762",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-966",
    "name": "St Vincent de Paul Springfield",
    "latitude": 39.9210517,
    "longitude": -83.7734982,
    "address": "228 RAFFENSPERGER AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-971",
    "name": "First Dawn Food Pantry",
    "latitude": 39.6288764,
    "longitude": -84.1564352,
    "address": "63 E FRANKLIN ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45459",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-972",
    "name": "Holy Trinity Baptist Church",
    "latitude": 41.45510866,
    "longitude": -81.59174107,
    "address": "3803 East 131st Street",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-973",
    "name": "West Side Catholic Center",
    "latitude": 41.4819342,
    "longitude": -81.7087007,
    "address": "3135 LORAIN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-976",
    "name": "Greater Grace Temple",
    "latitude": 39.8954794,
    "longitude": -83.8199495,
    "address": "380 W LEFFEL LN",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-977",
    "name": "Community Presbyterian Church",
    "latitude": 34.2820475,
    "longitude": -119.2770084,
    "address": "1555 POLI ST",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-979",
    "name": "Good Neighbors",
    "latitude": 41.07033167,
    "longitude": -81.47102641,
    "address": "1453 GOODYEAR BLVD",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-981",
    "name": "St. John Lutheran Church-Napoleon",
    "latitude": 41.4569161,
    "longitude": -84.17916821,
    "address": "16035 COUNTY ROAD U",
    "city": "NAPOLEON",
    "state": "OH",
    "zip_code": "43545",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-983",
    "name": "St Paris Federation of Churches",
    "latitude": 40.12894002,
    "longitude": -83.96130999,
    "address": "208 W Main St",
    "city": "SAINT PARIS",
    "state": "OH",
    "zip_code": "43072",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-984",
    "name": "Wherehouse",
    "latitude": 40.1102112,
    "longitude": -83.7528141,
    "address": "238 N MAIN ST",
    "city": "URBANA",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-985",
    "name": "New Life Worship Center",
    "latitude": 41.45640604,
    "longitude": -84.54521529,
    "address": "14451 COUNTY ROAD C",
    "city": "BRYAN",
    "state": "OH",
    "zip_code": "43506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-986",
    "name": "Saint Vincent De Paul Sacred Heart",
    "latitude": 41.02569429,
    "longitude": -81.72402825,
    "address": "260 Broad St",
    "city": "Wadsworth",
    "state": "OH",
    "zip_code": "44281",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-987",
    "name": "St. Joan of Arc Catholic Church ",
    "latitude": 40.7934453,
    "longitude": -81.4410525,
    "address": "4940 Tuscarawas St W",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44708",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-988",
    "name": "Whitehall UMC",
    "latitude": 39.96436654,
    "longitude": -82.87999836,
    "address": "525 BERNHARD RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-990",
    "name": "Market Place For All People",
    "latitude": 41.6548557,
    "longitude": -83.5425249,
    "address": "1201 MADISON AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43604",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-991",
    "name": "New Covenant Church",
    "latitude": 41.6726428,
    "longitude": -83.5265336,
    "address": "2519 STICKNEY AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-995",
    "name": "Stratford East",
    "latitude": 39.91349169,
    "longitude": -82.82098666,
    "address": "3401 QUINLAN BLVD",
    "city": "CANAL WINCHESTER",
    "state": "OH",
    "zip_code": "43110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-997",
    "name": "Nucleus.CA, Inc.",
    "latitude": 34.192278,
    "longitude": -118.9239076,
    "address": "999 RANCHO CONEJO BLVD",
    "city": "NEWBURY PARK",
    "state": "CA",
    "zip_code": "91320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-998",
    "name": "New Horizons Christian Fellowship ",
    "latitude": 39.93826425,
    "longitude": -82.95453119,
    "address": "1428 FAIRWOOD AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-999",
    "name": "St. Martin de Porres",
    "latitude": 41.6635356,
    "longitude": -83.5704044,
    "address": "1119 W BANCROFT ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1000",
    "name": "First Baptist Church of Akron",
    "latitude": 41.11587624,
    "longitude": -81.57289393,
    "address": "1670 Shatto Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44313",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1001",
    "name": "Starlight Baptist Church",
    "latitude": 41.5314836,
    "longitude": -81.5801236,
    "address": "14516 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1002",
    "name": "Archbold FISH Food Pantry",
    "latitude": 41.5083177,
    "longitude": -84.306843,
    "address": "1309 S DEFIANCE ST",
    "city": "ARCHBOLD",
    "state": "OH",
    "zip_code": "43502",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1003",
    "name": "Compassion in Action",
    "latitude": 39.93059239,
    "longitude": -82.74761753,
    "address": "6810 Blacklick-Eastern Rd NW",
    "city": "PICKERINGTON",
    "state": "OH",
    "zip_code": "43147",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1004",
    "name": "Jesus Christ People Care Center ",
    "latitude": 40.8004241,
    "longitude": -81.3923124,
    "address": "1612 Tuscarawas St W",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44708",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1006",
    "name": "Christian Center PTL",
    "latitude": 40.01004877,
    "longitude": -82.87136494,
    "address": "298 ROCKY FORK DR S",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1015",
    "name": "Hudson Community Service Association ",
    "latitude": 41.2718738,
    "longitude": -81.41094257,
    "address": "7855 Stow Rd",
    "city": "Hudson",
    "state": "OH",
    "zip_code": "44236",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1016",
    "name": "Unity United Methodist Church",
    "latitude": 41.6173899,
    "longitude": -83.5127265,
    "address": "1910 E BROADWAY ST",
    "city": "NORTHWOOD",
    "state": "OH",
    "zip_code": "43619",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1017",
    "name": "St. Paul United Church of Christ",
    "latitude": 41.50944449,
    "longitude": -83.15176917,
    "address": "165 N TOUSSAINT ST",
    "city": "OAK HARBOR",
    "state": "OH",
    "zip_code": "43449",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1019",
    "name": "Koinonia Dev. Corp Pantry",
    "latitude": 39.92257858,
    "longitude": -82.98833798,
    "address": "258 HOSACK ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1020",
    "name": "Woodview Court",
    "latitude": 40.02517765,
    "longitude": -83.16188777,
    "address": "3623 HERITAGE CLUB DR",
    "city": "HILLIARD",
    "state": "OH",
    "zip_code": "43026",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1021",
    "name": "Trinity Assembly of God Produce Market",
    "latitude": 39.93098771,
    "longitude": -83.09012206,
    "address": "1112 DEMOREST RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1025",
    "name": "Christian Fellowship Center Ministries",
    "latitude": 41.5732663,
    "longitude": -81.5794023,
    "address": "14713 LAKE SHORE BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1027",
    "name": "Mega Resource Center",
    "latitude": 41.4681746,
    "longitude": -81.6992445,
    "address": "2401 PRAME AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1028",
    "name": "Jaycee Village",
    "latitude": 40.08947805,
    "longitude": -82.96403695,
    "address": "5905 BEECHCROFT RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1031",
    "name": "Mid-Ohio Market at Bishop Griffin Resource Center",
    "latitude": 39.94701476,
    "longitude": -82.91957699,
    "address": "2867 East Livingston Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43209",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1033",
    "name": "The Salvation Army (Minerva)",
    "latitude": 40.7257998,
    "longitude": -81.1049894,
    "address": "301 Valley St",
    "city": "Minerva",
    "state": "OH",
    "zip_code": "44657",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1034",
    "name": "The Salvation Army (Barberton)",
    "latitude": 41.01195697,
    "longitude": -81.61070331,
    "address": "560 Wooster Rd W",
    "city": "Barberton",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1035",
    "name": "The Salvation Army (Barberton) Direct Distribution",
    "latitude": 41.01195697,
    "longitude": -81.61070331,
    "address": "560 WOOSTER RD W",
    "city": "BARBERTON",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1036",
    "name": "Cornerstone Christian Assembly",
    "latitude": 41.00327243,
    "longitude": -81.6427416,
    "address": "1531 Ettle Dr",
    "city": "Barberton",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1039",
    "name": "Canton Friendship Center",
    "latitude": 40.8221453,
    "longitude": -81.3826793,
    "address": "2200 Cleveland Ave NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44709",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1044",
    "name": "East Mt. Zion Baptist Church ",
    "latitude": 41.50357117,
    "longitude": -81.61840061,
    "address": "9990 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1046",
    "name": "Enon Emergency Relief",
    "latitude": 39.8778842,
    "longitude": -83.9393795,
    "address": "101 Scott St",
    "city": "ENON",
    "state": "OH",
    "zip_code": "45323",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1047",
    "name": "Faith Ministries",
    "latitude": 40.02648592,
    "longitude": -82.94053355,
    "address": "2747 AGLER RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1048",
    "name": "Asian Services In Action Inc",
    "latitude": 41.5064611,
    "longitude": -81.6623687,
    "address": "3631 PERKINS AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1054",
    "name": "The Concern Inc.",
    "latitude": 40.9231338,
    "longitude": -81.0194348,
    "address": "125 W OHIO AVE",
    "city": "SEBRING",
    "state": "OH",
    "zip_code": "44672",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1055",
    "name": "Middleburg Heights Food Pantry",
    "latitude": 41.379306,
    "longitude": -81.8073928,
    "address": "7000 PAULA DR",
    "city": "MIDDLEBURG HEIGHTS",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1056",
    "name": "Project Hope",
    "latitude": 41.42064286,
    "longitude": -81.67852393,
    "address": "233 TUXEDO AVE",
    "city": "INDEPENDENCE",
    "state": "OH",
    "zip_code": "44131",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1059",
    "name": "Church Street Ministries",
    "latitude": 41.3730097,
    "longitude": -81.8678781,
    "address": "398 W BAGLEY RD",
    "city": "BEREA",
    "state": "OH",
    "zip_code": "44017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1064",
    "name": "Brimfield Community Cupboard",
    "latitude": 41.1001502,
    "longitude": -81.34889,
    "address": "1235 Tallmadge Rd",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1065",
    "name": "Heavenly Kids Daycare",
    "latitude": 39.95612577,
    "longitude": -82.9884208,
    "address": "404 E MOUND ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1066",
    "name": "Iglesia Sinai",
    "latitude": 41.4657336,
    "longitude": -81.6984509,
    "address": "3256 SCRANTON RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1067",
    "name": "Seniors At Hegemon",
    "latitude": 40.01127433,
    "longitude": -82.94624032,
    "address": "2399 MOCK RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1068",
    "name": "New Exodus Christian Fellowship Church",
    "latitude": 41.04300497,
    "longitude": -81.49088103,
    "address": "1063 S Arlington St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1069",
    "name": "Union Baptist Church",
    "latitude": 40.7958243,
    "longitude": -81.3420483,
    "address": "413 Cornelia Ave NE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44704",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1070",
    "name": "Open Door Assembly of God ",
    "latitude": 41.08039629,
    "longitude": -81.492728,
    "address": "745 Upson St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1071",
    "name": "Randolph Suffield Atwater Food Shelf",
    "latitude": 41.0283605,
    "longitude": -81.2967074,
    "address": "2697 Waterloo Rd",
    "city": "Mogadore",
    "state": "OH",
    "zip_code": "44260",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1072",
    "name": "Shaker Heights Community Hunger Center",
    "latitude": 41.46272266,
    "longitude": -81.53844956,
    "address": "20120 LOMOND BLVD",
    "city": "SHAKER HEIGHTS",
    "state": "OH",
    "zip_code": "44122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1074",
    "name": "Santa Paula Foursquare Church",
    "latitude": 34.3523304,
    "longitude": -119.0670336,
    "address": "611 E MAIN ST",
    "city": "SANTA PAULA",
    "state": "CA",
    "zip_code": "93060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1078",
    "name": "St. Mary Magdalene SVDP",
    "latitude": 41.6423862,
    "longitude": -81.4600433,
    "address": "32114 VINE ST",
    "city": "WILLOWICK",
    "state": "OH",
    "zip_code": "44095",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1080",
    "name": "Holy Trinity - St. Vincent de Pauls",
    "latitude": 41.671866,
    "longitude": -83.9115144,
    "address": "2649 US HIGHWAY 20",
    "city": "SWANTON",
    "state": "OH",
    "zip_code": "43558",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1081",
    "name": "West 58th Church of God",
    "latitude": 41.4680875,
    "longitude": -81.7267884,
    "address": "3150 W 58TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1082",
    "name": "St. Johns Health Ministries",
    "latitude": 34.2168381,
    "longitude": -119.1562394,
    "address": "1600 N ROSE AVE",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1083",
    "name": "Samaritan Center - Simi Valley",
    "latitude": 34.263251,
    "longitude": -118.7919844,
    "address": "280 ROYAL AVE",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1085",
    "name": "Lincoln Gardens",
    "latitude": 39.95436903,
    "longitude": -83.13630556,
    "address": "110 STURBRIDGE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1086",
    "name": "Mentor Plains United Methodist Church",
    "latitude": 41.7005561,
    "longitude": -81.3796896,
    "address": "7271 LAKE SHORE BLVD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1087",
    "name": "Greater Bethel A.M.E. Church",
    "latitude": 41.5660776,
    "longitude": -81.5783266,
    "address": "14735 THAMES AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1088",
    "name": "Salvation Army - Oxnard",
    "latitude": 34.1895761,
    "longitude": -119.1842837,
    "address": "622 W WOOLEY RD",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1091",
    "name": "Stratford Place",
    "latitude": 39.94273313,
    "longitude": -83.1391034,
    "address": "383 INAH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1093",
    "name": "THE HELP GROUP AT CHRIST CHURCH",
    "latitude": 35.21812,
    "longitude": -89.8639841,
    "address": "5955 YALE RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38134",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1094",
    "name": "Fairview United Methodist Church Food Pantry",
    "latitude": 39.7869996,
    "longitude": -84.2254818,
    "address": "828 W FAIRVIEW AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1095",
    "name": "Upper Room Food Pantry ",
    "latitude": 40.27356786,
    "longitude": -81.86629223,
    "address": "803 Vine St",
    "city": "COSHOCTON",
    "state": "OH",
    "zip_code": "43812",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1098",
    "name": "Bethany Baptist",
    "latitude": 39.94765118,
    "longitude": -82.95205244,
    "address": "959 BULEN AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1099",
    "name": "Grace United Church of Christ - Canton",
    "latitude": 40.8234686,
    "longitude": -81.3833489,
    "address": "2300 Cleveland Ave NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44709",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1101",
    "name": "Grovewood Place",
    "latitude": 39.87580102,
    "longitude": -83.08205702,
    "address": "4301 STONER DR",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1104",
    "name": "St. Ladislas Church",
    "latitude": 41.46563749,
    "longitude": -81.75560777,
    "address": "10205 LORAIN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1105",
    "name": "FIRST UNITED METHODIST CHURCH - COVINGTON",
    "latitude": 35.56206912,
    "longitude": -89.64816285,
    "address": "145 W CHURCH AVE",
    "city": "COVINGTON",
    "state": "TN",
    "zip_code": "38019",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1109",
    "name": "Salvation Army Mansfield",
    "latitude": 40.757198,
    "longitude": -82.515533,
    "address": "47 S MAIN ST",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44902",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1111",
    "name": "SVDP - St. Julie Billiart",
    "latitude": 34.1809243,
    "longitude": -118.9298786,
    "address": "2475 BORCHARD RD",
    "city": "NEWBURY PARK",
    "state": "CA",
    "zip_code": "91320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1113",
    "name": "South Hills Lend-A-Hand",
    "latitude": 41.3045716,
    "longitude": -81.6802162,
    "address": "9543 BROADVIEW RD",
    "city": "BROADVIEW HEIGHTS",
    "state": "OH",
    "zip_code": "44147",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1114",
    "name": "The Salvation Army (Medina)",
    "latitude": 41.13946245,
    "longitude": -81.87050131,
    "address": "425 W Liberty St",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1116",
    "name": "Our Lady of Lourdes-Hospitality Kitchen",
    "latitude": 41.6378886,
    "longitude": -83.6876465,
    "address": "6149 HILL AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43615",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1118",
    "name": "Marcia Branson Zion Baptist Church Pantry",
    "latitude": 39.35461112,
    "longitude": -83.04716635,
    "address": "536 Mill St",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1122",
    "name": "FIRST CONGREGATIONAL CHURCH",
    "latitude": 35.1184089,
    "longitude": -89.9909034,
    "address": "1000 S COOPER ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1124",
    "name": "Market Place Community Church",
    "latitude": 41.7123255,
    "longitude": -83.556797,
    "address": "5055 Jackman RD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43613",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1125",
    "name": "Bethany Baptist Church",
    "latitude": 41.52256505,
    "longitude": -81.61540003,
    "address": "1211 E 105TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1128",
    "name": "Harrison Hills Market",
    "latitude": 40.2789378,
    "longitude": -81.0043406,
    "address": "12 Court St",
    "city": "CADIZ",
    "state": "OH",
    "zip_code": "43907",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1129",
    "name": "St. Frances Cabrini",
    "latitude": 40.14104733,
    "longitude": -80.83010406,
    "address": "72581 Colerain Road Route 250",
    "city": "COLERAIN",
    "state": "OH",
    "zip_code": "43916",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1130",
    "name": "AIDS Taskforce of Greater Cleveland",
    "latitude": 41.5026704,
    "longitude": -81.6686276,
    "address": "2829 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1131",
    "name": "All Faiths Pantry",
    "latitude": 41.4336955,
    "longitude": -81.7066943,
    "address": "4431 STATE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1132",
    "name": "Avon Avenue Baptist Church",
    "latitude": 41.4511248,
    "longitude": -81.6088035,
    "address": "10902 AVON AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1133",
    "name": "Bay Food Ministry",
    "latitude": 41.4848414,
    "longitude": -81.9002751,
    "address": "25415 LAKE RD",
    "city": "BAY VILLAGE",
    "state": "OH",
    "zip_code": "44140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1134",
    "name": "Beulah Baptist Church of Collinwood",
    "latitude": 41.55979662,
    "longitude": -81.57790482,
    "address": "14912 SARANAC RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1135",
    "name": "Bishop William Cosgrove Center",
    "latitude": 41.5055438,
    "longitude": -81.6803383,
    "address": "1736 SUPERIOR AVE E",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1141",
    "name": "Calvary Presbyterian Church",
    "latitude": 41.50327687,
    "longitude": -81.63360417,
    "address": "2020 E 79TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1142",
    "name": "Christ Presbyterian Church",
    "latitude": 41.53048225,
    "longitude": -81.33454479,
    "address": "12419 CHILLICOTHE RD",
    "city": "CHESTERLAND",
    "state": "OH",
    "zip_code": "44026",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1149",
    "name": "Collinwood Area Church Council",
    "latitude": 41.57418731,
    "longitude": -81.57517549,
    "address": "15220 LAKE SHORE BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1150",
    "name": "Freedom Church",
    "latitude": 41.4538743,
    "longitude": -81.7740691,
    "address": "12401 COOLEY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1152",
    "name": "Denison Avenue United Church of Christ",
    "latitude": 41.46627677,
    "longitude": -81.75231253,
    "address": "9900 DENISON AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1153",
    "name": "Eastlake Kiwanis",
    "latitude": 41.6376529,
    "longitude": -81.4525954,
    "address": "1580 E 332ND ST",
    "city": "EASTLAKE",
    "state": "OH",
    "zip_code": "44095",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1155",
    "name": "Five Pointe Community Center",
    "latitude": 41.5571616,
    "longitude": -81.575138,
    "address": "813 E 152ND ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1157",
    "name": "Fairport Harbor Food Pantry at St. Anthony of Padua",
    "latitude": 41.7515411,
    "longitude": -81.2741162,
    "address": "521 Plum St",
    "city": "Fairport Harbor",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1159",
    "name": "Fr. Mike Wittman Ozanam Center (at Saint Philomena Parish)",
    "latitude": 41.5255774,
    "longitude": -81.5860074,
    "address": "13824 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1164",
    "name": "Evangelistic Missionary Baptist Church",
    "latitude": 34.1505982,
    "longitude": -119.1995257,
    "address": "117 E PEARL ST",
    "city": "PORT HUENEME",
    "state": "CA",
    "zip_code": "93041",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1165",
    "name": "Community Bible Church - Ventura",
    "latitude": 34.2755893,
    "longitude": -119.2266158,
    "address": "5040 TELEGRAPH RD",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1167",
    "name": "Friendly Inn Settlement",
    "latitude": 41.49552602,
    "longitude": -81.65483243,
    "address": "2386 UNWIN RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1168",
    "name": "Garfield Heights Senior Center",
    "latitude": 41.4161116,
    "longitude": -81.6035014,
    "address": "5407 TURNEY RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1170",
    "name": "Grace Episcopal Church",
    "latitude": 40.7597133,
    "longitude": -82.5230952,
    "address": "41 BOWMAN ST",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1174",
    "name": "Harvard Community Service Center",
    "latitude": 41.4490441,
    "longitude": -81.5509847,
    "address": "18240 HARVARD AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1176",
    "name": "Holy Family Food Pantry",
    "latitude": 41.3659209,
    "longitude": -81.7591357,
    "address": "7367 YORK RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1177",
    "name": "Iglesia Nueva Vida - Free Methodist Church",
    "latitude": 41.4663731,
    "longitude": -81.6990357,
    "address": "2327 HOLMDEN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1178",
    "name": "Lakewood Community Services Center",
    "latitude": 41.4772473,
    "longitude": -81.7931199,
    "address": "14230 MADISON AVE",
    "city": "LAKEWOOD",
    "state": "OH",
    "zip_code": "44107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1180",
    "name": "Lucas Area Helping Hands",
    "latitude": 40.71833061,
    "longitude": -82.38224065,
    "address": "4065 MOUNT ZION RD",
    "city": "LUCAS",
    "state": "OH",
    "zip_code": "44843",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1181",
    "name": "Mt. Nebo Missionary Baptist",
    "latitude": 41.52315934,
    "longitude": -81.59398491,
    "address": "12919 Superior Ave.",
    "city": "EAST CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1182",
    "name": "New Covenant Lutheran Church",
    "latitude": 41.5393095,
    "longitude": -81.58699,
    "address": "1424 HAYDEN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1185",
    "name": "New Life Gospel Center",
    "latitude": 41.481168,
    "longitude": -81.610308,
    "address": "2856 MARTIN LUTHER KING JR DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1186",
    "name": "New Sardis Primitive Baptist",
    "latitude": 41.4649423,
    "longitude": -81.5792043,
    "address": "3474 E 147TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1187",
    "name": "Open Door Missionary Baptist",
    "latitude": 41.4885805,
    "longitude": -81.6305568,
    "address": "8215 WOODLAND AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1189",
    "name": "Parma Hunger Center",
    "latitude": 41.41672844,
    "longitude": -81.69477506,
    "address": "5280 BROADVIEW RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44134",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1190",
    "name": "Redeemer Crisis Center",
    "latitude": 41.4715583,
    "longitude": -81.7017629,
    "address": "2970 W 30TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1194",
    "name": "Newbury United Community Church",
    "latitude": 41.4616166,
    "longitude": -81.24478563,
    "address": "14916 AUBURN RD",
    "city": "NEWBURY",
    "state": "OH",
    "zip_code": "44065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1195",
    "name": "Nueva Luz Urban Resource Center",
    "latitude": 41.47106296,
    "longitude": -81.74510091,
    "address": "8901 Willard Avenue",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1196",
    "name": "Salvation Army - Painesville",
    "latitude": 41.7202424,
    "longitude": -81.2402517,
    "address": "69 PEARL ST",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1198",
    "name": "Westside Food Ministries",
    "latitude": 41.46940935,
    "longitude": -81.74317424,
    "address": "27650 Center Ridge Rd",
    "city": "Westlake",
    "state": "OH",
    "zip_code": "44145",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1199",
    "name": "Southeast Clergy Council Center",
    "latitude": 41.4049218,
    "longitude": -81.5264184,
    "address": "415 NORTHFIELD RD",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1200",
    "name": "St. Aloysius Church",
    "latitude": 41.5400398,
    "longitude": -81.6095995,
    "address": "10932 SAINT CLAIR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1204",
    "name": "St. Catherine Church",
    "latitude": 41.4652576,
    "longitude": -81.6199369,
    "address": "9412 HEATH AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1205",
    "name": "St. James Food Closet",
    "latitude": 41.5003318,
    "longitude": -81.6283621,
    "address": "8401 CEDAR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1207",
    "name": "St. Leo the Great",
    "latitude": 41.42197764,
    "longitude": -81.69609449,
    "address": "4940 BROADVIEW RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1208",
    "name": "St. Mark's Baptist Church",
    "latitude": 41.4818655,
    "longitude": -81.6075456,
    "address": "11123 BUCKEYE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1209",
    "name": "St. Mary's Painesville Food Pantry",
    "latitude": 41.7304429,
    "longitude": -81.2440389,
    "address": "242 N STATE ST",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1218",
    "name": "The Salvation Army (Ravenna) DD2",
    "latitude": 41.1383886,
    "longitude": -81.3223524,
    "address": "1972 Summit Road",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1220",
    "name": "The Salvation Army (Ravenna)",
    "latitude": 41.1579124,
    "longitude": -81.2459884,
    "address": "268 W Main St",
    "city": "Ravenna",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1223",
    "name": "The Salvation Army (Windham)",
    "latitude": 41.2362896,
    "longitude": -81.0372041,
    "address": "9005 Wilverne Dr",
    "city": "Windham",
    "state": "OH",
    "zip_code": "44288",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1224",
    "name": "The Salvation Army (Windham) DD",
    "latitude": 41.2362896,
    "longitude": -81.0372041,
    "address": "9005 Wilverne Dr",
    "city": "Windham",
    "state": "OH",
    "zip_code": "44288",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1228",
    "name": "Somis Pantry",
    "latitude": 34.2558008,
    "longitude": -118.998655,
    "address": "3300 West St.",
    "city": "SOMIS",
    "state": "CA",
    "zip_code": "93066",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1229",
    "name": "Camarillo Community Church",
    "latitude": 34.22049776,
    "longitude": -119.04309796,
    "address": "379 MOBIL AVE",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1230",
    "name": "Christian Church of Thousand Oaks",
    "latitude": 34.21268604,
    "longitude": -118.88528072,
    "address": "301 W AVENIDA DE LAS FLORES",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91360",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1231",
    "name": "SDA- Camarillo",
    "latitude": 34.2427838,
    "longitude": -119.0159208,
    "address": "3975 LAS POSAS RD",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1232",
    "name": "Mid-Ohio Market at St. Stephens Community House",
    "latitude": 40.00011008,
    "longitude": -82.96932606,
    "address": "1500 E 17TH AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1233",
    "name": "SVDP - St. Thomas Aquinas",
    "latitude": 34.4452804,
    "longitude": -119.272606,
    "address": "185 SAINT THOMAS DR",
    "city": "OJAI",
    "state": "CA",
    "zip_code": "93023",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1235",
    "name": "Elizabeth Baptist Church",
    "latitude": 41.4783576,
    "longitude": -81.6476717,
    "address": "6114 FRANCIS AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1236",
    "name": "Plymouth Shiloh Food Pantry",
    "latitude": 40.93512,
    "longitude": -82.50798,
    "address": "26 Reat Mechanic Street",
    "city": "SHILOH",
    "state": "OH",
    "zip_code": "44878",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1237",
    "name": "Focus Community Development Corp",
    "latitude": 41.0489153,
    "longitude": -81.5183667,
    "address": "1241 Grant St",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1238",
    "name": "Wesley United Methodist (Toledo)",
    "latitude": 41.677266,
    "longitude": -83.5263303,
    "address": "2934 STICKNEY AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1245",
    "name": "Chagrin Falls Park Community Center",
    "latitude": 41.41450497,
    "longitude": -81.38876932,
    "address": "7060 WOODLAND AVE",
    "city": "CHAGRIN FALLS",
    "state": "OH",
    "zip_code": "44023",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1252",
    "name": "Bryan Wesley United Methodist Church",
    "latitude": 41.46408641,
    "longitude": -84.56441333,
    "address": "903 CENTER ST",
    "city": "BRYAN",
    "state": "OH",
    "zip_code": "43506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1254",
    "name": "Bucyrus Christian Center New Day Ministries",
    "latitude": 40.8063782,
    "longitude": -82.9719676,
    "address": "133 North Sandusky Street",
    "city": "BUCYRUS",
    "state": "OH",
    "zip_code": "44820",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1257",
    "name": "St. Vincent de Paul-Immaculate Conception",
    "latitude": 41.5117913,
    "longitude": -82.94480795,
    "address": "129 MAPLE ST.",
    "city": "PORT CLINTON",
    "state": "OH",
    "zip_code": "43452",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1262",
    "name": "St Jude Helping Hands Food Pantry",
    "latitude": 41.38191772,
    "longitude": -82.08622254,
    "address": "590 POPLAR ST",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1263",
    "name": "N.W.O. Community Action-Richland PATH Center",
    "latitude": 41.2817531,
    "longitude": -84.3250669,
    "address": "1939 E 2ND ST",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1264",
    "name": "Spirit of Santa Paula",
    "latitude": 34.3542274,
    "longitude": -119.0610339,
    "address": "1498 Harvard ST",
    "city": "SANTA PAULA",
    "state": "CA",
    "zip_code": "93060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1265",
    "name": "Salvation Army Lancaster",
    "latitude": 39.70315611,
    "longitude": -82.60379648,
    "address": "228 W HUBERT AVE",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1266",
    "name": "Friendship Alliance Church",
    "latitude": 41.35031488,
    "longitude": -81.22383692,
    "address": "19126 RAVENNA RD",
    "city": "CHAGRIN FALLS",
    "state": "OH",
    "zip_code": "44023",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1268",
    "name": "Project Hope at St. Columba's Episcopal Church",
    "latitude": 34.2338133,
    "longitude": -119.0553219,
    "address": "1251 LAS POSAS RD",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1269",
    "name": "Vermilion Salvation Army",
    "latitude": 41.4258153,
    "longitude": -82.3469565,
    "address": "4560 LIBERTY AVE",
    "city": "VERMILION",
    "state": "OH",
    "zip_code": "44089",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1270",
    "name": "Oxnard Community Food Pantry",
    "latitude": 34.2019742,
    "longitude": -119.180688,
    "address": "144 S C ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1273",
    "name": "New Heart Foursquare Church",
    "latitude": 34.2930835,
    "longitude": -118.7138699,
    "address": "4200 TOWNSHIP AVE",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93063",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1274",
    "name": "St. Leo Church Pantry",
    "latitude": 39.1339379,
    "longitude": -84.5577184,
    "address": "2573 SAINT LEO PL",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45225",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1275",
    "name": "Old South United COC",
    "latitude": 41.6042803,
    "longitude": -81.3500251,
    "address": "9802 CHILLICOTHE RD",
    "city": "WILLOUGHBY",
    "state": "OH",
    "zip_code": "44094",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1276",
    "name": "New Beginnings Christian Center",
    "latitude": 39.9070897,
    "longitude": -82.8804977,
    "address": "3424 S HAMILTON RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1279",
    "name": "Coburn UMC Food Pantry",
    "latitude": 39.9905122,
    "longitude": -82.02269461,
    "address": "3618 MAPLE AVE",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1282",
    "name": "St. Paul Missionary Baptist Church",
    "latitude": 41.03536814,
    "longitude": -81.49683766,
    "address": "1350 Virginia Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1286",
    "name": "St. Luke’s Episcopal Church",
    "latitude": 41.48441563,
    "longitude": -81.73842232,
    "address": "1349 W 78TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1287",
    "name": "Salvation Army Cambridge",
    "latitude": 40.02337769,
    "longitude": -81.59683344,
    "address": "221 DEWEY AVE",
    "city": "CAMBRIDGE",
    "state": "OH",
    "zip_code": "43725",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1290",
    "name": "Main Ave UMC Food Pantry",
    "latitude": 39.97009016,
    "longitude": -81.53590868,
    "address": "223 MAIN ST",
    "city": "BYESVILLE",
    "state": "OH",
    "zip_code": "43723",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1291",
    "name": "Warren Family Mission",
    "latitude": 41.2348033,
    "longitude": -80.8292413,
    "address": "155 TOD AVE NW",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44485",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1292",
    "name": "Welcome Home",
    "latitude": 39.945666,
    "longitude": -82.9636971,
    "address": "995 LOCKBOURNE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1293",
    "name": "Catholic Charities Family Center of Lorain",
    "latitude": 41.4453984,
    "longitude": -82.1607173,
    "address": "2726 Caroline Ave",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1294",
    "name": "The Salvation Army (Massillon)",
    "latitude": 40.7915432,
    "longitude": -81.5297907,
    "address": "315 6th St NE",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1297",
    "name": "Mt. Zion Community Church",
    "latitude": 40.7416962,
    "longitude": -81.3407475,
    "address": "2637 Baum St SE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44707",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1300",
    "name": "Woodsfield Manna, SOMA",
    "latitude": 39.75899112,
    "longitude": -81.11799853,
    "address": "303 S MAIN ST",
    "city": "WOODSFIELD",
    "state": "OH",
    "zip_code": "43793",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1301",
    "name": "Avon Lake Community Resource Services",
    "latitude": 41.5034911,
    "longitude": -82.0494951,
    "address": "33479 Lake Road – Suite C",
    "city": "AVON LAKE",
    "state": "OH",
    "zip_code": "44012",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1302",
    "name": "Calvary Community Church",
    "latitude": 34.15207824,
    "longitude": -118.80820054,
    "address": "5495 VIA ROCAS",
    "city": "WESTLAKE VILLAGE",
    "state": "CA",
    "zip_code": "91362",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1304",
    "name": "Valley Family Church",
    "latitude": 42.23839782,
    "longitude": -85.62017164,
    "address": "2500 VINCENT AVE",
    "city": "PORTAGE",
    "state": "MI",
    "zip_code": "49024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1316",
    "name": "Plain City Food Pantry",
    "latitude": 40.10359585,
    "longitude": -83.29135919,
    "address": "11100 Lafayette-Plain City Rd",
    "city": "PLAIN CITY",
    "state": "OH",
    "zip_code": "43064",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1322",
    "name": "Refuge Church",
    "latitude": 41.37972902,
    "longitude": -82.15089234,
    "address": "7942 MURRAY RIDGE RD",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1324",
    "name": "Community Pentecostal Worship Center - Ignited Missions",
    "latitude": 39.6490307,
    "longitude": -84.3395635,
    "address": "8501 DAYTON GERMANTOWN PIKE",
    "city": "GERMANTOWN",
    "state": "OH",
    "zip_code": "45327",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1325",
    "name": "Helping Hands Food Pantry",
    "latitude": 41.58561347,
    "longitude": -84.61001347,
    "address": "309 W WASHINGTON ST",
    "city": "MONTPELIER",
    "state": "OH",
    "zip_code": "43543",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1327",
    "name": "Corban Commons MMK",
    "latitude": 40.0217766,
    "longitude": -82.9211319,
    "address": "3426 CORBAN COMMONS DR",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1329",
    "name": "North Canton Church of Christ",
    "latitude": 40.875347,
    "longitude": -81.3823955,
    "address": "1301 E Maple St",
    "city": "North Canton",
    "state": "OH",
    "zip_code": "44720",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1341",
    "name": "Metamora United Methodist Church",
    "latitude": 41.7115003,
    "longitude": -83.90991933,
    "address": "116 E. Main St.",
    "city": "METAMORA",
    "state": "OH",
    "zip_code": "43540",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1342",
    "name": "The University Church",
    "latitude": 41.6380582,
    "longitude": -83.6542134,
    "address": "4747 HILL AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43615",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1343",
    "name": "Salvation Army Marion",
    "latitude": 40.58694577,
    "longitude": -83.13669622,
    "address": "317 W CHURCH ST",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1344",
    "name": "SDA Community Service Chillicothe",
    "latitude": 39.3405122,
    "longitude": -82.9944428,
    "address": "510 METZGER AVE",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1352",
    "name": "Elyria Hospitality Center",
    "latitude": 41.3652702,
    "longitude": -82.10529075,
    "address": "244 3RD ST",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1353",
    "name": "County Line Church of the Brethren",
    "latitude": 40.8017546,
    "longitude": -83.8801656,
    "address": "4227 N HARDIN RD",
    "city": "HARROD",
    "state": "OH",
    "zip_code": "45850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1354",
    "name": "Community Action of Ventura",
    "latitude": 34.1958088,
    "longitude": -119.1703126,
    "address": "621 RICHMOND AVE",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1355",
    "name": "The Marketplace Movement",
    "latitude": 39.7507519,
    "longitude": -84.2439822,
    "address": "3320 W 3RD ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1358",
    "name": "FIRST UNITED METHODIST CHURCH, RIPLEY, TN",
    "latitude": 35.74403363,
    "longitude": -89.52991643,
    "address": "145 S MAIN ST",
    "city": "RIPLEY",
    "state": "TN",
    "zip_code": "38063",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1359",
    "name": "Our Lady Queen of Peace",
    "latitude": 41.27692761,
    "longitude": -82.06008949,
    "address": "708 ERIE ST",
    "city": "GRAFTON",
    "state": "OH",
    "zip_code": "44044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1360",
    "name": "Central Baptist Church",
    "latitude": 39.9195632,
    "longitude": -83.0546093,
    "address": "1955 FRANK RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1361",
    "name": "Barnesville Mobile Market",
    "latitude": 39.98913313,
    "longitude": -81.1771687,
    "address": "300 W CHURCH ST",
    "city": "BARNESVILLE",
    "state": "OH",
    "zip_code": "43713",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1362",
    "name": "Bethesda Mobile Market",
    "latitude": 40.0185289,
    "longitude": -81.07400753,
    "address": "40601 Bethesda Belmont Rd",
    "city": "BETHESDA",
    "state": "OH",
    "zip_code": "43719",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1364",
    "name": "Open Door Fellowship FP",
    "latitude": 39.29503206,
    "longitude": -82.94938889,
    "address": "3130 S BRIDGE ST",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1366",
    "name": "Musicians Towers",
    "latitude": 41.5088584,
    "longitude": -81.5825304,
    "address": "2727 LANCASHIRE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1377",
    "name": "Salvation Army Milan Service Unit",
    "latitude": 41.297084,
    "longitude": -82.6061901,
    "address": "4 W CHURCH ST",
    "city": "MILAN",
    "state": "OH",
    "zip_code": "44846",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1383",
    "name": "Eastside Grace Brethen",
    "latitude": 39.98659456,
    "longitude": -82.79507788,
    "address": "7510 E BROAD ST",
    "city": "BLACKLICK",
    "state": "OH",
    "zip_code": "43004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1384",
    "name": "Salvation Army",
    "latitude": 39.9245115,
    "longitude": -83.8179083,
    "address": "15 S PLUM ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1391",
    "name": "Catholic Charities of SW Ohio",
    "latitude": 39.191352,
    "longitude": -84.4612291,
    "address": "7162 READING RD",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1392",
    "name": "Park Layne United Brethren",
    "latitude": 39.8885234,
    "longitude": -84.0381972,
    "address": "1320 STYER DR",
    "city": "NEW CARLISLE",
    "state": "OH",
    "zip_code": "45344",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1393",
    "name": "Lao Volunteer Donation Association",
    "latitude": 39.9462326,
    "longitude": -82.9443191,
    "address": "1072 ALUM CREEK DR",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43209",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1395",
    "name": "MCNAIRY CO LOAVES",
    "latitude": 35.16862812,
    "longitude": -88.59260029,
    "address": "161 S FRONT ST",
    "city": "SELMER",
    "state": "TN",
    "zip_code": "38375",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1396",
    "name": "St. Vincent de Paul (Corning)",
    "latitude": 39.6076145,
    "longitude": -82.0883127,
    "address": "203 Adams St.",
    "city": "CORNING",
    "state": "OH",
    "zip_code": "43730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1397",
    "name": "Beallsville Mobile Market",
    "latitude": 39.851692,
    "longitude": -81.09652323,
    "address": "52753 Washington St",
    "city": "Beallsville",
    "state": "OH",
    "zip_code": "43716",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1398",
    "name": "Divine Destiny Christian Fellowship",
    "latitude": 41.38348497,
    "longitude": -82.12153202,
    "address": "223 CLINTON AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1400",
    "name": "The Salvation Army Elyria Corps",
    "latitude": 41.36752719,
    "longitude": -82.11263735,
    "address": "716 BROAD ST",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1404",
    "name": "St Albert the Great Parish",
    "latitude": 41.32195715,
    "longitude": -81.73315067,
    "address": "6667 WALLINGS RD",
    "city": "NORTH ROYALTON",
    "state": "OH",
    "zip_code": "44133",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1405",
    "name": "Lift Up Vikes!  Resource Center and Food Pantry",
    "latitude": 41.5021998,
    "longitude": -81.6753122,
    "address": "2121 Euclid Avenue RC 168",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1406",
    "name": "Central Christian Church FP",
    "latitude": 40.38515246,
    "longitude": -82.43096598,
    "address": "17833 GAMBIER RD",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1407",
    "name": "NEW TYLER A.M.E",
    "latitude": 35.1497158,
    "longitude": -89.9511457,
    "address": "3300 SUMMER AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1417",
    "name": "Fillmore Police Storefront",
    "latitude": 34.404127,
    "longitude": -118.9250299,
    "address": "642 Lemon Way",
    "city": "FILLMORE",
    "state": "CA",
    "zip_code": "93015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1419",
    "name": "Holton Recreation Center",
    "latitude": 39.9622596,
    "longitude": -83.0687742,
    "address": "303 N EUREKA AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1420",
    "name": "South Euclid United Church of Christ",
    "latitude": 41.535309,
    "longitude": -81.5288479,
    "address": "4217 BLUESTONE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1423",
    "name": "St. John's Lutheran Church New Washington",
    "latitude": 40.9622053,
    "longitude": -82.8520039,
    "address": "203 E MANSFIELD ST",
    "city": "NEW WASHINGTON",
    "state": "OH",
    "zip_code": "44854",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1432",
    "name": "Good Shepherd Baptist Church Amherst",
    "latitude": 41.40463858,
    "longitude": -82.21103494,
    "address": "1100 CLEVELAND AVE",
    "city": "AMHERST",
    "state": "OH",
    "zip_code": "44001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1436",
    "name": "Crossroads, Greater Ohio Volunteers of America",
    "latitude": 41.43750071,
    "longitude": -82.74342318,
    "address": "1843 Superior Street",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1439",
    "name": "Veteran Food Pantry",
    "latitude": 40.742828,
    "longitude": -84.1172849,
    "address": "810 W NORTH ST",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1440",
    "name": "Abington Arms",
    "latitude": 41.5091081,
    "longitude": -81.6027809,
    "address": "11501 MAYFIELD RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1443",
    "name": "Samaritan House of Noble County",
    "latitude": 39.74678213,
    "longitude": -81.5151146,
    "address": "307 MAIN ST",
    "city": "CALDWELL",
    "state": "OH",
    "zip_code": "43724",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1447",
    "name": "Greater Marietta Community Food Pantry",
    "latitude": 39.4154916,
    "longitude": -81.4567684,
    "address": "635C SR 821, Complex 1, Building 3",
    "city": "MARIETTA",
    "state": "OH",
    "zip_code": "45750",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1454",
    "name": "Feddersen Recreation Center",
    "latitude": 40.0472623,
    "longitude": -82.9703623,
    "address": "3911 DRESDEN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1458",
    "name": "Community of Faith Assembly",
    "latitude": 41.4661694,
    "longitude": -81.6478125,
    "address": "5949 ENGEL AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1462",
    "name": "Scioto Southland Recreation Center",
    "latitude": 39.8830025,
    "longitude": -82.9895596,
    "address": "3901 PARSONS AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1463",
    "name": "Howard Recreation Center",
    "latitude": 40.0221045,
    "longitude": -82.9307087,
    "address": "2505 N CASSADY AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1464",
    "name": "Fillmore Church of Christ",
    "latitude": 34.3978922,
    "longitude": -118.9086895,
    "address": "219 MOUNTAIN VIEW ST",
    "city": "FILLMORE",
    "state": "CA",
    "zip_code": "93015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1465",
    "name": "COGASOC Food Pantry",
    "latitude": 39.9314909,
    "longitude": -82.0131353,
    "address": "528 CLIFFWOOD AVE",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1467",
    "name": "Unity Temple",
    "latitude": 39.9255,
    "longitude": -82.9938737,
    "address": "161 N Hamilton road",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1468",
    "name": "Gates Mills",
    "latitude": 41.5223731,
    "longitude": -81.4352247,
    "address": "6755 MAYFIELD RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44124",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1469",
    "name": "Euclid Beach Club",
    "latitude": 41.58110487,
    "longitude": -81.5719678,
    "address": "123 E 156TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1473",
    "name": "Owl's Nest",
    "latitude": 41.5349474,
    "longitude": -81.5707642,
    "address": "2020 TAYLOR RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1474",
    "name": "Euclid Hill Villa",
    "latitude": 41.58559002,
    "longitude": -81.50074714,
    "address": "100 RICHMOND RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44143",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1481",
    "name": "Lorain Lighthouse UMC",
    "latitude": 41.44035055,
    "longitude": -82.20980173,
    "address": "3015 MEISTER RD",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44053",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1483",
    "name": "Flushing Ministerial Association Pantry",
    "latitude": 40.15258289,
    "longitude": -81.04888082,
    "address": "427 HIGH ST",
    "city": "FLUSHING",
    "state": "OH",
    "zip_code": "43977",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1485",
    "name": "HOPE The Food Pantry of New Orleans",
    "latitude": 30.0537117,
    "longitude": -89.9473597,
    "address": "13150 I 10 SERVICE RD",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1487",
    "name": "YWCA Dayton",
    "latitude": 39.75921406,
    "longitude": -84.19429801,
    "address": "141 W 3RD ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1493",
    "name": "Broadmoor Food Pantry at Gloria Dei",
    "latitude": 29.9494118,
    "longitude": -90.1042731,
    "address": "2021 S DUPRE ST",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1494",
    "name": "Dorothy B. Watson Community Center",
    "latitude": 29.9749135,
    "longitude": -90.2170045,
    "address": "1300 S MYRTLE ST",
    "city": "METAIRIE",
    "state": "LA",
    "zip_code": "70003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1507",
    "name": "We Care Food Pantry",
    "latitude": 39.9316615,
    "longitude": -82.0173844,
    "address": "535 MUNSON AVE",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1512",
    "name": "Ephesus SDA",
    "latitude": 40.034678,
    "longitude": -82.9319473,
    "address": "3650 SUNBURY RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1515",
    "name": "St. Peter Claver Church",
    "latitude": 34.2783054,
    "longitude": -118.6812475,
    "address": "2380 Stow St.",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93063",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1517",
    "name": "Christ Lutheran Church",
    "latitude": 41.42811075,
    "longitude": -82.12474458,
    "address": "4501 CLINTON AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1521",
    "name": "Olivet Institutional Baptist Church",
    "latitude": 41.49333816,
    "longitude": -81.6267357,
    "address": "8712 QUINCY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1528",
    "name": "Basics Needs at Albany Baptist Church",
    "latitude": 39.2255225,
    "longitude": -82.20266856,
    "address": "5331 STATE ST",
    "city": "ALBANY",
    "state": "OH",
    "zip_code": "45710",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1531",
    "name": "Church of the Nazarene - Oxnard",
    "latitude": 34.1831506,
    "longitude": -119.1771958,
    "address": "1630 SAVIERS RD",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1532",
    "name": "Shepherd Of The Valley",
    "latitude": 34.279355,
    "longitude": -118.7134045,
    "address": "4191 COCHRAN ST",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93063",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1536",
    "name": "Adams Community Recreation Center",
    "latitude": 39.9885512,
    "longitude": -82.9237591,
    "address": "854 ALTON AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1537",
    "name": "Jubilee Food Pantry",
    "latitude": 40.1073013,
    "longitude": -82.0200621,
    "address": "10516 Frazeysburg Rd",
    "city": "DRESDEN",
    "state": "OH",
    "zip_code": "43821",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1540",
    "name": "The Salvation Army Lorain Corps",
    "latitude": 41.44783089,
    "longitude": -82.16553851,
    "address": "2506 BROADWAY",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1541",
    "name": "Resurrection Evangelical Lutheran Church",
    "latitude": 40.0229603,
    "longitude": -83.159605,
    "address": "3500 MAIN ST",
    "city": "HILLIARD",
    "state": "OH",
    "zip_code": "43026",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1544",
    "name": "Cleveland Chesed Center",
    "latitude": 41.50787229,
    "longitude": -81.55591242,
    "address": "1898 S TAYLOR RD",
    "city": "CLEVELAND HEIGHTS",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1557",
    "name": "Ohio Serving Humanity Food Pantry",
    "latitude": 40.024178,
    "longitude": -82.9650106,
    "address": "2234 Mock Road",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1560",
    "name": "The Salvation Army - Sandusky Corps",
    "latitude": 41.4204602,
    "longitude": -82.6908647,
    "address": "3333 COLUMBUS AVE",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1563",
    "name": "Glad Tidings/Dorcas Room Ministry",
    "latitude": 30.19537984,
    "longitude": -93.19753206,
    "address": "3400 TEXAS ST",
    "city": "LAKE CHARLES",
    "state": "LA",
    "zip_code": "70607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1565",
    "name": "Gahanna Residents in Need",
    "latitude": 40.0184195,
    "longitude": -82.8760348,
    "address": "161 GRANVILLE ST",
    "city": "GAHANNA",
    "state": "OH",
    "zip_code": "43230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1571",
    "name": "With God's Grace - Montgomery",
    "latitude": 39.7689149,
    "longitude": -84.1546289,
    "address": "622 SPRINGFIELD ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45403",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1572",
    "name": "Linden Recreation Center ",
    "latitude": 40.0169701,
    "longitude": -82.97659,
    "address": "1254 BRIARWOOD AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1573",
    "name": "Barnett Recreation Center",
    "latitude": 39.9476633,
    "longitude": -82.9054836,
    "address": "1184 BARNETT RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1577",
    "name": "With God's Grace - Greene",
    "latitude": 39.7689149,
    "longitude": -84.1546289,
    "address": "622 SPRINGFIELD ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45403",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1581",
    "name": "Aspire Church (Christ Cathedral)",
    "latitude": 39.7697783,
    "longitude": -84.1936719,
    "address": "51 BEST ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45405",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1588",
    "name": "Maize Manor UMC",
    "latitude": 40.0452496,
    "longitude": -82.9893254,
    "address": "3901 MAIZE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1593",
    "name": "Maple Hts Senior Development Inc.",
    "latitude": 41.40076877,
    "longitude": -81.56949333,
    "address": "16029 MAPLE PARK DR",
    "city": "MAPLE HEIGHTS",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1594",
    "name": "NORA Northern Ohio Recovery",
    "latitude": 41.4667952,
    "longitude": -81.7369436,
    "address": "3201 W 73RD ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1595",
    "name": "Norwalk Baptist Church",
    "latitude": 41.24892285,
    "longitude": -82.51791443,
    "address": "2084 US HIGHWAY 20  W",
    "city": "NORWALK",
    "state": "OH",
    "zip_code": "44857",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1596",
    "name": "St. Peter Claver Church",
    "latitude": 29.9676229,
    "longitude": -90.0727898,
    "address": "1831 SAINT PHILIP ST",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70116",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1599",
    "name": "Redeemer Lutheran Church",
    "latitude": 41.6565314,
    "longitude": -83.5881741,
    "address": "1702 UPTON AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1600",
    "name": "Elliston Zion United Methodist Church",
    "latitude": 41.54886121,
    "longitude": -83.28059972,
    "address": "18045 W WILLIAM ST",
    "city": "GRAYTOWN",
    "state": "OH",
    "zip_code": "43432",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1601",
    "name": "Food For Thought",
    "latitude": 41.6526522,
    "longitude": -83.5334961,
    "address": "3350 Hill Ave",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1602",
    "name": "Sylvania Area Family Services",
    "latitude": 41.7200298,
    "longitude": -83.6742081,
    "address": "5440 MARSHALL RD",
    "city": "SYLVANIA",
    "state": "OH",
    "zip_code": "43560",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1608",
    "name": "Church of Jesus Christ Mount Moriah",
    "latitude": 41.4738415,
    "longitude": -81.7514314,
    "address": "9807 CUDELL AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1611",
    "name": "Mt. Calvary Baptist Church Food Pantry",
    "latitude": 30.0020029,
    "longitude": -91.8215458,
    "address": "418 JULIA ST",
    "city": "NEW IBERIA",
    "state": "LA",
    "zip_code": "70560",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1613",
    "name": "MMK Physicans Free Clinic - PCC",
    "latitude": 39.9593218,
    "longitude": -82.9808238,
    "address": "240 PARSONS AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1614",
    "name": "SVDP/Immaculate Conception Food Pantry",
    "latitude": 41.0466016,
    "longitude": -81.56139536,
    "address": "2101 17th St SW",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44314",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1615",
    "name": "SVDP/Fr. Hilkert Ozanam Center",
    "latitude": 41.07335033,
    "longitude": -81.4871991,
    "address": "93 Kent St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1617",
    "name": "River of Life",
    "latitude": 39.03177292,
    "longitude": -82.11150919,
    "address": "37032 State Route 124 ",
    "city": "MIDDLEPORT",
    "state": "OH",
    "zip_code": "45760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1619",
    "name": "Beach Side Fellowship",
    "latitude": 34.14867631,
    "longitude": -119.19812799,
    "address": "250 MARKET ST",
    "city": "PORT HUENEME",
    "state": "CA",
    "zip_code": "93041",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1625",
    "name": "Our Community Hunger Center",
    "latitude": 41.31224596,
    "longitude": -81.43866754,
    "address": "9733 Ravenna Rd",
    "city": "Twinsburg",
    "state": "OH",
    "zip_code": "44087",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1626",
    "name": "Malvern Christian Care Center, Inc",
    "latitude": 40.68871789,
    "longitude": -81.17202309,
    "address": "715 E Porter St",
    "city": "Malvern",
    "state": "OH",
    "zip_code": "44644",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1627",
    "name": "MedWish Medworks",
    "latitude": 41.5083873,
    "longitude": -81.4981257,
    "address": "1625 E 31st Street",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44124",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1629",
    "name": "Central Bible Baptist Church",
    "latitude": 41.536503,
    "longitude": -81.5529574,
    "address": "2285 NOBLE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1630",
    "name": "SE Perry Food Pantry",
    "latitude": 39.60290079,
    "longitude": -82.08631725,
    "address": "115 South Corning Ave",
    "city": "CORNING",
    "state": "OH",
    "zip_code": "43730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1631",
    "name": "Islamic Center of Cleveland",
    "latitude": 41.3988903,
    "longitude": -81.78157701,
    "address": "6055 W 130th St Parma",
    "city": "MIDDLEBURG HGTS",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1632",
    "name": "St. Innocent Orthodox Church",
    "latitude": 41.3681363,
    "longitude": -81.9099886,
    "address": "8526 USHER RD",
    "city": "OLMSTED TWP",
    "state": "OH",
    "zip_code": "44138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1633",
    "name": "Emmanuel Christian Church",
    "latitude": 41.5204416,
    "longitude": -81.6305356,
    "address": "8201 SUPERIOR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1637",
    "name": "Steadfast Church",
    "latitude": 39.8727765,
    "longitude": -83.1011493,
    "address": "4500 BROADWAY",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1638",
    "name": "St. Mary Magdalen Christian Service Center",
    "latitude": 29.97677467,
    "longitude": -92.12863381,
    "address": "701 CHEVIS ST",
    "city": "ABBEVILLE",
    "state": "LA",
    "zip_code": "70510",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1641",
    "name": "First Congregational Church of Elyria",
    "latitude": 41.36648074,
    "longitude": -82.10717364,
    "address": "330 2ND ST",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1644",
    "name": "First Church of Christ",
    "latitude": 40.83274785,
    "longitude": -80.5401514,
    "address": "20 W. Main",
    "city": "EAST PALESTINE",
    "state": "OH",
    "zip_code": "44413",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1645",
    "name": "Redeemer Lutheran Church",
    "latitude": 41.3973331,
    "longitude": -81.8033726,
    "address": "6151 SMITH RD",
    "city": "BROOKPARK",
    "state": "OH",
    "zip_code": "44142",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1653",
    "name": "The Dwelling Place",
    "latitude": 41.6245034,
    "longitude": -83.7379349,
    "address": "8201 ANGOLA RD",
    "city": "HOLLAND",
    "state": "OH",
    "zip_code": "43528",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1654",
    "name": "Hope Food Pantry",
    "latitude": 40.043226,
    "longitude": -82.928286,
    "address": "3360 PATRIOT BLVD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1656",
    "name": "Jesus House Cleveland",
    "latitude": 41.5694206,
    "longitude": -81.539445,
    "address": "1465 DILLE RD",
    "city": "EUCLID",
    "state": "OH",
    "zip_code": "44117",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1659",
    "name": "Crestline Assistance and Ministries Program",
    "latitude": 40.7795271,
    "longitude": -82.730888,
    "address": "464 East Livingston Ave",
    "city": "CRESTLINE",
    "state": "OH",
    "zip_code": "44827",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1660",
    "name": "Joint Organization for Inner-City Needs (JOIN)",
    "latitude": 39.9580916,
    "longitude": -82.9838958,
    "address": "578 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1662",
    "name": "San Salvador Mission - Piru",
    "latitude": 34.41556232,
    "longitude": -118.78941262,
    "address": "4053 Center St.",
    "city": "PIRU",
    "state": "CA",
    "zip_code": "93040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1663",
    "name": "Lakemore Methodist Church Food Pantry",
    "latitude": 41.01913735,
    "longitude": -81.4329468,
    "address": "1536 Flickinger Rd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44312",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1665",
    "name": "GREATER HARVEST FOOD PANTRY",
    "latitude": 35.0526309,
    "longitude": -89.9024063,
    "address": "3509 BOXDALE ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1666",
    "name": "Changing Lives Ministries",
    "latitude": 41.5426091,
    "longitude": -81.595672,
    "address": "12651 SAINT CLAIR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1673",
    "name": "Family Resource Center",
    "latitude": 41.31526814,
    "longitude": -81.55028891,
    "address": "311 W Aurora Rd",
    "city": "Northfield",
    "state": "OH",
    "zip_code": "44067",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1674",
    "name": "Millersburg Church of God",
    "latitude": 40.5721297,
    "longitude": -82.0062504,
    "address": "10643 State Rt 39",
    "city": "Millersburg",
    "state": "OH",
    "zip_code": "44654",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1675",
    "name": "Church of the Lion of Judah",
    "latitude": 41.41372189,
    "longitude": -81.5677998,
    "address": "15716 BROADWAY AVE",
    "city": "MAPLE HEIGHTS",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1676",
    "name": "Many Mansions",
    "latitude": 34.1796912,
    "longitude": -118.8545066,
    "address": "1459 E THOUSAND OAKS BLVD",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91362",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1680",
    "name": "Buckeye Valley Food Pantry",
    "latitude": 40.4095721,
    "longitude": -82.9472156,
    "address": "101 E High St",
    "city": "ASHLEY",
    "state": "OH",
    "zip_code": "43003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1682",
    "name": "Faith Ministries Christian Center",
    "latitude": 41.4708079,
    "longitude": -82.13947184,
    "address": "1306 EUCLID AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1683",
    "name": "Rio Foundation (ACTIVE)",
    "latitude": 34.23950298,
    "longitude": -119.16003155,
    "address": "3300 CORTEZ ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93036",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1692",
    "name": "Trials for Hope",
    "latitude": 41.46627677,
    "longitude": -81.75231253,
    "address": "4321 Bridge Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1696",
    "name": "Pathway's Enrichment Center",
    "latitude": 41.44701279,
    "longitude": -82.2022792,
    "address": "2505 LEAVITT RD",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1697",
    "name": "Deliverance Christian Church",
    "latitude": 40.8123436,
    "longitude": -81.37762867,
    "address": "1358 Cleveland Ave NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44703",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1702",
    "name": "Historic Church of St. Patrick",
    "latitude": 41.6486748,
    "longitude": -83.5460212,
    "address": "130 AVONDALE AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43604",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1704",
    "name": "Pontifex Disciples in Action",
    "latitude": 41.3480249,
    "longitude": -83.1149621,
    "address": "416 W STATE ST",
    "city": "FREMONT",
    "state": "OH",
    "zip_code": "43420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1706",
    "name": "St. Patrick of Heatherdowns",
    "latitude": 41.5941249,
    "longitude": -83.6432434,
    "address": "4201 HEATHERDOWNS BLVD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1707",
    "name": "Christ Church Old Brooklyn",
    "latitude": 41.4402308,
    "longitude": -81.7314346,
    "address": "6400 MEMPHIS AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44144",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1709",
    "name": "St. Paul's United Defiance",
    "latitude": 41.2848407,
    "longitude": -84.3618908,
    "address": "400 WAYNE AVE",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1714",
    "name": "The Redeemed Christian Church",
    "latitude": 41.6911712,
    "longitude": -83.5600767,
    "address": "2239 CHEYENNE BLVD.",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1715",
    "name": "St. Thomas More ",
    "latitude": 41.3790866,
    "longitude": -83.643139,
    "address": "425 THURSTIN ST",
    "city": "BOWLING GREEN",
    "state": "OH",
    "zip_code": "43402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1716",
    "name": "Foundation Stone Church",
    "latitude": 41.6032181,
    "longitude": -83.4664884,
    "address": "4532 WOODVILLE RD",
    "city": "NORTHWOOD",
    "state": "OH",
    "zip_code": "43619",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1717",
    "name": "Zoar Lutheran Church",
    "latitude": 41.5588213,
    "longitude": -83.6226126,
    "address": "314 E INDIANA AVE",
    "city": "PERRYSBURG",
    "state": "OH",
    "zip_code": "43551",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1718",
    "name": "St. John's Lutheran Church-Stony Ridge",
    "latitude": 41.5077946,
    "longitude": -83.5019361,
    "address": "5520 FREMONT PIKE",
    "city": "STONY RIDGE",
    "state": "OH",
    "zip_code": "43463",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1719",
    "name": "Faith Lutheran Church",
    "latitude": 41.6309904,
    "longitude": -83.6038198,
    "address": "2440 SOUTH AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43609",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1727",
    "name": "Centenary United Methodist Church",
    "latitude": 41.06855969,
    "longitude": -81.55990249,
    "address": "1310 Superior Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1728",
    "name": "Aspinwall Church",
    "latitude": 41.5582269,
    "longitude": -81.5796232,
    "address": "14627 ASPINWALL AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1729",
    "name": "Victory Center Food Pantry",
    "latitude": 40.5478113,
    "longitude": -84.16453186,
    "address": "13488 CEMETERY RD",
    "city": "WAPAKONETA",
    "state": "OH",
    "zip_code": "45895",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1730",
    "name": "UNIVERSITY CLUSTER",
    "latitude": 35.1181675,
    "longitude": -89.9451784,
    "address": "480 S HIGHLAND ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1749",
    "name": "New Lexington Food Pantry",
    "latitude": 39.71802,
    "longitude": -82.1859,
    "address": "933 PO BOX",
    "city": "NEW LEXINGTON",
    "state": "OH",
    "zip_code": "43764",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1751",
    "name": "Richland Road Church of Christ",
    "latitude": 40.5750761,
    "longitude": -83.0979478,
    "address": "535 RICHLAND RD",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1761",
    "name": "Temple Beth Torah",
    "latitude": 34.2875828,
    "longitude": -119.1940627,
    "address": "7620 FOOTHILL RD",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1764",
    "name": "River Community ",
    "latitude": 34.2798731,
    "longitude": -119.2872894,
    "address": "889 E SANTA CLARA ST",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1768",
    "name": "Sacred Heart Church",
    "latitude": 34.2868252,
    "longitude": -119.1582149,
    "address": "10800 HENDERSON RD",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1772",
    "name": "Feeding Medina County",
    "latitude": 41.13611042,
    "longitude": -81.87729949,
    "address": "650 W Smith Rd",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1773",
    "name": "Help of Ojai",
    "latitude": 34.4475406,
    "longitude": -119.2413256,
    "address": "108 S. Montgomery St.",
    "city": "OJAI",
    "state": "CA",
    "zip_code": "93023",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1774",
    "name": "Feeding Medina County DD",
    "latitude": 41.12582175,
    "longitude": -81.88988474,
    "address": "901 Lafayette Rd",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1776",
    "name": "Hebron Ministries",
    "latitude": 41.2736024,
    "longitude": -84.3471918,
    "address": "1123 AYERSVILLE AVE",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1777",
    "name": "Salvation Army - Simi Valley",
    "latitude": 34.2735661,
    "longitude": -118.7720634,
    "address": "1407 E LOS ANGELES AVE",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1779",
    "name": "St. Johns Luthern Church-Defiance",
    "latitude": 41.281916,
    "longitude": -84.3634715,
    "address": "655 WAYNE AVE",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1781",
    "name": "Mosaic Ministries of South Toledo",
    "latitude": 41.62790207,
    "longitude": -83.56161741,
    "address": "860 ORCHARD ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43609",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1782",
    "name": "Emmanuel Baptist",
    "latitude": 41.7054906,
    "longitude": -83.6418564,
    "address": "4207 W LASKEY RD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43623",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1785",
    "name": "Andover First United Methodist",
    "latitude": 41.6052286,
    "longitude": -80.57121717,
    "address": "181 South Main",
    "city": "ANDOVER",
    "state": "OH",
    "zip_code": "44003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1789",
    "name": "Family of Faith Community Church",
    "latitude": 40.08348175,
    "longitude": -82.41979321,
    "address": "975 MOUNT VERNON RD",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1792",
    "name": "Colonia Village Tenant Association",
    "latitude": 34.20677526,
    "longitude": -119.16258231,
    "address": "1500 CAMINO DEL SOL",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1793",
    "name": "Westbrook Park United Methodist Church",
    "latitude": 40.7899236,
    "longitude": -81.4034407,
    "address": "2521 12th St NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44708",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1794",
    "name": "Central Christian Church",
    "latitude": 39.715954,
    "longitude": -84.1437862,
    "address": "1200 Forrer Blvd",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1798",
    "name": "Ruben Castro Charities @ Moorpark College",
    "latitude": 34.3010806,
    "longitude": -118.8344779,
    "address": "7075 CAMPUS RD",
    "city": "MOORPARK",
    "state": "CA",
    "zip_code": "93021",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1799",
    "name": "Healthy New Albany Food Pantry",
    "latitude": 40.08345649,
    "longitude": -82.80880245,
    "address": "79 N HIGH ST",
    "city": "NEW ALBANY",
    "state": "OH",
    "zip_code": "43054",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1800",
    "name": "The Salvation Army (Dover)",
    "latitude": 40.5051672,
    "longitude": -81.4647422,
    "address": "809 Emmet Ave NW",
    "city": "New Philadelphia",
    "state": "OH",
    "zip_code": "44663",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1801",
    "name": "CMHA Bellaire Gardens B",
    "latitude": 41.440574,
    "longitude": -81.7715023,
    "address": "12000 WANDA AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1803",
    "name": "CMHA Cedar High Rise",
    "latitude": 41.49647741,
    "longitude": -81.666468,
    "address": "2320 E 30TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1805",
    "name": "CMHA Lakeview Apartments",
    "latitude": 41.492107,
    "longitude": -81.7100045,
    "address": "2700 WASHINGTON AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1806",
    "name": "CMHA Mt. Auburn",
    "latitude": 41.4756823,
    "longitude": -81.6211424,
    "address": "3061 E 93RD ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1807",
    "name": "CMHA Outhwaite",
    "latitude": 41.49196006,
    "longitude": -81.6555773,
    "address": "2452 E 46TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1809",
    "name": "CMHA Riverview",
    "latitude": 41.4874936,
    "longitude": -81.7054685,
    "address": "1745 W 25TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1810",
    "name": "CMHA Union Square",
    "latitude": 41.4585684,
    "longitude": -81.7508756,
    "address": "3495 E 98TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1815",
    "name": "Olivet Lutheran Church",
    "latitude": 41.713011,
    "longitude": -83.6823571,
    "address": "5840 MONROE ST",
    "city": "SYLVANIA",
    "state": "OH",
    "zip_code": "43560",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1816",
    "name": "St. Paul's Episcopal Under One Roof Pantry",
    "latitude": 41.5634723,
    "longitude": -83.6498508,
    "address": "310 ELIZABETH ST",
    "city": "MAUMEE",
    "state": "OH",
    "zip_code": "43537",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1822",
    "name": "New Life Community Church",
    "latitude": 34.2135578,
    "longitude": -119.1430157,
    "address": "1251 N RICE AVE",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1823",
    "name": "BG Christian Food Pantry",
    "latitude": 41.3712136,
    "longitude": -83.6448381,
    "address": "419 GOULD ST",
    "city": "BOWLING GREEN",
    "state": "OH",
    "zip_code": "43402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1824",
    "name": "SDA Community Health Services - Oxnard (Pacific)",
    "latitude": 34.1843297,
    "longitude": -119.1680028,
    "address": "1625 PACIFIC AVE",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1825",
    "name": "SDA Community Health Services - Oxnard (Birch)",
    "latitude": 34.1855926,
    "longitude": -119.1782871,
    "address": "135 W Birch St",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1826",
    "name": "First Baptist of Jennings",
    "latitude": 30.22962934,
    "longitude": -92.65930126,
    "address": "1001 CARY AVE",
    "city": "JENNINGS",
    "state": "LA",
    "zip_code": "70546",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1829",
    "name": "J.C. Hairston Food Bank",
    "latitude": 40.4617669,
    "longitude": -79.9082417,
    "address": "6556 SHETLAND ST",
    "city": "PITTSBURGH",
    "state": "PA",
    "zip_code": "15206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1831",
    "name": "Eleanors Pantry",
    "latitude": 42.22238247,
    "longitude": -85.88894271,
    "address": "221 DREW ST",
    "city": "PAW PAW",
    "state": "MI",
    "zip_code": "49079",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1835",
    "name": "Harbor Church",
    "latitude": 34.2663809,
    "longitude": -119.2537441,
    "address": "3100 PREBLE AVE",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1842",
    "name": "Pickaway County Community Action",
    "latitude": 39.5926102,
    "longitude": -82.9380847,
    "address": "469 E OHIO ST",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1846",
    "name": "Mary Queen of Peace",
    "latitude": 41.4351753,
    "longitude": -81.7094956,
    "address": "4423 PEARL RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1848",
    "name": "CMHA Beachcrest",
    "latitude": 41.5798745,
    "longitude": -81.5635268,
    "address": "16800 LAKE SHORE BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1849",
    "name": "SVDP - St. Anthony's Church",
    "latitude": 34.1765483,
    "longitude": -119.1816215,
    "address": "2511 S C ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1851",
    "name": "North Terrace Food Pantry",
    "latitude": 39.9862844,
    "longitude": -82.0308728,
    "address": "1420 BRANDYWINE BLVD",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1860",
    "name": "Pentecostal Church of God",
    "latitude": 41.6414846,
    "longitude": -83.5674895,
    "address": "143 N HAWLEY ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1861",
    "name": "St. Clair Place",
    "latitude": 41.5053212,
    "longitude": -81.6861217,
    "address": "1380 E 13TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1865",
    "name": "Belmont United Methodist Church",
    "latitude": 39.7282546,
    "longitude": -84.14179,
    "address": "2701 S SMITHVILLE RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1873",
    "name": "Catholic Charities - Ventura",
    "latitude": 34.284964,
    "longitude": -119.3001241,
    "address": "303 N VENTURA AVE",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1879",
    "name": "Second St. John Baptist",
    "latitude": 41.5375466,
    "longitude": -81.5971533,
    "address": "717 E 125TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1882",
    "name": "Doylestown Community Food Cupboard",
    "latitude": 40.9690921,
    "longitude": -81.6933452,
    "address": "153 Church St",
    "city": "Doylestown",
    "state": "OH",
    "zip_code": "44230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1883",
    "name": "Faith Klinik Ministries",
    "latitude": 40.0854619,
    "longitude": -82.9774152,
    "address": "1567 E DUBLIN GRANVILLE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1884",
    "name": "Community Center of St Benard",
    "latitude": 29.95660984,
    "longitude": -90.00073668,
    "address": "1111 LEBEAU ST",
    "city": "ARABI",
    "state": "LA",
    "zip_code": "70032",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1887",
    "name": "Greater Bethlehem / Turnkey Dev",
    "latitude": 39.9571111,
    "longitude": -82.9530647,
    "address": "1725 E MAIN ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1888",
    "name": "Mid-Ohio Market at My Project USA",
    "latitude": 39.943716,
    "longitude": -83.0793791,
    "address": "3275 SULLIVANT AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1889",
    "name": "Sterling United Methodist Church",
    "latitude": 40.9648724,
    "longitude": -81.8460578,
    "address": "13584 Kauffman Ave",
    "city": "Sterling",
    "state": "OH",
    "zip_code": "44276",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1891",
    "name": "South Zanesville UMC Food Pantry",
    "latitude": 39.9030906,
    "longitude": -82.0171095,
    "address": "53 E MAIN ST",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1894",
    "name": "Lantern Light Ministry",
    "latitude": 29.9565981,
    "longitude": -90.081779,
    "address": "1803 GRAVIER ST",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1895",
    "name": "Hayes Temple Church of God in Christ",
    "latitude": 41.4727337,
    "longitude": -81.6206294,
    "address": "3158 E 94TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1901",
    "name": "Compassionate Ministries of Jackson County",
    "latitude": 42.29913843,
    "longitude": -84.43675217,
    "address": "3724 M-50",
    "city": "JACKSON",
    "state": "MI",
    "zip_code": "49201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1902",
    "name": "Immaculate Conception Church Outreach",
    "latitude": 41.6352826,
    "longitude": -83.5503804,
    "address": "1102 BROADWAY ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43609",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1910",
    "name": "Dahlberg Gibson Learning Center     ",
    "latitude": 40.110738,
    "longitude": -83.0045725,
    "address": "350 E WILSON BRIDGE RD",
    "city": "WORTHINGTON",
    "state": "OH",
    "zip_code": "43085",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1915",
    "name": "Central City Christian Fellowship",
    "latitude": 29.93581831,
    "longitude": -90.08849808,
    "address": "2138 4th St",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1919",
    "name": "Bethel Lutheran Church    ",
    "latitude": 39.8713436,
    "longitude": -83.0708242,
    "address": "4501 HOOVER RD",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1920",
    "name": "Liberty Hill Baptist Church",
    "latitude": 41.503154,
    "longitude": -81.6306303,
    "address": "8206 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1925",
    "name": "Catholic Charities - Moorpark",
    "latitude": 34.28174262,
    "longitude": -118.87457461,
    "address": "612B Spring Rd",
    "city": "MOORPARK",
    "state": "CA",
    "zip_code": "93021",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1926",
    "name": "All Saints Episcopal Church",
    "latitude": 41.38372683,
    "longitude": -81.7466588,
    "address": "8911 W RIDGEWOOD DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1927",
    "name": "SVDP/ St.Mary's Church",
    "latitude": 40.8019394,
    "longitude": -81.5223668,
    "address": "206 Cherry Rd NE",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1928",
    "name": "New Mt Zion Baptist Church",
    "latitude": 41.5135932,
    "longitude": -81.6399661,
    "address": "1508 E 71ST ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1929",
    "name": "Oak Hill Food Pantry",
    "latitude": 38.8955172,
    "longitude": -82.5725943,
    "address": "105 W MAIN ST",
    "city": "OAK HILL",
    "state": "OH",
    "zip_code": "45656",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1930",
    "name": "Euclid Senior Programs",
    "latitude": 41.593056,
    "longitude": -81.526944,
    "address": "1 BLISS LN",
    "city": "EUCLID",
    "state": "OH",
    "zip_code": "44123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1939",
    "name": "Lafourche Parish Government",
    "latitude": 29.69216634,
    "longitude": -90.55088621,
    "address": "4876 HWY 1",
    "city": "MATHEWS",
    "state": "LA",
    "zip_code": "70375",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1948",
    "name": "First United Methodist Church-Bowling Green",
    "latitude": 41.3744065,
    "longitude": -83.6272585,
    "address": "1526 E WOOSTER ST",
    "city": "BOWLING GREEN",
    "state": "OH",
    "zip_code": "43402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1951",
    "name": "Good Samaritan Hunger Center",
    "latitude": 41.09585471,
    "longitude": -81.5694404,
    "address": "420 S Hawkins ave",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1952",
    "name": "Basic Needs of Ventura College",
    "latitude": 34.2762582,
    "longitude": -119.2319608,
    "address": "4667 TELEGRAPH RD",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1953",
    "name": "From Darkness to Light",
    "latitude": 41.4618185,
    "longitude": -81.6232465,
    "address": "3555 E 91ST ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1957",
    "name": "Northmont FISH",
    "latitude": 39.8572265,
    "longitude": -84.3276523,
    "address": "265 SMITH DR",
    "city": "ENGLEWOOD",
    "state": "OH",
    "zip_code": "45315",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1958",
    "name": "Storm Outreach Community Center",
    "latitude": 29.5978952,
    "longitude": -90.7299758,
    "address": "7505 MAIN ST",
    "city": "HOUMA",
    "state": "LA",
    "zip_code": "70360",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1963",
    "name": "Our Lady of Peace",
    "latitude": 41.89789015,
    "longitude": -80.80454805,
    "address": "330 Lake Ave.",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1968",
    "name": "Senior Citizen Resources",
    "latitude": 41.4393948,
    "longitude": -81.7031365,
    "address": "3100 DEVONSHIRE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1969",
    "name": "Pleasant Valley Church",
    "latitude": 41.363513,
    "longitude": -81.7750105,
    "address": "12193 W PLEASANT VALLEY RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1970",
    "name": "First Church of the Brethren",
    "latitude": 40.87022944,
    "longitude": -82.31841354,
    "address": "421 Campus Ave.",
    "city": "ASHLAND",
    "state": "OH",
    "zip_code": "44842",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1972",
    "name": "Community Outreach Center",
    "latitude": 30.45112015,
    "longitude": -93.42438867,
    "address": "1006 E FOURTH ST",
    "city": "DEQUINCY",
    "state": "LA",
    "zip_code": "70633",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1974",
    "name": "New Jerusalem Progressive Church Of God in Christ",
    "latitude": 40.7727775,
    "longitude": -82.5412443,
    "address": "709 BURNS ST",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1975",
    "name": "Revival of Life Ministries",
    "latitude": 41.4202391,
    "longitude": -81.5759873,
    "address": "15105 BROADWAY AVE",
    "city": "MAPLE HEIGHTS",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1977",
    "name": "Mansfield Foursquare Church",
    "latitude": 40.7475875,
    "longitude": -82.4948123,
    "address": "383 DAVIDSON ST",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44907",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1978",
    "name": "Journey Life Center",
    "latitude": 40.81063082,
    "longitude": -82.59011505,
    "address": "486 Springmill St",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1979",
    "name": "William T. Boyd Lodge #79",
    "latitude": 41.46411411,
    "longitude": -81.58120003,
    "address": "14402 KINSMAN RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1980",
    "name": "Volunteers of Geneva",
    "latitude": 41.7936728,
    "longitude": -80.9471226,
    "address": "811 S BROADWAY",
    "city": "GENEVA",
    "state": "OH",
    "zip_code": "44041",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1981",
    "name": "Fenway Manor",
    "latitude": 41.50437357,
    "longitude": -81.61087188,
    "address": "1986 STOKES BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1982",
    "name": "Celebration Lutheran Church",
    "latitude": 41.58295127,
    "longitude": -81.24141265,
    "address": "10621 AUBURN RD",
    "city": "CHARDON",
    "state": "OH",
    "zip_code": "44024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1983",
    "name": "Fidelity Baptist Church",
    "latitude": 41.51569206,
    "longitude": -81.62942367,
    "address": "8402 WADE PARK AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1984",
    "name": "Good Shepherd Baptist Church",
    "latitude": 41.5533132,
    "longitude": -81.5539952,
    "address": "17822 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1986",
    "name": "Knickerbocker Senior Apartments",
    "latitude": 41.48691331,
    "longitude": -81.92349897,
    "address": "27100 Knickerbocker Rd",
    "city": "BAY VILLAGE",
    "state": "OH",
    "zip_code": "44140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1996",
    "name": "Hazel Hurst Community Center",
    "latitude": 29.96766772,
    "longitude": -90.15634335,
    "address": "1121 CAUSEWAY BLVD",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-1999",
    "name": "Care on the Square Francis",
    "latitude": 41.4783576,
    "longitude": -81.6476717,
    "address": "6114 FRANCIS AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2002",
    "name": "First English Lutheran Church",
    "latitude": 40.7585135,
    "longitude": -82.5177674,
    "address": "53 PARK AVE W",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44902",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2007",
    "name": "Plymouth Methodist Church",
    "latitude": 41.8366974,
    "longitude": -80.7540489,
    "address": "970 PLYMOUTH RD",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2009",
    "name": "St. Robert Temple COGIC",
    "latitude": 41.4726379,
    "longitude": -81.6024933,
    "address": "3165 E 116TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2010",
    "name": "Victorious Women Helping Women Outreach Ministries",
    "latitude": 41.5194792,
    "longitude": -81.6447215,
    "address": "6527 SUPERIOR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2012",
    "name": "Sankofa Healthy Food Hub",
    "latitude": 29.9590118,
    "longitude": -90.0214733,
    "address": "5200 DAUPHINE ST",
    "city": "NEW ORLEANS",
    "state": "LA",
    "zip_code": "70117",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2013",
    "name": "Kenner Food Bank",
    "latitude": 29.97412352,
    "longitude": -90.24997847,
    "address": "317 OXLEY ST",
    "city": "KENNER",
    "state": "LA",
    "zip_code": "70062",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2014",
    "name": "St. Mary Magdalen",
    "latitude": 34.2156621,
    "longitude": -119.0360393,
    "address": "2532 VENTURA BLVD",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2018",
    "name": "Wooster Hope Center",
    "latitude": 40.7900413,
    "longitude": -81.9405743,
    "address": "807 Spruce St",
    "city": "Wooster",
    "state": "OH",
    "zip_code": "44691",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2019",
    "name": "Wooster Hope Center Direct Distribution",
    "latitude": 40.7900413,
    "longitude": -81.9405743,
    "address": "807 Spruce St",
    "city": "Wooster",
    "state": "OH",
    "zip_code": "44691",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2031",
    "name": "Kingdom Kids Outreach Ministries ",
    "latitude": 39.9031211,
    "longitude": -82.9523101,
    "address": "2815 Bulen Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2038",
    "name": "Fairhill Partners",
    "latitude": 41.4923496,
    "longitude": -81.5974918,
    "address": "12200 FAIRHILL RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2040",
    "name": "Christian World",
    "latitude": 30.088912,
    "longitude": -93.176486,
    "address": "2001 E GAUTHIER RD",
    "city": "LAKE CHARLES",
    "state": "LA",
    "zip_code": "70607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2053",
    "name": "SVDP - St. Francis of Assisi",
    "latitude": 34.3940747,
    "longitude": -118.9263334,
    "address": "1048 W VENTURA ST",
    "city": "FILLMORE",
    "state": "CA",
    "zip_code": "93015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2061",
    "name": "Salvation Army - Ventura",
    "latitude": 34.2772175,
    "longitude": -119.1750816,
    "address": "650 PETIT AVE",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2062",
    "name": "YMCA EARLY LEARNING CENTER",
    "latitude": 40.0059617,
    "longitude": -82.9080337,
    "address": "2879 JOHNSTOWN RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2063",
    "name": "Fleet Reserve",
    "latitude": 34.161105,
    "longitude": -119.189825,
    "address": "5472 Barrymore Dr.",
    "city": "PORT HUENEME",
    "state": "CA",
    "zip_code": "93041",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2064",
    "name": "New Beginning Ministries",
    "latitude": 41.4753433,
    "longitude": -81.7305513,
    "address": "2060 W 65TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2065",
    "name": "West Park Baptist Church",
    "latitude": 41.42845471,
    "longitude": -81.80265155,
    "address": "4600 W 150TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2067",
    "name": "City of Hope Family Worship Center",
    "latitude": 41.5315043,
    "longitude": -81.6157072,
    "address": "934 E 105TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2068",
    "name": "Oasis of Mercy Food Pantry at St Michael's Church",
    "latitude": 40.0722714,
    "longitude": -83.5583419,
    "address": "40 WALNUT ST",
    "city": "MECHANICSBURG",
    "state": "OH",
    "zip_code": "43044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2069",
    "name": "Wake Up the World",
    "latitude": 40.366463,
    "longitude": -83.747844,
    "address": "600 E BROWN AVE",
    "city": "BELLEFONTAINE",
    "state": "OH",
    "zip_code": "43311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2073",
    "name": "Jacque Cordle Childrens fund    ",
    "latitude": 40.30439,
    "longitude": -82.6966345,
    "address": "12 W Main St",
    "city": "CENTERBURG",
    "state": "OH",
    "zip_code": "43011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2077",
    "name": "Buckeye Food Alliance",
    "latitude": 39.9984206,
    "longitude": -83.0219582,
    "address": "1800 CANNON DR",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43210",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2078",
    "name": "Grace Harvest Ministries",
    "latitude": 34.275719,
    "longitude": -118.9040489,
    "address": "4823 MIRA SOL DR",
    "city": "MOORPARK",
    "state": "CA",
    "zip_code": "93021",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2083",
    "name": "Abundant Life Just Cares",
    "latitude": 30.25021582,
    "longitude": -92.27312255,
    "address": "400 GOSSEN MEMORIAL DR",
    "city": "RAYNE",
    "state": "LA",
    "zip_code": "70578",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2087",
    "name": "Restoration Tabernacle",
    "latitude": 41.30882786,
    "longitude": -84.38006365,
    "address": "09119 Christy Road",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2088",
    "name": "Wooster Hope Center School Pantry",
    "latitude": 40.7509978,
    "longitude": -81.8382145,
    "address": "173 W MAIN ST",
    "city": "APPLE CREEK",
    "state": "OH",
    "zip_code": "44606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2090",
    "name": "Kappa at Mount Olive MBC",
    "latitude": 41.4835161,
    "longitude": -81.5967271,
    "address": "3290 E 126th St",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2093",
    "name": "Catholic Charities Serving Portage and Stark Counties",
    "latitude": 41.1578211,
    "longitude": -81.2433853,
    "address": "206 W Main St",
    "city": "Ravenna",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2097",
    "name": "Food Bank of the Southern Tier - Admin Account",
    "latitude": 42.1377849,
    "longitude": -76.8241939,
    "address": "388 UPPER OAKWOOD AVE",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2098",
    "name": "MFP Millport",
    "latitude": 42.26701778,
    "longitude": -76.83753278,
    "address": "5528 State Street",
    "city": "MILLPORT",
    "state": "NY",
    "zip_code": "14864",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2101",
    "name": "Pavilion of Praise Baptist Church ",
    "latitude": 41.03209517,
    "longitude": -81.56120532,
    "address": "976 W Waterloo Rd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44314",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2102",
    "name": "Fairfax Community Center at Faith Tabernacle UHC",
    "latitude": 41.4953953,
    "longitude": -81.6302177,
    "address": "2335 E 82ND ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2106",
    "name": "Project Understanding",
    "latitude": 34.2503947,
    "longitude": -119.1958197,
    "address": "2734 JOHNSON DR",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2107",
    "name": "Community Outreach Mobile Pantry (CHOMP)",
    "latitude": 40.3962282,
    "longitude": -82.4865565,
    "address": "205 N MULBERRY ST",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2109",
    "name": "MFP Erin",
    "latitude": 42.1871,
    "longitude": -76.6632,
    "address": "1138 BREESPORT RD",
    "city": "ERIN",
    "state": "NY",
    "zip_code": "14838",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2111",
    "name": "MFP Penn Ave-Chapel Park",
    "latitude": 42.050672,
    "longitude": -76.866098,
    "address": "1122 PENNSYLVANIA AVE",
    "city": "PINE CITY",
    "state": "NY",
    "zip_code": "14871",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2112",
    "name": "MFP Senior - Villa Serene",
    "latitude": 42.1296624,
    "longitude": -76.8157903,
    "address": "399 E 14TH ST",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2113",
    "name": "MFP Senior - Flannery",
    "latitude": 42.082,
    "longitude": -76.8053,
    "address": "300 S MAIN ST",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14904",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2114",
    "name": "MFP Senior - Bragg",
    "latitude": 42.0895,
    "longitude": -76.7978,
    "address": "115 DEWITT AVE",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2115",
    "name": "MFP Senior - Carpenter Apartments",
    "latitude": 42.09268505,
    "longitude": -76.7988128,
    "address": "511 E. Church St.",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2117",
    "name": "MFP Senior - Park Terrace Congregate Apartments",
    "latitude": 42.0516,
    "longitude": -76.8337,
    "address": "1281 PENNSYLVANIA AVE",
    "city": "PINE CITY",
    "state": "NY",
    "zip_code": "14871",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2126",
    "name": "NEON - East Cleveland",
    "latitude": 41.5369079,
    "longitude": -81.5757916,
    "address": "15201 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2127",
    "name": "NEON - Hough",
    "latitude": 41.5091056,
    "longitude": -81.6299849,
    "address": "8300 HOUGH AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2128",
    "name": "NEON Southeast Health Center",
    "latitude": 41.4457214,
    "longitude": -81.5895904,
    "address": "13301 MILES AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2129",
    "name": "NEON Superior Health Center",
    "latitude": 41.52295631,
    "longitude": -81.60149244,
    "address": "12100 SUPERIOR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2130",
    "name": "NEON Collinwood Health Center",
    "latitude": 41.55444149,
    "longitude": -81.57386668,
    "address": "15322 SAINT CLAIR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2131",
    "name": "NEON Miles-Broadway Health Center",
    "latitude": 41.4453829,
    "longitude": -81.6226578,
    "address": "9127 MILES AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2135",
    "name": "Citadel of Faith Ministries ",
    "latitude": 41.41783338,
    "longitude": -81.55412982,
    "address": "5250 ARCH ST",
    "city": "MAPLE HEIGHTS",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2136",
    "name": "Second Calvary Baptist Church",
    "latitude": 41.4438926,
    "longitude": -81.7720275,
    "address": "12017 EMERY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2139",
    "name": "Logos Ministries",
    "latitude": 40.5984693,
    "longitude": -83.1493297,
    "address": "582 LEE ST",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2140",
    "name": "Matthew 25 Outreach",
    "latitude": 40.76329147,
    "longitude": -82.54336471,
    "address": "124 N LINDEN RD",
    "city": "MANSFIELD",
    "state": "OH",
    "zip_code": "44906",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2142",
    "name": "El Centro de Servicios Sociales, Inc.",
    "latitude": 41.44519822,
    "longitude": -82.13705402,
    "address": "2800 PEARL AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2143",
    "name": "New London Salvation Army",
    "latitude": 41.0865223,
    "longitude": -82.4013003,
    "address": "12 AKRON ST",
    "city": "NEW LONDON",
    "state": "OH",
    "zip_code": "44851",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2145",
    "name": "Christian Temple",
    "latitude": 41.4659819,
    "longitude": -82.1796061,
    "address": "940 W 5TH ST",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2146",
    "name": "First Lutheran Church",
    "latitude": 41.46465708,
    "longitude": -82.17663436,
    "address": "1019 W.5th Street",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2147",
    "name": "OH-GO",
    "latitude": 41.4118118,
    "longitude": -82.6490704,
    "address": "2304 E. Perkins Ave",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2148",
    "name": "Marion Franklin Recreation Center",
    "latitude": 39.9076544,
    "longitude": -82.9674966,
    "address": "2801 LOCKBOURNE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2149",
    "name": "MFP Deposit",
    "latitude": 42.0606788,
    "longitude": -75.4288604,
    "address": "74 2ND ST",
    "city": "DEPOSIT",
    "state": "NY",
    "zip_code": "13754",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2152",
    "name": "MFP Whitney Point",
    "latitude": 42.35784,
    "longitude": -75.93816,
    "address": "59 Keibel Rd",
    "city": "WHITNEY POINT",
    "state": "NY",
    "zip_code": "13862",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2154",
    "name": "MFP Maine",
    "latitude": 42.1960794,
    "longitude": -76.060322,
    "address": "2626 State Route 26",
    "city": "MAINE",
    "state": "NY",
    "zip_code": "13802",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2156",
    "name": "MFP Conklin-Maines Community Center",
    "latitude": 42.0870265,
    "longitude": -75.8310462,
    "address": "942 CONKLIN RD",
    "city": "CONKLIN",
    "state": "NY",
    "zip_code": "13748",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2157",
    "name": "MFP Senior - Wells Apartments",
    "latitude": 42.1076079,
    "longitude": -75.9608702,
    "address": "299 FLORAL AVE",
    "city": "JOHNSON CITY",
    "state": "NY",
    "zip_code": "13790",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2158",
    "name": "MFP Senior - Lincoln Court",
    "latitude": 42.0902739,
    "longitude": -75.9108421,
    "address": "21 NEW ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2159",
    "name": "MFP Senior - Metro Plaza Apartments",
    "latitude": 42.101709,
    "longitude": -75.9085268,
    "address": "110 CHENANGO PL",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2161",
    "name": "MFP Senior - East Hill Senior Living",
    "latitude": 42.1144104,
    "longitude": -75.8718435,
    "address": "50 E CLAPHAM ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13904",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2163",
    "name": "MFP Senior - Northern Broome Senior Center, Whitney Point",
    "latitude": 42.3269492,
    "longitude": -75.9677151,
    "address": "10 STRONGS PL",
    "city": "WHITNEY POINT",
    "state": "NY",
    "zip_code": "13862",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2164",
    "name": "MFP Trinity / Redeemer Lutheran Church",
    "latitude": 42.1000223,
    "longitude": -75.9224312,
    "address": "72 MAIN ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2166",
    "name": "St. Matthews",
    "latitude": 39.80927299,
    "longitude": -82.96812038,
    "address": "99 Commerce St",
    "city": "LOCKBOURNE",
    "state": "OH",
    "zip_code": "43137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2167",
    "name": "MFP Senior - Marian Apartments",
    "latitude": 42.1256723,
    "longitude": -76.0250805,
    "address": "701 HOOPER RD",
    "city": "ENDWELL",
    "state": "NY",
    "zip_code": "13760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2169",
    "name": "MFP Senior - Harry L. Apartments",
    "latitude": 42.1238129,
    "longitude": -75.9567972,
    "address": "235 HARRY L DR",
    "city": "JOHNSON CITY",
    "state": "NY",
    "zip_code": "13790",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2175",
    "name": "MFP Waverly",
    "latitude": 42.01047292,
    "longitude": -76.52852428,
    "address": "40 STATE ROUTE 34",
    "city": "WAVERLY",
    "state": "NY",
    "zip_code": "14892",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2176",
    "name": "MFP Richford",
    "latitude": 42.35564417,
    "longitude": -76.2007237,
    "address": "13290 NY-38",
    "city": "Richford",
    "state": "NY",
    "zip_code": "13835",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2179",
    "name": "MFP Apalachin",
    "latitude": 42.0588,
    "longitude": -76.1667,
    "address": "1110 PENNSYLVANIA AVE",
    "city": "APALACHIN",
    "state": "NY",
    "zip_code": "13732",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2181",
    "name": "MFP Senior - Elizabeth Square, Waverly",
    "latitude": 42.0016,
    "longitude": -76.5412,
    "address": "430 FULTON ST",
    "city": "WAVERLY",
    "state": "NY",
    "zip_code": "14892",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2182",
    "name": "MFP Senior - Long Meadow Senior Housing",
    "latitude": 42.1143047,
    "longitude": -76.27129982,
    "address": "5 BROWNS LN",
    "city": "OWEGO",
    "state": "NY",
    "zip_code": "13827",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2185",
    "name": "MFP Senior - Titus Towers",
    "latitude": 42.43069748,
    "longitude": -76.50357276,
    "address": "798 S PLAIN ST",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2186",
    "name": "MFP Senior - Conifer Village",
    "latitude": 42.4508689,
    "longitude": -76.532341,
    "address": "200 CONIFER DR",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2187",
    "name": "MFP Senior - Ellis Hollow",
    "latitude": 42.4360691,
    "longitude": -76.46097,
    "address": "1028 ELLIS HOLLOW RD",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2191",
    "name": "MFP Thrive Church / Freeville",
    "latitude": 42.491988,
    "longitude": -76.3443797,
    "address": "318 JOHNSON RD",
    "city": "FREEVILLE",
    "state": "NY",
    "zip_code": "13068",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2196",
    "name": "MFP Bath Turning Point",
    "latitude": 42.3363617,
    "longitude": -77.3177157,
    "address": "122 LIBERTY ST",
    "city": "BATH",
    "state": "NY",
    "zip_code": "14810",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2197",
    "name": "MFP Campbell",
    "latitude": 42.23095333,
    "longitude": -77.19355777,
    "address": "8516 Main Street",
    "city": "CAMPBELL",
    "state": "NY",
    "zip_code": "14821",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2198",
    "name": "MFP Senior - Dayspring Apartments",
    "latitude": 42.14215559,
    "longitude": -77.04453605,
    "address": "220 Tioga Ave",
    "city": "CORNING",
    "state": "NY",
    "zip_code": "14830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2200",
    "name": "MFP Woodhull",
    "latitude": 42.0786101,
    "longitude": -77.4142556,
    "address": "1585 Academy St",
    "city": "WOODHULL",
    "state": "NY",
    "zip_code": "14898",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2204",
    "name": "MFP Senior - Village Square and Manor",
    "latitude": 42.1596475,
    "longitude": -77.0912418,
    "address": "250 N HAMILTON ST",
    "city": "PAINTED POST",
    "state": "NY",
    "zip_code": "14870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2205",
    "name": "MFP Wayland",
    "latitude": 42.5688823,
    "longitude": -77.5959595,
    "address": "206 FREMONT ST",
    "city": "WAYLAND",
    "state": "NY",
    "zip_code": "14572",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2206",
    "name": "MFP Senior - Corning Senior Center",
    "latitude": 42.148991,
    "longitude": -77.0618582,
    "address": "1 PARK LN",
    "city": "CORNING",
    "state": "NY",
    "zip_code": "14830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2210",
    "name": "MFP Rathbone",
    "latitude": 42.107463,
    "longitude": -77.230985,
    "address": "County Rd 21",
    "city": "ADDISON",
    "state": "NY",
    "zip_code": "14801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2211",
    "name": "Faith Kitchen",
    "latitude": 40.8103639,
    "longitude": -81.3470436,
    "address": "2219 Mahoning Rd NE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44705",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2212",
    "name": "MFP Senior - CFS Lakeview",
    "latitude": 42.3484695,
    "longitude": -77.3116997,
    "address": "105 GENEVA ST",
    "city": "BATH",
    "state": "NY",
    "zip_code": "14810",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2221",
    "name": "Catholic Charities of Stark",
    "latitude": 40.8035322,
    "longitude": -81.372642,
    "address": "832 McKinley Ave NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44703",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2224",
    "name": "Beyond the Walls Church ",
    "latitude": 41.3637974,
    "longitude": -82.1174334,
    "address": "101 WOODFORD AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2227",
    "name": "Corning Community Food Pantry",
    "latitude": 42.15010282,
    "longitude": -77.06278711,
    "address": "11715 East Corning Rd",
    "city": "CORNING",
    "state": "NY",
    "zip_code": "14830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2228",
    "name": "Painted Post Food Pantry, Inc.",
    "latitude": 42.15865987,
    "longitude": -77.09201559,
    "address": "201 N HAMILTON ST",
    "city": "PAINTED POST",
    "state": "NY",
    "zip_code": "14870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2240",
    "name": "First Faith Development Corp",
    "latitude": 41.07468435,
    "longitude": -81.5518834,
    "address": "790 Easter Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2246",
    "name": "Rebuild",
    "latitude": 39.92550407,
    "longitude": -82.99387679,
    "address": "52 REEB AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2248",
    "name": "Holy Spirit Catholic Church",
    "latitude": 39.97430094,
    "longitude": -82.8838093,
    "address": "4383 E BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2260",
    "name": "SOUTH TISHOMINGO COUNTY FOOD PANTRY",
    "latitude": 34.51019656,
    "longitude": -88.208417,
    "address": "11 FRONT ST",
    "city": "BELMONT",
    "state": "MS",
    "zip_code": "38827",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2261",
    "name": "TIPPAH COUNTY GOOD SAMARITAN - RIPLEY",
    "latitude": 34.73576186,
    "longitude": -88.96008564,
    "address": "113 Bails Road ",
    "city": "RIPLEY",
    "state": "MS",
    "zip_code": "38663",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2262",
    "name": "TIPPAH COUNTY GOOD SAMARITAN - WALNUT",
    "latitude": 34.94449559,
    "longitude": -88.9004966,
    "address": "560 n Main ",
    "city": "WALNUT",
    "state": "MS",
    "zip_code": "38683",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2264",
    "name": "MISSISSIPPI BOULEVARD CHRISTIAN CHURCH",
    "latitude": 35.1412582,
    "longitude": -90.020966,
    "address": "70 N BELLEVUE BLVD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2266",
    "name": "Jerry L. Garver YMCA",
    "latitude": 39.91241262,
    "longitude": -82.82869726,
    "address": "6767 Refugee Rd.",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2267",
    "name": "Twin City Pantry",
    "latitude": 40.38920171,
    "longitude": -81.34591,
    "address": "109 N Water St",
    "city": "Uhrichsville",
    "state": "OH",
    "zip_code": "44683",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2275",
    "name": "Victory Center FP",
    "latitude": 40.60029682,
    "longitude": -83.09809472,
    "address": "1190 E FAIRGROUND RD",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2284",
    "name": "For His Glory",
    "latitude": 39.1087566,
    "longitude": -84.57094654,
    "address": "931 McPherson Ave.",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2287",
    "name": "Community Partnership On Aging",
    "latitude": 41.5225941,
    "longitude": -81.5213603,
    "address": "1370 VICTORY DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2288",
    "name": "Lowell Area Mission Basket",
    "latitude": 39.5297973,
    "longitude": -81.5065861,
    "address": "307 Walnut Street",
    "city": "LOWELL",
    "state": "OH",
    "zip_code": "45744",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2290",
    "name": "FAITH FOOD PANTRY ",
    "latitude": 34.09225733,
    "longitude": -88.62662872,
    "address": "102 FRONT AVE ",
    "city": "NETTLETON",
    "state": "MS",
    "zip_code": "38858",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2291",
    "name": "Queen City Kitchen",
    "latitude": 39.11367799,
    "longitude": -84.5158055,
    "address": "1620 Vine St.",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45202",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2293",
    "name": "OSU Newark",
    "latitude": 40.0694426,
    "longitude": -82.4456536,
    "address": "1179 UNIVERSITY DR",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2295",
    "name": "Zion United Church of Christ",
    "latitude": 39.16960014,
    "longitude": -84.45007645,
    "address": "2301 Indian Mound Road",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2298",
    "name": "Walk the Talk Mobile Food Pantry",
    "latitude": 39.63901569,
    "longitude": -82.94787788,
    "address": "2146 N COURT ST",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2300",
    "name": "Bucyrus Salvation Army ",
    "latitude": 40.80766815,
    "longitude": -82.97248455,
    "address": "717 Rogers St",
    "city": "BUCYRUS",
    "state": "OH",
    "zip_code": "44820",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2301",
    "name": "Second Chance Church Pantry",
    "latitude": 40.04793005,
    "longitude": -82.94572169,
    "address": "3833 WESTERVILLE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2311",
    "name": "MFP Senior - Springview Apartments",
    "latitude": 42.01046706,
    "longitude": -76.53369285,
    "address": "80 SPRING ST",
    "city": "WAVERLY",
    "state": "NY",
    "zip_code": "14892",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2312",
    "name": "Winchester Church of Christ",
    "latitude": 38.9421262,
    "longitude": -83.6531004,
    "address": "1540 Tri-County Rd",
    "city": "Winchester",
    "state": "OH",
    "zip_code": "45697",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2316",
    "name": "Helping Hands of Toronto",
    "latitude": 40.466134,
    "longitude": -80.6022967,
    "address": "411 CLARK ST",
    "city": "TORONTO",
    "state": "OH",
    "zip_code": "43964",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2317",
    "name": "Fieldstone Court Market",
    "latitude": 39.9111823,
    "longitude": -82.9277309,
    "address": "2850 ALUM CREEK DR",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2319",
    "name": "My Neighbors Place Food Pantry",
    "latitude": 39.1510538,
    "longitude": -84.59926283,
    "address": "3460 Epworth Ave.",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2322",
    "name": "Cleveland Department of Aging",
    "latitude": 41.51217441,
    "longitude": -81.67021419,
    "address": "1380 E 32ND ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2323",
    "name": "LIFE Food Pantry",
    "latitude": 39.27124302,
    "longitude": -84.28361836,
    "address": "541 Loveland Maderia Rd",
    "city": "Loveland",
    "state": "OH",
    "zip_code": "45140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2325",
    "name": "Dare to Love More",
    "latitude": 41.08487541,
    "longitude": -81.51129253,
    "address": "50 N Prospect St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44304",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2327",
    "name": "CEDC - Azahar Place Apts",
    "latitude": 34.293146,
    "longitude": -119.1516498,
    "address": "11370 MIMOSA ST",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2329",
    "name": "New Hope Community Church",
    "latitude": 40.8046332,
    "longitude": -82.972727,
    "address": "235 WOODLAWN AVE",
    "city": "BUCYRUS",
    "state": "OH",
    "zip_code": "44820",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2336",
    "name": "Christ Church ",
    "latitude": 41.35240937,
    "longitude": -82.07703975,
    "address": "1420 ABBE RD S",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2337",
    "name": "Father's Heart Ministries ",
    "latitude": 41.4347502,
    "longitude": -82.7273674,
    "address": "2211 Mills St.",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2338",
    "name": "Anderson Ferry Church of Christ",
    "latitude": 39.09396578,
    "longitude": -84.6051174,
    "address": "380 Greenwell Ave.",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45238",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2343",
    "name": "Lighthouse Pantry",
    "latitude": 40.09092275,
    "longitude": -82.16722462,
    "address": "8840 BLACKRUN RD",
    "city": "NASHPORT",
    "state": "OH",
    "zip_code": "43830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2345",
    "name": "Alexia Manor and Lourexis Apartments",
    "latitude": 41.4712959,
    "longitude": -81.6526489,
    "address": "5125 HECTOR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2346",
    "name": "New Covenant Church",
    "latitude": 39.9016653,
    "longitude": -82.019461,
    "address": "36 S SHAWNEE AVE",
    "city": "SOUTH ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2348",
    "name": "Virginia Peninsula Foodbank",
    "latitude": 37.00586489,
    "longitude": -76.40693577,
    "address": "2401 ALUMINUM AVE",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2350",
    "name": "Williamsport United Methodist Church",
    "latitude": 39.58965441,
    "longitude": -83.11722802,
    "address": "110 N. MAIN ST.",
    "city": "WILLIAMSPORT",
    "state": "OH",
    "zip_code": "43164",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2351",
    "name": "Asbury Methodist Church ",
    "latitude": 41.35197855,
    "longitude": -82.10753423,
    "address": "1611 MIDDLE AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2352",
    "name": "Nueva Luz",
    "latitude": 41.45132329,
    "longitude": -82.16774924,
    "address": "221 W.21st ",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2353",
    "name": "Lutheran Social Services Choice Pantry- Guernsey",
    "latitude": 39.74678237,
    "longitude": -81.51515905,
    "address": "60330 South Gate Rd",
    "city": "Byesville",
    "state": "OH",
    "zip_code": "43723",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2355",
    "name": "Calvary Church Of God In Christ",
    "latitude": 41.5217938,
    "longitude": -81.6118069,
    "address": "10808 SUPERIOR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2357",
    "name": "3rd Chance Ministries Inc. - Triple C",
    "latitude": 39.76944385,
    "longitude": -84.21216588,
    "address": "612 SALEM AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2361",
    "name": "Hilltop YMCA",
    "latitude": 39.96156912,
    "longitude": -83.07946365,
    "address": "2879 VALLEYVIEW DR",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2367",
    "name": "MFP CCC Elmira",
    "latitude": 42.09260824,
    "longitude": -76.79985718,
    "address": "318 MADISON AVE",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2371",
    "name": "Bloom Carroll Shalom Pantry Mission",
    "latitude": 39.78757699,
    "longitude": -82.69231744,
    "address": "4925 PLUM RD",
    "city": "CARROLL",
    "state": "OH",
    "zip_code": "43112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2376",
    "name": "Matt Garcia Apartments (02)",
    "latitude": 29.36633934,
    "longitude": -98.43911159,
    "address": "6114 PECAN VALLEY DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2379",
    "name": "West End Park (04)",
    "latitude": 29.44039673,
    "longitude": -98.53236774,
    "address": "1226 NW 18TH ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2380",
    "name": "St. Timothy (05)",
    "latitude": 29.41191188,
    "longitude": -98.53656349,
    "address": "1515 SALTILLO ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2382",
    "name": "O'Keefe Garden Brook (08)",
    "latitude": 29.420082,
    "longitude": -98.6571136,
    "address": "8734 GARDEN BRK",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78245",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2385",
    "name": "Bob Ross (103)",
    "latitude": 29.50363917,
    "longitude": -98.58276186,
    "address": "2219 BABCOCK RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2386",
    "name": "Sun Park (104)",
    "latitude": 29.41759192,
    "longitude": -98.40495462,
    "address": "4523 LAVENDER LN",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78220",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2387",
    "name": "Charles Gonzales (105)",
    "latitude": 29.40497524,
    "longitude": -98.52983547,
    "address": "2022 S ZARZAMORA ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2390",
    "name": "L. Hereford (110)",
    "latitude": 29.48512636,
    "longitude": -98.6615024,
    "address": "8911 TIMBERWILDE ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78250",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2393",
    "name": "Vista Verde Apts (117)",
    "latitude": 29.43317308,
    "longitude": -98.50510533,
    "address": "810 N FRIO ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2396",
    "name": "Villa O'Keefe (12)",
    "latitude": 29.39334466,
    "longitude": -98.40449471,
    "address": "2130 S WW WHITE RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78222",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2398",
    "name": "Elvira Cisneros (122)",
    "latitude": 29.35679047,
    "longitude": -98.49937811,
    "address": "517 SW MILITARY DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2399",
    "name": "Northeast Senior Ctr (124)",
    "latitude": 29.55332676,
    "longitude": -98.41107901,
    "address": "4135 Thousand Oak",
    "city": "San Antonio",
    "state": "TX",
    "zip_code": "78217",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2400",
    "name": "W.C. White (125)",
    "latitude": 29.42644778,
    "longitude": -98.47316516,
    "address": "618 N HACKBERRY",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78202",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2401",
    "name": "Willie Cortez (126)",
    "latitude": 29.37612687,
    "longitude": -98.61244979,
    "address": "5512 W MILITARY DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78242",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2402",
    "name": "DePaul Family Center (127)",
    "latitude": 29.34949124,
    "longitude": -98.55589643,
    "address": "7606 SOMERSET RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2403",
    "name": "District 5 (128)",
    "latitude": 29.39529466,
    "longitude": -98.48159258,
    "address": "2701 S PRESA ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78210",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2405",
    "name": "Park South Village (131)",
    "latitude": 29.34882661,
    "longitude": -98.53505251,
    "address": "1642 CANTRELL DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2406",
    "name": "District 2 (132)",
    "latitude": 29.40219517,
    "longitude": -98.40553608,
    "address": "1751 S WW WHITE RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78220",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2408",
    "name": "District 6 (135)",
    "latitude": 29.46860787,
    "longitude": -98.64907266,
    "address": "8353 CULEBRA RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78251",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2409",
    "name": "West Ave Compassion (136)",
    "latitude": 29.53733027,
    "longitude": -98.51817194,
    "address": "10715 WEST AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2410",
    "name": "Oak Manor Apts. (138)",
    "latitude": 29.5077319,
    "longitude": -98.41110354,
    "address": "2330 AUSTIN HWY",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78218",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2412",
    "name": "Salvation Army Peacock (14)",
    "latitude": 29.45182431,
    "longitude": -98.53859131,
    "address": "2810 W ASHBY PL",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2413",
    "name": "West Ave. Apartments (142)",
    "latitude": 29.49860713,
    "longitude": -98.52605228,
    "address": "3747 WEST AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2415",
    "name": "Casitas de Villa Corona (144)",
    "latitude": 29.43097544,
    "longitude": -98.57946001,
    "address": "339 SW 39TH ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2416",
    "name": "Country Club Village (151)",
    "latitude": 29.50201972,
    "longitude": -98.55703481,
    "address": "3500 MAGIC DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2417",
    "name": "Alamo River (Irene Teague)(153)",
    "latitude": 29.27323726,
    "longitude": -98.75263733,
    "address": "15209 WHEELER RD",
    "city": "ATASCOSA",
    "state": "TX",
    "zip_code": "78002",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2418",
    "name": "Christ Community Church (154)",
    "latitude": 29.36619456,
    "longitude": -98.24722769,
    "address": "11994 S. HWY 87",
    "city": "Adkins",
    "state": "TX",
    "zip_code": "78101",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2419",
    "name": "Blessed Angel (155)",
    "latitude": 29.46444381,
    "longitude": -98.35949141,
    "address": "4071 N FOSTER RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78244",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2421",
    "name": "District 7 (157)",
    "latitude": 29.4721159,
    "longitude": -98.6163006,
    "address": "6157 NW LOOP 410",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78238",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2428",
    "name": "Normoyle Park (164)",
    "latitude": 29.38207699,
    "longitude": -98.53985837,
    "address": "700 CULBERSON AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78225",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2429",
    "name": "Holy Spirit (165)",
    "latitude": 29.54705599,
    "longitude": -98.66070025,
    "address": "11093 Bandera ",
    "city": "Bandera",
    "state": "TX",
    "zip_code": "78250",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2433",
    "name": "Sacred Heart (25)",
    "latitude": 29.42741914,
    "longitude": -98.51807181,
    "address": "2123 W. Commerce",
    "city": "San Antonio",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2435",
    "name": "OLO Guadalupe (27)",
    "latitude": 29.4195853,
    "longitude": -98.51500058,
    "address": "1321 EL PASO ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2438",
    "name": "Harlandale (33)",
    "latitude": 29.36844819,
    "longitude": -98.5052111,
    "address": "115 W SOUTHCROSS BLVD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2439",
    "name": "Jardin De St. James (35)",
    "latitude": 29.38900832,
    "longitude": -98.51862984,
    "address": "420 NUNES ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78225",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2441",
    "name": "Presa Community Ctr (37)",
    "latitude": 29.38679611,
    "longitude": -98.47928097,
    "address": "3721 S PRESA ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78210",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2442",
    "name": "El Carmen (38)",
    "latitude": 29.24165212,
    "longitude": -98.46540239,
    "address": "18555 LEAL ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2445",
    "name": "Fair Avenue (46)",
    "latitude": 29.38419551,
    "longitude": -98.45995723,
    "address": "1215 FAIR AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2446",
    "name": "Rolling Oaks (47)",
    "latitude": 29.57702912,
    "longitude": -98.36349088,
    "address": "6401 WENZEL RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78233",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2449",
    "name": "Pecan Hill (52)",
    "latitude": 29.50965973,
    "longitude": -98.46982682,
    "address": "1600 W LAWNDALE DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78209",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2454",
    "name": "Bethel (57)",
    "latitude": 29.43223778,
    "longitude": -98.58765382,
    "address": "227 S ACME RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2455",
    "name": "Palacio Del Sol (59)",
    "latitude": 29.42887175,
    "longitude": -98.50343163,
    "address": "400 N FRIO ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2456",
    "name": "George Cisneros (60)",
    "latitude": 29.39849747,
    "longitude": -98.55270057,
    "address": "3003 WEIR AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78226",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2457",
    "name": "Jewett Circle (61)",
    "latitude": 29.42525724,
    "longitude": -98.56828743,
    "address": "425 SW 34TH ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2458",
    "name": "Sunshine Apts. (62)",
    "latitude": 29.47284549,
    "longitude": -98.55102984,
    "address": "455 E SUNSHINE DR",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2459",
    "name": "Parkview (63)",
    "latitude": 29.44627037,
    "longitude": -98.50404642,
    "address": "114 HICKMAN",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2461",
    "name": "OP Schnabel  (64A)",
    "latitude": 29.41385548,
    "longitude": -98.49724155,
    "address": "919 S MAIN AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2462",
    "name": "Villa Tranchese (65)",
    "latitude": 29.43754134,
    "longitude": -98.49815873,
    "address": "307 MARSHALL ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2464",
    "name": "Good Samaritan (69)",
    "latitude": 29.421586,
    "longitude": -98.523179,
    "address": "1600 Satillo St.",
    "city": "San Antonio",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2465",
    "name": "Roseville Apts. (73)",
    "latitude": 29.42492215,
    "longitude": -98.41557764,
    "address": "4139 E HOUSTON ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78220",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2466",
    "name": "Villa Hermosa (74)",
    "latitude": 29.42762533,
    "longitude": -98.49453797,
    "address": "327 N FLORES ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2467",
    "name": "Tarry Towne (76)",
    "latitude": 29.47522599,
    "longitude": -98.53501266,
    "address": "315 VANCE JACKSON RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2468",
    "name": "Lila Cockrell (78)",
    "latitude": 29.34466183,
    "longitude": -98.50377879,
    "address": "3500 PLEASANTON RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2469",
    "name": "Granada Homes (80)",
    "latitude": 29.42306077,
    "longitude": -98.4918666,
    "address": "311 S SAINT MARYS ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2470",
    "name": "Primrose Montecello (81)",
    "latitude": 29.46942615,
    "longitude": -98.53115774,
    "address": "2803 FREDERICKSBURG RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2471",
    "name": "Kirby Senior Center (82)",
    "latitude": 29.46086883,
    "longitude": -98.39548583,
    "address": "3211 ALAN SHEPARD DR",
    "city": "KIRBY",
    "state": "TX",
    "zip_code": "78219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2473",
    "name": "Blanco Apartments (87)",
    "latitude": 29.45567924,
    "longitude": -98.5080219,
    "address": "906 W HUISACHE AVE",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2476",
    "name": "Guadalupe C.C. (95)",
    "latitude": 29.4233772,
    "longitude": -98.5175116,
    "address": "1801 W CESAR E CHAVEZ BLVD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2478",
    "name": "Christ the King Apartments (99)",
    "latitude": 29.43362194,
    "longitude": -98.54461162,
    "address": "4502 W MARTIN ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2490",
    "name": "Christian Village (116)",
    "latitude": 29.48730244,
    "longitude": -98.60208054,
    "address": "5800 WURZBACH RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78238",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2532",
    "name": "Henry B. Gonzalez",
    "latitude": 29.46549215,
    "longitude": -98.59838474,
    "address": "5811 INGRAM RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2544",
    "name": "SAFB Programs",
    "latitude": 29.418014,
    "longitude": -98.5918673,
    "address": "5200 ENRIQUE M BARRERA PKWY",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2547",
    "name": "Westpark PAL- Ventura",
    "latitude": 34.2823997,
    "longitude": -119.2930975,
    "address": "501 POLI ST",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2548",
    "name": "MFP Senior - Cayuga Meadows",
    "latitude": 42.46471771,
    "longitude": -76.54105002,
    "address": "108 ASTER LN",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2550",
    "name": "Salvation Army Coshocton",
    "latitude": 40.27526043,
    "longitude": -81.86526679,
    "address": "219 North fourth Street",
    "city": "COSHOCTON",
    "state": "OH",
    "zip_code": "43812",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2552",
    "name": "St. Clement School Pantry",
    "latitude": 39.16525383,
    "longitude": -84.50132545,
    "address": "4534 Vine St.",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45217",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2555",
    "name": "Community Action Wayne/Medina",
    "latitude": 40.96896386,
    "longitude": -81.78177948,
    "address": "110 S Main St",
    "city": "Rittman",
    "state": "OH",
    "zip_code": "44270",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2563",
    "name": "Goshen Methodist Church",
    "latitude": 39.22948891,
    "longitude": -84.15539574,
    "address": "6710 Goshen Rd.",
    "city": "Goshen",
    "state": "OH",
    "zip_code": "45122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2564",
    "name": "Helping Hands In Christian Service",
    "latitude": 38.87086224,
    "longitude": -83.89393105,
    "address": "688 Camp Run Road",
    "city": "Georgetown",
    "state": "OH",
    "zip_code": "45121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2565",
    "name": "St. George Interfaith Food Pantry",
    "latitude": 39.12869166,
    "longitude": -84.51357491,
    "address": "2554 Dennis St",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2566",
    "name": "Epiphany Lutheran Church",
    "latitude": 41.64920876,
    "longitude": -83.66472184,
    "address": "915 N REYNOLDS RD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43615",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2567",
    "name": "Holiness Temple Church of God",
    "latitude": 41.6446437,
    "longitude": -83.503652,
    "address": "602 DEARBORN AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2569",
    "name": "Mt. Orab UMC",
    "latitude": 39.03019437,
    "longitude": -83.91820843,
    "address": "212 Church Street",
    "city": "Mount Orab",
    "state": "OH",
    "zip_code": "45154",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2570",
    "name": "LIBERTY TRANSITIONAL",
    "latitude": 35.1301518,
    "longitude": -90.0368253,
    "address": "749 TATE AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2571",
    "name": "Salvation Army Steubenville",
    "latitude": 40.36371955,
    "longitude": -80.61312679,
    "address": "332 N 4TH ST",
    "city": "STEUBENVILLE",
    "state": "OH",
    "zip_code": "43952",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2572",
    "name": "Liberty Chapel UMC",
    "latitude": 38.866498,
    "longitude": -83.39638309,
    "address": "3889 White Oak Rd.",
    "city": "Blue Creek",
    "state": "OH",
    "zip_code": "45616",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2574",
    "name": "Poquoson City-MFP",
    "latitude": 37.13310993,
    "longitude": -76.37763891,
    "address": "830 POQUOSON AVE",
    "city": "POQUOSON",
    "state": "VA",
    "zip_code": "23662",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2576",
    "name": "Tidewater Senior Apartments-MFP",
    "latitude": 37.02573323,
    "longitude": -76.38168094,
    "address": "1446 W QUEEN ST",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2577",
    "name": "Great Oak Senior Living-MFP",
    "latitude": 37.080013,
    "longitude": -76.4655578,
    "address": "1 GREAT OAKS CIR",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2578",
    "name": "Berkley Village-MFP",
    "latitude": 37.0943037,
    "longitude": -76.446252,
    "address": "900 DAPHIA CIR",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2579",
    "name": "Paula Maria-MFP",
    "latitude": 37.02193926,
    "longitude": -76.42187376,
    "address": "100 MARTHA LEE DR",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2580",
    "name": "Joynes Road Church of God-MFP",
    "latitude": 37.02632312,
    "longitude": -76.4079739,
    "address": "31 JOYNES RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2581",
    "name": "Surry-MFP",
    "latitude": 37.12639628,
    "longitude": -76.84857407,
    "address": "205 Enos Farm Drive",
    "city": "SURRY",
    "state": "VA",
    "zip_code": "23883",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2582",
    "name": "CHECED Warwick Apartments-MFP",
    "latitude": 37.1456251,
    "longitude": -76.5508033,
    "address": "15315 COMMUNITY LN",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2584",
    "name": "Pinecroft Senior Apartments-MFP",
    "latitude": 37.0777726,
    "longitude": -76.4985682,
    "address": "75 WELLESLEY DR",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2588",
    "name": "Langley Village Apartments-MFP",
    "latitude": 37.04180847,
    "longitude": -76.34868223,
    "address": "100 LANGLEY AVE",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2589",
    "name": "Lackey-MFP",
    "latitude": 37.22667709,
    "longitude": -76.51940321,
    "address": "100 RIVERMEADE CT",
    "city": "YORKTOWN",
    "state": "VA",
    "zip_code": "23690",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2590",
    "name": "Hampton Coliseum - MFP",
    "latitude": 37.02253726,
    "longitude": -76.33076273,
    "address": "1000 Coliseum Dr",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2591",
    "name": "Peninsula Dream Center",
    "latitude": 37.05029798,
    "longitude": -76.47325577,
    "address": "28 HARPERSVILLE RD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2592",
    "name": "Seton Manor Senior Living MFP",
    "latitude": 37.05064849,
    "longitude": -76.38962615,
    "address": "215 MARCELLA RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2594",
    "name": "MFP-GETHSEMANE BAPTIST CHURCH (RIDLEY)",
    "latitude": 37.0040688,
    "longitude": -76.423009,
    "address": "5405 Roanoke Ave",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2598",
    "name": "Victory Chapel Fellowship",
    "latitude": 41.23899912,
    "longitude": -83.64715183,
    "address": "280 Union Street",
    "city": "CYGNET",
    "state": "OH",
    "zip_code": "43413",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2600",
    "name": "Greater Victory Christian Ministries",
    "latitude": 41.46550761,
    "longitude": -82.17680744,
    "address": "559 REID AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2603",
    "name": "St. Mark's Resource Center",
    "latitude": 40.75333815,
    "longitude": -84.11305949,
    "address": "1110 N METCALF ST",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2605",
    "name": "New Second Metropolitan Baptist",
    "latitude": 41.49775152,
    "longitude": -81.65222207,
    "address": "2244 E 55TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2606",
    "name": "Hamilton Country Community Action Agency",
    "latitude": 39.18465021,
    "longitude": -84.46331056,
    "address": "1740 Langdon Farm Road",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2608",
    "name": "MFP Endwell United Methodist Church",
    "latitude": 42.1113163,
    "longitude": -76.0220133,
    "address": "3301 WATSON BLVD",
    "city": "ENDICOTT",
    "state": "NY",
    "zip_code": "13760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2610",
    "name": "First Assembly of God ",
    "latitude": 34.20924422,
    "longitude": -90.56786764,
    "address": "203 CHURCH ST",
    "city": "CLARKSDALE",
    "state": "MS",
    "zip_code": "38614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2611",
    "name": "HELPFUL SAMARITAN FOOD PANTRY",
    "latitude": 34.81183015,
    "longitude": -88.18895245,
    "address": "119 E EASTPORT ST",
    "city": "IUKA",
    "state": "MS",
    "zip_code": "38852",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2612",
    "name": "Hampton Baptist Church-MFP",
    "latitude": 37.0268463,
    "longitude": -76.3440545,
    "address": "40 KINGS WAY",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2613",
    "name": "Potter’s House Ministries",
    "latitude": 38.76023249,
    "longitude": -82.89368065,
    "address": "5409 WINCHESTER AVE",
    "city": "Sciotoville",
    "state": "OH",
    "zip_code": "45662",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2614",
    "name": "Community Care Center",
    "latitude": 38.68851664,
    "longitude": -83.60300036,
    "address": "212 E Main Street",
    "city": "Manchester",
    "state": "OH",
    "zip_code": "45144",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2615",
    "name": "Catholic Food Pantry at St. Mary's",
    "latitude": 41.28018089,
    "longitude": -84.3627947,
    "address": "715 JEFFERSON AVE",
    "city": "DEFIANCE",
    "state": "OH",
    "zip_code": "43512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2616",
    "name": "Grace Community Church",
    "latitude": 41.48328982,
    "longitude": -84.55325805,
    "address": "206 W BEMENT ST",
    "city": "BRYAN",
    "state": "OH",
    "zip_code": "43506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2618",
    "name": "Berkley South-MFP",
    "latitude": 37.09023331,
    "longitude": -76.44733672,
    "address": "4 SAINT EGNATIOS DR",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2620",
    "name": "Greater Williamsburg MFP",
    "latitude": 37.31290474,
    "longitude": -76.76479265,
    "address": "4451 LONGHILL RD",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23188",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2623",
    "name": "Lorain County Community College",
    "latitude": 41.41235151,
    "longitude": -82.07317222,
    "address": "1005 ABBE RD N",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2624",
    "name": "Coker Methodist (181)",
    "latitude": 29.5551427,
    "longitude": -98.49316311,
    "address": "231 E NORTH LOOP RD",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78216",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2625",
    "name": "Bread for Life ",
    "latitude": 37.4165921,
    "longitude": -76.53932743,
    "address": "6262 MAIN ST",
    "city": "GLOUCESTER",
    "state": "VA",
    "zip_code": "23061",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2629",
    "name": "St. Monica Church SVDP",
    "latitude": 41.4021827,
    "longitude": -81.5877162,
    "address": "13623 ROCKSIDE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2634",
    "name": "God's Pantry Portsmouth",
    "latitude": 38.73622093,
    "longitude": -82.98933465,
    "address": "801 Waller Street",
    "city": "Portsmouth",
    "state": "OH",
    "zip_code": "45662",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2636",
    "name": "Famicos Foundation ",
    "latitude": 41.5097149,
    "longitude": -81.6279612,
    "address": "8555 HOUGH AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2637",
    "name": "Pilgrim Christian Church",
    "latitude": 41.58064094,
    "longitude": -81.2024915,
    "address": "202 S HAMBDEN ST",
    "city": "CHARDON",
    "state": "OH",
    "zip_code": "44024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2638",
    "name": "North Star Neighborhood Reentry Resource Center ",
    "latitude": 41.50914568,
    "longitude": -81.65193203,
    "address": "1834 E 55TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2643",
    "name": "FLAT ROCK BAPTIST CHURCH/MATTHEW 25 MINISTRIES",
    "latitude": 34.670141,
    "longitude": -89.019896,
    "address": "385 PO BOX",
    "city": "BLUE MOUNTAIN",
    "state": "MS",
    "zip_code": "38610",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2644",
    "name": "FULTON UNITED METHODIST CHURCH PANTRY",
    "latitude": 34.27279512,
    "longitude": -88.40181388,
    "address": "301 E MAIN ST",
    "city": "FULTON",
    "state": "MS",
    "zip_code": "38843",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2645",
    "name": "Horizon Education Center - Market Square",
    "latitude": 41.4943865,
    "longitude": -81.6764699,
    "address": "2500 W.25th St.",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2646",
    "name": "BRINKLEY HEIGHTS FOOD PANTRY",
    "latitude": 35.1647797,
    "longitude": -89.9509424,
    "address": "3286 ROSAMOND AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2647",
    "name": "ST. VINCENT DEPAUL - ST. ANNE",
    "latitude": 35.112714,
    "longitude": -89.9453398,
    "address": "706 S HIGHLAND ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2650",
    "name": "AMORY FOOD PANTRY",
    "latitude": 33.98446949,
    "longitude": -88.48839985,
    "address": "123 MAIN ST S",
    "city": "AMORY",
    "state": "MS",
    "zip_code": "38821",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2651",
    "name": "ITAWAMBA UNITED METHODIST FOOD PANTRY WEST",
    "latitude": 34.32538639,
    "longitude": -88.49316394,
    "address": "5905 HWY 363",
    "city": "MANTACHIE",
    "state": "MS",
    "zip_code": "38855",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2652",
    "name": "St. Francis Catholic Outreach Center",
    "latitude": 38.74823397,
    "longitude": -82.98192417,
    "address": "2311 Stockham Lane",
    "city": "Portsmouth",
    "state": "OH",
    "zip_code": "45662",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2653",
    "name": "GRACE BAPTIST MINISTRIES",
    "latitude": 35.1745782,
    "longitude": -90.0318638,
    "address": "1231 N MANASSAS ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2654",
    "name": "FOOD DEPOT OF TISHIMINGO COUNTY",
    "latitude": 34.82718,
    "longitude": -88.2165,
    "address": "1701 Paul Edmundson Dr",
    "city": "IUKA",
    "state": "MS",
    "zip_code": "38852",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2656",
    "name": "AMEN Food Pantry ",
    "latitude": 34.93826258,
    "longitude": -88.52409398,
    "address": "104 W LINDEN ST",
    "city": "CORINTH",
    "state": "MS",
    "zip_code": "38834",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2657",
    "name": "CHOPIN Hall",
    "latitude": 41.0612369,
    "longitude": -83.6416379,
    "address": "1800 N BLANCHARD ST",
    "city": "FINDLAY",
    "state": "OH",
    "zip_code": "45840",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2659",
    "name": "Revealed Holiness House of God",
    "latitude": 39.2395159,
    "longitude": -84.452711,
    "address": "1408 Steffen Ave",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2660",
    "name": "Heart 4 the City Direct Distribution",
    "latitude": 41.08816279,
    "longitude": -81.46363725,
    "address": "954 Eastland Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2665",
    "name": "South Arlington United Methodist Church",
    "latitude": 41.05068795,
    "longitude": -81.49143204,
    "address": "790 S Arlington St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2669",
    "name": "UNION COUNTY GOOD SAMARITAN",
    "latitude": 34.51807066,
    "longitude": -89.01858443,
    "address": "845B SAM T BARKLEY DR",
    "city": "NEW ALBANY",
    "state": "MS",
    "zip_code": "38652",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2670",
    "name": "Coastal Community Church",
    "latitude": 37.11662884,
    "longitude": -76.46363139,
    "address": "101 VILLAGE AVE",
    "city": "YORKTOWN",
    "state": "VA",
    "zip_code": "23693",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2671",
    "name": "Lorain County Office on Aging",
    "latitude": 41.37412873,
    "longitude": -82.11846073,
    "address": "534 South Abbe Rd",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2675",
    "name": "ST. PAUL BAPTIST CHURCH",
    "latitude": 35.0070081,
    "longitude": -89.9917477,
    "address": "2156 E HOLMES RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38116",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2676",
    "name": "Lincoln Heights Boosters",
    "latitude": 39.298237,
    "longitude": -84.447483,
    "address": "12095 Chesterdale Road",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45246",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2677",
    "name": "Peter Maurin Center Food Pantry",
    "latitude": 41.05725071,
    "longitude": -81.5292794,
    "address": "1088 S Main St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2680",
    "name": "Have a Gay Day",
    "latitude": 39.7183416,
    "longitude": -84.2192598,
    "address": "1902 Needmore Rd",
    "city": "Dayton",
    "state": "OH",
    "zip_code": "45414",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2681",
    "name": "LANDMARK FOOD PANTRY ",
    "latitude": 35.1126375,
    "longitude": -89.9791311,
    "address": "2489 CARNES AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2682",
    "name": "PANOLA FOOD PANTRY ",
    "latitude": 34.504355,
    "longitude": -90.192058,
    "address": "201 VAN VORIS",
    "city": "CRENSHAW",
    "state": "MS",
    "zip_code": "38621",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2683",
    "name": "Church of God & Saints of Christ",
    "latitude": 41.459814,
    "longitude": -81.6615944,
    "address": "3561 INDEPENDENCE RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2684",
    "name": "Wakeman Caring Community",
    "latitude": 41.2547019,
    "longitude": -82.3951596,
    "address": "46 E MAIN ST",
    "city": "WAKEMAN",
    "state": "OH",
    "zip_code": "44889",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2685",
    "name": "St. Ambrose Catholic Works of Mercy",
    "latitude": 41.2499555,
    "longitude": -81.8410734,
    "address": "929 Pearl Rd",
    "city": "Brunswick",
    "state": "OH",
    "zip_code": "44212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2688",
    "name": "Mentor Senior Center",
    "latitude": 41.6991271,
    "longitude": -81.3356012,
    "address": "8484 MUNSON RD",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2689",
    "name": "Fish East Liverpool",
    "latitude": 40.6192802,
    "longitude": -80.5826358,
    "address": "213 W 4TH ST",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2691",
    "name": "The Foodbank (Walk Ins",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 ARMOR PL",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2692",
    "name": "Cuyahoga County Public Library",
    "latitude": 41.4180864,
    "longitude": -81.5693797,
    "address": "5225 LIBRARY LN",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2693",
    "name": "Westfall C.A.R.E.S",
    "latitude": 39.6983175,
    "longitude": -83.0557406,
    "address": "16394 TURNEY CALDWELL RD",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2695",
    "name": "SERENITY RECOVERY ",
    "latitude": 35.1450271,
    "longitude": -90.0238589,
    "address": "1094 POPLAR AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2696",
    "name": "Willard Area Food Bank",
    "latitude": 41.0573412,
    "longitude": -82.7284836,
    "address": "124 Maple St",
    "city": "WILLARD",
    "state": "OH",
    "zip_code": "44890",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2697",
    "name": "ST PATRICK CATHOLIC CHURCH ",
    "latitude": 35.1369431,
    "longitude": -90.0499994,
    "address": "297 S 4TH ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2698",
    "name": "South Side Lions (196)",
    "latitude": 29.3888281,
    "longitude": -98.4332173,
    "address": "3303 Pecan Valley Drive",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78210",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2701",
    "name": "The Way Station Columbiana",
    "latitude": 40.8900554,
    "longitude": -80.6741532,
    "address": "769 SPRINGFIELD RD",
    "city": "COLUMBIANA",
    "state": "OH",
    "zip_code": "44408",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2702",
    "name": "The Way Station East Liverpool",
    "latitude": 40.6197491,
    "longitude": -80.5808526,
    "address": "127 W 5TH ST",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2703",
    "name": "JEWISH FAMILY SERVICE ",
    "latitude": 35.1002046,
    "longitude": -89.8445158,
    "address": "6560 POPLAR AVE",
    "city": "GERMANTOWN",
    "state": "TN",
    "zip_code": "38138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2704",
    "name": "Emmanuel Community Care Center",
    "latitude": 41.1542731,
    "longitude": -80.7011934,
    "address": "2 N STATE ST",
    "city": "GIRARD",
    "state": "OH",
    "zip_code": "44420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2706",
    "name": "FIRST UNITED METHODIST MILLINGTON",
    "latitude": 35.3454368,
    "longitude": -89.8947941,
    "address": "8029 WILKINSVILLE RD",
    "city": "MILLINGTON",
    "state": "TN",
    "zip_code": "38053",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2707",
    "name": "Edward J. Eiding Food Pantry",
    "latitude": 39.11939824,
    "longitude": -84.6963043,
    "address": "150 Dahlia Ave.",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45233",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2709",
    "name": "Rust City Church",
    "latitude": 41.23611488,
    "longitude": -80.81225219,
    "address": "5555 Youngstown-Warren RD",
    "city": "Niles",
    "state": "OH",
    "zip_code": "44446",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2710",
    "name": "First Presbyterian Church Warren",
    "latitude": 41.2380559,
    "longitude": -80.8208125,
    "address": "256 MAHONING AVE NW",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44483",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2711",
    "name": "Columbiana Co Community Action",
    "latitude": 40.7870218,
    "longitude": -80.7722784,
    "address": "7860 LINCOLE PL",
    "city": "LISBON",
    "state": "OH",
    "zip_code": "44432",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2713",
    "name": "Salvation Army of Mahoning County",
    "latitude": 41.0856164,
    "longitude": -80.6730604,
    "address": "1501 GLENWOOD AVE",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44511",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2714",
    "name": "Ursuline Sisters Ministries",
    "latitude": 41.04460283,
    "longitude": -80.72762482,
    "address": "4250 SHIELDS RD",
    "city": "CANFIELD",
    "state": "OH",
    "zip_code": "44406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2715",
    "name": "Salvation Army East Liverpool",
    "latitude": 40.62060313,
    "longitude": -80.58664043,
    "address": "413 E 4TH ST",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2716",
    "name": "Yost Community Center",
    "latitude": 41.10929462,
    "longitude": -80.99220662,
    "address": "1320 GRANDVIEW RD",
    "city": "LAKE MILTON",
    "state": "OH",
    "zip_code": "44429",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2717",
    "name": "City Alive Church Food Pantry",
    "latitude": 41.051961,
    "longitude": -80.544699,
    "address": "5716 STRUTHERS RD",
    "city": "LOWELLVILLE",
    "state": "OH",
    "zip_code": "44436",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2718",
    "name": "Beatitude House",
    "latitude": 41.10532459,
    "longitude": -80.70109617,
    "address": "145 N GLENELLEN AVE",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44509",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2719",
    "name": "CATHOLIC CHARITIES",
    "latitude": 35.1414545,
    "longitude": -90.0167939,
    "address": "1325 JEFFERSON AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2720",
    "name": "Lisbon First United Methodist",
    "latitude": 40.77100719,
    "longitude": -80.76781299,
    "address": "114 E WASHINGTON ST",
    "city": "LISBON",
    "state": "OH",
    "zip_code": "44432",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2721",
    "name": "Austintown Community Church",
    "latitude": 41.0970955,
    "longitude": -80.76549832,
    "address": "242 S CANFIELD NILES RD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44515",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2722",
    "name": "The Centers - Gordon Square",
    "latitude": 41.4850076,
    "longitude": -81.723005,
    "address": "5209 DETROIT AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2726",
    "name": "The Centers - Uptown Health",
    "latitude": 41.514442,
    "longitude": -81.5990004,
    "address": "12201 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2732",
    "name": "Shelter Care Resources ",
    "latitude": 34.1986948,
    "longitude": -119.1553967,
    "address": "1925 EASTMAN AVE",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2736",
    "name": "Dayton Children's Hospital",
    "latitude": 39.7740282,
    "longitude": -84.1688698,
    "address": "1 CHILDRENS PLZ",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45404",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2737",
    "name": "Lewis Chatham Apts (79)",
    "latitude": 29.3612752,
    "longitude": -98.4937373,
    "address": "6405 S FLORES ST",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78214",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2738",
    "name": "ST JAMES TEMPLE COGIC",
    "latitude": 34.19945556,
    "longitude": -90.57467593,
    "address": "398 SUNFLOWER AVE",
    "city": "CLARKSDALE",
    "state": "MS",
    "zip_code": "38614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2739",
    "name": "CHURCH OF THE CROSSROADS/HIS COMPASSIONATE TOUCH",
    "latitude": 34.90770091,
    "longitude": -88.48919016,
    "address": "2037 HIGHWAY 72 E ANX",
    "city": "CORINTH",
    "state": "MS",
    "zip_code": "38834",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2742",
    "name": "J216 Ministry",
    "latitude": 39.2304492,
    "longitude": -83.2578346,
    "address": "3920 US-50",
    "city": "BAINBRIDGE",
    "state": "OH",
    "zip_code": "45612",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2747",
    "name": "Lorain County Community Action Agency",
    "latitude": 41.4625997,
    "longitude": -82.17288749,
    "address": "204 W.10th street",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2748",
    "name": "Todds Lane Bible Church",
    "latitude": 37.04070391,
    "longitude": -76.41936614,
    "address": "1457 TODDS LN",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2749",
    "name": "I Promise School Pantry",
    "latitude": 41.09026798,
    "longitude": -81.53121523,
    "address": "400 W MARKET ST",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44303",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2751",
    "name": "First Baptist Church of El Rio",
    "latitude": 34.2355983,
    "longitude": -119.1645598,
    "address": "2857 CORTEZ ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93036",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2752",
    "name": "Hope Center @ Magnetic Springs",
    "latitude": 40.35502376,
    "longitude": -83.26197964,
    "address": "30 Magnetic St",
    "city": "MARYSVILLE",
    "state": "OH",
    "zip_code": "43040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2753",
    "name": "Tichenor Middle School",
    "latitude": 39.0186653,
    "longitude": -84.6068716,
    "address": "305 Bartlett Ave",
    "city": "Erlanger",
    "state": "KY",
    "zip_code": "41018",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2755",
    "name": "THE DWELLING PLACE MOBILE",
    "latitude": 35.208249,
    "longitude": -89.9208767,
    "address": "3034 OLD AUSTIN PEAY HWY",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2756",
    "name": "North Woodbury Alliance Church",
    "latitude": 40.58647044,
    "longitude": -82.66198745,
    "address": "6385 STATE ROUTE 314",
    "city": "MOUNT GILEAD",
    "state": "OH",
    "zip_code": "43338",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2759",
    "name": "Bethel Church of the Nazarene",
    "latitude": 38.9619556,
    "longitude": -84.07814988,
    "address": "50 E Water St.",
    "city": "Bethel",
    "state": "OH",
    "zip_code": "45106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2761",
    "name": "University Hospitals Food Clinic",
    "latitude": 41.49351734,
    "longitude": -81.62522402,
    "address": "8819 QUINCY AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2762",
    "name": "Poindexter Place (CMHA)",
    "latitude": 39.9726232,
    "longitude": -82.9686688,
    "address": "240 N CHAMPION AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2763",
    "name": "MEMPHIS INTERNATIONAL CHURCH",
    "latitude": 35.1705865,
    "longitude": -89.917379,
    "address": "1435 WELLS STATION RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2765",
    "name": "YWCA",
    "latitude": 41.3646867,
    "longitude": -82.109764,
    "address": "318 West Ave",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2769",
    "name": "Unitarian Universalist Church of Akron",
    "latitude": 41.13126502,
    "longitude": -81.62189999,
    "address": "3300 Morewood Rd",
    "city": "Fairlawn",
    "state": "OH",
    "zip_code": "44333",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2771",
    "name": "St.Patrick Helping Hands",
    "latitude": 41.174175,
    "longitude": -82.2146434,
    "address": "512 N MAIN ST",
    "city": "WELLINGTON",
    "state": "OH",
    "zip_code": "44090",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2773",
    "name": "Church of the Resurrection: Bond Hill",
    "latitude": 39.1756463,
    "longitude": -84.46981545,
    "address": "1619 CALIFORNIA AVE",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2774",
    "name": "MetroHealth Food Clinic",
    "latitude": 41.45997845,
    "longitude": -81.70024233,
    "address": "2439 Southpoint Dr.",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2781",
    "name": "ODESSA GRANT FOOD PANTRY",
    "latitude": 34.6944,
    "longitude": -90.36942,
    "address": "624 PO BOX",
    "city": "TUNICA",
    "state": "MS",
    "zip_code": "38676",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2796",
    "name": "ST. JOHN'S UMC",
    "latitude": 35.1323584,
    "longitude": -90.021083,
    "address": "1207 PEABODY AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2807",
    "name": "Tunica 10 Point MOBILE",
    "latitude": 34.71994535,
    "longitude": -90.37490459,
    "address": "1165 ABBAY ST",
    "city": "TUNICA",
    "state": "MS",
    "zip_code": "38676",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2812",
    "name": "Lorain City School District",
    "latitude": 41.42719628,
    "longitude": -82.11492238,
    "address": "2321 FAIRLESS DR",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2813",
    "name": "ST. VINCENT DE PAUL-ST.MICHAEL",
    "latitude": 35.1487257,
    "longitude": -89.9325147,
    "address": "3863 SUMMER AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2815",
    "name": "Clearview School District ",
    "latitude": 41.42494383,
    "longitude": -82.16631504,
    "address": "100 N RIDGE RD W",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44053",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2817",
    "name": "Midview Local Schools ",
    "latitude": 41.29755373,
    "longitude": -82.06367723,
    "address": "12865 GRAFTON RD",
    "city": "GRAFTON",
    "state": "OH",
    "zip_code": "44044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2819",
    "name": "RIVERS OF LIFE INTERNATIONAL MINISTRIES ",
    "latitude": 35.05038679,
    "longitude": -89.19591937,
    "address": "524 HIGHWAY 57  W",
    "city": "GRAND JUNCTION",
    "state": "TN",
    "zip_code": "38039",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2822",
    "name": "Antioch Improvement Ministries",
    "latitude": 37.04337218,
    "longitude": -76.30268684,
    "address": "1553 OLD BUCKROE RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23664",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2823",
    "name": "UMNC HEARTSONG ",
    "latitude": 35.1476047,
    "longitude": -89.7243673,
    "address": "800 N HOUSTON LEVEE RD",
    "city": "CORDOVA",
    "state": "TN",
    "zip_code": "38018",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2828",
    "name": "Greater Peace Missionary Baptist Church",
    "latitude": 41.4867854,
    "longitude": -81.5563346,
    "address": "3435 FAIRMOUNT BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2829",
    "name": "Canal Fulton Community cupboard",
    "latitude": 40.9001524,
    "longitude": -81.5844213,
    "address": "8101 Manchester Ave NW",
    "city": "Canal Fulton",
    "state": "OH",
    "zip_code": "44614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2865",
    "name": "Abundant Life",
    "latitude": 39.24442135,
    "longitude": -84.57562285,
    "address": "2740 Hyannis",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45251",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2872",
    "name": "Salvation Army Sidney",
    "latitude": 40.2901297,
    "longitude": -84.1676168,
    "address": "419 BUCKEYE AVE",
    "city": "SIDNEY",
    "state": "OH",
    "zip_code": "45365",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2874",
    "name": "E House",
    "latitude": 37.0273261,
    "longitude": -76.4518183,
    "address": "521 NORTH AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2875",
    "name": "HELPING HANDS FOOD PANTRY",
    "latitude": 34.25528829,
    "longitude": -88.70866449,
    "address": "314 S CHURCH ST",
    "city": "TUPELO",
    "state": "MS",
    "zip_code": "38804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2878",
    "name": "ALPHA OMEGA VETERANS SERVICE, INC",
    "latitude": 35.1628187,
    "longitude": -89.9573608,
    "address": "3114 Jackson Ave",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2879",
    "name": "HOLY TEMPLE CHURCH",
    "latitude": 35.2496374,
    "longitude": -89.9394961,
    "address": "4590 NEW ALLEN RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2883",
    "name": "REELFOOT RURAL MINISTRIES",
    "latitude": 36.2742543,
    "longitude": -89.39434647,
    "address": "6923 MINNICK ELBRIDGE RD",
    "city": "OBION",
    "state": "TN",
    "zip_code": "38240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2884",
    "name": "HOPE HOUSE",
    "latitude": 35.1372595,
    "longitude": -90.0015205,
    "address": "15 S IDLEWILD ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2892",
    "name": "Madison County Public Health",
    "latitude": 39.89516414,
    "longitude": -83.44035933,
    "address": "306 Lafayette Street",
    "city": "LONDON",
    "state": "OH",
    "zip_code": "43140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2897",
    "name": "OXFORD FOOD PANTRY",
    "latitude": 34.37451434,
    "longitude": -89.52700826,
    "address": "713 MOLLY BARR RD",
    "city": "OXFORD",
    "state": "MS",
    "zip_code": "38655",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2898",
    "name": "SACRED HEART SOUTHERN MISSIONS",
    "latitude": 34.94971161,
    "longitude": -90.15344255,
    "address": "6144 HWY 161 NORTH",
    "city": "WALLS",
    "state": "MS",
    "zip_code": "38680",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2899",
    "name": "THE SAMARITANS",
    "latitude": 34.96272779,
    "longitude": -90.03727219,
    "address": "2600 GOODMAN RD W",
    "city": "HORN LAKE",
    "state": "MS",
    "zip_code": "38637",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2900",
    "name": "Six House ",
    "latitude": 37.00119553,
    "longitude": -76.38155138,
    "address": "2003 KECOUGHTAN RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2903",
    "name": "Well Help ",
    "latitude": 41.1742946,
    "longitude": -82.2248695,
    "address": "127 PARK PL",
    "city": "WELLINGTON",
    "state": "OH",
    "zip_code": "44090",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2904",
    "name": "Willard Church of God",
    "latitude": 41.0544404,
    "longitude": -82.7503319,
    "address": "4551 Willard West Rd.",
    "city": "Willard",
    "state": "Ohio",
    "zip_code": "44890",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2907",
    "name": "Langley Christian Church",
    "latitude": 37.05547205,
    "longitude": -76.32979066,
    "address": "175 FOX HILL RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2908",
    "name": "Temple of Refuge",
    "latitude": 36.9814302,
    "longitude": -76.4105597,
    "address": "906 21ST ST",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2910",
    "name": "SPB Helping Hands Food Pantry",
    "latitude": 41.53673592,
    "longitude": -81.48650453,
    "address": "5384 WILSON MILLS RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44143",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2911",
    "name": "Buckroe Baptist Church",
    "latitude": 37.04034435,
    "longitude": -76.29474203,
    "address": "1819 N MALLORY ST",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23664",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2912",
    "name": "Rock Church",
    "latitude": 37.121524,
    "longitude": -76.5320872,
    "address": "340 TABBS LN",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2913",
    "name": "Ashtabula Towers",
    "latitude": 41.8638923,
    "longitude": -80.7852241,
    "address": "325 W 48TH ST",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2915",
    "name": "UNITY TEMPLE",
    "latitude": 35.61828742,
    "longitude": -88.80505915,
    "address": "369 LEXINGTON AVE",
    "city": "JACKSON",
    "state": "TN",
    "zip_code": "38301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2919",
    "name": "BALDWYN FIRST UNITED METHODIST CHURCH",
    "latitude": 34.51014194,
    "longitude": -88.63622543,
    "address": "312 W MAIN ST",
    "city": "BALDWYN",
    "state": "MS",
    "zip_code": "38824",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2920",
    "name": "ALIENTO DE VIDA SDA CHURCH",
    "latitude": 35.0724806,
    "longitude": -89.8761271,
    "address": "2771 CLARKE RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2922",
    "name": "CAPLEVILLE UMC",
    "latitude": 35.0193602,
    "longitude": -89.8319284,
    "address": "4725 RIVERDALE RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38141",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2924",
    "name": "MFP The Love Church",
    "latitude": 42.1419,
    "longitude": -76.8138,
    "address": "3136 LAKE RD",
    "city": "HORSEHEADS",
    "state": "NY",
    "zip_code": "14845",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2925",
    "name": "MFP Senior - Addison Place",
    "latitude": 42.0999,
    "longitude": -77.237,
    "address": "43 WILLIAM ST",
    "city": "ADDISON",
    "state": "NY",
    "zip_code": "14801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2927",
    "name": "Buckeye Food Alliance Food Pantry",
    "latitude": 40.588875,
    "longitude": -83.12552,
    "address": "1465 MOUNT VERNON AVE",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2929",
    "name": "FEEDING HEART FOOD PANTRY",
    "latitude": 34.95591,
    "longitude": -89.51604,
    "address": "5996 Hwy 178 West ",
    "city": "RED BANKS",
    "state": "MS",
    "zip_code": "38661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2930",
    "name": "Sandstone Community Church",
    "latitude": 41.3570734,
    "longitude": -82.246628,
    "address": "201 W MAIN ST",
    "city": "SOUTH AMHERST",
    "state": "OH",
    "zip_code": "44001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2931",
    "name": "UNIVERSITY OF MEMPHIS TIGER PANTRY ",
    "latitude": 35.120123,
    "longitude": -89.939705,
    "address": "359 UNIVERISTY CTR",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38152",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2932",
    "name": "IGLESIA APOSTOLICA ",
    "latitude": 35.2142347,
    "longitude": -90.040802,
    "address": "3248 BENJESTOWN RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2937",
    "name": "SAINT JOHN BAPTIST CHURCH",
    "latitude": 35.1345989,
    "longitude": -90.0402707,
    "address": "640 VANCE AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2940",
    "name": "WE ARE FAMILY",
    "latitude": 35.0360929,
    "longitude": -89.8381983,
    "address": "6720 E RAINES RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2946",
    "name": "DAVIS TEMPLE OUTREACH MOBILE",
    "latitude": 34.78055653,
    "longitude": -89.43986886,
    "address": "635 WEST ST",
    "city": "HOLLY SPRINGS",
    "state": "MS",
    "zip_code": "38635",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2948",
    "name": "Beauty for Ashes Church",
    "latitude": 37.1348377,
    "longitude": -76.5286548,
    "address": "487 DENBIGH BLVD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2949",
    "name": "Greater Bethlehem Christian Assembly",
    "latitude": 37.01530967,
    "longitude": -76.35624283,
    "address": "360 IVY HOME RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2950",
    "name": "Our Lady of Lourdes Church",
    "latitude": 41.084232,
    "longitude": -82.3976643,
    "address": "18 PARK AVE",
    "city": "NEW LONDON",
    "state": "OH",
    "zip_code": "44851",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2951",
    "name": "St. Agnes Table of Plenty Food Pantry",
    "latitude": 41.3772337,
    "longitude": -82.119758,
    "address": "611 LAKE AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2952",
    "name": "Norwalk Alliance Church ",
    "latitude": 41.2154217,
    "longitude": -82.5928499,
    "address": "2755 US HIGHWAY 250  S",
    "city": "NORWALK",
    "state": "OH",
    "zip_code": "44857",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2953",
    "name": "Mother Cabrini's Food Pantry",
    "latitude": 41.4370408,
    "longitude": -82.1214037,
    "address": "2143 HOMEWOOD DR",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2954",
    "name": "Harvestland Ministries ",
    "latitude": 37.0079485,
    "longitude": -76.4380497,
    "address": "5889 JEFFERSON AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2966",
    "name": "Lagrange Lions Community Foundation ",
    "latitude": 41.23589064,
    "longitude": -82.12201111,
    "address": "240 GLENDALE ST",
    "city": "LAGRANGE",
    "state": "OH",
    "zip_code": "44050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2967",
    "name": "St.Paul United Methodist Church Pantry ",
    "latitude": 40.7324864,
    "longitude": -82.8024511,
    "address": "746 CHERRY ST",
    "city": "GALION",
    "state": "OH",
    "zip_code": "44833",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2970",
    "name": "WORD OF FAITH ",
    "latitude": 36.01672595,
    "longitude": -89.39299517,
    "address": "515 LAIRD ST",
    "city": "DYERSBURG",
    "state": "TN",
    "zip_code": "38024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2971",
    "name": "West Side Community House",
    "latitude": 41.4691785,
    "longitude": -81.7476184,
    "address": "9300 LORAIN AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2972",
    "name": "Church Of Our Saviour",
    "latitude": 39.1254796,
    "longitude": -84.5101113,
    "address": "65 E Hollister St",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2973",
    "name": "First Baptist Church Denbigh ",
    "latitude": 37.1204241,
    "longitude": -76.5220905,
    "address": "3628 CAMPBELL RD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2975",
    "name": "ST. LUKE BAPTIST CHURCH",
    "latitude": 35.557255,
    "longitude": -89.657223,
    "address": "632 ST LUKE RD",
    "city": "COVINGTON",
    "state": "TN",
    "zip_code": "38019",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2979",
    "name": "GRACE UMC",
    "latitude": 35.0351644,
    "longitude": -90.0101361,
    "address": "1619 E RAINES RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38116",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2981",
    "name": "CATHOLIC CHURCH OF ASCENSION",
    "latitude": 35.2261499,
    "longitude": -89.9249026,
    "address": "3680 RAMILL RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2982",
    "name": "BREAD OF LIFE - CORNERSTONE",
    "latitude": 35.01666752,
    "longitude": -89.61741442,
    "address": "1350 HIGHWAY 196  S",
    "city": "COLLIERVILLE",
    "state": "TN",
    "zip_code": "38017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2989",
    "name": "Vine Of Hope",
    "latitude": 41.46512179,
    "longitude": -82.1587236,
    "address": "1310 COLORADO AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2992",
    "name": "CHRIST MISSIONARY BAPTIST CHURCH",
    "latitude": 35.1077763,
    "longitude": -90.0465389,
    "address": "480 S PARKWAY  E",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-2999",
    "name": "Newfield Kitchen Cupboard",
    "latitude": 42.3602277,
    "longitude": -76.593736,
    "address": "227 Main Street",
    "city": "NEWFIELD",
    "state": "NY",
    "zip_code": "14867",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3008",
    "name": "SYNERGY TREATMENT CENTERS",
    "latitude": 35.0635074,
    "longitude": -89.988046,
    "address": "2305 AIRPORT INTERCHANGE AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38132",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3009",
    "name": "CALVARY BAPTIST CHURCH",
    "latitude": 36.41164637,
    "longitude": -89.01902176,
    "address": "2250 E REELFOOT AVE",
    "city": "UNION CITY",
    "state": "TN",
    "zip_code": "38261",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3010",
    "name": "DYERSBURG CHRISTIAN CENTER",
    "latitude": 36.0328094,
    "longitude": -89.3905713,
    "address": "439 W COURT ST",
    "city": "DYERSBURG",
    "state": "TN",
    "zip_code": "38024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3013",
    "name": "IMPACT AMERICA MINISTRIES",
    "latitude": 35.2062773,
    "longitude": -89.996727,
    "address": "2025 CLIFTON AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3021",
    "name": "FIRST PRESBYTERIAN CHURCH",
    "latitude": 35.1498456,
    "longitude": -90.0485307,
    "address": "166 POPLAR AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3022",
    "name": "Windsor Human Development Food Pantry",
    "latitude": 42.0700844,
    "longitude": -75.6427604,
    "address": "594 Kent St",
    "city": "WINDSOR",
    "state": "NY",
    "zip_code": "13865",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3023",
    "name": "Bread of Life Food Pantry",
    "latitude": 42.2277,
    "longitude": -76.3386,
    "address": "1 Water St",
    "city": "CANDOR",
    "state": "NY",
    "zip_code": "13743",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3024",
    "name": "Project Neighbor of Newark Valley Food Pantry",
    "latitude": 42.2199,
    "longitude": -76.1868,
    "address": "79 Whig St",
    "city": "NEWARK VALLEY",
    "state": "NY",
    "zip_code": "13811",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3034",
    "name": "Helping Hands Food Pantry",
    "latitude": 42.3067,
    "longitude": -76.1867,
    "address": "11 Jewett Hill Rd",
    "city": "BERKSHIRE",
    "state": "NY",
    "zip_code": "13736",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3038",
    "name": "Park Terrace Food Pantry",
    "latitude": 42.0578,
    "longitude": -76.1262,
    "address": "30 GLANN RD",
    "city": "APALACHIN",
    "state": "NY",
    "zip_code": "13732",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3040",
    "name": "Norwalk Salvation Army",
    "latitude": 41.2438486,
    "longitude": -82.6169336,
    "address": "55 WHITTLESEY AVE",
    "city": "NORWALK",
    "state": "OH",
    "zip_code": "44857",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3042",
    "name": "GOOD NEIGHBOR LOVE",
    "latitude": 35.1463265,
    "longitude": -90.1753477,
    "address": "709 E BROADWAY ST",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3043",
    "name": "NAMBC",
    "latitude": 35.0830213,
    "longitude": -90.0151006,
    "address": "1437 NORRIS RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3044",
    "name": "NEIGHBORHOOD CHRISTIAN CENTER NORTH CENTER",
    "latitude": 35.1567208,
    "longitude": -90.0325126,
    "address": "785 JACKSON AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3046",
    "name": "City of Berea",
    "latitude": 41.3583297,
    "longitude": -81.8799712,
    "address": "535 WYLESWOOD DR",
    "city": "BEREA",
    "state": "OH",
    "zip_code": "44017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3047",
    "name": "Hope United Methodist Church",
    "latitude": 41.39493321,
    "longitude": -81.53710404,
    "address": "79 CENTER RD",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3048",
    "name": "BICKFORD COMMUNITY CENTER/Oasis of Hope-Senior",
    "latitude": 35.1657758,
    "longitude": -90.0404439,
    "address": "233 HENRY AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3049",
    "name": "Spring Valley Global Methodist Church",
    "latitude": 39.6080098,
    "longitude": -84.0073066,
    "address": "1 Walnut St.",
    "city": "SPRING VALLEY",
    "state": "OH",
    "zip_code": "45370",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3052",
    "name": "Hartford Community Church Food Pantry",
    "latitude": 41.30898227,
    "longitude": -80.56843566,
    "address": "3334 State Route 7",
    "city": "HARTFORD",
    "state": "OH",
    "zip_code": "44424",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3053",
    "name": "First Federated Church",
    "latitude": 41.1005831,
    "longitude": -80.8531135,
    "address": "10786 Mahoning Ave",
    "city": "NORTH JACKSON",
    "state": "OH",
    "zip_code": "44451",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3057",
    "name": "SPIRIT OF TRUTH UMC",
    "latitude": 35.40996067,
    "longitude": -89.53510777,
    "address": "186 FRONT ST",
    "city": "MASON",
    "state": "TN",
    "zip_code": "38049",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3061",
    "name": "MFP Rehoboth Deliverance Ministry",
    "latitude": 42.3182797,
    "longitude": -77.6495001,
    "address": "112 EAST AVE",
    "city": "HORNELL",
    "state": "NY",
    "zip_code": "14843",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3062",
    "name": "Newbury Park First Christian Church",
    "latitude": 34.1629041,
    "longitude": -118.9556371,
    "address": "801 KNOLLWOOD DR",
    "city": "NEWBURY PARK",
    "state": "CA",
    "zip_code": "91320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3063",
    "name": "CSUCI -Foundation - Wellness Promotion & Education",
    "latitude": 34.16216375,
    "longitude": -119.04209548,
    "address": "1 UNIVERSITY DR",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93012",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3064",
    "name": "Nyeland Promise",
    "latitude": 34.22626753,
    "longitude": -119.13840981,
    "address": "3334 SANTA CLARA AVE",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93036",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3065",
    "name": "Ambassadors for Jesus Christ",
    "latitude": 37.03112416,
    "longitude": -76.30985865,
    "address": "4 DUNCAN DR",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23663",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3066",
    "name": "Temple Blessings",
    "latitude": 39.1914336,
    "longitude": -84.4586763,
    "address": "1833 Losantiville Ave",
    "city": "Cincinnati",
    "state": "OH",
    "zip_code": "45237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3067",
    "name": "OCCHA",
    "latitude": 41.0614005,
    "longitude": -80.6309412,
    "address": "3660 SHIRLEY RD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44502",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3068",
    "name": "Clinton Township CHAT",
    "latitude": 40.0467288,
    "longitude": -82.9546463,
    "address": "3820 Cleveland Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3069",
    "name": "Victory Church of Coitsville",
    "latitude": 41.0899516,
    "longitude": -80.5299134,
    "address": "3899 McCartney Road",
    "city": "LOWELLVILLE",
    "state": "OH",
    "zip_code": "44436",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3070",
    "name": "Open Door Community Church",
    "latitude": 41.1551673,
    "longitude": -80.7179993,
    "address": "525 E MARSHALL RD",
    "city": "MC DONALD",
    "state": "OH",
    "zip_code": "44437",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3072",
    "name": "St. Elias Melkite Church",
    "latitude": 41.4395814,
    "longitude": -81.7385614,
    "address": "8023 Memphis Ave.",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44144",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3073",
    "name": "Mt. Calvary",
    "latitude": 41.073822,
    "longitude": -80.656567,
    "address": "8112 Oak Hill",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44507",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3074",
    "name": "South Range Council",
    "latitude": 40.946553,
    "longitude": -80.6608874,
    "address": "11836 SOUTH AVE",
    "city": "NORTH LIMA",
    "state": "OH",
    "zip_code": "44452",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3105",
    "name": "GREATER MIDDLE BAPTIST ",
    "latitude": 35.0625456,
    "longitude": -89.8974938,
    "address": "4982 KNIGHT ARNOLD RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3107",
    "name": "QUITMAN COUNTY FOOD PANTRY",
    "latitude": 34.202923,
    "longitude": -90.281184,
    "address": "P. O. BOX 1627",
    "city": "LAMBERT",
    "state": "MS",
    "zip_code": "38643",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3109",
    "name": "Salvation Army Williamsburg",
    "latitude": 37.2888793,
    "longitude": -76.7282741,
    "address": "216 IRONBOUND RD",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23188",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3112",
    "name": "First United Methodist Church Fox Hill",
    "latitude": 37.05906563,
    "longitude": -76.30019975,
    "address": "1 SALT POND RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23664",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3115",
    "name": "FRIENDS FOR LIFE",
    "latitude": 35.1401087,
    "longitude": -90.0164869,
    "address": "43 N CLEVELAND ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3116",
    "name": "Gethsemane Lutheran Church",
    "latitude": 40.074322,
    "longitude": -83.0175597,
    "address": "35 E STANTON AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43214",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3122",
    "name": "Villa Mercede",
    "latitude": 41.4849796,
    "longitude": -81.73333751,
    "address": "1331 W 70TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3124",
    "name": "WESLEY HIGHLAND MEADOWS SENIORS",
    "latitude": 35.2025378,
    "longitude": -89.9463848,
    "address": "3517 ANDY WAY LN",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3129",
    "name": "Sharon Woods Church",
    "latitude": 40.0891241,
    "longitude": -82.9704662,
    "address": "5959 SHARON WOODS BLVD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3130",
    "name": "SHELBY STATION SENIORS",
    "latitude": 35.0583649,
    "longitude": -89.9155586,
    "address": "3290 WOODHOLLOW DR",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3132",
    "name": "Amazing Grace Food Pantry",
    "latitude": 41.09935068,
    "longitude": -80.9366866,
    "address": "15736 MAHONING AVE",
    "city": "DIAMOND",
    "state": "OH",
    "zip_code": "44412",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3135",
    "name": "MACE",
    "latitude": 41.57984846,
    "longitude": -81.49291237,
    "address": "26901 CHARDON RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44143",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3138",
    "name": "SALVATION ARMY - DYER COUNTY",
    "latitude": 36.0324904,
    "longitude": -89.3886974,
    "address": "318 W MARKET ST",
    "city": "DYERSBURG",
    "state": "TN",
    "zip_code": "38024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3139",
    "name": "Greenwood-Rexville Food Pantry",
    "latitude": 42.13312928,
    "longitude": -77.64890217,
    "address": "2666 State Route 248",
    "city": "GREENWOOD",
    "state": "NY",
    "zip_code": "14839",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3141",
    "name": "First Baptist Church Morrison",
    "latitude": 37.1401273,
    "longitude": -76.5149573,
    "address": "12720 PATRICK HENRY DR",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3142",
    "name": "Salem United Methodist Church",
    "latitude": 37.52708237,
    "longitude": -76.59368482,
    "address": "11408 SALEM CHURCH RD",
    "city": "GLOUCESTER",
    "state": "VA",
    "zip_code": "23061",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3144",
    "name": "Spirit of Truth",
    "latitude": 36.9836834,
    "longitude": -76.4161535,
    "address": "2501 MARSHALL AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3146",
    "name": "Peninsula Hispanic SDA",
    "latitude": 37.0185821,
    "longitude": -76.4378085,
    "address": "682 79TH ST",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3149",
    "name": "MATTHEW 25:40, INC",
    "latitude": 36.0335247,
    "longitude": -89.3902581,
    "address": "432 W. Court St.",
    "city": "DYERSBURG",
    "state": "TN",
    "zip_code": "38024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3150",
    "name": "Parma Heights Senior Center",
    "latitude": 41.3795736,
    "longitude": -81.7499598,
    "address": "9275 North Church Dr",
    "city": "MIDDLEBURG HGTS",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3151",
    "name": "North Canton Cares Pantry",
    "latitude": 40.88984434,
    "longitude": -81.41906333,
    "address": "",
    "city": "North Canton",
    "state": "OH",
    "zip_code": "44720",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3156",
    "name": "Heavenly Harvest Food Pantry",
    "latitude": 41.4388156,
    "longitude": -81.8208271,
    "address": "4260 Rocky River Road",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3162",
    "name": "Immaculate Heart of Mary Church",
    "latitude": 41.10377468,
    "longitude": -80.73614972,
    "address": "4490 NORQUEST BLVD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44515",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3166",
    "name": "House of Mercy-MFP",
    "latitude": 37.2749666,
    "longitude": -76.7155442,
    "address": "10 HARRISON AVE",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23185",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3169",
    "name": "Hampton Baptist Church",
    "latitude": 37.02652032,
    "longitude": -76.34433698,
    "address": "40 KINGS WAY",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3170",
    "name": "Cleveland Heights-University Heights Public Library",
    "latitude": 41.5074947,
    "longitude": -81.579655,
    "address": "1925 COVENTRY RD",
    "city": "CLEVELAND HEIGHTS",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3173",
    "name": "First Baptist Church of Greater Cleveland",
    "latitude": 41.4858323,
    "longitude": -81.5495677,
    "address": "3630 FAIRMOUNT BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3174",
    "name": "Grace Tabernacle Baptist Church",
    "latitude": 41.519337,
    "longitude": -81.4988199,
    "address": "5020 MAYFIELD RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44124",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3175",
    "name": "Cleveland Hope Exchange",
    "latitude": 41.4621186,
    "longitude": -81.7095513,
    "address": "3185 W 41st St.",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3176",
    "name": "HOPE MINISTRIES ",
    "latitude": 34.621475,
    "longitude": -89.96314021,
    "address": "110 N ROBINSON ST",
    "city": "SENATOBIA",
    "state": "MS",
    "zip_code": "38668",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3177",
    "name": "Sandusky Church of God",
    "latitude": 41.3961628,
    "longitude": -82.6927255,
    "address": "1018 W BOGART RD",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3179",
    "name": "The Tabernacle Church",
    "latitude": 41.651011,
    "longitude": -83.5556785,
    "address": "531 PINEWOOD AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43604",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3180",
    "name": "River of Life Church",
    "latitude": 41.6859846,
    "longitude": -83.5895232,
    "address": "3611 UPTON AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43613",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3181",
    "name": "Mt. Zion Oakwood Village",
    "latitude": 41.38669,
    "longitude": -81.527124,
    "address": "1 MOUNT ZION CIR",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3183",
    "name": "Advancing Gods Kingdom",
    "latitude": 37.05755293,
    "longitude": -76.34735131,
    "address": "1401 N KING ST",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3184",
    "name": "Crossroads Community Church - Camarillo",
    "latitude": 34.21494622,
    "longitude": -119.06044296,
    "address": "161 PLAZA LA VISTA",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3185",
    "name": "SDA - Thousand Oaks",
    "latitude": 34.1924767,
    "longitude": -118.8879809,
    "address": "480 W GAINSBOROUGH RD",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91360",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3187",
    "name": "Rise In Love",
    "latitude": 41.4511071,
    "longitude": -81.7495595,
    "address": "9227 CLINTON RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44144",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3188",
    "name": "Wayland Food Pantry at Lighthouse",
    "latitude": 42.5659523,
    "longitude": -77.5900417,
    "address": "101 S LACKAWANNA ST",
    "city": "WAYLAND",
    "state": "NY",
    "zip_code": "14572",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3189",
    "name": "Solid Rock Community Church of Elyria",
    "latitude": 41.3964802,
    "longitude": -82.0790489,
    "address": "680 ABBE RD N",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3192",
    "name": "Salvation Army Hampton",
    "latitude": 37.04926176,
    "longitude": -76.42940539,
    "address": "1033 BIG BETHEL RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3194",
    "name": "Neighbor to Neighbor Food Pantry ",
    "latitude": 41.1055069,
    "longitude": -82.6102229,
    "address": "505 West State Rt 162",
    "city": "NORTH FAIRFIELD",
    "state": "OH",
    "zip_code": "44855",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3196",
    "name": "Bethel Temple",
    "latitude": 37.04018623,
    "longitude": -76.40870558,
    "address": "1705 TODDS LN",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3197",
    "name": "Grove Christian Outreach Center",
    "latitude": 37.214433,
    "longitude": -76.6187265,
    "address": "8800 POCAHONTAS TRL",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23185",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3198",
    "name": "Mercy Seat Baptist Church",
    "latitude": 37.04321408,
    "longitude": -76.43694047,
    "address": "1013 TODDS LN",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3199",
    "name": "THRIVE Peninsula",
    "latitude": 37.1122844,
    "longitude": -76.5194082,
    "address": "13195 WARWICK BLVD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3200",
    "name": "White Marsh Baptist Church",
    "latitude": 37.34182,
    "longitude": -76.520077,
    "address": "5123 George Washington Memorial Hwy",
    "city": "WHITE MARSH",
    "state": "VA",
    "zip_code": "23183",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3206",
    "name": "Community Volunteer Council",
    "latitude": 41.2351646,
    "longitude": -80.8402774,
    "address": "1642 W. Market Street SW",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44485",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3207",
    "name": "EB Life",
    "latitude": 41.0961642,
    "longitude": -80.6280264,
    "address": "7 S. Garland",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3208",
    "name": "Trinity Baptist Church",
    "latitude": 41.2327301,
    "longitude": -80.8263678,
    "address": "221 Highland Ave. SW",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44485",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3209",
    "name": "Cortland Area Cares",
    "latitude": 41.3211828,
    "longitude": -80.7124797,
    "address": "1000 Fowler St.",
    "city": "CORTLAND",
    "state": "OH",
    "zip_code": "44410",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3210",
    "name": "First Baptist Church",
    "latitude": 40.6003692,
    "longitude": -80.6546341,
    "address": "1401 Center Street",
    "city": "WELLSVILLE",
    "state": "OH",
    "zip_code": "43968",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3212",
    "name": "Newton Falls Ministerial Alliance",
    "latitude": 41.18815133,
    "longitude": -80.97749867,
    "address": "26 1/2  W. Broad Street",
    "city": "NEWTON FALLS",
    "state": "OH",
    "zip_code": "44444",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3213",
    "name": "Food for Friends by Friends",
    "latitude": 40.8336342,
    "longitude": -80.8962631,
    "address": "4615 Whinnery Rd.",
    "city": "SALEM",
    "state": "OH",
    "zip_code": "44460",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3214",
    "name": "Counseling Center of Columbiana",
    "latitude": 40.7659252,
    "longitude": -80.7325646,
    "address": "40722 SR 154",
    "city": "LISBON",
    "state": "OH",
    "zip_code": "44432",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3215",
    "name": "Warren SDA",
    "latitude": 41.2549302,
    "longitude": -80.7741972,
    "address": "1645 North Rd. NE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44483",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3216",
    "name": "Champion Christian Church",
    "latitude": 41.3082876,
    "longitude": -80.850967,
    "address": "151 Center Street W",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44481",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3217",
    "name": "Second Baptist Church",
    "latitude": 41.2218438,
    "longitude": -80.8181977,
    "address": "1510 Main Ave",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44483",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3218",
    "name": "Northampton Christian Church",
    "latitude": 37.04196868,
    "longitude": -76.42469589,
    "address": "1409 TODDS LN",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3219",
    "name": "MetroHealth Mobile Pantry",
    "latitude": 41.4628833,
    "longitude": -81.6961346,
    "address": "2500 METROHEALTH DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3222",
    "name": "Noor Islamic Cultural Center",
    "latitude": 40.065267,
    "longitude": -83.1495323,
    "address": "5001 WILCOX RD",
    "city": "DUBLIN",
    "state": "OH",
    "zip_code": "43016",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3225",
    "name": "Pocahontas Temple Baptist Church",
    "latitude": 36.97530202,
    "longitude": -76.99905484,
    "address": "10324 Branch Street",
    "city": "WAKEFIELD",
    "state": "VA",
    "zip_code": "23888",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3226",
    "name": "All Saints Temple COGIC",
    "latitude": 40.7858502,
    "longitude": -81.3691113,
    "address": "1451 Wilbur Allen Jr Ave SE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44707",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3227",
    "name": "Perry Helping Perry",
    "latitude": 40.7938748,
    "longitude": -81.4617906,
    "address": "3757 Lincoln Way W",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3228",
    "name": "WESTWOOD YOUTH DEVELOPMENT",
    "latitude": 35.027068,
    "longitude": -90.0847252,
    "address": "620 PARKROSE AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3229",
    "name": "Crusading Outreach Ministry",
    "latitude": 37.0672465,
    "longitude": -76.4921386,
    "address": "711 Spruce Street",
    "city": "Hampton",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3232",
    "name": "Temple Baptist Church",
    "latitude": 37.0575378,
    "longitude": -76.4695761,
    "address": "235 HARPERSVILLE RD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3233",
    "name": "Living Waters Family Outreach",
    "latitude": 37.435603,
    "longitude": -76.547405,
    "address": "2061 Windsor Road",
    "city": "GLOUCESTER",
    "state": "VA",
    "zip_code": "23061",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3236",
    "name": "FIRST BAPTIST CHURCH",
    "latitude": 35.59257353,
    "longitude": -89.25864342,
    "address": "311 E JEFFERSON ST",
    "city": "BROWNSVILLE",
    "state": "TN",
    "zip_code": "38012",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3237",
    "name": "RIDGELY CHAPEL BAPTIST CHURCH",
    "latitude": 36.2712134,
    "longitude": -89.4851301,
    "address": "552 BISHOP ST",
    "city": "RIDGELY",
    "state": "TN",
    "zip_code": "38080",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3240",
    "name": "LUTHER TERRACE",
    "latitude": 35.2036276,
    "longitude": -89.9333527,
    "address": "3907 JAMES RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3243",
    "name": "Horizon Education Center- Triskett Station",
    "latitude": 41.46460359,
    "longitude": -81.7857958,
    "address": "13700 TRISKETT RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3247",
    "name": "North Riverdale Lutheran Church",
    "latitude": 39.7935915,
    "longitude": -84.2171289,
    "address": "45 KURTZ AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45405",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3248",
    "name": "Runnymede Holiness Church",
    "latitude": 37.0335152,
    "longitude": -76.85467337,
    "address": "7711 WHITE MARSH RD",
    "city": "ELBERON",
    "state": "VA",
    "zip_code": "23846",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3251",
    "name": "Living Faith Christian Center",
    "latitude": 37.1395705,
    "longitude": -76.5471371,
    "address": "14901 WARWICK BLVD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3252",
    "name": "World Outreach Worship Center",
    "latitude": 37.1664668,
    "longitude": -76.5489572,
    "address": "525 INDUSTRIAL PARK DR",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3255",
    "name": "Centers for Dialysis Care",
    "latitude": 41.49936543,
    "longitude": -81.60708691,
    "address": "2155 Stokes Blvd.",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3257",
    "name": "Jeffersonian Senior Center CSFP",
    "latitude": 39.9452476,
    "longitude": -83.2681438,
    "address": "28 E MAIN ST",
    "city": "WEST JEFFERSON",
    "state": "OH",
    "zip_code": "43162",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3259",
    "name": "Lorain County Public Health ",
    "latitude": 41.34665743,
    "longitude": -82.13445335,
    "address": "9880 MURRAY RIDGE RD",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3265",
    "name": "Greater Works Ministries",
    "latitude": 36.986074,
    "longitude": -76.4329681,
    "address": "3614 HUNTINGTON AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3270",
    "name": "Coshocton Senior Meals/CSFP FF",
    "latitude": 40.2580532,
    "longitude": -81.869285,
    "address": "201 BROWNS LN",
    "city": "COSHOCTON",
    "state": "OH",
    "zip_code": "43812",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3274",
    "name": "SCOPE Food Truck",
    "latitude": 41.2400847,
    "longitude": -80.8183101,
    "address": "375 N PARK AVE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44481",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3275",
    "name": "Pickaway Senior Center CSFP FF",
    "latitude": 39.5670191,
    "longitude": -82.9472391,
    "address": "2105 CHICKASAW DR",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3276",
    "name": "Fairfield County Meals on Wheels CSFP/Fresh Produce",
    "latitude": 39.7145374,
    "longitude": -82.6245838,
    "address": "1515 CEDAR HILL RD",
    "city": "LANCASTER",
    "state": "OH",
    "zip_code": "43130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3282",
    "name": "NUTRITION ON WHEELS ",
    "latitude": 35.0431308,
    "longitude": -89.9099421,
    "address": "3865 S PERKINS RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3286",
    "name": "SPAN Ministires",
    "latitude": 41.1090085,
    "longitude": -81.43078492,
    "address": "361 Northeast Ave",
    "city": "Tallmadge",
    "state": "OH",
    "zip_code": "44278",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3287",
    "name": "Grove City UMC",
    "latitude": 39.8817203,
    "longitude": -83.0745824,
    "address": "2684 COLUMBUS ST",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3288",
    "name": "Georgesville WIC",
    "latitude": 39.9176297,
    "longitude": -83.1211419,
    "address": "1681 HOLT RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3291",
    "name": "North Presbyterian Church Food Pantry",
    "latitude": 42.0994978,
    "longitude": -76.8162521,
    "address": "921 COLLEGE AVE",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3292",
    "name": "Village Pantry at New Lebanon FBC",
    "latitude": 39.7414896,
    "longitude": -84.3866419,
    "address": "335 S CHURCH ST",
    "city": "NEW LEBANON",
    "state": "OH",
    "zip_code": "45345",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3293",
    "name": "New Bethel Baptist Church",
    "latitude": 41.0852765,
    "longitude": -80.6642155,
    "address": "1524 HILLMAN ST",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44507",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3294",
    "name": "Warwick SRO",
    "latitude": 36.9769928,
    "longitude": -76.4318141,
    "address": "2410 WEST AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3296",
    "name": "Goodwill Industries of Lorain County ",
    "latitude": 41.4060456,
    "longitude": -82.12655877,
    "address": "145 KEEP CT",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3300",
    "name": "St. Vincent de Paul-Little Flower",
    "latitude": 41.6536836,
    "longitude": -83.6726475,
    "address": "5522 DORR ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43615",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3301",
    "name": "Community & Seasoned Citizens Senior Center",
    "latitude": 40.23437252,
    "longitude": -83.35355562,
    "address": "900 COLUMBUS AVE",
    "city": "MARYSVILLE",
    "state": "OH",
    "zip_code": "43040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3304",
    "name": "Elyria City Schools ",
    "latitude": 41.36179582,
    "longitude": -82.1072666,
    "address": "601 MIDDLE AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3306",
    "name": "SECOND BAPTIST-UNION CITY",
    "latitude": 36.42604484,
    "longitude": -89.05645875,
    "address": "126 E MAIN ST",
    "city": "UNION CITY",
    "state": "TN",
    "zip_code": "38261",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3307",
    "name": "Zion Baptist Newport News",
    "latitude": 36.9783867,
    "longitude": -76.4172967,
    "address": "633 20TH ST",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3308",
    "name": "Church on Fire",
    "latitude": 39.2528736,
    "longitude": -84.793175,
    "address": "10544 HARRISON AVE",
    "city": "HARRISON",
    "state": "OH",
    "zip_code": "45030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3309",
    "name": "Abundant Season at American Fitness Health and Wellness Institute",
    "latitude": 39.7782952,
    "longitude": -84.1750182,
    "address": "643 TROY ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45404",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3311",
    "name": "Community Housing Partners: Lafayette Apts.",
    "latitude": 37.3125173,
    "longitude": -76.7553743,
    "address": "121 LAFAYETTE BLVD",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23188",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3313",
    "name": "Clark State and Second Harvest",
    "latitude": 39.8976601,
    "longitude": -83.7966358,
    "address": "570 E LEFFEL LN",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3314",
    "name": "Mary's Cupboard of Hope",
    "latitude": 41.4668687,
    "longitude": -81.7065626,
    "address": "3205 FULTON RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3318",
    "name": "Akron Dream Center",
    "latitude": 41.03570931,
    "longitude": -81.48945235,
    "address": "1035 Rosemary Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3320",
    "name": "Care Connection at Judah Tabernacle",
    "latitude": 39.8965627,
    "longitude": -82.994463,
    "address": "3176 S HIGH ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3323",
    "name": "New Hope Fellowship Senior Market",
    "latitude": 41.5437502,
    "longitude": -81.5672065,
    "address": "16100 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3324",
    "name": "Loaves and Fishes Food Pantry - Binghamton",
    "latitude": 42.09071638,
    "longitude": -75.90639299,
    "address": "25 1/2 MILL ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3325",
    "name": "Our Lady of Sorrows Church Food Pantry",
    "latitude": 42.075349,
    "longitude": -76.0481187,
    "address": "801 MAIN ST",
    "city": "VESTAL",
    "state": "NY",
    "zip_code": "13850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3327",
    "name": "MMK Worley Terrace (CMHA)",
    "latitude": 39.955513,
    "longitude": -83.0391725,
    "address": "99 S CENTRAL AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43222",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3332",
    "name": "Gleaning Baptist Church",
    "latitude": 37.51370906,
    "longitude": -76.4953577,
    "address": "7749 Dutton Rd ",
    "city": "GLOUCESTER",
    "state": "VA",
    "zip_code": "23061",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3335",
    "name": "Fitchville Community Church",
    "latitude": 41.0952441,
    "longitude": -82.4890437,
    "address": "1593 US Hwy. 250 S",
    "city": "NEW LONDON",
    "state": "OH",
    "zip_code": "44851",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3336",
    "name": "New Mt. Zion Baptist Church",
    "latitude": 37.5112854,
    "longitude": -76.592687,
    "address": "11127 Woods Cross Road",
    "city": "GLOUCESTER",
    "state": "VA",
    "zip_code": "23061",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3339",
    "name": "Catherine's Cupboard",
    "latitude": 42.14491,
    "longitude": -75.8908545,
    "address": "1031 CHENANGO ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3340",
    "name": "Oberlin Manor",
    "latitude": 41.43687532,
    "longitude": -82.18585076,
    "address": "1220 W 37TH ST",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44053",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3345",
    "name": "Fremont Youth and Community Outreach",
    "latitude": 41.73465004,
    "longitude": -84.93789791,
    "address": "601 N COLDWATER ST",
    "city": "FREMONT",
    "state": "IN",
    "zip_code": "46737",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3346",
    "name": "HOLY VISION TEMPLE",
    "latitude": 35.1641267,
    "longitude": -90.0212227,
    "address": "875 CROCKETT ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3347",
    "name": "Pantry of Angels",
    "latitude": 42.02945593,
    "longitude": -77.13875259,
    "address": "682 County Road 115",
    "city": "LINDLEY",
    "state": "NY",
    "zip_code": "14858",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3348",
    "name": "Oakwood UMC Food Pantry",
    "latitude": 42.1274622,
    "longitude": -76.8266684,
    "address": "212 OAKWOOD AVE",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14903",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3349",
    "name": "C.C. Chemung/Community Food Pantry",
    "latitude": 42.0907361,
    "longitude": -76.7968186,
    "address": "161 HIGH ST",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3351",
    "name": "Colesville Community Pantry",
    "latitude": 42.1843516,
    "longitude": -75.6327992,
    "address": "28 King Road",
    "city": "HARPURSVILLE",
    "state": "NY",
    "zip_code": "13787",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3353",
    "name": "MFP Watkins Glen Community Center",
    "latitude": 42.38427635,
    "longitude": -76.85997077,
    "address": "155 S CLUTE PARK DR",
    "city": "WATKINS GLEN",
    "state": "NY",
    "zip_code": "14891",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3354",
    "name": "Sheffield Lake City Schools ",
    "latitude": 41.48357699,
    "longitude": -82.11689228,
    "address": "3975 FORESTLAWN AVE",
    "city": "SHEFFIELD LAKE",
    "state": "OH",
    "zip_code": "44054",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3356",
    "name": "Our Neighbors Farm and Pantry",
    "latitude": 32.8286329,
    "longitude": -109.71967238,
    "address": "1020 S 10TH AVE",
    "city": "SAFFORD",
    "state": "AZ",
    "zip_code": "85546",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3361",
    "name": "Shared Harvest Foodbank",
    "latitude": 39.32834915,
    "longitude": -84.51623225,
    "address": "5901 Dixie Highway",
    "city": "Fairfield",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3362",
    "name": "Victory Faith Center",
    "latitude": 39.9189604,
    "longitude": -83.8105072,
    "address": "424 S FOUNTAIN AVE",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3363",
    "name": "FAITH HERITAGE COGIC",
    "latitude": 35.1794418,
    "longitude": -89.9332525,
    "address": "3802 GRAGG AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3364",
    "name": "The Pantry at Ithaca College",
    "latitude": 42.445573,
    "longitude": -76.496428,
    "address": "201 EGBERT HALL",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3365",
    "name": "McGregor Foundation Food Pantry",
    "latitude": 41.53149277,
    "longitude": -81.57268305,
    "address": "14900 PRIVATE DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3366",
    "name": "Ithaca Kitchen Cupboard",
    "latitude": 42.4398301,
    "longitude": -76.5019823,
    "address": "150 N ALBANY ST",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3367",
    "name": "Shared Harvest Food Pantry",
    "latitude": 39.32834915,
    "longitude": -84.51623225,
    "address": "5901 DIXIE HWY",
    "city": "FAIRFIELD",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3368",
    "name": "Miami - Mobile Pantry",
    "latitude": 39.32834915,
    "longitude": -84.51623225,
    "address": "5901 DIXIE HWY",
    "city": "FAIRFIELD",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3369",
    "name": "SNAP OUTREACH-TENNESSEE",
    "latitude": 35.0431308,
    "longitude": -89.9099421,
    "address": "3865 S PERKINS RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3372",
    "name": "The Common Good of Preble County",
    "latitude": 39.7431052,
    "longitude": -84.6348913,
    "address": "113 S CHERRY ST",
    "city": "EATON",
    "state": "OH",
    "zip_code": "45320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3374",
    "name": "Feed our Vets",
    "latitude": 41.8650962,
    "longitude": -80.7871987,
    "address": "433 CENTER ST",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3376",
    "name": "Youth Opportunities",
    "latitude": 41.8597634,
    "longitude": -80.7841653,
    "address": "5402 MAIN AVE",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3382",
    "name": "Educational Service Center of Lorain County ",
    "latitude": 41.39425728,
    "longitude": -82.12978646,
    "address": "1885 LAKE AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3383",
    "name": "CHURCHES UNITED FOOD DEPOT",
    "latitude": 34.24574861,
    "longitude": -88.99696058,
    "address": "24 S LIBERTY ST",
    "city": "PONTOTOC",
    "state": "MS",
    "zip_code": "38863",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3385",
    "name": "ROCK DEVELOPMENT CORP",
    "latitude": 35.0360929,
    "longitude": -89.8381983,
    "address": "6720 E RAINES RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3389",
    "name": "Darke County Mobile Pantry",
    "latitude": 39.32834915,
    "longitude": -84.51623225,
    "address": "5901 DIXIE HWY",
    "city": "FAIRFIELD",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3393",
    "name": "Rocking Horse Community Health Center",
    "latitude": 39.9164177,
    "longitude": -83.8093527,
    "address": "651 S LIMESTONE ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3394",
    "name": "FOUNTIN OF LIFE COGIC",
    "latitude": 35.87650942,
    "longitude": -89.38616356,
    "address": "748 E TIGRETT ST",
    "city": "HALLS",
    "state": "TN",
    "zip_code": "38040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3396",
    "name": "Zion Christian Assembly",
    "latitude": 39.90735617,
    "longitude": -82.8168606,
    "address": "6930 Motts Place Rd.",
    "city": "CANAL WINCHESTER",
    "state": "OH",
    "zip_code": "43110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3398",
    "name": "ST JUDE",
    "latitude": 35.1117204,
    "longitude": -90.0340428,
    "address": "853 E TRIGG AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3401",
    "name": "Freedom Lima City Schools",
    "latitude": 40.7330292,
    "longitude": -84.091243,
    "address": "575 CALUMET AVE",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3402",
    "name": "Copley Outreach Center",
    "latitude": 41.09740853,
    "longitude": -81.64471007,
    "address": "1502 S Cleveland Massillon Rd",
    "city": "Copley",
    "state": "OH",
    "zip_code": "44321",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3403",
    "name": "Cancer Dietary Initiative",
    "latitude": 40.3628269,
    "longitude": -80.6138371,
    "address": "235 N 4TH ST",
    "city": "STEUBENVILLE",
    "state": "OH",
    "zip_code": "43952",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3408",
    "name": "Fairgreen Food Pantry-FYN#05",
    "latitude": 41.7065037,
    "longitude": -83.6216825,
    "address": "3220 W LASKEY RD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43613",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3409",
    "name": "Northeast Emergency Distribution Services NEEDS",
    "latitude": 39.2098044,
    "longitude": -84.3800809,
    "address": "8341 KENWOOD RD",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45236",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3410",
    "name": "North Ridgeville Community Care",
    "latitude": 41.39928701,
    "longitude": -81.99371746,
    "address": "34015 CENTER RIDGE RD",
    "city": "NORTH RIDGEVILLE",
    "state": "OH",
    "zip_code": "44039",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3411",
    "name": "Mid-Ohio Market at Center of Hope",
    "latitude": 40.2843334,
    "longitude": -82.286303,
    "address": "25821 New Guilford Rd",
    "city": "Bladensburg",
    "state": "OH",
    "zip_code": "43005",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3413",
    "name": "Neighborhood Relief Ministries",
    "latitude": 40.75386867,
    "longitude": -84.13123257,
    "address": "1520 Elida Rd. ",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45805",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3417",
    "name": "Harrison County Senior Center - CSFP",
    "latitude": 40.2724152,
    "longitude": -80.9972692,
    "address": "120 N MAIN ST",
    "city": "CADIZ",
    "state": "OH",
    "zip_code": "43907",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3418",
    "name": "Green Good Neighbors",
    "latitude": 40.9315061,
    "longitude": -81.4682274,
    "address": "2161 Greensburg Rd",
    "city": "GREEN",
    "state": "OH",
    "zip_code": "44232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3429",
    "name": "Jordan's Crossing",
    "latitude": 39.9617226,
    "longitude": -83.0757198,
    "address": "342 N HAGUE AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3432",
    "name": "Morrow County Seniors",
    "latitude": 40.5486784,
    "longitude": -82.8292746,
    "address": "41 W CENTER ST",
    "city": "MOUNT GILEAD",
    "state": "OH",
    "zip_code": "43338",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3433",
    "name": "Guernsey Senior Center",
    "latitude": 40.0226308,
    "longitude": -81.5860249,
    "address": "1022 CARLISLE AVE",
    "city": "CAMBRIDGE",
    "state": "OH",
    "zip_code": "43725",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3434",
    "name": "Marion Senior Center",
    "latitude": 40.6022996,
    "longitude": -83.0664504,
    "address": "2375 HARDING HWY E",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3436",
    "name": "Fayette County Commission on Aging",
    "latitude": 39.5364651,
    "longitude": -83.425581,
    "address": "1179 S ELM ST",
    "city": "WASHINGTON COURT HOUSE",
    "state": "OH",
    "zip_code": "43160",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3437",
    "name": "The Station Break - Knox County",
    "latitude": 40.3897063,
    "longitude": -82.483139,
    "address": "160 HOWARD ST",
    "city": "MOUNT VERNON",
    "state": "OH",
    "zip_code": "43050",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3442",
    "name": "Mt. Vernon Apartments",
    "latitude": 39.9732353,
    "longitude": -82.9747214,
    "address": "1035 ATCHESON ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3443",
    "name": "Oaks Community Church",
    "latitude": 39.51523099,
    "longitude": -84.40706611,
    "address": "124 S MAIN ST",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3447",
    "name": "Chandler Arms",
    "latitude": 39.977501,
    "longitude": -82.9233564,
    "address": "305 N GOULD RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43209",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3448",
    "name": "Ross County Committee for the Elderly",
    "latitude": 39.3389082,
    "longitude": -83.0296045,
    "address": "1824 WESTERN AVE",
    "city": "CHILLICOTHE",
    "state": "OH",
    "zip_code": "45601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3451",
    "name": "GREATER BETHEL COGIC",
    "latitude": 36.43020128,
    "longitude": -89.04671506,
    "address": "805 E GIBBS ST",
    "city": "UNION CITY",
    "state": "TN",
    "zip_code": "38261",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3452",
    "name": "CHILD HUNGER SITES ",
    "latitude": 35.0431308,
    "longitude": -89.9099421,
    "address": "3865 S PERKINS RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3453",
    "name": "The Pantry at Cumberland Presbyterian Church of Germantown",
    "latitude": 35.0838019,
    "longitude": -89.8261034,
    "address": "2385 RIVERDALE RD",
    "city": "GERMANTOWN",
    "state": "TN",
    "zip_code": "38138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3454",
    "name": "MIDSOUTH FOOD BANK AGENCY SITES",
    "latitude": 35.0428722,
    "longitude": -89.9095757,
    "address": "3865 S PERKINS RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3456",
    "name": "Dillonvale Food Pantry",
    "latitude": 40.20161349,
    "longitude": -80.77206879,
    "address": "11 Smithfield St ",
    "city": "DILLONVALE",
    "state": "OH",
    "zip_code": "43917",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3457",
    "name": "Reeb Avenue Center",
    "latitude": 39.925083,
    "longitude": -82.9877956,
    "address": "280 REEB AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3467",
    "name": "SVDP - St. Paschal Baylon",
    "latitude": 34.2003504,
    "longitude": -118.8700909,
    "address": "155 E JANSS RD",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91360",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3468",
    "name": "NEW MACEDONIA CHURCH",
    "latitude": 36.0247679,
    "longitude": -89.37750414,
    "address": "806 BRUCE AVE",
    "city": "DYERSBURG",
    "state": "TN",
    "zip_code": "38024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3473",
    "name": "The Vine UMC",
    "latitude": 40.9304299,
    "longitude": -81.1312814,
    "address": "1544 W Vine St",
    "city": "Alliance",
    "state": "OH",
    "zip_code": "44601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3474",
    "name": "St. Paschal's Helping Hands",
    "latitude": 41.53673592,
    "longitude": -81.48650453,
    "address": "5384 WILSON MILLS RD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44143",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3475",
    "name": "Humility of Mary Housing-St. Timothy Park",
    "latitude": 41.44017602,
    "longitude": -81.58805104,
    "address": "4350 E 136TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3477",
    "name": "REDEEMER",
    "latitude": 35.0914103,
    "longitude": -89.8840433,
    "address": "5340 QUINCE RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3478",
    "name": "Grand Lodge Food Pantry",
    "latitude": 41.660005,
    "longitude": -83.5454818,
    "address": "1947 FRANKLIN AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43604",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3480",
    "name": "Loaves and Fishes Food Pantry - Hammondsport",
    "latitude": 42.4087368,
    "longitude": -77.22541,
    "address": "78 SHETHAR ST",
    "city": "HAMMONDSPORT",
    "state": "NY",
    "zip_code": "14840",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3481",
    "name": "SALT BOX Kitchen",
    "latitude": 40.8898856,
    "longitude": -81.60182794,
    "address": "336 Market St W",
    "city": "Canal Fulton",
    "state": "OH",
    "zip_code": "44614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3483",
    "name": "Bridgeport Manor",
    "latitude": 40.0664545,
    "longitude": -80.7445601,
    "address": "1 GOULD PARK RD",
    "city": "BRIDGEPORT",
    "state": "OH",
    "zip_code": "43912",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3484",
    "name": "STANTON FEEDING HAYWOOD",
    "latitude": 35.46192312,
    "longitude": -89.40499623,
    "address": "8 MAIN STREET",
    "city": "STANTON",
    "state": "TN",
    "zip_code": "38069",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3486",
    "name": "Family Empowerment Ministries",
    "latitude": 40.9027245,
    "longitude": -81.09056,
    "address": "425 E Market St",
    "city": "Alliance",
    "state": "OH",
    "zip_code": "44601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3487",
    "name": "Preble Mass Distribution",
    "latitude": 39.7314487,
    "longitude": -84.6481568,
    "address": "6840 Oxford Gettysburg Rd",
    "city": "New Paris",
    "state": "OH",
    "zip_code": "45347",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3489",
    "name": "Fellowship Tabernacle Free Will Baptist",
    "latitude": 39.6308776,
    "longitude": -83.9442507,
    "address": "1780 STATE ROUTE 380",
    "city": "XENIA",
    "state": "OH",
    "zip_code": "45385",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3496",
    "name": "LifeWay Church",
    "latitude": 40.47695862,
    "longitude": -81.44166096,
    "address": "742 Cookson Ave SE",
    "city": "New Philadelphia",
    "state": "OH",
    "zip_code": "44663",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3498",
    "name": "New Life Assembly of God",
    "latitude": 40.9887262,
    "longitude": -80.6100965,
    "address": "2250 E WESTERN RESERVE RD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44514",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3499",
    "name": "Village Food Pantry",
    "latitude": 39.44160071,
    "longitude": -84.53578207,
    "address": "617B N RIVERSIDE DR",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3500",
    "name": "Faith Community United Methodist Church",
    "latitude": 39.33882167,
    "longitude": -84.36619093,
    "address": "8230 COX RD",
    "city": "WEST CHESTER",
    "state": "OH",
    "zip_code": "45069",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3501",
    "name": "First Baptist Newport News ",
    "latitude": 37.0892864,
    "longitude": -76.5007603,
    "address": "12716 WARWICK BLVD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3504",
    "name": "Wilmington Church of God",
    "latitude": 39.4368473,
    "longitude": -83.8512514,
    "address": "627 S NELSON AVE",
    "city": "WILMINGTON",
    "state": "OH",
    "zip_code": "45177",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3505",
    "name": "Pentecostal Fellowship International - Storehouse",
    "latitude": 39.648938,
    "longitude": -84.52708,
    "address": "9126 OH-126",
    "city": "Camden",
    "state": "OH",
    "zip_code": "45330",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3506",
    "name": "Faith United Methodist Church ",
    "latitude": 41.33290291,
    "longitude": -81.43926324,
    "address": "2560 Post Rd",
    "city": "Twinsburg",
    "state": "OH",
    "zip_code": "44087",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3507",
    "name": "SAM Center",
    "latitude": 40.7979351,
    "longitude": -81.5176572,
    "address": "413 Lincoln Way E",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3509",
    "name": "Goodyear Heights Presbyterian Church",
    "latitude": 41.07020544,
    "longitude": -81.47148809,
    "address": "1430 Goodyear Blvd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3510",
    "name": "Southeast Clergy-Meals on Wheels",
    "latitude": 41.4049218,
    "longitude": -81.5264184,
    "address": "415 NORTHFIELD RD",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3512",
    "name": "Fairport Harbor Senior Market",
    "latitude": 41.7383428,
    "longitude": -81.2681092,
    "address": "1380 EAST ST",
    "city": "FAIRPORT HARBOR",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3517",
    "name": "Tuttle Recreation Center",
    "latitude": 40.0091009,
    "longitude": -83.0163345,
    "address": "240 W OAKLAND AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3518",
    "name": "Donna Smallwood Activities Center",
    "latitude": 41.38443396,
    "longitude": -81.732845,
    "address": "7001 W RIDGEWOOD DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44129",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3530",
    "name": "GREATER IMANI",
    "latitude": 35.2298438,
    "longitude": -89.8990355,
    "address": "3824 AUSTIN PEAY HWY",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3531",
    "name": "Safe Passage Youth Foundation",
    "latitude": 34.1857528,
    "longitude": -118.9150068,
    "address": "1707 CALLE DIAMONTE",
    "city": "NEWBURY PARK",
    "state": "CA",
    "zip_code": "91320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3532",
    "name": "Adelante Comunidad",
    "latitude": 34.1789256,
    "longitude": -118.8469697,
    "address": "1949 Los Feliz Dr., Thousand Oaks",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91362",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3548",
    "name": "Jerusalem Missionary Baptist Church",
    "latitude": 41.06663798,
    "longitude": -81.56669166,
    "address": "1225 Vernon Odom Blvd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3550",
    "name": "Sugar Grove Square / CMHA",
    "latitude": 40.1121558,
    "longitude": -82.923327,
    "address": "530 S STATE ST",
    "city": "WESTERVILLE",
    "state": "OH",
    "zip_code": "43081",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3551",
    "name": "Lutheran Social Service",
    "latitude": 41.663516,
    "longitude": -83.5555617,
    "address": "2149 COLLINGWOOD BLVD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43620",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3553",
    "name": "Pilgrim Church",
    "latitude": 41.6922381,
    "longitude": -83.5751209,
    "address": "1375 W SYLVANIA AVE",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43612",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3555",
    "name": "Muskingum County Center for Seniors",
    "latitude": 39.9431039,
    "longitude": -82.0074205,
    "address": "160 N 4TH ST",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3571",
    "name": "Painesville Church of the Nazarene ",
    "latitude": 41.7012786,
    "longitude": -81.2587317,
    "address": "6235 CHESTNUT ST",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3573",
    "name": "Senior Services of Belmont County",
    "latitude": 40.0697586,
    "longitude": -80.9789806,
    "address": "67650 OAKVIEW DR",
    "city": "SAINT CLAIRSVILLE",
    "state": "OH",
    "zip_code": "43950",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3574",
    "name": "FACCES",
    "latitude": 39.9133913,
    "longitude": -82.96623169,
    "address": "2515 LOCKBOURNE RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3579",
    "name": "Healing Vine Ministries",
    "latitude": 41.1295592,
    "longitude": -81.47873296,
    "address": "1752 Williams St",
    "city": "Cuyahoga Falls",
    "state": "OH",
    "zip_code": "44221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3581",
    "name": "North Industry Christian Church",
    "latitude": 40.74535842,
    "longitude": -81.37733244,
    "address": "425 45th St SW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44706",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3583",
    "name": "Second Harvest Food Bank of NCO- HURON",
    "latitude": 41.0543108,
    "longitude": -82.7359041,
    "address": "561 Laurel W Street",
    "city": "WILLARD",
    "state": "OH",
    "zip_code": "44890",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3585",
    "name": "Forever R Children/Pantry",
    "latitude": 41.06909741,
    "longitude": -81.53552726,
    "address": "896 WICKET DR",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3587",
    "name": "BeTheChurch Ministry Inc.",
    "latitude": 41.01932093,
    "longitude": -81.58487592,
    "address": "1250 Edison St NW",
    "city": "Hartville",
    "state": "OH",
    "zip_code": "44632",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3589",
    "name": "Second Chance Learning Center of Hope Pantry",
    "latitude": 39.538388,
    "longitude": -83.4477071,
    "address": "420 W OAKLAND AVE",
    "city": "WASHINGTON COURT HOUSE",
    "state": "OH",
    "zip_code": "43160",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3590",
    "name": "Barton Senior Center",
    "latitude": 41.4857942,
    "longitude": -81.7938058,
    "address": "14300 DETROIT AVE",
    "city": "LAKEWOOD",
    "state": "OH",
    "zip_code": "44107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3592",
    "name": "Community Pantry at UPC",
    "latitude": 42.1000587,
    "longitude": -75.9097504,
    "address": "42 CHENANGO ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3593",
    "name": "Warren Mass Distribution",
    "latitude": 39.32834915,
    "longitude": -84.51623225,
    "address": "5901 DIXIE HWY",
    "city": "FAIRFIELD",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3594",
    "name": "NCR Barnesville Manor ",
    "latitude": 39.99595116,
    "longitude": -81.17237019,
    "address": "485 NORTH ST",
    "city": "BARNESVILLE",
    "state": "OH",
    "zip_code": "43713",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3595",
    "name": "Painesville Baptist Church ",
    "latitude": 41.7222087,
    "longitude": -81.195633,
    "address": "140 PARK ROAD EXT",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3596",
    "name": "Neffs UMC Pantry",
    "latitude": 40.02793081,
    "longitude": -80.81408425,
    "address": "54070 Belmont St ",
    "city": "NEFFS",
    "state": "OH",
    "zip_code": "43940",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3597",
    "name": "PETRA",
    "latitude": 35.34624844,
    "longitude": -88.3744844,
    "address": "7730 HIGHWAY 22  N",
    "city": "MORRIS CHAPEL",
    "state": "TN",
    "zip_code": "38361",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3598",
    "name": "Christ's Community Meal",
    "latitude": 41.3951996,
    "longitude": -82.5554563,
    "address": "225 WILLIAMS ST",
    "city": "HURON",
    "state": "OH",
    "zip_code": "44839",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3613",
    "name": "MFP Senior - Spring Meadows",
    "latitude": 42.3414704,
    "longitude": -77.3311961,
    "address": "135 WATER ST",
    "city": "BATH",
    "state": "NY",
    "zip_code": "14810",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3614",
    "name": "St. John's UCC Massillon",
    "latitude": 40.7951226,
    "longitude": -81.5207756,
    "address": "101 Tremont Ave SE",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3615",
    "name": "Asian Services In Action Inc.",
    "latitude": 41.0802563,
    "longitude": -81.50605645,
    "address": "370 E Market St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44304",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3616",
    "name": "C.C. Steuben/Livingston - Bath Food Pantry",
    "latitude": 42.3343267,
    "longitude": -77.3185549,
    "address": "23 LIBERTY ST",
    "city": "BATH",
    "state": "NY",
    "zip_code": "14810",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3618",
    "name": "Far East Recreation Center",
    "latitude": 39.9427392,
    "longitude": -82.8598041,
    "address": "1826 Lattimer Dr",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3620",
    "name": "Neighborhood Alliance ",
    "latitude": 41.4344798,
    "longitude": -82.1566166,
    "address": "1536 E 30TH ST",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3622",
    "name": "Tikkun Farm",
    "latitude": 39.23839495,
    "longitude": -84.5437649,
    "address": "7941 ELIZABETH ST",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45231",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3624",
    "name": "West Park United Church of Christ",
    "latitude": 41.44850166,
    "longitude": -81.816824,
    "address": "3909 ROCKY RIVER DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3625",
    "name": "Salvation Army Food Pantry - Elmira",
    "latitude": 42.0937,
    "longitude": -76.8036,
    "address": "414 LAKE ST",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3627",
    "name": "Total Living Center",
    "latitude": 40.79397145,
    "longitude": -81.39875823,
    "address": "2221 9th St SW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44702",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3628",
    "name": "Bristolville Christian Harbor",
    "latitude": 41.36000622,
    "longitude": -80.88999126,
    "address": "1787 HOUSEL CRAFT RD",
    "city": "BRISTOLVILLE",
    "state": "OH",
    "zip_code": "44402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3629",
    "name": "Well of Hope Ministries",
    "latitude": 40.75142762,
    "longitude": -81.42742585,
    "address": "3990 Faircrest St SW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44706",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3630",
    "name": "HUD/VASH",
    "latitude": 37.02253726,
    "longitude": -76.33076273,
    "address": "100 EMANCIPATION DR",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23667",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3631",
    "name": "North Eaton Christian Church ",
    "latitude": 41.31394764,
    "longitude": -82.01828694,
    "address": "35895 ROYALTON RD",
    "city": "GRAFTON",
    "state": "OH",
    "zip_code": "44044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3632",
    "name": "Ohio Heartland CAC The Egner Center ",
    "latitude": 40.74362829,
    "longitude": -82.78199319,
    "address": "124 BUEHLER ST",
    "city": "GALION",
    "state": "OH",
    "zip_code": "44833",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3633",
    "name": "St. John's Red Door",
    "latitude": 41.10340456,
    "longitude": -80.64661915,
    "address": "323 WICK AVE",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3634",
    "name": "Good Hope Lutheran Church",
    "latitude": 41.04872157,
    "longitude": -80.65827514,
    "address": "98 HOMESTEAD DR",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3636",
    "name": "Viewpoint CSFP",
    "latitude": 41.4583412,
    "longitude": -82.71080569,
    "address": "215 E SHORELINE DR",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3637",
    "name": "LMHA CSFP",
    "latitude": 41.36476653,
    "longitude": -82.10356789,
    "address": "310 EAST AVE",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3638",
    "name": "Harborview CSFP",
    "latitude": 41.45821841,
    "longitude": -82.70776961,
    "address": "115 FRANKLIN ST",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3640",
    "name": "Westminster Free Clinic T.O.",
    "latitude": 34.21622863,
    "longitude": -118.90163338,
    "address": "2673 SAN MIGUEL CIR",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91360",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3641",
    "name": "Revive Church",
    "latitude": 39.81439649,
    "longitude": -84.2025338,
    "address": "2520 Arthur Avenue",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45414",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3642",
    "name": "Alianza 614",
    "latitude": 39.9296284,
    "longitude": -83.10666091,
    "address": "4131 CLIME RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3647",
    "name": "BROWN BAG FOOD PROJECT",
    "latitude": 41.36686061,
    "longitude": -83.65667903,
    "address": "530 SAND RIDGE RD",
    "city": "BOWLING GREEN",
    "state": "OH",
    "zip_code": "43402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3649",
    "name": "Eastside Mission Food Pantry",
    "latitude": 40.30718715,
    "longitude": -83.05463254,
    "address": "32 JOY AVE",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3650",
    "name": "Community Resource Center",
    "latitude": 40.62941767,
    "longitude": -80.55761762,
    "address": "940 PENNSYLVANIA AVE",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3651",
    "name": "MFP Senior - Village Manor Apartments",
    "latitude": 42.16,
    "longitude": -77.0925,
    "address": "300 STEUBEN ST",
    "city": "PAINTED POST",
    "state": "NY",
    "zip_code": "14870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3654",
    "name": "The Charles School",
    "latitude": 40.005201,
    "longitude": -82.931203,
    "address": "1270 Bretnell Avenue",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3656",
    "name": "Community Food Pantry",
    "latitude": 41.2421086,
    "longitude": -81.34538274,
    "address": "9222 State Rt 43",
    "city": "Streetsboro",
    "state": "OH",
    "zip_code": "44241",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3657",
    "name": "Seton Square MMK",
    "latitude": 40.0682056,
    "longitude": -83.06628435,
    "address": "1776 DREW AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43235",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3659",
    "name": "Westminster Free Clinic - Oxnard",
    "latitude": 34.18234282,
    "longitude": -119.1811828,
    "address": "1800 S C ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3660",
    "name": "First Christian Church-Stow",
    "latitude": 41.1613573,
    "longitude": -81.44029277,
    "address": "3493 Darrow Rd",
    "city": "Stow",
    "state": "OH",
    "zip_code": "44224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3661",
    "name": "Hispanic Resource Center",
    "latitude": 37.005206,
    "longitude": -76.382577,
    "address": "3000 Incubator Road ",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3665",
    "name": "Jackson Area Festivals and Events",
    "latitude": 39.032746,
    "longitude": -82.649218,
    "address": "521 McCarty Lane",
    "city": "JACKSON",
    "state": "OH",
    "zip_code": "45640",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3667",
    "name": "Grace Resurrection Community Center",
    "latitude": 40.10594717,
    "longitude": -84.63014817,
    "address": "433 E WATER ST",
    "city": "GREENVILLE",
    "state": "OH",
    "zip_code": "45331",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3669",
    "name": "ACRFB Pop-Up Pantry (Portage)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Parkway",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3670",
    "name": "New Beginnings Church",
    "latitude": 34.28657507,
    "longitude": -118.74372006,
    "address": "2816 SYCAMORE DR",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3671",
    "name": "Lighthouse Church - Newbury Park",
    "latitude": 34.19074974,
    "longitude": -118.94633721,
    "address": "3353 OLD CONEJO RD",
    "city": "NEWBURY PARK",
    "state": "CA",
    "zip_code": "91320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3672",
    "name": "Galion City School Pantry Program ",
    "latitude": 40.73954957,
    "longitude": -82.80079576,
    "address": "470 PORTLAND WAY N",
    "city": "GALION",
    "state": "OH",
    "zip_code": "44833",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3673",
    "name": "St. Stephen Lutheran Church",
    "latitude": 41.15983464,
    "longitude": -81.4278716,
    "address": "3725 Kent Rd",
    "city": "Stow",
    "state": "OH",
    "zip_code": "44224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3674",
    "name": "Laketran Senior Market",
    "latitude": 41.73314039,
    "longitude": -81.28522078,
    "address": "555 LAKESHORE BLVD",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3677",
    "name": "Serve City",
    "latitude": 39.39092113,
    "longitude": -84.55267344,
    "address": "622 EAST AVE",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3678",
    "name": "Fairfield Food Pantry",
    "latitude": 39.34397645,
    "longitude": -84.53528246,
    "address": "78 DONALD DR",
    "city": "FAIRFIELD",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3681",
    "name": "Christian Family Center",
    "latitude": 39.40238686,
    "longitude": -84.55359335,
    "address": "601 HEATON ST",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3684",
    "name": "New Life Mission Inc.",
    "latitude": 39.39474477,
    "longitude": -84.56064256,
    "address": "415 HENRY ST",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3685",
    "name": "Open Door Food Pantry",
    "latitude": 39.39209892,
    "longitude": -84.56726119,
    "address": "800 S FRONT ST",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3686",
    "name": "Princeton Pike Church of God- West",
    "latitude": 39.37710557,
    "longitude": -84.53666408,
    "address": "1815 TULEY RD",
    "city": "FAIRFIELD TOWNSHIP",
    "state": "OH",
    "zip_code": "45015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3688",
    "name": "Family Service of Middletown",
    "latitude": 39.50123539,
    "longitude": -84.3523434,
    "address": "1210 Elliott Dr",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3689",
    "name": "Full Gospel Outreach",
    "latitude": 39.56022615,
    "longitude": -84.383524,
    "address": "6898 MIDDLETOWN GERMANTOWN RD",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45042",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3690",
    "name": "Radiant Lighthouse Church",
    "latitude": 40.0778472,
    "longitude": -84.60689963,
    "address": "5256 SEBRING WARNER RD",
    "city": "GREENVILLE",
    "state": "OH",
    "zip_code": "45331",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3693",
    "name": "Poasttown First Church of God",
    "latitude": 39.54879529,
    "longitude": -84.38328878,
    "address": "6376 GERMANTOWN RD",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45042",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3697",
    "name": "Salvation Army (Middletown)",
    "latitude": 39.51262053,
    "longitude": -84.39146295,
    "address": "1914 1ST AVE",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3701",
    "name": "Towne Blvd Church of God",
    "latitude": 39.49953083,
    "longitude": -84.32858415,
    "address": "3722 TOWNE BLVD",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45005",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3705",
    "name": "Talawanda Oxford Pantry & Social Serivices",
    "latitude": 39.52332578,
    "longitude": -84.76352033,
    "address": "5445 COLLEGE CORNER PIKE",
    "city": "OXFORD",
    "state": "OH",
    "zip_code": "45056",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3708",
    "name": "West Alexandria Food Pantry",
    "latitude": 39.74337489,
    "longitude": -84.5304862,
    "address": "20 E SOUTH ST",
    "city": "WEST ALEXANDRIA",
    "state": "OH",
    "zip_code": "45381",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3710",
    "name": "Monroe Township Food Pantry",
    "latitude": 39.86616073,
    "longitude": -84.64747451,
    "address": "1060 FOOS RD",
    "city": "WEST MANCHESTER",
    "state": "OH",
    "zip_code": "45382",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3711",
    "name": "Islamic Center of Greater Cincinnati",
    "latitude": 39.34782423,
    "longitude": -84.38439652,
    "address": "8092 PLANTATION DR",
    "city": "WEST CHESTER",
    "state": "OH",
    "zip_code": "45069",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3714",
    "name": "Franklin Area Community Services",
    "latitude": 39.56045501,
    "longitude": -84.30415128,
    "address": "345 S MAIN ST",
    "city": "FRANKLIN",
    "state": "OH",
    "zip_code": "45005",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3715",
    "name": "Lebanon Food Pantry",
    "latitude": 39.43910413,
    "longitude": -84.20474616,
    "address": "190 New Street",
    "city": "LEBANON",
    "state": "OH",
    "zip_code": "45036",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3717",
    "name": "Mason Food Pantry",
    "latitude": 39.35685716,
    "longitude": -84.31612441,
    "address": "406 4TH AVE",
    "city": "MASON",
    "state": "OH",
    "zip_code": "45040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3719",
    "name": "Kings Local Pantry",
    "latitude": 39.37057417,
    "longitude": -84.21297588,
    "address": "83 N SECTION ST",
    "city": "SOUTH LEBANON",
    "state": "OH",
    "zip_code": "45065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3720",
    "name": "Springboro Community Assistance Center",
    "latitude": 39.53444862,
    "longitude": -84.23529196,
    "address": "1629 S MAIN ST",
    "city": "SPRINGBORO",
    "state": "OH",
    "zip_code": "45066",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3721",
    "name": "Bethany Center",
    "latitude": 40.14012958,
    "longitude": -84.24387778,
    "address": "339 SOUTH ST",
    "city": "PIQUA",
    "state": "OH",
    "zip_code": "45356",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3723",
    "name": "Stonebridge Community Church",
    "latitude": 40.15053183,
    "longitude": -84.23895745,
    "address": "105 E GREENE ST",
    "city": "PIQUA",
    "state": "OH",
    "zip_code": "45356",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3724",
    "name": "Needy Basket of So. Miami County",
    "latitude": 39.95746812,
    "longitude": -84.17391987,
    "address": "330A S 5TH ST",
    "city": "TIPP CITY",
    "state": "OH",
    "zip_code": "45371",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3727",
    "name": "Highland BIC",
    "latitude": 39.93149125,
    "longitude": -84.33635323,
    "address": "7210 S JAY RD",
    "city": "WEST MILTON",
    "state": "OH",
    "zip_code": "45383",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3729",
    "name": "Food For Life Market UH Portage Medical Center",
    "latitude": 41.16758159,
    "longitude": -81.24311735,
    "address": "3847 N Chestnut St",
    "city": "RAVENNA",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3731",
    "name": "Humility of Mary Housing/CSFP",
    "latitude": 41.02581958,
    "longitude": -81.5127736,
    "address": "320 GUYS RUN RD",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44319",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3732",
    "name": "Carroll County Council on Aging/CSFP",
    "latitude": 40.5817177,
    "longitude": -81.08342117,
    "address": "100 KENSINGTON RD NE",
    "city": "CARROLLTON",
    "state": "OH",
    "zip_code": "44615",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3734",
    "name": "Alpha Phi Alpha Nutrition Program-Portage",
    "latitude": 41.16873819,
    "longitude": -81.22815192,
    "address": "778 NORTHGATE DR",
    "city": "RAVENNA",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3741",
    "name": "Alpha Phi Alpha - Wesley Towers",
    "latitude": 41.10739159,
    "longitude": -81.5689433,
    "address": "1500 MARION AVE",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44313",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3742",
    "name": "New Hope Apostolic Food Pantry",
    "latitude": 39.90590398,
    "longitude": -82.88136765,
    "address": "3454 S HAMILTON RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3743",
    "name": "New Life East Food pantry",
    "latitude": 39.99372516,
    "longitude": -82.73446565,
    "address": "13142 East BROAD ST SW",
    "city": "PATASKALA",
    "state": "OH",
    "zip_code": "43062",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3744",
    "name": "Shiloh Church UCC",
    "latitude": 39.81889422,
    "longitude": -84.23478507,
    "address": "5300 PHILADELPHIA DR",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45415",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3747",
    "name": "Society of St Vincent Depaul at Our Lady of Lourdes",
    "latitude": 40.23925717,
    "longitude": -83.38425797,
    "address": "1033 W 5TH ST",
    "city": "MARYSVILLE",
    "state": "OH",
    "zip_code": "43040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3748",
    "name": "City of Willoughby Senior Market",
    "latitude": 41.63937739,
    "longitude": -81.40512626,
    "address": "36939 Ridge Rd",
    "city": "WILLOUGHBY",
    "state": "OH",
    "zip_code": "44094",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3751",
    "name": "Salvation Army Toledo-Food Pantry",
    "latitude": 41.65715117,
    "longitude": -83.5337814,
    "address": "620 N ERIE ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43604",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3753",
    "name": "BELIEVING CHURCH",
    "latitude": 35.14902583,
    "longitude": -89.90075401,
    "address": "4798 SUMMER AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3754",
    "name": "John Knox Presbyterian Church",
    "latitude": 40.87139739,
    "longitude": -81.44384045,
    "address": "5155 Eastlake St NW",
    "city": "North Canton",
    "state": "OH",
    "zip_code": "44720",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3755",
    "name": "SPRINGDALE BAPTIST",
    "latitude": 35.1726949,
    "longitude": -89.9832771,
    "address": "1332 SPRINGDALE ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3757",
    "name": "NEW SALEM",
    "latitude": 35.1139234,
    "longitude": -89.9876012,
    "address": "2237 S. PARKWAY E",
    "city": "Memphis",
    "state": "TN",
    "zip_code": "38114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3758",
    "name": "LUCHA - Poder Popular ",
    "latitude": 34.35378341,
    "longitude": -119.06019624,
    "address": "978 E MAIN ST",
    "city": "SANTA PAULA",
    "state": "CA",
    "zip_code": "93060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3759",
    "name": "BROWN BAPTIST CHURCH",
    "latitude": 34.9917768,
    "longitude": -89.97315385,
    "address": "980 STATELINE RD E",
    "city": "SOUTHAVEN",
    "state": "MS",
    "zip_code": "38671",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3760",
    "name": "SALVATION ARMY-MADISON",
    "latitude": 35.62536069,
    "longitude": -88.8175477,
    "address": "125 ALLEN AVE",
    "city": "JACKSON",
    "state": "TN",
    "zip_code": "38301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3761",
    "name": "Bethel United Church of Christ",
    "latitude": 40.8722668,
    "longitude": -81.01892761,
    "address": "25701 BUCK RD",
    "city": "BELOIT",
    "state": "OH",
    "zip_code": "44609",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3762",
    "name": "Kent Social Services (Kent State University)/Pantry",
    "latitude": 41.14390657,
    "longitude": -81.35840923,
    "address": "1066 S Water St",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3768",
    "name": "ST JAMES UMC - MP",
    "latitude": 33.98487492,
    "longitude": -88.49637849,
    "address": "1072 F AVE",
    "city": "AMORY",
    "state": "MS",
    "zip_code": "38821",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3769",
    "name": "Stark Metropolitan Housing Authority",
    "latitude": 40.79870179,
    "longitude": -81.37796575,
    "address": "400 TUSCARAWAS ST E",
    "city": "CANTON",
    "state": "OH",
    "zip_code": "44702",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3770",
    "name": "Fish of Tiffin",
    "latitude": 41.11606777,
    "longitude": -83.17512528,
    "address": "131 E PERRY ST",
    "city": "TIFFIN",
    "state": "OH",
    "zip_code": "44883",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3771",
    "name": "Christian Corner Community Center",
    "latitude": 40.71281186,
    "longitude": -84.10795406,
    "address": "1601 MCCLAIN RD",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3772",
    "name": "Allentown 5 Loaf Pantry",
    "latitude": 40.75480481,
    "longitude": -84.19569037,
    "address": "4900 ALLENTOWN RD",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45807",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3775",
    "name": "Christ’s church @ Tiffin ",
    "latitude": 41.10878132,
    "longitude": -83.22099167,
    "address": "2586 W US HIGHWAY 224",
    "city": "TIFFIN",
    "state": "OH",
    "zip_code": "44883",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3777",
    "name": "Harmony UMC",
    "latitude": 41.03292186,
    "longitude": -83.18712617,
    "address": "6487 so. State rt. 19",
    "city": "TIFFIN",
    "state": "OH",
    "zip_code": "44883",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3779",
    "name": "Open door resource center",
    "latitude": 40.8275982,
    "longitude": -83.28302887,
    "address": "212 W WYANDOT AVE",
    "city": "UPPER SANDUSKY",
    "state": "OH",
    "zip_code": "43351",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3782",
    "name": "Fish pond food pantry ",
    "latitude": 40.43884797,
    "longitude": -84.03730096,
    "address": "310 DAVIS ST",
    "city": "JACKSON CENTER",
    "state": "OH",
    "zip_code": "45334",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3784",
    "name": "New Path Inc",
    "latitude": 40.14507673,
    "longitude": -84.27942355,
    "address": "7695 South County Road 25A",
    "city": "Tipp City",
    "state": "OH",
    "zip_code": "45371",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3786",
    "name": "The Mike Gallmeier foundation",
    "latitude": 40.84701665,
    "longitude": -84.34308802,
    "address": "315 W 5TH ST",
    "city": "DELPHOS",
    "state": "OH",
    "zip_code": "45833",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3787",
    "name": "Spencerville Community Samaritans FP",
    "latitude": 40.94806383,
    "longitude": -83.96268412,
    "address": "119 n Main St",
    "city": "Spencerville",
    "state": "OH",
    "zip_code": "45877",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3790",
    "name": "ACRFB Pop-Up Pantry (Stark)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Parkway",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3792",
    "name": "One Church",
    "latitude": 40.74186935,
    "longitude": -84.12714603,
    "address": "3065 Yoakam Rd",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45806",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3794",
    "name": "Impact mt. Tabor",
    "latitude": 40.51953985,
    "longitude": -84.03800595,
    "address": "21611 GUTMAN RD",
    "city": "WAPAKONETA",
    "state": "OH",
    "zip_code": "45895",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3796",
    "name": "Lords pantry ",
    "latitude": 40.9200462,
    "longitude": -84.05842398,
    "address": "205 W SYCAMORE ST",
    "city": "COLUMBUS GROVE",
    "state": "OH",
    "zip_code": "45830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3798",
    "name": "Salvation Army van wert",
    "latitude": 40.86976494,
    "longitude": -84.57811654,
    "address": "120 N CHERRY ST",
    "city": "VAN WERT",
    "state": "OH",
    "zip_code": "45891",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3799",
    "name": "Cecil community church",
    "latitude": 41.21871027,
    "longitude": -84.60217208,
    "address": "203 S MAIN ST",
    "city": "CECIL",
    "state": "OH",
    "zip_code": "45821",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3800",
    "name": "Auglaize chapel church of god ",
    "latitude": 41.09188201,
    "longitude": -84.41880662,
    "address": "580 state st. ",
    "city": "MELROSE",
    "state": "OH",
    "zip_code": "45861",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3801",
    "name": "Grover hill food pantry ",
    "latitude": 41.01730947,
    "longitude": -84.47791193,
    "address": "204 S HARRISON ST",
    "city": "GROVER HILL",
    "state": "OH",
    "zip_code": "45849",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3802",
    "name": "OAK GROVE MBC",
    "latitude": 35.20391918,
    "longitude": -89.82035117,
    "address": "7289 US HIGHWAY 64",
    "city": "BARTLETT",
    "state": "TN",
    "zip_code": "38133",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3803",
    "name": "Our home",
    "latitude": 40.54828442,
    "longitude": -84.57175842,
    "address": "117 W FAYETTE ST",
    "city": "CELINA",
    "state": "OH",
    "zip_code": "45822",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3804",
    "name": "Victory chapel ",
    "latitude": 40.566781,
    "longitude": -83.842051,
    "address": "13634 st. Rt. 235 ",
    "city": "ROUNDHEAD",
    "state": "OH",
    "zip_code": "43346",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3805",
    "name": "Neighborhood opportunity center",
    "latitude": 40.6449682,
    "longitude": -83.6073674,
    "address": "115 e. Walnut st. ",
    "city": "Kenton",
    "state": "OH",
    "zip_code": "43328",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3809",
    "name": "Clarksdale Coahoma Mobiles",
    "latitude": 34.01419,
    "longitude": -90.59512,
    "address": "318 John Lee Hooker",
    "city": "CLARKSDALE",
    "state": "MS",
    "zip_code": "38614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3810",
    "name": "Salvation Army Findlay ",
    "latitude": 41.04370922,
    "longitude": -83.64643904,
    "address": "301 CENTER ST",
    "city": "FINDLAY",
    "state": "OH",
    "zip_code": "45840",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3815",
    "name": "CH KI LO ",
    "latitude": 40.65572846,
    "longitude": -84.13728176,
    "address": "510 E SUGAR ST",
    "city": "CRIDERSVILLE",
    "state": "OH",
    "zip_code": "45806",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3822",
    "name": "Coleman professional services",
    "latitude": 40.73379707,
    "longitude": -84.1049263,
    "address": "529 s. Main st. ",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3827",
    "name": "Heritage Elementary School",
    "latitude": 40.74818313,
    "longitude": -84.12559759,
    "address": "816 COLLEGE AVE",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45805",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3833",
    "name": "CHURCH OF THE CROSSROADS/HIS COMPASSIONATE TOUCH",
    "latitude": 34.936175,
    "longitude": -88.512642,
    "address": "2037 HIGHWAY 72 E ANX",
    "city": "CORINTH",
    "state": "MS",
    "zip_code": "38834",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3834",
    "name": "Blackburn Ministries",
    "latitude": 41.2517467,
    "longitude": -84.13272692,
    "address": "300 KAUFMAN ST",
    "city": "HOLGATE",
    "state": "OH",
    "zip_code": "43527",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3835",
    "name": "LINKS Community & Family Services",
    "latitude": 41.08005622,
    "longitude": -81.49251784,
    "address": "756 Upson St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3837",
    "name": "Lakeland Community College",
    "latitude": 41.63664704,
    "longitude": -81.37039858,
    "address": "7700 CLOCKTOWER DR",
    "city": "WILLOUGHBY",
    "state": "OH",
    "zip_code": "44094",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3848",
    "name": "Focus Dreamers INC",
    "latitude": 41.484079,
    "longitude": -81.629568,
    "address": "11501 Mt. Carmel Road",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3849",
    "name": "Family Alliance Church",
    "latitude": 41.9147809,
    "longitude": -80.67355265,
    "address": "3137 E CENTER ST",
    "city": "CONNEAUT",
    "state": "OH",
    "zip_code": "44030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3854",
    "name": "First United Methodist Church",
    "latitude": 41.13697475,
    "longitude": -81.48518441,
    "address": "245 Portage Trl",
    "city": "Cuyahoga Falls",
    "state": "OH",
    "zip_code": "44221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3858",
    "name": "Salem Salvation Army",
    "latitude": 40.9144748,
    "longitude": -80.85665268,
    "address": "1249 N ELLSWORTH AVE",
    "city": "SALEM",
    "state": "OH",
    "zip_code": "44460",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3859",
    "name": "St. Mary and St. Joseph Church Pantry",
    "latitude": 41.18349424,
    "longitude": -80.98343001,
    "address": "120 MAPLE DR",
    "city": "NEWTON FALLS",
    "state": "OH",
    "zip_code": "44444",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3864",
    "name": "Salvation Army (Hamilton)",
    "latitude": 39.3970874,
    "longitude": -84.56206131,
    "address": "235 LUDLOW ST",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3866",
    "name": "Help Feed Toledo Area",
    "latitude": 41.65369645,
    "longitude": -83.68620073,
    "address": "6047 DORR ST",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43615",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3867",
    "name": "Memorial United Methodist Church - MUM",
    "latitude": 39.67240373,
    "longitude": -84.25157822,
    "address": "26 N LOCUST ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45449",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3870",
    "name": "Tallmadge Lutheran Church",
    "latitude": 41.10219047,
    "longitude": -81.41251411,
    "address": "759 East Ave",
    "city": "Tallmadge",
    "state": "OH",
    "zip_code": "44278",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3871",
    "name": "District 7 Helping Hand",
    "latitude": 41.41553357,
    "longitude": -81.53720433,
    "address": "5345 WARRENSVILLE CENTER RD",
    "city": "MAPLE HEIGHTS",
    "state": "OH",
    "zip_code": "44137",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3873",
    "name": "Maranatha Worship Center ",
    "latitude": 39.8127695,
    "longitude": -84.25485408,
    "address": "4501 WOLF RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45416",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3874",
    "name": "Virginia Penn - CSFP",
    "latitude": 37.00586489,
    "longitude": -76.40693577,
    "address": "2401 ALUMINUM AVE",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3875",
    "name": "New Hope Community Church",
    "latitude": 39.1781053,
    "longitude": -84.6086199,
    "address": "3707 EDGEWOOD DR",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3879",
    "name": "Freeport Food Pantry",
    "latitude": 40.2427768,
    "longitude": -81.2514908,
    "address": "79030 FREEPORT TIPPECANOE RD",
    "city": "TIPPECANOE",
    "state": "OH",
    "zip_code": "44699",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3881",
    "name": "AIM - Community Nutrition Program",
    "latitude": 42.1395555,
    "longitude": -77.0448035,
    "address": "1206 S Main St",
    "city": "Elmira",
    "state": "NY",
    "zip_code": "14904",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3898",
    "name": "Milford Center Mobile Market",
    "latitude": 40.1783754,
    "longitude": -83.438086,
    "address": "77 W Center St",
    "city": "MILFORD CENTER",
    "state": "OH",
    "zip_code": "43045",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3905",
    "name": "St Vincent de Paul-Middletown",
    "latitude": 39.51402988,
    "longitude": -84.39939997,
    "address": "1405 1st Ave",
    "city": "MIDDLETOWN",
    "state": "OH",
    "zip_code": "45044",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3906",
    "name": "ACRFB Pop-Up Pantry (Medina)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Parkway",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3935",
    "name": "COLONIAL PARK UMC",
    "latitude": 35.1043589,
    "longitude": -89.8839827,
    "address": "5330 PARK AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3936",
    "name": "St. Vincent Charity Medical Center",
    "latitude": 41.4962343,
    "longitude": -81.6730245,
    "address": "2351 E 22ND ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3937",
    "name": "CROCKETT COUNTY OFFICE ON AGING & SENIOR CENTER",
    "latitude": 35.7746075,
    "longitude": -89.1166452,
    "address": "736 S BELLS ST",
    "city": "ALAMO",
    "state": "TN",
    "zip_code": "38001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3939",
    "name": "New Hope Baptist Church",
    "latitude": 41.0627158,
    "longitude": -81.5699012,
    "address": "1706 S Hawkins Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3941",
    "name": "The Solid Rock Apostolic Church",
    "latitude": 40.11096247,
    "longitude": -84.47019157,
    "address": "8991 Old St Rt 36",
    "city": "BRADFORD",
    "state": "OH",
    "zip_code": "45308",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3946",
    "name": "Adventist Outreach",
    "latitude": 39.136749,
    "longitude": -84.494968,
    "address": "725 WHITTIER ST",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3948",
    "name": "Bethel Ridge Food Pantry",
    "latitude": 39.032746,
    "longitude": -82.649218,
    "address": "3342 Glade Road",
    "city": "JACKSON",
    "state": "OH",
    "zip_code": "45640",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3950",
    "name": "SEEDS OF HOPE MINISTRIES",
    "latitude": 35.0202501,
    "longitude": -89.8948369,
    "address": "5053 E SHELBY DR",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3956",
    "name": "Aldersgate United Methodist Church",
    "latitude": 41.692778,
    "longitude": -83.6034176,
    "address": "4030 DOUGLAS RD",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43613",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3957",
    "name": "Two Fish Five Loaves",
    "latitude": 41.5161868,
    "longitude": -81.5697791,
    "address": "2490 LEE BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3958",
    "name": "Church of Christ at the Boulevard",
    "latitude": 41.5342172,
    "longitude": -81.6267345,
    "address": "8837 SAINT CLAIR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3962",
    "name": "Church Of The Open Door/We Care Elyria",
    "latitude": 41.4334243,
    "longitude": -82.1831092,
    "address": "43275 TELEGRAPH RD",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3963",
    "name": "Renovate Life Church of God",
    "latitude": 39.2670028,
    "longitude": -82.4751728,
    "address": "64698 Infirmary Road",
    "city": "MC ARTHUR",
    "state": "OH",
    "zip_code": "45651",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3965",
    "name": "Breaking Bread",
    "latitude": 40.576925,
    "longitude": -83.13918268,
    "address": "636 Bellefontaine Ave",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3966",
    "name": "Delta Alpha Lambda Foundation, Inc.",
    "latitude": 41.4823811,
    "longitude": -81.6031966,
    "address": "2820 E 116TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3970",
    "name": "East Liverpool Church of God",
    "latitude": 40.6256791,
    "longitude": -80.5916441,
    "address": "926 W 8TH ST",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3971",
    "name": "Church Hill United Methodist Church",
    "latitude": 41.162139,
    "longitude": -80.6628468,
    "address": "189 CHURCHILL HUBBARD RD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3972",
    "name": "C.C. Chemung/Samaritan Center",
    "latitude": 42.0795593,
    "longitude": -76.80393,
    "address": "380 S MAIN ST",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14904",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3973",
    "name": "Church of Pentecost",
    "latitude": 40.0999997,
    "longitude": -82.947997,
    "address": "6200 CLEVELAND AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43231",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-3982",
    "name": "Alger Home Missions",
    "latitude": 40.7083851,
    "longitude": -83.8439918,
    "address": "305 N Main Street",
    "city": "ALGER",
    "state": "OH",
    "zip_code": "45812",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4028",
    "name": "South Side Baptist Church",
    "latitude": 39.07277577,
    "longitude": -84.51264608,
    "address": "1501 HOLMAN AVE",
    "city": "COVINGTON",
    "state": "KY",
    "zip_code": "41011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4029",
    "name": "Truth Agape",
    "latitude": 39.1787964,
    "longitude": -82.52508161,
    "address": "38052 SR 683",
    "city": "HAMDEN",
    "state": "OH",
    "zip_code": "45634",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4030",
    "name": "MFP Binghamton Plaza",
    "latitude": 42.1101834,
    "longitude": -75.9064608,
    "address": "33 W STATE ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4034",
    "name": "Christ Lutheran Church",
    "latitude": 40.8326029,
    "longitude": -81.5124364,
    "address": "3545 Amherst Ave NW",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4035",
    "name": "New Beginnings Church",
    "latitude": 40.1067125,
    "longitude": -84.6226698,
    "address": "802 E 4TH ST",
    "city": "GREENVILLE",
    "state": "OH",
    "zip_code": "45331",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4036",
    "name": "Lake Brady United Methodist Church",
    "latitude": 41.1689162,
    "longitude": -81.3222659,
    "address": "1995 Brady Lake Rd",
    "city": "Kent",
    "state": "OH",
    "zip_code": "44240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4039",
    "name": "Giving Hope - Stephen Stumpf Food Pantry",
    "latitude": 29.8731102,
    "longitude": -90.1035689,
    "address": "5151 LAPALCO BLVD",
    "city": "MARRERO",
    "state": "LA",
    "zip_code": "70072",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4041",
    "name": "Longstreth Food Pantry",
    "latitude": 39.4962901,
    "longitude": -82.2144598,
    "address": "43243 CARBON HILL BUCHTEL RD",
    "city": "NELSONVILLE",
    "state": "OH",
    "zip_code": "45764",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4042",
    "name": "First Presbyterian Church Food Pantry",
    "latitude": 39.5414376,
    "longitude": -82.4088193,
    "address": "2 W HUNTER ST",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4043",
    "name": "Federal Valley Resource Center Food Pantry",
    "latitude": 39.30813637,
    "longitude": -81.89525155,
    "address": "8225 SR 329",
    "city": "STEWART",
    "state": "OH",
    "zip_code": "45778",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4044",
    "name": "Thornville Food Pantry",
    "latitude": 39.8986814,
    "longitude": -82.42047908,
    "address": "123 N. Main St.",
    "city": "THORNVILLE",
    "state": "OH",
    "zip_code": "43076",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4046",
    "name": "SEWA",
    "latitude": 34.1827036,
    "longitude": -118.7671228,
    "address": "5766 OAK BANK TRL",
    "city": "OAK PARK",
    "state": "CA",
    "zip_code": "91377",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4048",
    "name": "New Paris Community Food Pantry",
    "latitude": 39.857327,
    "longitude": -84.7903101,
    "address": "301 E MAIN ST",
    "city": "NEW PARIS",
    "state": "OH",
    "zip_code": "45347",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4049",
    "name": "Greater Cleveland Delta Foundation",
    "latitude": 41.4844299,
    "longitude": -81.5996718,
    "address": "11955 SHAKER BLVD",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4050",
    "name": "YMCA of Central Stark County",
    "latitude": 40.8003625,
    "longitude": -81.3773459,
    "address": "420 3rd St NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44702",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4067",
    "name": "Bolindale Christian church",
    "latitude": 41.2120288,
    "longitude": -80.7847817,
    "address": "2749 FAIRVIEW AVE SE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44484",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4068",
    "name": "STAND FIRM MINISTRIES - MP",
    "latitude": 33.84,
    "longitude": -88.53012,
    "address": "70 HWY 255",
    "city": "ABERDEEN",
    "state": "MS",
    "zip_code": "39730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4069",
    "name": "Bethel AME",
    "latitude": 34.192973,
    "longitude": -119.1852642,
    "address": "855 S F ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4070",
    "name": "Buckeye Community Schools produce market",
    "latitude": 40.5885304,
    "longitude": -83.1360437,
    "address": "366 W CENTER ST",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4073",
    "name": "Cleveland Clinic South Pointe",
    "latitude": 41.4481297,
    "longitude": -81.5377408,
    "address": "20000 HARVARD AVE",
    "city": "WARRENSVILLE HEIGHTS",
    "state": "OH",
    "zip_code": "44122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4075",
    "name": "Linden Market",
    "latitude": 39.9950717,
    "longitude": -82.979796,
    "address": "1464 CLEVELAND AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4076",
    "name": "A SERVING HEART",
    "latitude": 34.19517422,
    "longitude": -88.71587703,
    "address": "278 College Street",
    "city": "VERONA",
    "state": "MS",
    "zip_code": "38879",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4078",
    "name": "McKinley United Methodist Church - The Helen Brinkley Food Pantry",
    "latitude": 39.75074852,
    "longitude": -84.21078426,
    "address": "196 HAWTHORN ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4080",
    "name": "FEED MY SHEEP",
    "latitude": 34.48564142,
    "longitude": -89.00585115,
    "address": "1165 Bratton Road",
    "city": "NEW ALBANY",
    "state": "MS",
    "zip_code": "38652",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4081",
    "name": "TOWN OF SELMER",
    "latitude": 35.1704041,
    "longitude": -88.5919968,
    "address": "144 N 2ND ST",
    "city": "SELMER",
    "state": "TN",
    "zip_code": "38375",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4083",
    "name": "North YMCA",
    "latitude": 40.07784183,
    "longitude": -82.97379743,
    "address": "1640 SANDALWOOD PL",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4086",
    "name": "ST VINCENT DEPAUL RESURRECTION CHURCH",
    "latitude": 35.05277496,
    "longitude": -89.88169472,
    "address": "5475 NEWBERRY AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4089",
    "name": "Southern Community Center",
    "latitude": 40.62549209,
    "longitude": -80.83892284,
    "address": "34A WASHINGTON ST",
    "city": "SALINEVILLE",
    "state": "OH",
    "zip_code": "43945",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4105",
    "name": "Baron Necessities @ CCC",
    "latitude": 42.1172,
    "longitude": -77.0724,
    "address": "1 ACADEMIC DR",
    "city": "CORNING",
    "state": "NY",
    "zip_code": "14830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4109",
    "name": "Salvation Army - Warren",
    "latitude": 41.23473665,
    "longitude": -80.81461508,
    "address": "270 FRANKLIN ST SE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44483",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4115",
    "name": "Hector Food Pantry",
    "latitude": 42.50281885,
    "longitude": -76.87417901,
    "address": "5511 State Rte. 414",
    "city": "HECTOR",
    "state": "NY",
    "zip_code": "14841",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4116",
    "name": "Keith D Monda Family Food Pantry",
    "latitude": 40.81154898,
    "longitude": -81.3685029,
    "address": "1365 Cherry Ave NE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44714",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4124",
    "name": "FIRST BAPTIST CHURCH MIDDLETON-MP",
    "latitude": 35.07524169,
    "longitude": -88.89164041,
    "address": "525 MAIN ST N",
    "city": "MIDDLETON",
    "state": "TN",
    "zip_code": "38052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4125",
    "name": "INTERFAITH COUNCIL ON POVERTY",
    "latitude": 34.83845906,
    "longitude": -89.97228116,
    "address": "1455 MCINGVALE RD",
    "city": "HERNANDO",
    "state": "MS",
    "zip_code": "38632",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4128",
    "name": "Star House/Carol Stewart Village",
    "latitude": 39.95708587,
    "longitude": -83.04224618,
    "address": "1567 W BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43222",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4129",
    "name": "United Methodist Church - Thousand Oaks",
    "latitude": 34.19920678,
    "longitude": -118.86105274,
    "address": "1000 E JANSS RD",
    "city": "THOUSAND OAKS",
    "state": "CA",
    "zip_code": "91360",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4130",
    "name": "Celebration Nation, Inc.",
    "latitude": 37.31783899,
    "longitude": -121.94749229,
    "address": "3031 TISCH WAY",
    "city": "SAN JOSE",
    "state": "CA",
    "zip_code": "95128",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4133",
    "name": "Alpha & Omega First Baptist",
    "latitude": 41.12896211,
    "longitude": -80.58454893,
    "address": "3120 WINTON AVE",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4135",
    "name": "Fairview UMC Food Pantry",
    "latitude": 42.10800174,
    "longitude": -75.88138421,
    "address": "254 ROBINSON ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13904",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4137",
    "name": "Grace Bible Church",
    "latitude": 34.19765342,
    "longitude": -119.18836998,
    "address": "936 W 5TH ST",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4140",
    "name": "Caring Hearts Outreach, Inc.",
    "latitude": 40.80763351,
    "longitude": -81.38273541,
    "address": "1100 10th St NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44703",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4143",
    "name": "SHSM DESOTO MOBILE",
    "latitude": 34.92838495,
    "longitude": -89.99948704,
    "address": "4560 VENTURE DR",
    "city": "SOUTHAVEN",
    "state": "MS",
    "zip_code": "38671",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4144",
    "name": "SHSM MARSHALL MOBILE",
    "latitude": 34.772162,
    "longitude": -89.450965,
    "address": "295 E FRANCISO AVE",
    "city": "HOLLY SPRINGS",
    "state": "MS",
    "zip_code": "38635",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4151",
    "name": "Salem Community Pantry",
    "latitude": 40.9032484,
    "longitude": -80.85084637,
    "address": "794 E 3RD ST",
    "city": "SALEM",
    "state": "OH",
    "zip_code": "44460",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4154",
    "name": "BGSU Firelands",
    "latitude": 41.39945997,
    "longitude": -82.59374132,
    "address": "1 UNIVERSITY DR",
    "city": "HURON",
    "state": "OH",
    "zip_code": "44839",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4156",
    "name": "St Peters UCC",
    "latitude": 40.7498155,
    "longitude": -81.83664125,
    "address": "68 West Main St",
    "city": "Apple Creek",
    "state": "OH",
    "zip_code": "44606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4157",
    "name": "Liberty- MFP",
    "latitude": 37.04818056,
    "longitude": -76.42982037,
    "address": "1021 BIG BETHEL RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4160",
    "name": "SHSM HOLLY SPRINGS FOOD PANTRY",
    "latitude": 34.772162,
    "longitude": -89.450965,
    "address": "295 E FRANCISO AVE",
    "city": "HOLLY SPRINGS",
    "state": "MS",
    "zip_code": "38635",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4162",
    "name": "School of Innovation",
    "latitude": 39.91442002,
    "longitude": -83.80115837,
    "address": "601 SELMA RD",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4163",
    "name": "Kings Arms - CSFP",
    "latitude": 37.04080991,
    "longitude": -76.34836359,
    "address": "1010 N KING ST",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4164",
    "name": "Ashe Manor",
    "latitude": 36.9916191,
    "longitude": -76.4172964,
    "address": "900 36TH ST",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4169",
    "name": "Canisteo Community Food Pantry",
    "latitude": 42.2696,
    "longitude": -77.606,
    "address": "18 GREENWOOD ST",
    "city": "CANISTEO",
    "state": "NY",
    "zip_code": "14823",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4170",
    "name": "The Schuyler County Food Pantry",
    "latitude": 42.34505403,
    "longitude": -76.84693359,
    "address": "221 W South St",
    "city": "MONTOUR FALLS",
    "state": "NY",
    "zip_code": "14865",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4172",
    "name": "Cohocton Community Food Pantry",
    "latitude": 42.5006336,
    "longitude": -77.4973807,
    "address": "37 Maple Ave",
    "city": "COHOCTON",
    "state": "NY",
    "zip_code": "14826",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4173",
    "name": "Jasper-Troupsburg Community Food Pantry",
    "latitude": 42.0439164,
    "longitude": -77.54497995,
    "address": "913 County Route 82",
    "city": "TROUPSBURG",
    "state": "NY",
    "zip_code": "14885",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4174",
    "name": "FARMER'S MARKET FRIDAY",
    "latitude": 35.04263132,
    "longitude": -89.90906535,
    "address": "3865 S PERKINS RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4175",
    "name": "God's Kngdom ",
    "latitude": 41.37391551,
    "longitude": -82.10587988,
    "address": "423 WASHINGTON AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4178",
    "name": "Abundant Harvest Deliverance Ministry",
    "latitude": 40.78534677,
    "longitude": -81.38829603,
    "address": "1368 Henry Ave SW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44706",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4180",
    "name": "Lake County Council on Aging - CSFP",
    "latitude": 41.67986551,
    "longitude": -81.33447739,
    "address": "8520 EAST AVE",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4190",
    "name": "The Lord's Cupboard Food Pantry",
    "latitude": 48.22446069,
    "longitude": -101.31793472,
    "address": "1725 BURDICK EXPY W",
    "city": "MINOT",
    "state": "ND",
    "zip_code": "58701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4196",
    "name": "Walk Ups SHFB",
    "latitude": 39.92298611,
    "longitude": -83.79987292,
    "address": "20 N MURRAY ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4197",
    "name": "Order Ahead SHFB",
    "latitude": 39.92298611,
    "longitude": -83.79987292,
    "address": "20 N MURRAY ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4198",
    "name": "Pleasant Valley Rec.",
    "latitude": 34.22553753,
    "longitude": -119.05012397,
    "address": "1605 BURNLEY ST",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4199",
    "name": "Good Shepherd Lutheran Church",
    "latitude": 41.9603296,
    "longitude": -80.56156209,
    "address": "876 GROVE ST",
    "city": "CONNEAUT",
    "state": "OH",
    "zip_code": "44030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4200",
    "name": "With God's Grace Free Store",
    "latitude": 39.81723801,
    "longitude": -84.19872098,
    "address": "5505 N DIXIE DR",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45414",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4202",
    "name": "BREAD OF LIFE - JERICHO",
    "latitude": 34.50796448,
    "longitude": -88.75678815,
    "address": "2179 COUNTY ROAD 171",
    "city": "GUNTOWN",
    "state": "MS",
    "zip_code": "38849",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4204",
    "name": "Methodist Le Bonheur Healthcare",
    "latitude": 35.13663548,
    "longitude": -90.02134744,
    "address": "1211 UNION AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4205",
    "name": "Found by Faith Food Pantry",
    "latitude": 39.50253123,
    "longitude": -84.0102918,
    "address": "73 South St",
    "city": "HARVEYSBURG",
    "state": "OH",
    "zip_code": "45032",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4206",
    "name": "UTHSC CAMPUS CUPBOARD",
    "latitude": 35.13702941,
    "longitude": -90.02948354,
    "address": "210 S. DUDLEY",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4209",
    "name": "St Johns ELCA ",
    "latitude": 39.8310318,
    "longitude": -81.98688384,
    "address": "6575 Center Road",
    "city": "PHILO",
    "state": "OH",
    "zip_code": "43771",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4210",
    "name": "TFI CSFP - Montgomery",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 ARMOR PL",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4211",
    "name": "TFI CSFP - Greene",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 ARMOR PL",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4212",
    "name": "MCNAIRY COUNTY CITY HALL-RURAL",
    "latitude": 35.1537,
    "longitude": -88.611,
    "address": "701 INDUSTRIAL PARK DR",
    "city": "SELMER",
    "state": "TN",
    "zip_code": "38375",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4214",
    "name": "Sonshine Pantry ",
    "latitude": 39.86190714,
    "longitude": -80.81344956,
    "address": "100 SR 7",
    "city": "POWHATAN POINT",
    "state": "OH",
    "zip_code": "43942",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4218",
    "name": "LAMBERT CITY HALL",
    "latitude": 34.20368233,
    "longitude": -90.28396251,
    "address": "831 SCOTT AVE",
    "city": "LAMBERT",
    "state": "MS",
    "zip_code": "38643",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4220",
    "name": "CHURCHES FAMILY AND TOGETHER",
    "latitude": 35.03441762,
    "longitude": -89.98225981,
    "address": "4233 LOUIS CARRUTHERS DR",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4224",
    "name": "ANTHONYVILLE VOLUNTEER FIRE DEPT",
    "latitude": 35.097258,
    "longitude": -90.282934,
    "address": "149 LUKE ANTHONY SR",
    "city": "PROCTOR",
    "state": "AR",
    "zip_code": "72376",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4226",
    "name": "MFP-Tabernacle Baptist, East End",
    "latitude": 36.97657894,
    "longitude": -76.41102954,
    "address": "1408 MARSHALL AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4228",
    "name": "Prattsburgh Emergency Food Pantry",
    "latitude": 42.524871,
    "longitude": -77.249474,
    "address": "1 ACADEMY ST",
    "city": "PRATTSBURGH",
    "state": "NY",
    "zip_code": "14873",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4230",
    "name": "Expressions of Life, Inc.",
    "latitude": 39.76372982,
    "longitude": -84.20683433,
    "address": "160 SALEM AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4232",
    "name": "PowerHouse Church of the Nazarene",
    "latitude": 34.27202171,
    "longitude": -119.26694885,
    "address": "365 S SEAWARD AVE",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4235",
    "name": "QUITMAN SHERIFF DEPT",
    "latitude": 34.25917293,
    "longitude": -90.27027022,
    "address": "233 CHESTNUT ST",
    "city": "MARKS",
    "state": "MS",
    "zip_code": "38646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4236",
    "name": "Bulldog Bags, Inc.",
    "latitude": 41.1613573,
    "longitude": -81.44029277,
    "address": "3493 Darrow Rd",
    "city": "Stow",
    "state": "OH",
    "zip_code": "44224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4237",
    "name": "Faith Fellowship Church of God",
    "latitude": 41.06117551,
    "longitude": -80.64633085,
    "address": "388 E MIDLOTHIAN BLVD",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44507",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4238",
    "name": "MATTHEW 25:40 (MP)",
    "latitude": 36.03325349,
    "longitude": -89.38948056,
    "address": "432 W COURT ST",
    "city": "DYERSBURG",
    "state": "TN",
    "zip_code": "38024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4239",
    "name": "Be A Fence Food Pantry",
    "latitude": 39.95703227,
    "longitude": -82.95723838,
    "address": "480 LILLEY AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43205",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4241",
    "name": "Union Presbyterian Church Food Pantry",
    "latitude": 42.09494877,
    "longitude": -76.0639026,
    "address": "200 E MAIN ST",
    "city": "ENDICOTT",
    "state": "NY",
    "zip_code": "13760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4242",
    "name": "Life Spring Community Church",
    "latitude": 41.22955706,
    "longitude": -81.93767218,
    "address": "1638 Lester Rd",
    "city": "Valley City",
    "state": "OH",
    "zip_code": "44280",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4243",
    "name": "ABERDEEN CITY HALL",
    "latitude": 33.82518302,
    "longitude": -88.54411704,
    "address": "125 W COMMERCE ST",
    "city": "ABERDEEN",
    "state": "MS",
    "zip_code": "39730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4251",
    "name": "Christ Memorial Church",
    "latitude": 40.761561,
    "longitude": -81.186167,
    "address": "156 PO BOX",
    "city": "Robertsville",
    "state": "OH",
    "zip_code": "44670",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4253",
    "name": "Clark County Combined Health District",
    "latitude": 39.92098414,
    "longitude": -83.77185444,
    "address": "2501 E HIGH ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4254",
    "name": "Celebration United Methodist Church",
    "latitude": 41.60643993,
    "longitude": -81.50284792,
    "address": "771 E 260TH ST",
    "city": "EUCLID",
    "state": "OH",
    "zip_code": "44132",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4256",
    "name": "ECRU SECOND BAPTIST CHURCH",
    "latitude": 34.3553505,
    "longitude": -89.02477576,
    "address": "350 Central Ave",
    "city": "ECRU",
    "state": "MS",
    "zip_code": "38841",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4259",
    "name": "EKKLESIA M.B. CHURCH",
    "latitude": 34.90483401,
    "longitude": -88.54385073,
    "address": "2066 S TATE ST",
    "city": "CORINTH",
    "state": "MS",
    "zip_code": "38834",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4261",
    "name": "Good Ground World Ministries",
    "latitude": 40.71991584,
    "longitude": -84.20444666,
    "address": "5300 SPENCERVILLE RD",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45805",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4262",
    "name": "CHULAHOME MOBILE PANTRY",
    "latitude": 34.65702278,
    "longitude": -89.61811596,
    "address": "5509 HIGHWAY 4  W",
    "city": "HOLLY SPRINGS",
    "state": "MS",
    "zip_code": "38635",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4265",
    "name": "Project Concern",
    "latitude": 42.16956118,
    "longitude": -75.87301087,
    "address": "23 KATTELVILLE RD",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4266",
    "name": "St. Patrick's Roman Catholic Church",
    "latitude": 42.09530032,
    "longitude": -75.92100819,
    "address": "58 Oak St",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4267",
    "name": "Salvation Army - Hubbard",
    "latitude": 41.15723366,
    "longitude": -80.57080667,
    "address": "59 ORCHARD AVE",
    "city": "HUBBARD",
    "state": "OH",
    "zip_code": "44425",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4271",
    "name": "GRAY'S CREEK",
    "latitude": 35.21188821,
    "longitude": -89.68176386,
    "address": "3141 INGLEWOOD PL",
    "city": "ARLINGTON",
    "state": "TN",
    "zip_code": "38002",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4272",
    "name": "Helping Hands Helping Others",
    "latitude": 40.5891811,
    "longitude": -83.1253186,
    "address": "160 Oak St",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4276",
    "name": "New Life Vineyard Church",
    "latitude": 39.39213675,
    "longitude": -84.53890045,
    "address": "1701 PRINCETON RD",
    "city": "FAIRFIELD TOWNSHIP",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4277",
    "name": "NEW MOUNT GILLIAN MB CHURCH - MP",
    "latitude": 34.86011019,
    "longitude": -89.71386903,
    "address": "774 Stonewall Rd ",
    "city": "BYHALIA",
    "state": "MS",
    "zip_code": "38611",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4278",
    "name": "St. Michael's Food Pantry",
    "latitude": 42.1088065,
    "longitude": -75.93387919,
    "address": "296 CLINTON ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4282",
    "name": "Christian Life Center",
    "latitude": 41.02993021,
    "longitude": -80.7354158,
    "address": "6101 S RACCOON RD",
    "city": "CANFIELD",
    "state": "OH",
    "zip_code": "44406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4283",
    "name": "St. Angela Merici",
    "latitude": 41.08673685,
    "longitude": -80.62137759,
    "address": "400 LINCOLN PARK DR",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4284",
    "name": "Eastway Village",
    "latitude": 39.97459372,
    "longitude": -82.88801143,
    "address": "4237 E BROAD ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4285",
    "name": "Hamilton Crossing",
    "latitude": 39.96381272,
    "longitude": -82.87417294,
    "address": "540 S HAMILTON RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43213",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4288",
    "name": "Zion Lutheran Church North Canton",
    "latitude": 40.8801229,
    "longitude": -81.41319458,
    "address": "349 Lindy Lane Ave NW",
    "city": "North Canton",
    "state": "OH",
    "zip_code": "44720",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4290",
    "name": "YMCA: Gamble-Nippert",
    "latitude": 39.14831643,
    "longitude": -84.60515121,
    "address": "3159 MONTANA AVE",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4291",
    "name": "Liberty Assembly",
    "latitude": 41.20129002,
    "longitude": -80.66190912,
    "address": "6779 BELMONT AVE",
    "city": "GIRARD",
    "state": "OH",
    "zip_code": "44420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4295",
    "name": "New Hope Community Church",
    "latitude": 40.64253283,
    "longitude": -82.23324143,
    "address": "637 N MARKET ST",
    "city": "LOUDONVILLE",
    "state": "OH",
    "zip_code": "44842",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4297",
    "name": "Hunger Network",
    "latitude": 41.50393883,
    "longitude": -81.6562067,
    "address": "4415 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4298",
    "name": "Go Ministries International ",
    "latitude": 39.90302745,
    "longitude": -84.62849451,
    "address": "114 W ORCHARD ST",
    "city": "WEST MANCHESTER",
    "state": "OH",
    "zip_code": "45382",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4301",
    "name": "Shaker Place Apartments",
    "latitude": 41.46218948,
    "longitude": -81.53368104,
    "address": "3600 NORTHFIELD RD",
    "city": "BEACHWOOD",
    "state": "OH",
    "zip_code": "44122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4302",
    "name": "Addiction Center of Broome County",
    "latitude": 42.10830575,
    "longitude": -75.90395026,
    "address": "477 STATE ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4303",
    "name": "Alomary Mosque",
    "latitude": 41.43025495,
    "longitude": -81.82544658,
    "address": "4600 ROCKY RIVER DR",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4304",
    "name": "Fellowship Baptist Food Pantry",
    "latitude": 39.89713689,
    "longitude": -82.87664117,
    "address": "4701 WINCHESTER PIKE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4308",
    "name": "NEW COVENANT SDA",
    "latitude": 35.03012482,
    "longitude": -90.07017215,
    "address": "4335 HORN LAKE RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4316",
    "name": "NEW HOPR MISSIONARY BAPTIAT CHURCH - MP",
    "latitude": 34.35036,
    "longitude": -89.51898,
    "address": "87 CR 321 Pea Ridge Road",
    "city": "OXFORD",
    "state": "MS",
    "zip_code": "38655",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4318",
    "name": "Home Delivery - HAPCAP for Health",
    "latitude": 39.53449987,
    "longitude": -82.39097747,
    "address": "1005 CIC Dr. ",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4320",
    "name": "ROAR Church",
    "latitude": 34.21999401,
    "longitude": -119.04291943,
    "address": "340 MOBIL AVE",
    "city": "CAMARILLO",
    "state": "CA",
    "zip_code": "93010",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4321",
    "name": "Christ Our Savior",
    "latitude": 41.06534171,
    "longitude": -80.57893458,
    "address": "250 N BRIDGE ST",
    "city": "STRUTHERS",
    "state": "OH",
    "zip_code": "44471",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4322",
    "name": "East Palestine Nazarene Church",
    "latitude": 40.83434665,
    "longitude": -80.53826365,
    "address": "38 E REBECCA ST",
    "city": "EAST PALESTINE",
    "state": "OH",
    "zip_code": "44413",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4327",
    "name": "Helping Hands Development Corporation",
    "latitude": 41.5408996,
    "longitude": -81.5957511,
    "address": "12618 Shaw Avenue",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4328",
    "name": "DELIVERANCE TEMPLE MOBILE",
    "latitude": 35.17721491,
    "longitude": -90.01776394,
    "address": "1377 N BELLEVUE BLVD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4329",
    "name": "FATHER'S TABLE",
    "latitude": 34.87571986,
    "longitude": -88.64083513,
    "address": "08 CR 604 ",
    "city": "CORINTH",
    "state": "MS",
    "zip_code": "38834",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4330",
    "name": "DREAM CENTER MEMPHIS",
    "latitude": 35.1746922,
    "longitude": -89.7915346,
    "address": "1800 N. GERMANTOWN",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4332",
    "name": "MACEDONIA BAPTIST CHURCH (MADISON)",
    "latitude": 35.62701929,
    "longitude": -88.79886487,
    "address": "106 GLASS ST",
    "city": "JACKSON",
    "state": "TN",
    "zip_code": "38301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4335",
    "name": "MFP Senior - Hamilton House",
    "latitude": 42.09357047,
    "longitude": -75.92554507,
    "address": "16 SAINT JOHN AVE",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4336",
    "name": "Living Bread Pantry",
    "latitude": 40.01600561,
    "longitude": -80.74349331,
    "address": "3402 GUERNSEY ST",
    "city": "BELLAIRE",
    "state": "OH",
    "zip_code": "43906",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4337",
    "name": "Barnes Temple COGIC",
    "latitude": 41.21613313,
    "longitude": -80.79215435,
    "address": "2618 NILES RD SE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44484",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4338",
    "name": "OPERATION HOPE NEIGHBORHOOD - PANTRY",
    "latitude": 35.60612243,
    "longitude": -88.79666337,
    "address": "360 COMMERCE ST",
    "city": "JACKSON",
    "state": "TN",
    "zip_code": "38301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4342",
    "name": "UMNC ASBURY",
    "latitude": 35.06805777,
    "longitude": -89.88629965,
    "address": "2969 S MENDENHALL RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4345",
    "name": "HELPING HANDS OF HOPE/NIG'S CLOSET MOBILE",
    "latitude": 34.25015,
    "longitude": -90.274085,
    "address": "1098 M.L.K. JR DR ",
    "city": "MARKS",
    "state": "MS",
    "zip_code": "38646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4347",
    "name": "Court Street Ministries",
    "latitude": 38.80660315,
    "longitude": -82.20748998,
    "address": "33 COURT ST",
    "city": "GALLIPOLIS",
    "state": "OH",
    "zip_code": "45631",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4350",
    "name": "Nueva Esperanza",
    "latitude": 34.27158848,
    "longitude": -118.70288537,
    "address": "4680 E LOS ANGELES AVE",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93063",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4351",
    "name": "Emmanuel Presbyterian Church",
    "latitude": 40.6446717,
    "longitude": -80.57120546,
    "address": "767 PARK BLVD W",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4353",
    "name": "Prince Hall Masonic Temple",
    "latitude": 41.05159947,
    "longitude": -81.52352297,
    "address": "1295 Curtis St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4354",
    "name": "NEWBERN FIRST BAPTIST",
    "latitude": 36.11246617,
    "longitude": -89.26581881,
    "address": "114 W MAIN ST",
    "city": "NEWBERN",
    "state": "TN",
    "zip_code": "38059",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4355",
    "name": "FIRST BAPTIST CHUTCH OF UNION CITY",
    "latitude": 36.42411866,
    "longitude": -89.05188647,
    "address": "500 E CHURCH ST",
    "city": "UNION CITY",
    "state": "TN",
    "zip_code": "38261",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4356",
    "name": "E III Inc. ",
    "latitude": 41.46237844,
    "longitude": -82.1812099,
    "address": "740 HAMILTON AVE",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4358",
    "name": "Mid-Ohio Market at Norton Road",
    "latitude": 39.9380049,
    "longitude": -83.14352355,
    "address": "620 NORTON RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43228",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4361",
    "name": "Helping The Homeless",
    "latitude": 37.39319637,
    "longitude": -76.52868997,
    "address": "7040 GEORGE WASHINGTON MEMORIAL HWY",
    "city": "GLOUCESTER",
    "state": "VA",
    "zip_code": "23061",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4362",
    "name": "Seville Community Food Pantry",
    "latitude": 41.01020765,
    "longitude": -81.86595047,
    "address": "74 W Main St",
    "city": "Seville",
    "state": "OH",
    "zip_code": "44273",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4364",
    "name": "Care on the Square",
    "latitude": 41.24165361,
    "longitude": -81.8607131,
    "address": "1226 Substation Rd",
    "city": "Brunswick",
    "state": "OH",
    "zip_code": "44212",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4368",
    "name": "God's Hands At Work",
    "latitude": 38.84256695,
    "longitude": -82.25656756,
    "address": "1498 State Route 850",
    "city": "Bidwell",
    "state": "OH",
    "zip_code": "45614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4369",
    "name": "First Church of Newport News Baptist",
    "latitude": 36.98342854,
    "longitude": -76.4121153,
    "address": "2300 WICKHAM AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4375",
    "name": "The Overflow Church ",
    "latitude": 41.56178143,
    "longitude": -81.5698273,
    "address": "707 E 159TH ST",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4376",
    "name": "Ellet Community Church of God",
    "latitude": 41.04119584,
    "longitude": -81.43330499,
    "address": "2700 Priscilla Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44312",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4379",
    "name": "A\\LMA RE OUTREACH",
    "latitude": 35.16554107,
    "longitude": -90.18754831,
    "address": "260C SHOPPINGWAY BLVD",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4380",
    "name": "St. Patrick's Church Pantry",
    "latitude": 40.87686141,
    "longitude": -80.75929928,
    "address": "167 MAIN ST",
    "city": "LEETONIA",
    "state": "OH",
    "zip_code": "44431",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4381",
    "name": "House Of Healing Ministries",
    "latitude": 39.04729517,
    "longitude": -82.1813059,
    "address": "33304 STATE ROUTE 124",
    "city": "LANGSVILLE",
    "state": "OH",
    "zip_code": "45741",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4385",
    "name": "S.T.A.P. Southern Tier AIDS Program",
    "latitude": 42.09277923,
    "longitude": -75.92165609,
    "address": "22 RIVERSIDE DR",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4387",
    "name": "UrbanArk, Inc",
    "latitude": 40.80246249,
    "longitude": -81.37188915,
    "address": "715 2nd St. NE",
    "city": "CANTON",
    "state": "OH",
    "zip_code": "44704",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4389",
    "name": "UNITED FELLOWSHIP CHURCH - MP",
    "latitude": 35.15344424,
    "longitude": -90.15357594,
    "address": "2507 E BARTON AVE",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4390",
    "name": "CITY OF GILMORE",
    "latitude": 35.41167732,
    "longitude": -90.27992701,
    "address": "97 FRONT ST. ",
    "city": "GILMORE",
    "state": "AR",
    "zip_code": "72339",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4393",
    "name": "Moms Mobile Mission",
    "latitude": 41.52763581,
    "longitude": -83.63638341,
    "address": "12282 JEFFERSON ST",
    "city": "PERRYSBURG",
    "state": "OH",
    "zip_code": "43551",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4395",
    "name": "Immaculate Conception Food Pantry",
    "latitude": 42.4402,
    "longitude": -76.5001,
    "address": "113 N GENEVA ST",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4396",
    "name": "ADAMSVILLE FIRE DEPT",
    "latitude": 35.2349765,
    "longitude": -88.3871659,
    "address": "231 E. MAIN ST ",
    "city": "Adamsville",
    "state": "TN",
    "zip_code": "43802",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4398",
    "name": "ACRFB Pop-Up Pantry (Summit)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Pkwy",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4401",
    "name": "COTA Central Ohio Transit Auth   ",
    "latitude": 40.04099645,
    "longitude": -82.96158377,
    "address": "3573 CLEVELAND AVE",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4402",
    "name": "United Community Brethren",
    "latitude": 39.79142182,
    "longitude": -84.21365815,
    "address": "15 W HILLCREST AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45405",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4408",
    "name": "FIRST UNITED METHODIST CHURCH OF WEST MEMPHIS",
    "latitude": 35.14908724,
    "longitude": -90.18469286,
    "address": "215 N MISSOURI ST",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4409",
    "name": "Operation Hunger: Springfield",
    "latitude": 39.919924,
    "longitude": -83.74029051,
    "address": "157 S. Bird Rd.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4411",
    "name": "New Birth Mission",
    "latitude": 39.92760103,
    "longitude": -83.81930458,
    "address": "539 W NORTH ST",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45504",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4412",
    "name": "MFP Prattsburgh (School)",
    "latitude": 42.51030534,
    "longitude": -77.278033,
    "address": "7274 County Route 74",
    "city": "PRATTSBURGH",
    "state": "NY",
    "zip_code": "14873",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4416",
    "name": "The Mount-Peninsula",
    "latitude": 37.17001347,
    "longitude": -76.47226503,
    "address": "6406 GEORGE WASHINGTON MEM HWY",
    "city": "YORKTOWN",
    "state": "VA",
    "zip_code": "23692",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4417",
    "name": "Be Blessed Be A Blessing Outreach",
    "latitude": 37.02625404,
    "longitude": -76.45021235,
    "address": "605 SOUTH AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4419",
    "name": "Hamden United Methodist Church",
    "latitude": 39.16087,
    "longitude": -82.524305,
    "address": "325 PO BOX",
    "city": "HAMDEN",
    "state": "OH",
    "zip_code": "45634",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4420",
    "name": "Spanish Evangelical Church",
    "latitude": 41.112602,
    "longitude": -80.609229,
    "address": "369 KEYSTONE AVE",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4422",
    "name": "WARREN COMMUNITY CHURCH",
    "latitude": 35.2337704,
    "longitude": -89.43623494,
    "address": "11800 US HIGHWAY 64",
    "city": "SOMERVILLE",
    "state": "TN",
    "zip_code": "38068",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4423",
    "name": "RCCG - Dominion Center",
    "latitude": 39.75254687,
    "longitude": -84.25908596,
    "address": "360 ELMHURST RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4425",
    "name": "LIA HOUSE",
    "latitude": 35.0966633,
    "longitude": -90.01366788,
    "address": "1782 CINCINNATI RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4427",
    "name": "Queen of Heaven Church Labre Program",
    "latitude": 41.07104601,
    "longitude": -81.48869533,
    "address": "55 N. Broad St.",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4431",
    "name": "MMK Huck House ",
    "latitude": 39.9124488,
    "longitude": -82.8355323,
    "address": "5981 CHATTERTON RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4433",
    "name": "The Salvation Army FP - Ithaca",
    "latitude": 42.4398,
    "longitude": -76.502,
    "address": "150 N ALBANY ST",
    "city": "ITHACA",
    "state": "NY",
    "zip_code": "14850",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4435",
    "name": "First Regular Baptist Church",
    "latitude": 39.56246891,
    "longitude": -84.30366865,
    "address": "16 W 2ND ST",
    "city": "FRANKLIN",
    "state": "OH",
    "zip_code": "45005",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4436",
    "name": "Christ Presbyterian Church",
    "latitude": 40.79889964,
    "longitude": -81.37893541,
    "address": "530 Tuscarawas St W",
    "city": "canton",
    "state": "Ohio",
    "zip_code": "44702",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4437",
    "name": "The Remedy Church",
    "latitude": 41.11044427,
    "longitude": -81.4672885,
    "address": "1700 Brittain Rd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4438",
    "name": "Luke 19",
    "latitude": 40.89376081,
    "longitude": -81.59995916,
    "address": "532 High St NE",
    "city": "Canal Fulton",
    "state": "OH",
    "zip_code": "44614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4439",
    "name": "Apostolic Lighthouse Church",
    "latitude": 39.8039934,
    "longitude": -84.13175338,
    "address": "2221 HARSHMAN RD",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45424",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4441",
    "name": "Blanchester Community Food Pantry",
    "latitude": 39.29492162,
    "longitude": -83.98458642,
    "address": "318 E MAIN ST",
    "city": "BLANCHESTER",
    "state": "OH",
    "zip_code": "45107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4444",
    "name": "Cleveland Clinic Akron General",
    "latitude": 41.0784796,
    "longitude": -81.533191,
    "address": "1 AKRON GENERAL AVE",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4445",
    "name": "Summa Family Medicine Center",
    "latitude": 41.07944832,
    "longitude": -81.49911676,
    "address": "55 ARCH ST",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44304",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4446",
    "name": "MFP Senior - Owego Gardens",
    "latitude": 42.10036821,
    "longitude": -76.25280998,
    "address": "130A SOUTHSIDE DR",
    "city": "OWEGO",
    "state": "NY",
    "zip_code": "13827",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4447",
    "name": "Alliant Health",
    "latitude": 41.55134027,
    "longitude": -81.55615822,
    "address": "17608 EUCLID AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4449",
    "name": "CC Broome / 100 Main Street Food Pantry",
    "latitude": 42.10092337,
    "longitude": -75.92592802,
    "address": "100 MAIN ST",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13905",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4451",
    "name": "Greater Joy COGIC",
    "latitude": 36.98502409,
    "longitude": -76.39775037,
    "address": "72 WALNUT AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4455",
    "name": "Heritage College of Osteopathic Medicine",
    "latitude": 39.32401233,
    "longitude": -82.10483476,
    "address": "16 W Green Drive",
    "city": "Athens",
    "state": "OH",
    "zip_code": "45701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4458",
    "name": "Matthew 25 Outreach Center Direct Distribution",
    "latitude": 41.04784687,
    "longitude": -81.96566572,
    "address": "5700 Ashland Rd",
    "city": "Wooster",
    "state": "OH",
    "zip_code": "44691",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4459",
    "name": "South Fairborn Baptist Church",
    "latitude": 39.7963738,
    "longitude": -84.03545696,
    "address": "1642 SUPERIOR AVE",
    "city": "FAIRBORN",
    "state": "OH",
    "zip_code": "45324",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4460",
    "name": "Diabetes Dayton - Diabetic Friendly Food Pantry (LifeCare Alliance)",
    "latitude": 39.71578009,
    "longitude": -84.19882227,
    "address": "2555 S DIXIE DR",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45409",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4464",
    "name": "Ethos Food Pantry",
    "latitude": 40.19887901,
    "longitude": -83.00217731,
    "address": "6576 Africa Rd",
    "city": "Westerville",
    "state": "OH",
    "zip_code": "43021",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4465",
    "name": "Wedgewood UMC",
    "latitude": 41.0488491,
    "longitude": -81.44481668,
    "address": "2350 Wedgewood Dr",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44312",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4466",
    "name": "ST. JAMES TEMPLE COGIC - MP",
    "latitude": 34.72835914,
    "longitude": -88.96142412,
    "address": "719 ASHLAND RD",
    "city": "RIPLEY",
    "state": "MS",
    "zip_code": "38663",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4467",
    "name": "MMK Huck House Kenmore ",
    "latitude": 40.01227781,
    "longitude": -82.96453207,
    "address": "2216 BANCROFT ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4477",
    "name": "SECOND BAPTIST COLDWATER",
    "latitude": 34.68925295,
    "longitude": -89.97144843,
    "address": "710 FORREST ",
    "city": "COLDWATER",
    "state": "MS",
    "zip_code": "38618",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4478",
    "name": "Our Lady of Guadalupe - SP",
    "latitude": 34.36051159,
    "longitude": -119.059394,
    "address": "427 N OAK ST",
    "city": "SANTA PAULA",
    "state": "CA",
    "zip_code": "93060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4479",
    "name": "City of Cleveland Dept of Health - J. GLEN SMITH",
    "latitude": 41.54059699,
    "longitude": -81.60765474,
    "address": "11100 SAINT CLAIR AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4484",
    "name": "BEARMAN GOLDEN GARDENS",
    "latitude": 35.01879425,
    "longitude": -90.0566693,
    "address": "4755 NEELY RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4485",
    "name": "Shield of Faith Ministries Pantry",
    "latitude": 39.51258901,
    "longitude": -82.97169554,
    "address": "28840 LOGAN ELM RD",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4486",
    "name": "Eagle Vision Outreach",
    "latitude": 34.27657473,
    "longitude": -118.788657,
    "address": "2380 SHASTA WAY",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4490",
    "name": "WEST MEMPHIS HOUSING AUTHORITY",
    "latitude": 35.14152169,
    "longitude": -90.14948259,
    "address": "390 S WALKER AVE",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4491",
    "name": "SENATOBIA CITY HALL",
    "latitude": 34.65318,
    "longitude": -89.86986,
    "address": "133 N FRONT ST",
    "city": "SENATOBIA",
    "state": "MS",
    "zip_code": "38668",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4492",
    "name": "Good Shepherd Baptist Church",
    "latitude": 41.08094872,
    "longitude": -81.5698593,
    "address": "1010 S Hawkins Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4497",
    "name": "The Salvation Army (Wadsworth)",
    "latitude": 41.0253236,
    "longitude": -81.74526155,
    "address": "527 College St",
    "city": "Wadsworth",
    "state": "OH",
    "zip_code": "44281",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4500",
    "name": "Dayton Metro Library - Northwest",
    "latitude": 39.79217911,
    "longitude": -84.23502375,
    "address": "2410 PHILADELPHIA DR",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45406",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4501",
    "name": "Dayton Metro Library - Miamisburg",
    "latitude": 39.63898418,
    "longitude": -84.28276098,
    "address": "545 E LINDEN AVE",
    "city": "MIAMISBURG",
    "state": "OH",
    "zip_code": "45342",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4505",
    "name": "Dayton Metro Library - Main ",
    "latitude": 39.76022566,
    "longitude": -84.18801829,
    "address": "215 E 3RD ST",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4506",
    "name": "Dayton Metro Library - West",
    "latitude": 39.74822837,
    "longitude": -84.23982943,
    "address": "300 ABBEY AVE",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4507",
    "name": "CNE Cares",
    "latitude": 39.11908083,
    "longitude": -84.13604927,
    "address": "463 S Broadway",
    "city": "OWENSVILLE",
    "state": "OH",
    "zip_code": "45160",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4508",
    "name": "BINGHAMPTON COMMUNITY CHURCH",
    "latitude": 35.14199525,
    "longitude": -89.96110379,
    "address": "3006 JOHNSON AVE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4510",
    "name": "Oakley Full Baptist Church ",
    "latitude": 39.97346808,
    "longitude": -83.09544479,
    "address": "3415 EL PASO DR",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4513",
    "name": "FAITHFUL COMMUNITY OUTREACH MINISTRIES",
    "latitude": 35.06608109,
    "longitude": -90.07938718,
    "address": "462 FLYNN RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4514",
    "name": "Temple Emmanuel SDA Church",
    "latitude": 41.07261605,
    "longitude": -80.66050513,
    "address": "108 W INDIANOLA AVE",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44507",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4517",
    "name": "Dayton Metro Library - Huber Heights",
    "latitude": 39.84707599,
    "longitude": -84.11873186,
    "address": "6243 Brandt Pike",
    "city": "Huber Heights",
    "state": "OH",
    "zip_code": "45424",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4519",
    "name": "Woodmere Village Senior Market",
    "latitude": 41.46172021,
    "longitude": -81.48397195,
    "address": "3636 MAPLECREST RD",
    "city": "BEACHWOOD",
    "state": "OH",
    "zip_code": "44122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4521",
    "name": "ISRAEL UNITED IN CHRIST",
    "latitude": 34.21968246,
    "longitude": -88.71978772,
    "address": "1705 S GLOSTER ST",
    "city": "TUPELO",
    "state": "MS",
    "zip_code": "38801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4522",
    "name": "HARRISBURG BAPTIST CHURCH",
    "latitude": 34.23049641,
    "longitude": -88.76276237,
    "address": "1675 CLIFF GOOKIN BLVD",
    "city": "TUPELO",
    "state": "MS",
    "zip_code": "38801",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4533",
    "name": "Greater Heights Church of Christ",
    "latitude": 41.453643,
    "longitude": -81.7003636,
    "address": "2409 WILLOWDALE AVE",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4535",
    "name": "Orrville Loaves & Fishes",
    "latitude": 40.8485286,
    "longitude": -81.7744045,
    "address": "925 N Elm St",
    "city": "Orrville",
    "state": "OH",
    "zip_code": "44667",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4539",
    "name": "FAITHFUL COMMUNITY OUTREACH MINISTRIES",
    "latitude": 35.06608109,
    "longitude": -90.07938718,
    "address": "462 FLYNN RD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4540",
    "name": "Union Center UMC",
    "latitude": 42.1533169,
    "longitude": -76.0705448,
    "address": "128 MAPLE DR",
    "city": "ENDICOTT",
    "state": "NY",
    "zip_code": "13760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4543",
    "name": "New Life SDA Church",
    "latitude": 37.0063795,
    "longitude": -76.38344237,
    "address": "1808 SHELL RD",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4544",
    "name": "North Dearborn Pantry",
    "latitude": 39.24022887,
    "longitude": -84.866615,
    "address": "2517 N DEARBORN RD",
    "city": "WEST HARRISON",
    "state": "IN",
    "zip_code": "47060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4546",
    "name": "Impacting Tomorrow",
    "latitude": 39.17333416,
    "longitude": -84.27502447,
    "address": "995 LILA AVE",
    "city": "MILFORD",
    "state": "OH",
    "zip_code": "45150",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4547",
    "name": "THE TOWN OF FALCON",
    "latitude": 34.25015,
    "longitude": -90.274085,
    "address": "274 railroad",
    "city": "MARKS",
    "state": "MS",
    "zip_code": "38646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4548",
    "name": "DEWITT COMMUNITY COALITION",
    "latitude": 35.043857,
    "longitude": -89.58339772,
    "address": "3585 HIGHWAY 57",
    "city": "ROSSVILLE",
    "state": "TN",
    "zip_code": "38066",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4549",
    "name": "JOURNEY CHURCH - MP",
    "latitude": 35.3498795,
    "longitude": -89.9388296,
    "address": "3719 Shelby Rd",
    "city": "MILLINGTON",
    "state": "TN",
    "zip_code": "38053",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4550",
    "name": "Fellowship Church of God",
    "latitude": 41.4037865,
    "longitude": -81.5026964,
    "address": "24821 Columbus Rd. ",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4553",
    "name": "Hilliard Dream Center",
    "latitude": 39.9863632,
    "longitude": -83.0064608,
    "address": "38 W Greenwood Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4555",
    "name": "SOLID ROCK DEVELOPMENT CORP",
    "latitude": 35.0359472,
    "longitude": -89.838418,
    "address": "6720 East Raines Rd",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4558",
    "name": "Primary One Healthy Pantry",
    "latitude": 39.8851649,
    "longitude": -83.0026286,
    "address": "3781 S HIGH ST",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4572",
    "name": "Miami Valley Veterans Center",
    "latitude": 39.8316717,
    "longitude": -84.1197028,
    "address": "5420 Brandt Pike",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45424",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4573",
    "name": "IMPACT",
    "latitude": 40.81283938,
    "longitude": -81.36804038,
    "address": "1411 Cherry Ave NE",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44714",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4578",
    "name": "Holy Martyrs Catholic Church",
    "latitude": 41.1912903,
    "longitude": -81.7931701,
    "address": "3100 Old Weymouth ",
    "city": "Medina",
    "state": "OH",
    "zip_code": "44256",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4584",
    "name": "New Hope Baptist Church (Windham)",
    "latitude": 41.2351892,
    "longitude": -81.0366923,
    "address": "9809 E Center St",
    "city": "Windham",
    "state": "OH",
    "zip_code": "44288",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4591",
    "name": "Mt Carmel Produce Market ",
    "latitude": 39.9280577,
    "longitude": -82.8981179,
    "address": "2182 COURTRIGHT RD",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4592",
    "name": "Somali Bantu Community Cooperation of Cleveland",
    "latitude": 41.4389975,
    "longitude": -81.7782952,
    "address": "12808 Bellaire Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4593",
    "name": "Tuslaw Food Pantry ",
    "latitude": 40.8483028,
    "longitude": -81.6220067,
    "address": "14411 Orrville St NW",
    "city": "North Lawrence",
    "state": "OH",
    "zip_code": "44666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4595",
    "name": "Sharing and Caring",
    "latitude": 40.7866866,
    "longitude": -81.5137515,
    "address": "920 3rd St SE",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4603",
    "name": "MEMPHIS UNIVERSITY SCHOOL",
    "latitude": 35.098103,
    "longitude": -89.8549964,
    "address": "6191 PARK",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4605",
    "name": "Bridge Pointe Commons",
    "latitude": 41.37076576,
    "longitude": -82.0965142,
    "address": "338 E. Bridge Street",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4606",
    "name": "Walker Ranch Senior Center",
    "latitude": 29.55380445,
    "longitude": -98.50285556,
    "address": "835 W Rhapsody Dr",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78216",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4607",
    "name": "Helping Hands of Central Ohio",
    "latitude": 39.9173529,
    "longitude": -83.06437931,
    "address": "1963 Harrisburg Pike",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4610",
    "name": "CATHOLIC CHARITIES TIPTON",
    "latitude": 35.54889657,
    "longitude": -89.65885731,
    "address": "1225 us-51",
    "city": "COVINGTON",
    "state": "TN",
    "zip_code": "38019",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4612",
    "name": "Sr Produce Mkt Lansing Ltd & Gardens",
    "latitude": 40.0719264,
    "longitude": -80.7799335,
    "address": "68216 Commercial Dr",
    "city": "BRIDGEPORT",
    "state": "OH",
    "zip_code": "43912",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4614",
    "name": "ROSE CHAPEL-CRENSHAW",
    "latitude": 34.50862933,
    "longitude": -90.19589333,
    "address": "303 N. WILLIAMS STOKE",
    "city": "CRENSHAW",
    "state": "MS",
    "zip_code": "38621",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4615",
    "name": "CSFP: Freestore: Hamilton County",
    "latitude": 39.1690423,
    "longitude": -84.4762886,
    "address": "1250 Tennessee Ave",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4616",
    "name": "Bardsdale United Methodist Church",
    "latitude": 34.37143488,
    "longitude": -118.93111316,
    "address": "1498 Bardsdale Avenue",
    "city": "FILLMORE",
    "state": "CA",
    "zip_code": "93015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4622",
    "name": "Caring Hands Charity",
    "latitude": 41.05857377,
    "longitude": -81.45014626,
    "address": "2208 E Market St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44313",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4629",
    "name": "UH Midtown",
    "latitude": 41.5045848,
    "longitude": -81.64978406,
    "address": "5805 Euclid Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4638",
    "name": "MM2 Zane Trace - NCR",
    "latitude": 39.9582541,
    "longitude": -82.0255482,
    "address": "1600 Adams Ln                           ",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4640",
    "name": "Community Action Committee of Pike County",
    "latitude": 39.0646778,
    "longitude": -82.98139317,
    "address": "941 Market Street",
    "city": "PIKETON",
    "state": "OH",
    "zip_code": "45661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4641",
    "name": "Shawnee UMC",
    "latitude": 40.7000313,
    "longitude": -84.1515739,
    "address": "2600 Zurmehly Rd",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45806",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4645",
    "name": "Liberians In Columbus ",
    "latitude": 39.9264137,
    "longitude": -82.8813207,
    "address": "4300 Kimberly Parkway",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4649",
    "name": "Jake's Reach",
    "latitude": 41.0414997,
    "longitude": -81.5181025,
    "address": "250 N Firestone Blvd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4655",
    "name": "SPRINGFIELD FAMILY LIFE COMMUNITY PANTRY",
    "latitude": 34.49881688,
    "longitude": -89.53518078,
    "address": "62 CR 106",
    "city": "ABBEVILLE",
    "state": "MS",
    "zip_code": "38601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4658",
    "name": "Tower of Prayer",
    "latitude": 41.0703484,
    "longitude": -81.5596471,
    "address": "1334 Diagonal Rd",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4659",
    "name": "Mission F.I.S.H. @ Fellowship Hall",
    "latitude": 34.2806234,
    "longitude": -119.2867962,
    "address": "660 N. Ventura Ave",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4660",
    "name": "Mt. Tabor UMC",
    "latitude": 40.7849321,
    "longitude": -81.2845778,
    "address": "108 Walnut St Ste E",
    "city": "East Canton",
    "state": "OH",
    "zip_code": "44730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4661",
    "name": "LFC Ambassador",
    "latitude": 41.03847822,
    "longitude": -81.99720568,
    "address": "669 Oak Ct",
    "city": "Lodi",
    "state": "OH",
    "zip_code": "44254",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4663",
    "name": "BLOOMFIELD URBAN INITIATIVE",
    "latitude": 35.046864,
    "longitude": -90.068205,
    "address": "123 South Parkway West",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4665",
    "name": "Sunbury UMC CSFP",
    "latitude": 40.2453284,
    "longitude": -82.8629598,
    "address": "100 West Cherry Street",
    "city": "SUNBURY",
    "state": "OH",
    "zip_code": "43074",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4666",
    "name": "Gloria's Welcoming Hands Inc",
    "latitude": 41.1603616,
    "longitude": -81.2566706,
    "address": "150 Oakwood St",
    "city": "Ravenna",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4670",
    "name": "Dakota Center ",
    "latitude": 39.7524849,
    "longitude": -84.2151754,
    "address": "33 Barnett St",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4671",
    "name": "Warren Revival Center",
    "latitude": 41.2400329,
    "longitude": -80.8745895,
    "address": "4400 W Market St",
    "city": "LEAVITTSBURG",
    "state": "OH",
    "zip_code": "44430",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4675",
    "name": "MYRTLE FOOD PANTRY",
    "latitude": 34.55830157,
    "longitude": -89.11739605,
    "address": "2059 BANKHEAD ST",
    "city": "MYRTLE",
    "state": "MS",
    "zip_code": "38650",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4676",
    "name": "Church of Scientology of Ventura",
    "latitude": 34.2679874,
    "longitude": -119.2705804,
    "address": "2151 Alessandro Dr.",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4677",
    "name": "Glenwood Rec",
    "latitude": 39.9551778,
    "longitude": -83.050495,
    "address": "1888 Fairmont Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4679",
    "name": "Barack Rec Center",
    "latitude": 39.9281782,
    "longitude": -82.9801214,
    "address": "580 E Woodrow Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4680",
    "name": "Douglas Rec Center",
    "latitude": 39.9970632,
    "longitude": -82.9729077,
    "address": "1250 Windsor Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4681",
    "name": "Sullivant Gardens Rec Center",
    "latitude": 39.9455231,
    "longitude": -83.0180769,
    "address": "755 Renick St",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43223",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4687",
    "name": "Wildare Church",
    "latitude": 41.331036,
    "longitude": -80.729796,
    "address": "7211 N. Park Ave. Ext",
    "city": "CORTLAND",
    "state": "OH",
    "zip_code": "44410",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4695",
    "name": "MFP Burdett",
    "latitude": 42.421369,
    "longitude": -76.8379024,
    "address": "4124 Lake Ave",
    "city": "BURDETT",
    "state": "NY",
    "zip_code": "14818",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4696",
    "name": "We Think 4 A Change",
    "latitude": 41.4622741,
    "longitude": -81.7238385,
    "address": "5405 Storer Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4697",
    "name": "HELPING HANDS OF THE GROVE",
    "latitude": 34.80853148,
    "longitude": -89.9902971,
    "address": "3455 HWY 51 S",
    "city": "HERNANDO",
    "state": "MS",
    "zip_code": "38632",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4703",
    "name": "God's Lighthouse",
    "latitude": 41.1172368,
    "longitude": -83.2010332,
    "address": "634 Miami Street",
    "city": "TIFFIN",
    "state": "OH",
    "zip_code": "44883",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4713",
    "name": "ST MARK MANOR",
    "latitude": 35.059236,
    "longitude": -89.379123,
    "address": "85 St Mark Cove",
    "city": "MOSCOW",
    "state": "TN",
    "zip_code": "38057",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4715",
    "name": "Oakhurst Place CSFP",
    "latitude": 40.3285448,
    "longitude": -83.0764654,
    "address": "2178 Bruce Rd.",
    "city": "DELAWARE",
    "state": "OH",
    "zip_code": "43015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4716",
    "name": "Montgomery County Public Defender's Office",
    "latitude": 39.7575878,
    "longitude": -84.1918701,
    "address": "117 S. Main St, Suite 400",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45422",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4718",
    "name": "Serving You Ministries Cafe",
    "latitude": 39.2148706,
    "longitude": -84.3917746,
    "address": "4305 Sycamore Road",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45236",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4719",
    "name": "Melanie Manor CSFP",
    "latitude": 39.8847864,
    "longitude": -83.0654553,
    "address": "2346 Sonora Dr.",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4721",
    "name": "Cleveland Clinic Akron Gen. (Women's Health Center)",
    "latitude": 41.06724253,
    "longitude": -81.52458195,
    "address": "676 Broadway St.",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44311",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4722",
    "name": "SDA - El Rio",
    "latitude": 34.22949421,
    "longitude": -119.16357481,
    "address": "2670 Alvarado St.",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93036",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4724",
    "name": "Hosanna Christian Church",
    "latitude": 36.7243839,
    "longitude": -76.5791435,
    "address": "179 Tynes Street",
    "city": "SUFFOLK",
    "state": "VA",
    "zip_code": "23434",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4726",
    "name": "MFP Senior - Nichols Notch Apartments",
    "latitude": 42.1135022,
    "longitude": -76.0403205,
    "address": "401 Hayes Ave",
    "city": "ENDICOTT",
    "state": "NY",
    "zip_code": "13760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4727",
    "name": "North Community Place (LSS) MMK",
    "latitude": 40.0641164,
    "longitude": -83.0158251,
    "address": "120 Morse Road",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43214",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4731",
    "name": "Stoneridge Court CSFP - NCR",
    "latitude": 40.0974438,
    "longitude": -83.0987062,
    "address": "4105 Stoneridge Court",
    "city": "DUBLIN",
    "state": "OH",
    "zip_code": "43017",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4734",
    "name": "Blessed of God Outreach",
    "latitude": 35.0618263,
    "longitude": -90.0818364,
    "address": "530 Gilleas Rd",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4735",
    "name": "Simi Senior Center Pantry",
    "latitude": 34.2890448,
    "longitude": -118.7204894,
    "address": "3900 Avenida Simi",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93063",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4738",
    "name": "Faith Tabernacle",
    "latitude": 38.9669097,
    "longitude": -84.0846897,
    "address": "517 W. Osborne Street",
    "city": "BETHEL",
    "state": "OH",
    "zip_code": "45106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4739",
    "name": "The Living Well Lighthouse",
    "latitude": 39.8879955,
    "longitude": -83.8102238,
    "address": "151 Neosha Ave",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4740",
    "name": "EIGHT STREET MISSION ",
    "latitude": 35.14640437,
    "longitude": -90.17558786,
    "address": "717 E. BROADWAY AVE. ",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4741",
    "name": "LT Col Luke J Weathers VA Medical Center",
    "latitude": 35.14180265,
    "longitude": -90.01746194,
    "address": "1300 Jefferson Ave",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4742",
    "name": "Mustard Seed Outreach Ministry",
    "latitude": 41.7192133,
    "longitude": -83.4773289,
    "address": "5420 302nd St. ",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43611",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4745",
    "name": "Simon Acts",
    "latitude": 41.0840157,
    "longitude": -82.4159623,
    "address": "1971 Euclid Rd",
    "city": "NEW LONDON",
    "state": "OH",
    "zip_code": "44851",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4746",
    "name": "Go Green - Crockett",
    "latitude": 35.76348494,
    "longitude": -89.10975826,
    "address": "1550 TN-88",
    "city": "ALAMO",
    "state": "TN",
    "zip_code": "38001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4747",
    "name": "Cleveland Clinic Marymount",
    "latitude": 41.4211561,
    "longitude": -81.5979293,
    "address": "12300 McCracken Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44125",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4748",
    "name": "HOPE INHERITANCE MINISTRIES INC.",
    "latitude": 35.27016473,
    "longitude": -90.46107667,
    "address": "604 PARK ST, ",
    "city": "EARLE",
    "state": "AR",
    "zip_code": "72331",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4755",
    "name": "GO GREEN MCNAIRY",
    "latitude": 35.1537,
    "longitude": -88.611,
    "address": "MCNAIRY",
    "city": "SELMER",
    "state": "TN",
    "zip_code": "38375",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4757",
    "name": "TRANSFORMATIVE ADULT DAY SERVICES",
    "latitude": 34.77028275,
    "longitude": -89.44865819,
    "address": "198 N MEMPHIS ",
    "city": "HOLLY SPRINGS",
    "state": "MS",
    "zip_code": "38635",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4758",
    "name": "New Hope",
    "latitude": 40.91609119,
    "longitude": -81.04636955,
    "address": "20990 Oak St",
    "city": "ALLIANCE",
    "state": "OH",
    "zip_code": "44601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4759",
    "name": "Hopkins Rehabilitation and Care Center",
    "latitude": 41.3736664,
    "longitude": -81.8399302,
    "address": "19530 Bagley Rd",
    "city": "MIDDLEBURG HGTS",
    "state": "OH",
    "zip_code": "44130",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4761",
    "name": "CONCERNED CITIZENS OF DOUGLASS",
    "latitude": 35.42876009,
    "longitude": -89.34484918,
    "address": "1037 DOUGLASS",
    "city": "STANTON",
    "state": "TN",
    "zip_code": "38069",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4763",
    "name": "HEALTH COUNCIL OF SARDIS",
    "latitude": 34.43105542,
    "longitude": -89.92430785,
    "address": "421 JUANITA",
    "city": "SARDIS",
    "state": "MS",
    "zip_code": "38666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4767",
    "name": "Case Western Reserve University",
    "latitude": 41.5009143,
    "longitude": -81.6062097,
    "address": "10900 Euclid Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4772",
    "name": "Sinclair Community College Foundation ",
    "latitude": 39.7576211,
    "longitude": -84.2005876,
    "address": "444 W. Third St, Suite 13-426",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4777",
    "name": "Zion Hill Baptist Church",
    "latitude": 41.4691045,
    "longitude": -81.6060782,
    "address": "11115 Kinsman Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4778",
    "name": "Holy Trinity Greek Orthodox Church",
    "latitude": 40.849489,
    "longitude": -81.3780004,
    "address": "4705 Fairhaven Ave NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44709",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4780",
    "name": "Newtonsville Food pantry",
    "latitude": 39.1785631,
    "longitude": -84.09027091,
    "address": "794 Wright Street",
    "city": "NEWTONSVILLE",
    "state": "OH",
    "zip_code": "45158",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4782",
    "name": "NEW SITE FIRE",
    "latitude": 34.55181012,
    "longitude": -88.40983525,
    "address": "1104 HWY 4 EAST",
    "city": "NEW SITE",
    "state": "MS",
    "zip_code": "38859",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4784",
    "name": "Ada Food Pantry",
    "latitude": 40.7691981,
    "longitude": -83.8233809,
    "address": "201 S Main Street",
    "city": "ADA",
    "state": "OH",
    "zip_code": "45810",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4796",
    "name": "Carey Food Pantry",
    "latitude": 40.9545994,
    "longitude": -83.3942624,
    "address": "711 West Findlay Street",
    "city": "CAREY",
    "state": "OH",
    "zip_code": "43316",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4797",
    "name": "CSFP Route A",
    "latitude": 39.923385,
    "longitude": -83.8003056,
    "address": "20 N Murray St.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4798",
    "name": "CSFP Route B",
    "latitude": 39.923385,
    "longitude": -83.8003056,
    "address": "20 N Murray St.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4799",
    "name": "CSFP Route C",
    "latitude": 39.923385,
    "longitude": -83.8003056,
    "address": "20 N Murray St.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4800",
    "name": "CSFP Route D",
    "latitude": 39.923385,
    "longitude": -83.8003056,
    "address": "20 N Murray St.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4801",
    "name": "CSFP Route E",
    "latitude": 39.923385,
    "longitude": -83.8003056,
    "address": "20 N Murray St.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4802",
    "name": "CSFP Home Deliveries",
    "latitude": 39.923385,
    "longitude": -83.8003056,
    "address": "20 N Murray St.",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4803",
    "name": "Central Presbyterian Church Door Ministry",
    "latitude": 40.7977007,
    "longitude": -81.5206748,
    "address": "47 2nd St NE",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4804",
    "name": "Canton For All People",
    "latitude": 40.8035157,
    "longitude": -81.3807677,
    "address": "603 Shorb Ave NW",
    "city": "Canton",
    "state": "OH",
    "zip_code": "44703",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4805",
    "name": "St Vincent de Paul Safe Haven",
    "latitude": 39.8186049,
    "longitude": -84.2331301,
    "address": "5524 N. Main St",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45414",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4806",
    "name": "GCFB Market at CRC",
    "latitude": 41.5669006,
    "longitude": -81.5724759,
    "address": "15500 S Waterloo Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4809",
    "name": "Little Miami Food Service",
    "latitude": 39.35805314,
    "longitude": -84.09716252,
    "address": "4766 Whitacre Rd.",
    "city": "MORROW",
    "state": "OH",
    "zip_code": "45152",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4817",
    "name": "Jordan's Crossing Pantry",
    "latitude": 39.9617149,
    "longitude": -83.0757156,
    "address": "342 N Hague Ave ",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43204",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4818",
    "name": "Bare needs diaper bank",
    "latitude": 35.0428722,
    "longitude": -89.9095757,
    "address": "3865 S. PERKINS",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4819",
    "name": "Winton Manor Apartments",
    "latitude": 41.4990139,
    "longitude": -81.6839442,
    "address": "1012 Prospect Ave E",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4820",
    "name": "CROSSPOINTE BAPTIST CHURCH",
    "latitude": 35.45056032,
    "longitude": -89.81110865,
    "address": "220 BEAVER RD",
    "city": "MUNFORD",
    "state": "TN",
    "zip_code": "38058",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4822",
    "name": "Saline Twp Pantry",
    "latitude": 40.176383,
    "longitude": -80.800676,
    "address": "154 SR 50A",
    "city": "Hammondsville",
    "state": "OH",
    "zip_code": "43932",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4823",
    "name": "People Feeding People",
    "latitude": 41.0916248,
    "longitude": -81.5454421,
    "address": "848 West Exchange St",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4824",
    "name": "MOFC CSFP",
    "latitude": 39.8820028,
    "longitude": -83.0500478,
    "address": "3960 Brookham Dr.",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4825",
    "name": "UNIQUELY ME",
    "latitude": 34.393358,
    "longitude": -90.49031,
    "address": "325 Cherry St Crcl",
    "city": "COAHOMA",
    "state": "MS",
    "zip_code": "38617",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4826",
    "name": "FISH",
    "latitude": 37.2741262,
    "longitude": -76.6832557,
    "address": "312 Second Street",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23185",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4827",
    "name": "Collins Career Technical Center",
    "latitude": 38.4918547,
    "longitude": -82.4739867,
    "address": "11627 St. Rt. 243",
    "city": "CHESAPEAKE",
    "state": "OH",
    "zip_code": "45619",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4828",
    "name": "Village Keepers of Ohio Inc.",
    "latitude": 41.0826,
    "longitude": -81.5533724,
    "address": "545 Noble Ave",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44320",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4829",
    "name": "Fellowship Chapel Food Pantry",
    "latitude": 38.9765358,
    "longitude": -82.347644,
    "address": "68 Keystone Road",
    "city": "VINTON",
    "state": "OH",
    "zip_code": "45686",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4834",
    "name": "Patricia Ann Cargill Charities ",
    "latitude": 41.0493477,
    "longitude": -81.5473868,
    "address": "1823 Manchester Rd.",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44314",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4836",
    "name": "DOOR DASH-MSFB",
    "latitude": 35.0428722,
    "longitude": -89.9095757,
    "address": "3865 S PERKINS",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4837",
    "name": "MFP Woodlawn Court",
    "latitude": 42.108927,
    "longitude": -76.8227237,
    "address": "346 Woodlawn Ave",
    "city": "ELMIRA",
    "state": "NY",
    "zip_code": "14901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4838",
    "name": "Windham UMC",
    "latitude": 41.2379677,
    "longitude": -81.0490679,
    "address": "9051 N Main St",
    "city": "Windham",
    "state": "OH",
    "zip_code": "44288",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4839",
    "name": "Licking Memorial Health Systems",
    "latitude": 40.0474579,
    "longitude": -82.4495008,
    "address": "1320 W Main St",
    "city": "NEWARK",
    "state": "OH",
    "zip_code": "43055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4840",
    "name": "Stark Community Support Network",
    "latitude": 40.809595,
    "longitude": -81.3499247,
    "address": "1221 Harrisburg Rd. NE",
    "city": "CANTON",
    "state": "OH",
    "zip_code": "44705",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4841",
    "name": "New Straitsville FP",
    "latitude": 39.57781805,
    "longitude": -82.237109,
    "address": "101 Clark St",
    "city": "NEW STRAITSVILLE",
    "state": "OH",
    "zip_code": "43766",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4842",
    "name": "Hope Presbyterian Church",
    "latitude": 35.1305475,
    "longitude": -89.778319,
    "address": "8500 Walnut Grove RD.",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4844",
    "name": "Immaculate Conception Catholic Church",
    "latitude": 37.04790457,
    "longitude": -76.38279417,
    "address": "2150 Cunningham Dr",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4845",
    "name": "Ripley Food Pantr -/ Centenary Methodist Church",
    "latitude": 38.747335,
    "longitude": -83.8461424,
    "address": "110 N. Second Street",
    "city": "RIPLEY",
    "state": "OH",
    "zip_code": "45167",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4846",
    "name": "Faith Community Fellowship",
    "latitude": 40.7821288,
    "longitude": -81.5330316,
    "address": "1303 9th St SW",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44647",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4847",
    "name": "Nourish Pantry South Pointe Hospital",
    "latitude": 41.4459324,
    "longitude": -81.5369212,
    "address": "4180 Warrensville Center Rd",
    "city": "Warrensville Heights",
    "state": "OH",
    "zip_code": "44122",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4849",
    "name": "Warren First Assembly of God Pantry",
    "latitude": 41.2528193,
    "longitude": -80.8565096,
    "address": "2640 Parkman Rd NW",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44486",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4850",
    "name": "Venarge Family Food Pantry",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Pkwy",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4855",
    "name": "MFP Senior - Community Gardens",
    "latitude": 42.1196754,
    "longitude": -76.2670923,
    "address": "148 Dean St",
    "city": "OWEGO",
    "state": "NY",
    "zip_code": "13827",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4857",
    "name": "GMN - Noble County Senior Ctr",
    "latitude": 39.7461411,
    "longitude": -81.5157413,
    "address": "300 Cumberland St",
    "city": "CALDWELL",
    "state": "OH",
    "zip_code": "43724",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4858",
    "name": "GMN - Monroe Senior Ctr",
    "latitude": 39.7800565,
    "longitude": -81.1128896,
    "address": "47115 Black Walnut Parkway    ",
    "city": "WOODSFIELD",
    "state": "OH",
    "zip_code": "43793",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4860",
    "name": "Commons at Chantry",
    "latitude": 39.9264246,
    "longitude": -82.8440349,
    "address": "5500 Millersfield Dr ",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43232",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4863",
    "name": "Sentara Home Health Care - Newport News",
    "latitude": 37.0950391,
    "longitude": -76.4668139,
    "address": "11844 Rock Landing Drive",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23606",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4864",
    "name": "Sentara Home Health Care Williamsburg",
    "latitude": 37.2821376,
    "longitude": -76.740876,
    "address": "5372 Discovery Park Blvd",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23188",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4866",
    "name": "Green Street UMC Food Pantry",
    "latitude": 40.14950368,
    "longitude": -84.24341103,
    "address": "325 West Ash St",
    "city": "PIQUA",
    "state": "OH",
    "zip_code": "45356",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4867",
    "name": "Calvary SDA Church",
    "latitude": 36.9814612,
    "longitude": -76.4022878,
    "address": "1200 17th street",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4868",
    "name": "Church of the Cross United Methodist Church",
    "latitude": 39.70124404,
    "longitude": -84.14172813,
    "address": "3121 Wilmington Pike",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45429",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4869",
    "name": "Circle of Faith Outreach Program",
    "latitude": 39.7628234,
    "longitude": -84.2220547,
    "address": "1800 W. Riverview Ave.",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4871",
    "name": "Victorian Heritage - Homeport",
    "latitude": 39.9904458,
    "longitude": -83.0066595,
    "address": "1379 N. High St.",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43201",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4872",
    "name": "Mound Street Academy Food Pantry - Dakota Center",
    "latitude": 39.7509019,
    "longitude": -84.2088665,
    "address": "354 Mound Street",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4873",
    "name": "Allison Avenue Baptist",
    "latitude": 39.4101472,
    "longitude": -84.52776997,
    "address": "5915 Allison Ave",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4874",
    "name": "Riverside NN",
    "latitude": 37.0848338,
    "longitude": -76.4561284,
    "address": "856 J Clyde Morris Blvd",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4877",
    "name": "Water's Edge UM Ministries",
    "latitude": 39.9289709,
    "longitude": -82.4878811,
    "address": "4852 Walnut Rd. ",
    "city": "BUCKEYE LAKE",
    "state": "OH",
    "zip_code": "43008",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4878",
    "name": "Dayton Metro Library - Miami Township Branch",
    "latitude": 39.6275007,
    "longitude": -84.2211183,
    "address": "2718 Lyons Rd",
    "city": "MIAMISBURG",
    "state": "OH",
    "zip_code": "45342",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4879",
    "name": "Binding Hearts",
    "latitude": 40.797699,
    "longitude": -81.552259,
    "address": "123 Brock Ave",
    "city": "MASSILLON",
    "state": "OH",
    "zip_code": "44647",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4880",
    "name": "Community Health Worker - The Foodbank, Inc.",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 Armor Place",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4883",
    "name": "House of Deliverance Worship Center",
    "latitude": 39.39720323,
    "longitude": -84.5632401,
    "address": "331 S. 2nd St",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4884",
    "name": "Tyrone Food Pantry",
    "latitude": 42.4097851,
    "longitude": -77.0586671,
    "address": "3647 Church Hill Rd",
    "city": "TYRONE",
    "state": "NY",
    "zip_code": "14887",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4885",
    "name": "Wesley Grove",
    "latitude": 36.9853642,
    "longitude": -76.4082903,
    "address": "2308 Roanoke Ave",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4886",
    "name": "Lake County YMCA",
    "latitude": 41.61899309,
    "longitude": -81.42379292,
    "address": "36909 Ridge Rd",
    "city": "WILLOUGHBY",
    "state": "OH",
    "zip_code": "44094",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4887",
    "name": "Lindenwood Christian Church",
    "latitude": 35.1342371,
    "longitude": -89.9822059,
    "address": "2400 Union Ave ",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4888",
    "name": "First United Methodist Church of Ravenna",
    "latitude": 41.1554032,
    "longitude": -81.2414759,
    "address": "263 S. Prospect",
    "city": "RAVENNA",
    "state": "OH",
    "zip_code": "44266",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4889",
    "name": "AHA -Affordable Housing Access @ Pacific Point Apts",
    "latitude": 34.181531,
    "longitude": -119.1805794,
    "address": "1800 So C St.",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4890",
    "name": "SEM Food Pantry",
    "latitude": 39.0907628,
    "longitude": -84.3859162,
    "address": "2020 Beechmont Ave",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4891",
    "name": "Little Zion Baptist Church",
    "latitude": 37.03381904,
    "longitude": -76.39615478,
    "address": "1824 West Queen Street",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4892",
    "name": "Spirit Life Church",
    "latitude": 34.2657283,
    "longitude": -118.7870175,
    "address": "1482 Sinaloa Rd",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93065",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4893",
    "name": "Riveon Community Wellness Center",
    "latitude": 41.44189841,
    "longitude": -82.15733999,
    "address": "3150 Clifton Ave ",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4894",
    "name": "The Cleveland Clinic ",
    "latitude": 41.448666,
    "longitude": -82.021439,
    "address": "33300 Cleveland Clinic Blvd. ",
    "city": "AVON",
    "state": "OH",
    "zip_code": "44011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4898",
    "name": "United Family Worship Center",
    "latitude": 37.00629326,
    "longitude": -76.38895481,
    "address": "667 Hannah Street",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23661",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4899",
    "name": "C.C. Broome/Mother Teresa's Cupboard",
    "latitude": 42.1003106,
    "longitude": -76.0470863,
    "address": "202 Garfield Ave",
    "city": "ENDICOTT",
    "state": "NY",
    "zip_code": "13760",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4900",
    "name": "CPL - South",
    "latitude": 41.470223,
    "longitude": -81.6972039,
    "address": "3096 Scranton Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4903",
    "name": "Mulby Place - Homeport",
    "latitude": 40.0165754,
    "longitude": -82.9652423,
    "address": "2420 Cleveland Ave.",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4904",
    "name": "Nurturing Angels",
    "latitude": 41.4113335,
    "longitude": -81.5042714,
    "address": "24748 Aurora Rd",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4905",
    "name": "NORTH MS PRIMARY HEALTH",
    "latitude": 34.940336,
    "longitude": -88.90158449,
    "address": "27880 hwy 15",
    "city": "WALNUT",
    "state": "MS",
    "zip_code": "38683",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4906",
    "name": "God's Instruments",
    "latitude": 41.619142,
    "longitude": -83.5279725,
    "address": "1705 Tracy St.",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4907",
    "name": "St. Louis Church",
    "latitude": 40.8389062,
    "longitude": -81.2594193,
    "address": "300 N. Chapel St.",
    "city": "LOUISVILLE",
    "state": "OH",
    "zip_code": "44641",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4908",
    "name": "Vision of Hope Ministries",
    "latitude": 41.6397323,
    "longitude": -83.5188282,
    "address": "602 Federal St.",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4909",
    "name": "MFP Senior - Carroll Street",
    "latitude": 42.100016,
    "longitude": -75.9078315,
    "address": "86 Carroll Street",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4910",
    "name": "City of Bay Village - Senior Center",
    "latitude": 41.48691331,
    "longitude": -81.92349897,
    "address": "300 Bryson Ln",
    "city": "Bay Village",
    "state": "OH",
    "zip_code": "44140",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4912",
    "name": "Miami University",
    "latitude": 39.5064962,
    "longitude": -84.7389967,
    "address": "301 South Campus Ave",
    "city": "OXFORD",
    "state": "OH",
    "zip_code": "45056",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4914",
    "name": "SVdP Community Pantry",
    "latitude": 41.2381337,
    "longitude": -80.8152985,
    "address": "232 Seneca Ave NE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44481",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4915",
    "name": "House of Samuel Fresh Food",
    "latitude": 40.0345558,
    "longitude": -81.5815092,
    "address": "1300 Clairmont ",
    "city": "CAMBRIDGE",
    "state": "OH",
    "zip_code": "43725",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4916",
    "name": "THE LIFE OF LIBERTY FOOD AND DIAPER",
    "latitude": 35.1302693,
    "longitude": -90.0368477,
    "address": "749 TATE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4917",
    "name": "Kappa Venue at Euclid",
    "latitude": 41.5870187,
    "longitude": -81.5357048,
    "address": "20713 Recher Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4918",
    "name": "COLEMAN CRAWFORD ESTATES",
    "latitude": 34.81913286,
    "longitude": -90.00040036,
    "address": "2780 College St",
    "city": "HERNANDO",
    "state": "MS",
    "zip_code": "38632",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4919",
    "name": "NEW HAILBURTON BAPTIST CHURCH",
    "latitude": 34.950007,
    "longitude": -89.862634,
    "address": "14484 DESOTO RD",
    "city": "OLIVE BRANCH",
    "state": "MS",
    "zip_code": "38654",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4921",
    "name": "KINGDOM SUPPORT SOLUTIONS MINISTRIES",
    "latitude": 35.6380397,
    "longitude": -88.8238356,
    "address": "1408 NORTH HIGHLAND AVENUE",
    "city": "JACKSON",
    "state": "TN",
    "zip_code": "38305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4922",
    "name": "Cincinnati Urban Promise",
    "latitude": 39.140034,
    "longitude": -84.5796174,
    "address": "2420 Harrison Avenue",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45211",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4924",
    "name": "Tender Hands",
    "latitude": 40.8310644,
    "longitude": -81.4239731,
    "address": "2882 Whipple Ave. NW",
    "city": "CANTON",
    "state": "OH",
    "zip_code": "44708",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4926",
    "name": "REDZONE MEMPHIS",
    "latitude": 35.0705903,
    "longitude": -89.9642546,
    "address": "2855 Park Ave",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4927",
    "name": "CROCKETT CARES FOOD PANTRY",
    "latitude": 35.77736666,
    "longitude": -89.11738333,
    "address": "494 SOUTH BELLS ST.",
    "city": "ALAMO",
    "state": "TN",
    "zip_code": "38001",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4928",
    "name": "Gnadenhutten UMC",
    "latitude": 40.3601018,
    "longitude": -81.4375921,
    "address": "220 N. Walnut St.",
    "city": "GNADENHUTTEN",
    "state": "OH",
    "zip_code": "44629",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4929",
    "name": "Spaulding Church of God - 5 Loaves",
    "latitude": 39.7321071,
    "longitude": -84.109687,
    "address": "1658 Spaulding Road",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45432",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4930",
    "name": "Seeds of Love Food Pantry",
    "latitude": 40.1098202,
    "longitude": -83.7648451,
    "address": "129 N. Oakland St.",
    "city": "URBANA",
    "state": "OH",
    "zip_code": "43078",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4931",
    "name": "Akron Children's Hospital",
    "latitude": 41.0787978,
    "longitude": -81.5249879,
    "address": "1 Perkins Square",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44308",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4932",
    "name": "Virtuous New Life Ministries",
    "latitude": 39.668355,
    "longitude": -84.246864,
    "address": "127 Market St",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45449",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4933",
    "name": "Feeding Miracles ",
    "latitude": 39.81596229,
    "longitude": -84.23011495,
    "address": "5314 N. Main St",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45415",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4936",
    "name": "FEEDING HEARTS OXFORD",
    "latitude": 34.35036,
    "longitude": -89.51898,
    "address": "70 F.D. BUDDY PKWY",
    "city": "OXFORD",
    "state": "MS",
    "zip_code": "38655",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4942",
    "name": "Hallelujah Nepali Ministry",
    "latitude": 39.38012287,
    "longitude": -84.54286595,
    "address": "1493 Parrish Ave",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4944",
    "name": "House of Blessing",
    "latitude": 36.9866119,
    "longitude": -76.4085962,
    "address": "1113 25th St",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4945",
    "name": "Emmanuel Lutheran",
    "latitude": 41.2350386,
    "longitude": -80.8315996,
    "address": "140 Cherry Ave",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44485",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4947",
    "name": "Cuyahoga Chapel Church of God",
    "latitude": 41.135889,
    "longitude": -81.4875281,
    "address": "2106 4th Street",
    "city": "CUYAHOGA FALLS",
    "state": "OH",
    "zip_code": "44221",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4948",
    "name": "Kappa House Plaza ",
    "latitude": 41.48411294,
    "longitude": -81.59714205,
    "address": "12300 Shaker Blvd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44120",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4949",
    "name": "New Door Praise and Worship Center",
    "latitude": 41.5515723,
    "longitude": -81.5593816,
    "address": "17325 Euclid Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4950",
    "name": "In Him Community Outreach",
    "latitude": 41.4224568,
    "longitude": -81.7800195,
    "address": "4855 W 130th St",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4951",
    "name": "Eternal Light Baptist Church",
    "latitude": 39.77496,
    "longitude": -84.2704946,
    "address": "5103 Schroeder Rd",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4953",
    "name": "Neighborhood Family Practice",
    "latitude": 41.4594825,
    "longitude": -81.7378956,
    "address": "3569 Ridge Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44102",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4954",
    "name": "Circle of Love",
    "latitude": 34.1509624,
    "longitude": -119.1802934,
    "address": "300 West Clara St.",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4955",
    "name": "St. John of the Cross Pantry",
    "latitude": 41.5833328,
    "longitude": -81.5002003,
    "address": "140 Richmond Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44143",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4957",
    "name": "Mary's Little Lamb",
    "latitude": 39.9264379,
    "longitude": -82.9841182,
    "address": "1800 Parsons Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43207",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4959",
    "name": "Selmer First United Methodist Church",
    "latitude": 35.18551387,
    "longitude": -88.6215987,
    "address": "1122 West Cherry Avenue",
    "city": "SELMER",
    "state": "TN",
    "zip_code": "38375",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4961",
    "name": "Gateway Apostolic Produce Market",
    "latitude": 40.1584272,
    "longitude": -80.70694316,
    "address": "129 Market St ",
    "city": "YORKVILLE",
    "state": "OH",
    "zip_code": "43971",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4962",
    "name": "Divine Trinity Outreach",
    "latitude": 37.1146577,
    "longitude": -76.5182121,
    "address": "66 Colony Road",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4963",
    "name": "Eastway Behavioral Health",
    "latitude": 39.7557355,
    "longitude": -84.1798053,
    "address": "419 Bainbridge St",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45410",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4964",
    "name": "ST. JOSEPH CATHOLIC CHURCH",
    "latitude": 37.04396129,
    "longitude": -76.29571193,
    "address": "512 BUCKROE AVE.",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23664",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4965",
    "name": "Living Hope",
    "latitude": 34.16135654,
    "longitude": -119.17288123,
    "address": "755  Bard Rd.",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4966",
    "name": "MVCAP - Darke",
    "latitude": 40.07805432,
    "longitude": -84.6330642,
    "address": "1469 Sweitzer St",
    "city": "Greenville",
    "state": "OH",
    "zip_code": "45331",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4968",
    "name": "SHFB Leadership Emergency Bags",
    "latitude": 39.9246805,
    "longitude": -83.7994829,
    "address": "20 N. Murray St",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4970",
    "name": "Hilton Baptist Church",
    "latitude": 37.0329207,
    "longitude": -76.4605688,
    "address": "101 Main Street",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23601",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4971",
    "name": "Maineville Kings Point Church of God",
    "latitude": 39.35299881,
    "longitude": -84.21842476,
    "address": "5600 St Rt 48",
    "city": "MAINEVILLE",
    "state": "OH",
    "zip_code": "45039",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4972",
    "name": "Fairview Park Hunger Center",
    "latitude": 41.43737137,
    "longitude": -81.87468338,
    "address": "22964 Lorain Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4973",
    "name": "TRANQUILITY SENIORS",
    "latitude": 35.0668015,
    "longitude": -89.8656872,
    "address": "2990 HIckory Hill Rd",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38115",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4974",
    "name": "Five Voices",
    "latitude": 40.8435986,
    "longitude": -81.7704516,
    "address": "516 W. High St.",
    "city": "ORRVILLE",
    "state": "OH",
    "zip_code": "44667",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4975",
    "name": "ACRFB Pop-up Pantry (Wayne)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Pkwy",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4976",
    "name": "Unitarian Universalist Church of Akron",
    "latitude": 41.1311181,
    "longitude": -81.6208372,
    "address": "3300 Morewood Rd",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44333",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4977",
    "name": "Holy Spirit Catholic Church",
    "latitude": 41.441176,
    "longitude": -81.5905342,
    "address": "4341 E 131st St",
    "city": "Garfield Heights",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4980",
    "name": "Malachi Center",
    "latitude": 41.4928227,
    "longitude": -81.7068865,
    "address": "2416 Superior Viaduct",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4981",
    "name": "PARKVIEW BAPTIST CHURCH",
    "latitude": 37.0088545,
    "longitude": -76.4371334,
    "address": "604 Hilton Blvd",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4983",
    "name": "Philippi Missionary Baptist Church",
    "latitude": 41.4559968,
    "longitude": -81.6015186,
    "address": "11703 Corlett Avenue",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4984",
    "name": "CEDC - Rodney Fernandez",
    "latitude": 34.3521455,
    "longitude": -119.0771321,
    "address": "212 W Santa Barbara St.",
    "city": "SANTA PAULA",
    "state": "CA",
    "zip_code": "93060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4985",
    "name": "The Gloww Center",
    "latitude": 37.124608,
    "longitude": -76.519972,
    "address": "321 Grafton Drive",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23602",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4987",
    "name": "NEW COVENANT SENIORS",
    "latitude": 34.772162,
    "longitude": -89.450965,
    "address": "1400 Hwy 4-East",
    "city": "Holly Springs",
    "state": "MS",
    "zip_code": "38635",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4989",
    "name": "Trinity United Methodist Church",
    "latitude": 40.92117356,
    "longitude": -80.60082962,
    "address": "2427 Columbiana Rd",
    "city": "NEW SPRINGFIELD",
    "state": "OH",
    "zip_code": "44443",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4991",
    "name": "THE WE CARE COMMITTEE ",
    "latitude": 33.80316255,
    "longitude": -88.46371839,
    "address": "40158 LACKEY ROAD",
    "city": "ABERDEEN",
    "state": "MS",
    "zip_code": "39730",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4992",
    "name": "First Church of Port Hueneme",
    "latitude": 34.1530114,
    "longitude": -119.1943125,
    "address": "523 N. 5th St.",
    "city": "PORT HUENEME",
    "state": "CA",
    "zip_code": "93041",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4995",
    "name": "New Beech Grove",
    "latitude": 37.1365774,
    "longitude": -76.5474545,
    "address": "361 Beechment Drive",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4996",
    "name": "Park Christian Church",
    "latitude": 40.3932366,
    "longitude": -81.3189147,
    "address": "236 Miller Ave",
    "city": "DENNISON",
    "state": "OH",
    "zip_code": "44621",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-4999",
    "name": "BROWNSVILLE SENIORS",
    "latitude": 35.5960098,
    "longitude": -89.2710103,
    "address": "127 NORTH GRAND AVE",
    "city": "BROWNSVILLE",
    "state": "TN",
    "zip_code": "38012",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5001",
    "name": "Iglesia Episcopal del Espiritu Santo",
    "latitude": 39.2847025,
    "longitude": -84.5133708,
    "address": "11381 Hanover Road",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45240",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5002",
    "name": "HEART AND SOUL ASSISTED LIVING",
    "latitude": 36.9772659,
    "longitude": -76.4179145,
    "address": "611 19TH STREET",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5003",
    "name": "HAPCAP for Health Market",
    "latitude": 39.5210309,
    "longitude": -82.3675273,
    "address": "35222 Hocking Drive",
    "city": "LOGAN",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5004",
    "name": "Open Bible Christian Center",
    "latitude": 40.7474015,
    "longitude": -81.4841477,
    "address": "4170 Eldridge Ave SW",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44646",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5005",
    "name": "Mt Zion KA Food Pantry",
    "latitude": 40.6001619,
    "longitude": -83.1191514,
    "address": "475 East Fairground St",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5006",
    "name": "Good News Baptist Church",
    "latitude": 39.2344128,
    "longitude": -84.5960596,
    "address": "3551 Poole Rd.",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45251",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5008",
    "name": "Common Threads Closet",
    "latitude": 41.0161524,
    "longitude": -81.6084846,
    "address": "211 3rd St NW",
    "city": "BARBERTON",
    "state": "OH",
    "zip_code": "44203",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5013",
    "name": "The Salvation Army (Simmons Hall)",
    "latitude": 41.0859908,
    "longitude": -81.5289084,
    "address": "190 S. Maple St",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5015",
    "name": "Salvation Army (Piqua)",
    "latitude": 40.14584799,
    "longitude": -84.24074256,
    "address": "129 S. Wayne St",
    "city": "PIQUA",
    "state": "OH",
    "zip_code": "45356",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5016",
    "name": "Church 180",
    "latitude": 38.9412572,
    "longitude": -83.5849386,
    "address": "2556 Moores Road",
    "city": "Seaman",
    "state": "OH",
    "zip_code": "45679",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5018",
    "name": "Centers for Dialysis Care Mentor",
    "latitude": 41.6939418,
    "longitude": -81.3201666,
    "address": "8900 Tyler Blvd.",
    "city": "MENTOR",
    "state": "OH",
    "zip_code": "44060",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5019",
    "name": "Friends in Tents",
    "latitude": 41.08320888,
    "longitude": -81.53535126,
    "address": "445 W. Cedar St",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5020",
    "name": "MFP Monterey Walk-Up",
    "latitude": 42.30425315,
    "longitude": -77.05012311,
    "address": "1465 South St",
    "city": "BEAVER DAMS",
    "state": "NY",
    "zip_code": "14812",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5021",
    "name": "Christ Woodland UMC",
    "latitude": 41.12283769,
    "longitude": -81.56981913,
    "address": "444 N. HawkinsAve",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44313",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5022",
    "name": "Feed My Lambs Inc",
    "latitude": 41.435631,
    "longitude": -82.1636912,
    "address": "3720 Broadway Ave ",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44052",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5023",
    "name": "Mt Calvary",
    "latitude": 40.7348428,
    "longitude": -84.0959551,
    "address": "400 South Scott St",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5024",
    "name": "Grace House",
    "latitude": 41.0983863,
    "longitude": -81.515396,
    "address": "475 North Howard St.",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5025",
    "name": "Mt Sterling UMC",
    "latitude": 39.9568361,
    "longitude": -82.1453824,
    "address": "8185 Hopewell National Rd",
    "city": "ZANESVILLE",
    "state": "OH",
    "zip_code": "43701",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5026",
    "name": "Memorial United Church of Christ",
    "latitude": 41.6436713,
    "longitude": -83.5119122,
    "address": "1301 Starr Ave. ",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5027",
    "name": "Family Health Services",
    "latitude": 41.437423,
    "longitude": -82.7127278,
    "address": "1912 Hayes Ave ",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5029",
    "name": "Manchester Christian Church",
    "latitude": 40.9373243,
    "longitude": -81.5673188,
    "address": "930 W Nimisila Rd",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44319",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5030",
    "name": "Abundant Life Christian Fellowship ",
    "latitude": 40.7921107,
    "longitude": -81.5311597,
    "address": "641 Treemont Ave. SW",
    "city": "Massillon",
    "state": "OH",
    "zip_code": "44647",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5031",
    "name": "MFP-NEW PHOENIX VILLAGE",
    "latitude": 37.1699978,
    "longitude": -76.5668924,
    "address": "327 Charles St",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5032",
    "name": "Oak View Park and Resource Center",
    "latitude": 34.3997967,
    "longitude": -119.3049035,
    "address": "555 Mahoney Ave",
    "city": "OAK VIEW",
    "state": "CA",
    "zip_code": "93022",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5033",
    "name": "St.Patrick Mobile",
    "latitude": 35.1370663,
    "longitude": -90.0498968,
    "address": "277 S Forth ",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5034",
    "name": "Friends & Neighbors",
    "latitude": 39.2135824,
    "longitude": -81.8305149,
    "address": "24576 Parkersburg Rd.",
    "city": "COOLVILLE",
    "state": "OH",
    "zip_code": "45723",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5035",
    "name": "Expanding Vision Ministries Pantry",
    "latitude": 39.9921531,
    "longitude": -82.8535217,
    "address": "845 Claycraft Road",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5036",
    "name": "Summerside Feeding Ministries",
    "latitude": 39.0759211,
    "longitude": -84.1726527,
    "address": "180 North 5th street",
    "city": "BATAVIA",
    "state": "OH",
    "zip_code": "45103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5040",
    "name": "Our Helpers Free Store ",
    "latitude": 40.0649839,
    "longitude": -82.9938595,
    "address": "4848 Evanswood Dr ",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5041",
    "name": "Jefferson Nazarene Church",
    "latitude": 41.7363618,
    "longitude": -80.7669041,
    "address": "55 East Satin Street",
    "city": "JEFFERSON",
    "state": "OH",
    "zip_code": "44047",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5042",
    "name": "The Foodbank, Inc. CSFP Home Delivery",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 Armor Place",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5043",
    "name": "Awakenings Christian Fellowship",
    "latitude": 40.14921438,
    "longitude": -84.24108927,
    "address": "317 N. Main St",
    "city": "PIQUA",
    "state": "OH",
    "zip_code": "45356",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5044",
    "name": "New Light Baptist Church",
    "latitude": 41.4554587,
    "longitude": -81.5941246,
    "address": "12700 Corlett Avenue",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44105",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5045",
    "name": "Rome Missionary Baptist Church",
    "latitude": 41.3667129,
    "longitude": -81.508363,
    "address": "23920 Lincolnville Avenue",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5046",
    "name": "West Chester Nazarene Church",
    "latitude": 39.3512887,
    "longitude": -84.3599328,
    "address": "7951 Tylersville Rd",
    "city": "WEST CHESTER",
    "state": "OH",
    "zip_code": "45069",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5047",
    "name": "Zion Global Missions (Blessed to be a Blessing)",
    "latitude": 39.3191604,
    "longitude": -84.3674821,
    "address": "9180 Cincinnati Columbus Rd",
    "city": "WEST CHESTER",
    "state": "OH",
    "zip_code": "45069",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5048",
    "name": "Blessing Basket St. John's Evangelical Lutheran Church",
    "latitude": 41.0524642,
    "longitude": -83.6167916,
    "address": "1701 Tiffin Avenue",
    "city": "FINDLAY",
    "state": "OH",
    "zip_code": "45840",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5049",
    "name": "Butler County Educational Service Center",
    "latitude": 39.3994083,
    "longitude": -84.5451887,
    "address": "400 North Erie Blvd",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45011",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5050",
    "name": "SafeHaven",
    "latitude": 40.08791326,
    "longitude": -84.63172,
    "address": "322 Fair St",
    "city": "GREENVILLE",
    "state": "OH",
    "zip_code": "45331",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5051",
    "name": "FF Veterans Pantry",
    "latitude": 39.9819336,
    "longitude": -82.9619448,
    "address": "1561 Old Leonard Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43219",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5053",
    "name": "SafeHaven",
    "latitude": 40.297264,
    "longitude": -84.1857608,
    "address": "1101 N Vandemark Rd",
    "city": "SIDNEY",
    "state": "OH",
    "zip_code": "45365",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5056",
    "name": "FOCUS Cincinnati",
    "latitude": 39.2060716,
    "longitude": -84.5198959,
    "address": "7000 Winton Rd",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45224",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5057",
    "name": "Centers for Dialysis Care Oakwood",
    "latitude": 41.3745089,
    "longitude": -81.5122027,
    "address": "7690 First Place",
    "city": "BEDFORD",
    "state": "OH",
    "zip_code": "44146",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5058",
    "name": "The Door of Hope",
    "latitude": 38.65817889,
    "longitude": -83.76105583,
    "address": "941 Market Street",
    "city": "ABERDEEN",
    "state": "OH",
    "zip_code": "45101",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5059",
    "name": "First Place Food Pantry",
    "latitude": 40.03397791,
    "longitude": -84.2180399,
    "address": "1100 Wayne St., Suite 1450",
    "city": "TROY",
    "state": "OH",
    "zip_code": "45373",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5061",
    "name": "Early Childhood Learning Center- Rudy Rd ",
    "latitude": 40.0454231,
    "longitude": -83.0385846,
    "address": "4141 Rudy Rd ",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43214",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5064",
    "name": "Athens County ER ",
    "latitude": 39.4965121,
    "longitude": -82.0835806,
    "address": "3 Cardaras Dr. ",
    "city": "GLOUSTER",
    "state": "OH",
    "zip_code": "45732",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5066",
    "name": "Perry County ER",
    "latitude": 39.7208534,
    "longitude": -82.202057,
    "address": "399 Lincoln Park Dr.",
    "city": "New Lexington",
    "state": "OH",
    "zip_code": "43764",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5067",
    "name": "Saybrook Methodist Church",
    "latitude": 41.8264044,
    "longitude": -80.8708605,
    "address": "7900 DEPOT RD",
    "city": "ASHTABULA",
    "state": "OH",
    "zip_code": "44004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5069",
    "name": "Madisonville Education & Assistance Center ",
    "latitude": 39.15639858,
    "longitude": -84.39577758,
    "address": "4600 Erie Ave",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45227",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5070",
    "name": "Grover Hill Elementary",
    "latitude": 41.0194737,
    "longitude": -84.4791837,
    "address": "101 Monroe St",
    "city": "GROVER HILL",
    "state": "OH",
    "zip_code": "45849",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5072",
    "name": "WPAFB Airman/Guardian Food Pantry",
    "latitude": 39.8148426,
    "longitude": -84.0382623,
    "address": "5030 Pearson Ave",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45433",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5074",
    "name": "Here2ServeOutreach",
    "latitude": 40.8335904,
    "longitude": -81.3272035,
    "address": "3412 Harmont Ave NE",
    "city": "CANTON",
    "state": "OH",
    "zip_code": "44705",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5076",
    "name": "The Steak Club Foundation",
    "latitude": 41.5281056,
    "longitude": -81.5411274,
    "address": "2706 Noble Road",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44121",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5077",
    "name": "CHESTNUT AVE FOOD PANTRY",
    "latitude": 36.9939927,
    "longitude": -76.4109022,
    "address": "3509 CHESTNUT AVE",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5078",
    "name": "Helping Hands Kenton",
    "latitude": 40.6467424,
    "longitude": -83.6170111,
    "address": "100 Cleveland Avenue",
    "city": "KENTON",
    "state": "OH",
    "zip_code": "43326",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5080",
    "name": "Akron Children's Hospital",
    "latitude": 41.0326193,
    "longitude": -80.6582307,
    "address": "6505 Market St",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5081",
    "name": "Bethel COGIC",
    "latitude": 41.0670414,
    "longitude": -80.674933,
    "address": "3147 Glenwood Ave.",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44511",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5082",
    "name": "Amesville School Pantry",
    "latitude": 39.4022934,
    "longitude": -81.9572995,
    "address": "23 Main Street",
    "city": "AMESVILLE",
    "state": "OH",
    "zip_code": "45711",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5083",
    "name": "New Point Church ",
    "latitude": 39.889297,
    "longitude": -84.2093797,
    "address": "626 W. National Rd.",
    "city": "VANDALIA",
    "state": "OH",
    "zip_code": "45377",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5084",
    "name": "Yeshua Assembly of God",
    "latitude": 40.6743512,
    "longitude": -80.5680314,
    "address": "49345 Calcutta Smith Ferry Rd",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5085",
    "name": "Lima Memorial Hospital",
    "latitude": 40.7358768,
    "longitude": -84.0875818,
    "address": "1001 Bellefontaine Avenue",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5086",
    "name": "Beacon Charitable Pharmacy",
    "latitude": 40.8118665,
    "longitude": -81.4020595,
    "address": "2525 13th St. NW",
    "city": "CANTON",
    "state": "OH",
    "zip_code": "44708",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5087",
    "name": "Grace Evandelistic Temple Church",
    "latitude": 41.1029476,
    "longitude": -80.6936137,
    "address": "2214 Mahoning Avenue",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44509",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5088",
    "name": "Havesting Hope",
    "latitude": 40.9175686,
    "longitude": -81.0141012,
    "address": "230 S. 12th St",
    "city": "SEBRING",
    "state": "OH",
    "zip_code": "44672",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5090",
    "name": "NOW IS THE TIME PONOTOC",
    "latitude": 34.32178542,
    "longitude": -89.04094655,
    "address": "85 FRIENDSHIP RD",
    "city": "ECRU",
    "state": "MS",
    "zip_code": "38841",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5091",
    "name": "NOW IS THE TIME ITAWAMBA",
    "latitude": 34.269865,
    "longitude": -88.403996,
    "address": "602 WEST HILL STREET, FULTON, MS, (CYPRESS PAVILION ON CAMPUS)",
    "city": "FULTON",
    "state": "MS",
    "zip_code": "38843",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5092",
    "name": "NOW IS THE TIME DESOTO",
    "latitude": 34.97241919,
    "longitude": -90.01625717,
    "address": "7701 US 51 HWY, SOUTHAVEN, MS",
    "city": "SOUTHAVEN",
    "state": "MS",
    "zip_code": "38671",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5093",
    "name": "Serving Our Savior",
    "latitude": 39.42087594,
    "longitude": -84.59924185,
    "address": "1068 Stahlheber Rd",
    "city": "HAMILTON",
    "state": "OH",
    "zip_code": "45013",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5094",
    "name": "Pathways To Home",
    "latitude": 39.2446368,
    "longitude": -84.7828068,
    "address": "9141 Kilby Road",
    "city": "HARRISON",
    "state": "OH",
    "zip_code": "45030",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5095",
    "name": "Forge",
    "latitude": 40.8686223,
    "longitude": -84.5718189,
    "address": "210 S Franklin St",
    "city": "VAN WERT",
    "state": "OH",
    "zip_code": "45891",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5096",
    "name": "OneHope NEO ",
    "latitude": 41.46678975,
    "longitude": -81.70793169,
    "address": "3202 Fulton Road ",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5097",
    "name": "Safe Haven Empowerment Center",
    "latitude": 37.1522038,
    "longitude": -76.5493343,
    "address": "429 Thorncliff Dr",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5099",
    "name": "Food Lockers at SHFB ",
    "latitude": 39.9246805,
    "longitude": -83.7994829,
    "address": "20 N. Murray St",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45503",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5100",
    "name": "Piru Neighborhood Council",
    "latitude": 34.4154622,
    "longitude": -118.79501484,
    "address": "3945 Center St",
    "city": "PIRU",
    "state": "CA",
    "zip_code": "93040",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5101",
    "name": "United Parents",
    "latitude": 34.21814076,
    "longitude": -119.06301836,
    "address": "584 Ventura St, Fillmore CA",
    "city": "Fillmore",
    "state": "CA",
    "zip_code": "93015",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5102",
    "name": "Mercy Health Emergency Food Service",
    "latitude": 39.9280732,
    "longitude": -83.8162655,
    "address": "100 Medical Center Dr",
    "city": "SPRINGFIELD",
    "state": "OH",
    "zip_code": "45504",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5103",
    "name": "DYER COUNTY SENIORS",
    "latitude": 36.0664233,
    "longitude": -89.3598085,
    "address": "1200 Community Park Rd Ste A",
    "city": "Dyersburg",
    "state": "TN",
    "zip_code": "38054",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5104",
    "name": "Owens Community College",
    "latitude": 41.588312,
    "longitude": -83.5385871,
    "address": "30335 Oregon Rd.",
    "city": "PERRYSBURG",
    "state": "OH",
    "zip_code": "43551",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5105",
    "name": "HANDS ACROSS MATHEWS",
    "latitude": 37.4370501,
    "longitude": -76.32103959,
    "address": "10878 BUCKLEY HALL RD",
    "city": "MATHEWS",
    "state": "VA",
    "zip_code": "23109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5106",
    "name": "Bethel Worship Center-Manna and More Food Pantry",
    "latitude": 39.1359536,
    "longitude": -81.8611293,
    "address": "39782 SR 7",
    "city": "Reedsville",
    "state": "OH",
    "zip_code": "45772",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5107",
    "name": "Geauga County Department on Aging",
    "latitude": 41.5917017,
    "longitude": -81.2242912,
    "address": "470 Center St. ",
    "city": "CHARDON",
    "state": "OH",
    "zip_code": "44024",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5108",
    "name": "New London Local Schools Community Food Pantry  ",
    "latitude": 41.0734675,
    "longitude": -82.3970034,
    "address": "425 Park Ave",
    "city": "NEW LONDON",
    "state": "OH",
    "zip_code": "44851",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5109",
    "name": "Lorain County JVS",
    "latitude": 41.2628994,
    "longitude": -82.2126663,
    "address": "15181 State Rt. 58",
    "city": "OBERLIN",
    "state": "OH",
    "zip_code": "44074",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5110",
    "name": "Lynx Pantry-Rhodes College",
    "latitude": 35.1524546,
    "longitude": -89.9888334,
    "address": "2000 N Parkway",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5112",
    "name": "ACRFB Pop-Up Pantry (Carroll)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Parkway",
    "city": "Akron",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5113",
    "name": "Mercy Unlimited",
    "latitude": 40.5706625,
    "longitude": -84.1928866,
    "address": "38 E Auglaize Street",
    "city": "WAPAKONETA",
    "state": "OH",
    "zip_code": "45895",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5115",
    "name": "Mercy Neighborhood Ministries",
    "latitude": 39.1298273,
    "longitude": -84.4760715,
    "address": "1602 Madison Rd",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45206",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5116",
    "name": "Lincoln Heights Outreach",
    "latitude": 39.246795,
    "longitude": -84.465872,
    "address": "9991 Wayne Avenue",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5117",
    "name": "UNIVERSITY OF MISSISSIPPI - GROVE GROCERY",
    "latitude": 34.36738798,
    "longitude": -89.53998321,
    "address": "207 REBEL DRIVE",
    "city": "UNIVERSITY",
    "state": "MS",
    "zip_code": "38677",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5118",
    "name": "Lima Seventh Day Adventist",
    "latitude": 40.7305463,
    "longitude": -84.1353143,
    "address": "1976 Spencerville Rd",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45805",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5119",
    "name": "Two Trees COC",
    "latitude": 34.28340021,
    "longitude": -119.30306902,
    "address": "110 N. Olive St",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5121",
    "name": "Islamic Association of Cincinnati",
    "latitude": 39.1495505,
    "longitude": -84.5179899,
    "address": "3668 Clifton Avenue",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45220",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5122",
    "name": "West Ohio Food Fort",
    "latitude": 40.7331466,
    "longitude": -84.0781645,
    "address": "601 S Leonard",
    "city": "LIMA",
    "state": "OH",
    "zip_code": "45804",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5123",
    "name": "Smart Development, Inc",
    "latitude": 41.4689291,
    "longitude": -81.9011424,
    "address": "1255 Columbia Rd",
    "city": "WESTLAKE",
    "state": "OH",
    "zip_code": "44145",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5125",
    "name": "St. Vincent de Paul-St. Joan of ARC",
    "latitude": 41.595307,
    "longitude": -83.6815735,
    "address": "5856 Heatherdowns Blvd.",
    "city": "TOLEDO",
    "state": "OH",
    "zip_code": "43614",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5126",
    "name": "Centers for Dialysis Care Warrensville",
    "latitude": 41.539143,
    "longitude": -81.611674,
    "address": "4877 Galaxy Pkwy",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5127",
    "name": "Iglesia de Pentecostal M.I. Oasis de Bendicion",
    "latitude": 41.44718368,
    "longitude": -81.76529283,
    "address": "11405 Bellaire Rd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5129",
    "name": "VC Believe Center",
    "latitude": 34.246686,
    "longitude": -119.227647,
    "address": "2851 Palma Dr.",
    "city": "Ventura",
    "state": "CA",
    "zip_code": "93003",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5130",
    "name": "Carey's Gathering Place",
    "latitude": 41.44759654,
    "longitude": -82.16301067,
    "address": "2500 Elyria  Ave",
    "city": "LORAIN",
    "state": "OH",
    "zip_code": "44055",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5131",
    "name": "Feed My Sheep of Rogers Ohio",
    "latitude": 40.7906463,
    "longitude": -80.6239202,
    "address": "7580 Farr Street",
    "city": "ROGERS",
    "state": "OH",
    "zip_code": "44455",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5132",
    "name": "Connection Food Pantry",
    "latitude": 36.33852316,
    "longitude": -89.1607671,
    "address": "111 N Mary Jane St",
    "city": "TROY",
    "state": "TN",
    "zip_code": "38260",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5133",
    "name": "ONE BY ONE MINISTRIES",
    "latitude": 35.0949167,
    "longitude": -89.8692532,
    "address": "1355 LYNNFIELD RD SUITE 286",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5134",
    "name": "Cleveland Clinic Euclid",
    "latitude": 41.5976883,
    "longitude": -81.5480462,
    "address": "18901 Lakeshore Blvd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44119",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5135",
    "name": "55 AND BETTER SENIORS",
    "latitude": 35.1744331,
    "longitude": -89.955895,
    "address": "1543 Brookins St",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5136",
    "name": "Memphis Towers",
    "latitude": 35.1407849,
    "longitude": -90.0248175,
    "address": "1081 Court Ave",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38104",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5138",
    "name": "Firelands Center for Coordinated Care ",
    "latitude": 41.4455082,
    "longitude": -82.7094205,
    "address": "1221 Hayes Ave. Suite 4 ",
    "city": "SANDUSKY",
    "state": "OH",
    "zip_code": "44870",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5139",
    "name": "Cleveland Hope Exchange/Journey Church",
    "latitude": 41.3209758,
    "longitude": -81.4524843,
    "address": "10204 Ravenna Rd",
    "city": "TWINSBURG",
    "state": "OH",
    "zip_code": "44087",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5140",
    "name": "Memphis Shelby County Schools",
    "latitude": 35.1296539,
    "longitude": -89.9756396,
    "address": "160 s. hollywood",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38112",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5141",
    "name": "Oak Harbor Alliance Chapel",
    "latitude": 41.506509,
    "longitude": -83.1607229,
    "address": "11805 W. State Rte 105",
    "city": "OAK HARBOR",
    "state": "OH",
    "zip_code": "43449",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5142",
    "name": "Howland Community Church Pantry",
    "latitude": 41.2368761,
    "longitude": -80.7406926,
    "address": "198 Niles-Cortland Rd., S.E.",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44484",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5143",
    "name": "MFP Rumble Ponies (Drive-Thru)",
    "latitude": 42.10235584,
    "longitude": -75.90536015,
    "address": "211 Henry St.",
    "city": "BINGHAMTON",
    "state": "NY",
    "zip_code": "13901",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5144",
    "name": "LUCHA @ PV Mobile Home Park ",
    "latitude": 34.1539476,
    "longitude": -119.174563,
    "address": "250 E, Pleasant Valley Rd. ",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5145",
    "name": "Salem First Friends Church",
    "latitude": 40.9113538,
    "longitude": -80.8632256,
    "address": "1028 Jennings Ave.",
    "city": "SALEM",
    "state": "OH",
    "zip_code": "44460",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5146",
    "name": "St. James Church Pantry",
    "latitude": 41.2199056,
    "longitude": -80.787557,
    "address": "2532 Burton Street SE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44484",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5147",
    "name": "NonCSFP Clients - Greene",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 Armor Place",
    "city": "Dayton",
    "state": "Ohio",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5148",
    "name": "NonCSFP Clients - Montgomery",
    "latitude": 39.75581,
    "longitude": -84.240573,
    "address": "56 Armor Place",
    "city": "Dayton",
    "state": "Ohio",
    "zip_code": "45417",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5149",
    "name": "Brookfield United Methodist Church",
    "latitude": 41.232775,
    "longitude": -80.5675529,
    "address": "6951 Grove Street",
    "city": "BROOKFIELD",
    "state": "OH",
    "zip_code": "44403",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5150",
    "name": "First Christian Church of Girard",
    "latitude": 41.1569905,
    "longitude": -80.6988774,
    "address": "140 E. Broadway",
    "city": "GIRARD",
    "state": "OH",
    "zip_code": "44420",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5151",
    "name": "Hubbard Nazarene Church",
    "latitude": 41.1939699,
    "longitude": -80.5620788,
    "address": "1815 Cherry Lane Dr. SE",
    "city": "HUBBARD",
    "state": "OH",
    "zip_code": "44425",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5152",
    "name": "NESFACE",
    "latitude": 41.443924,
    "longitude": -80.5880792,
    "address": "6416 Kinsman Nickerson Rd",
    "city": "KINSMAN",
    "state": "OH",
    "zip_code": "44428",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5153",
    "name": "Vienna Ecumenical Food Pantry",
    "latitude": 41.2378713,
    "longitude": -80.6583121,
    "address": "4453 Warren Sharon Road",
    "city": "VIENNA",
    "state": "OH",
    "zip_code": "44473",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5154",
    "name": "Good Shepherd Community Church",
    "latitude": 41.2504841,
    "longitude": -80.8775567,
    "address": "4600 Eagle Creek Road",
    "city": "LEAVITTSBURG",
    "state": "OH",
    "zip_code": "44430",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5155",
    "name": "Mt. Olive Missionary Baptist",
    "latitude": 41.2219937,
    "longitude": -80.5237778,
    "address": "8148 Ulp Street",
    "city": "MASURY",
    "state": "OH",
    "zip_code": "44438",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5157",
    "name": "Our Lady of Perpetual Help",
    "latitude": 41.1610583,
    "longitude": -80.7245441,
    "address": "618 Ohio Avenue",
    "city": "MC DONALD",
    "state": "OH",
    "zip_code": "44437",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5158",
    "name": "Christ The Good Shepherd",
    "latitude": 41.0712842,
    "longitude": -80.591265,
    "address": "159 Reed Avenue",
    "city": "CAMPBELL",
    "state": "OH",
    "zip_code": "44405",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5159",
    "name": "Evergreen SDA Pantry",
    "latitude": 41.0140436,
    "longitude": -80.6728146,
    "address": "7668 Glenwood Avenue",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44512",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5160",
    "name": "Mt. Zion Baptist Church",
    "latitude": 41.092464,
    "longitude": -80.6341962,
    "address": "827 Wilson Avenue",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5161",
    "name": "Needle's Eye Christian Counseling",
    "latitude": 41.0870526,
    "longitude": -80.6595133,
    "address": "74 Kenmore Avenue",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44507",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5163",
    "name": "Oak Baptist Church",
    "latitude": 41.1013246,
    "longitude": -80.6413966,
    "address": "320 Elk Street",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5164",
    "name": "Poland Interfaith Pantry",
    "latitude": 41.0250088,
    "longitude": -80.6209424,
    "address": "1940 Boardman-Poland Road",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44514",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5165",
    "name": "Richard Brown Foodshelf",
    "latitude": 41.1154885,
    "longitude": -80.6451335,
    "address": "1205 Elm Street",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5166",
    "name": "Spanish Seventh Day Adventist",
    "latitude": 41.0984318,
    "longitude": -80.6157833,
    "address": "155 Lansdowne Blvd",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44506",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5167",
    "name": "St. Edwards Church Food Pantry",
    "latitude": 41.1253536,
    "longitude": -80.6477279,
    "address": "240 Tod Lane",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44504",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5168",
    "name": "Zion Lutheran Church",
    "latitude": 41.0641307,
    "longitude": -80.7075347,
    "address": "3300 Canfield Road",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44511",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5170",
    "name": "St. Patrick's Pantry Hubbard",
    "latitude": 41.1592448,
    "longitude": -80.568735,
    "address": "225 N. Main Street",
    "city": "HUBBARD",
    "state": "OH",
    "zip_code": "44425",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5171",
    "name": "Homeschool Voyages",
    "latitude": 40.9719367,
    "longitude": -82.1097725,
    "address": "148 S Milton St",
    "city": "Smithville",
    "state": "OH",
    "zip_code": "44677",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5172",
    "name": "Buckeye Community Schools pantry",
    "latitude": 40.5885304,
    "longitude": -83.1360437,
    "address": "366 W Center St",
    "city": "MARION",
    "state": "OH",
    "zip_code": "43302",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5173",
    "name": "Protestant Family Service",
    "latitude": 41.07041759,
    "longitude": -80.67491466,
    "address": "2915 Glenwood Avenue # 6",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44511",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5174",
    "name": "Robinette Senior Center",
    "latitude": 29.4198203,
    "longitude": -98.6790695,
    "address": "1423 S. Ellison Dr",
    "city": "SAN ANTONIO",
    "state": "TX",
    "zip_code": "78245",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5175",
    "name": "Visions Revealed",
    "latitude": 41.5086415,
    "longitude": -81.656847,
    "address": "1790 East 43rd Street",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44103",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5176",
    "name": "Time and Season",
    "latitude": 41.4518216,
    "longitude": -81.7632894,
    "address": "3727 Bosworth Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44111",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5178",
    "name": "HOUSE ME HAMPTON ROADS",
    "latitude": 37.0193491,
    "longitude": -76.4370254,
    "address": "811 79th Street",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5179",
    "name": "BOTTS CHAPEL MB CHURCH",
    "latitude": 34.9383245,
    "longitude": -89.77745397,
    "address": "5413 POLK LANE",
    "city": "OLIVE BRANCH",
    "state": "MS",
    "zip_code": "38654",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5180",
    "name": "LIFE CENTER",
    "latitude": 37.02482011,
    "longitude": -76.3636427,
    "address": "20 Settlers Landing Rd",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5181",
    "name": "Promise Community Hub",
    "latitude": 41.0895065,
    "longitude": -80.6654739,
    "address": "336 Breaden St",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44507",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5182",
    "name": "Lake County Free Clinic",
    "latitude": 41.7295524,
    "longitude": -81.2548059,
    "address": "462 Chardon St.",
    "city": "PAINESVILLE",
    "state": "OH",
    "zip_code": "44077",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5183",
    "name": "Living Waters Community Church",
    "latitude": 41.21341153,
    "longitude": -80.55795187,
    "address": "7382 Stewart Sharon Road",
    "city": "HUBBARD",
    "state": "OH",
    "zip_code": "44425",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5184",
    "name": "MFP South Corning",
    "latitude": 42.1324,
    "longitude": -77.0361,
    "address": "328 Park Ave",
    "city": "CORNING",
    "state": "NY",
    "zip_code": "14830",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5185",
    "name": "Foodbank Food Pantry - York County",
    "latitude": 37.225941,
    "longitude": -76.523574,
    "address": "2401 Aluminum Ave",
    "city": "YORKTOWN",
    "state": "VA",
    "zip_code": "23690",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5186",
    "name": "St. Vincent DePaul @ Niles Road",
    "latitude": 41.21849333,
    "longitude": -80.79385266,
    "address": "2355 Niles Road SE",
    "city": "WARREN",
    "state": "OH",
    "zip_code": "44481",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5187",
    "name": "ARRKANSAS STATE UNIVERSITY ",
    "latitude": 35.14643937,
    "longitude": -90.18921271,
    "address": "200 WEST BROADWAY",
    "city": "WEST MEMPHIS",
    "state": "AR",
    "zip_code": "72301",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5188",
    "name": "Foodbank Food Pantry - Newport News",
    "latitude": 37.143493,
    "longitude": -76.539049,
    "address": "2401 Aluminum Ave",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5191",
    "name": "Equip Church International",
    "latitude": 41.0767733,
    "longitude": -81.491687,
    "address": "825 E. Buchtel Ave",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44305",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5192",
    "name": "PIONEER COMMUNITY CHURCH",
    "latitude": 41.67999741,
    "longitude": -84.54400632,
    "address": "708 E. Baubice St. ",
    "city": "PIONEER",
    "state": "OH",
    "zip_code": "43554",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5193",
    "name": "Monarch: Wings of Kyla Foundation",
    "latitude": 39.0436396,
    "longitude": -82.6293286,
    "address": "680 E. Main St.",
    "city": "JACKSON",
    "state": "OH",
    "zip_code": "45640",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5194",
    "name": "Love Thy Neighbor Food Pantry",
    "latitude": 39.7707192,
    "longitude": -82.0997135,
    "address": "183 West Main St. ",
    "city": "CROOKSVILLE",
    "state": "OH",
    "zip_code": "43731",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5196",
    "name": "Columbus Public Health CPH",
    "latitude": 39.9593296,
    "longitude": -82.9808279,
    "address": "240 Parsons Ave",
    "city": "COLUMBUS",
    "state": "OH",
    "zip_code": "43215",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5197",
    "name": "Dreams of Hope",
    "latitude": 37.0137995,
    "longitude": -76.4474172,
    "address": "7320 WARWICK BLVD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5199",
    "name": "Faith Temple Ministries ",
    "latitude": 39.1439198,
    "longitude": -84.4899299,
    "address": "825 Rockdale Ave.",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45229",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5200",
    "name": "CHRIST COMMUNITY-FRAYSER",
    "latitude": 35.2169097,
    "longitude": -90.0317105,
    "address": "969 FRAYSER BLVD",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38127",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5201",
    "name": "Harvest Christian Church",
    "latitude": 41.3814763,
    "longitude": -82.1177468,
    "address": "626 Lorain Blvd",
    "city": "ELYRIA",
    "state": "OH",
    "zip_code": "44035",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5204",
    "name": "ACRFB Akron Public Schools Cluster",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Parkway",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5205",
    "name": "CSFP Innovage",
    "latitude": 37.132952,
    "longitude": -76.5360522,
    "address": "439 Oriana rd",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5206",
    "name": "ST PATRICK FOOD PANTRY",
    "latitude": 35.1364263,
    "longitude": -90.0500039,
    "address": "297 SOUTH FOURTH",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5207",
    "name": "Heritage Nazarene Church",
    "latitude": 39.5971446,
    "longitude": -82.9473346,
    "address": "520 S Court Street",
    "city": "CIRCLEVILLE",
    "state": "OH",
    "zip_code": "43113",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5208",
    "name": "A NEW BEGINNING COMMUNITY ORG",
    "latitude": 35.168302,
    "longitude": -90.0283,
    "address": "2212 JACKSON AVE. MEMPHIS, TN",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38107",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5209",
    "name": "ISLAMIC FOOD BANK-PANTRY TOLEDO",
    "latitude": 41.52763581,
    "longitude": -83.63638341,
    "address": "12282 Jefferson Ave.",
    "city": "PERRYSBURG",
    "state": "OH",
    "zip_code": "43551",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5211",
    "name": "SHFBMV CSFP",
    "latitude": 41.1286691,
    "longitude": -80.706146,
    "address": "2805 Salt Springs Rd",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44509",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5213",
    "name": "MFP-SNOWDEN SENIOR APTS",
    "latitude": 37.0126232,
    "longitude": -76.4201614,
    "address": "1115 BRIARFIELD RD",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23605",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5214",
    "name": "Freedom Village Apratments",
    "latitude": 41.1159932,
    "longitude": -80.7066468,
    "address": "1356 North Osborn Avenue",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44509",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5215",
    "name": "CSFP - SPRATLEY HOUSE",
    "latitude": 36.9825737,
    "longitude": -76.4194019,
    "address": "651 25TH STREET",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23607",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5216",
    "name": "Joseph Knight Towers",
    "latitude": 41.099874,
    "longitude": -80.751233,
    "address": "Joseph Knight Towers",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44515",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5217",
    "name": "Foodbank Food Pantry - Williamsburg",
    "latitude": 37.266334,
    "longitude": -76.709764,
    "address": "2401 Aluminum Ave",
    "city": "WILLIAMSBURG",
    "state": "VA",
    "zip_code": "23185",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5218",
    "name": "Centers for Dialysis Care West",
    "latitude": 41.4635893,
    "longitude": -81.7005585,
    "address": "3330 W 25th St",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44109",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5219",
    "name": "ISREAL UNITED IN CHRIST",
    "latitude": 35.0506555,
    "longitude": -89.920508,
    "address": "3620 COMMERCE CIRCLE",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5221",
    "name": "ST PATRICK OUTREACH MOBILE",
    "latitude": 35.1370663,
    "longitude": -90.0498968,
    "address": "277 SOUTH 4TH STREET",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38126",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5223",
    "name": "Queen Street Baptist Church",
    "latitude": 37.02566222,
    "longitude": -76.34761621,
    "address": "190 West Queens Way",
    "city": "HAMPTON",
    "state": "VA",
    "zip_code": "23669",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5227",
    "name": "Orange Mound Community Service Center",
    "latitude": 35.1086077,
    "longitude": -89.9756808,
    "address": "2590 Park Ave ",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38114",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5228",
    "name": "WILLING SOULS",
    "latitude": 35.1781675,
    "longitude": -89.9543466,
    "address": "1676 ORR ST",
    "city": "MEMPHIS",
    "state": "TN",
    "zip_code": "38108",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5229",
    "name": "Quinn Chapel",
    "latitude": 39.078715,
    "longitude": -84.377216,
    "address": "10998 Southland Rd.",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45230",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5230",
    "name": "FEEDING HEART - BENTON",
    "latitude": 34.82192056,
    "longitude": -89.18691353,
    "address": "17136 MS. HWY 5",
    "city": "ASHLAND",
    "state": "MS",
    "zip_code": "38603",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5231",
    "name": "The Porchlight Foundation",
    "latitude": 34.1539476,
    "longitude": -119.174563,
    "address": "250 E. Pleasant Valley Rd.",
    "city": "OXNARD",
    "state": "CA",
    "zip_code": "93033",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5233",
    "name": "Harvest House of Hope",
    "latitude": 41.0744236,
    "longitude": -80.6727127,
    "address": "570 Sherwood Ave",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5234",
    "name": "Catholic Charities Southwestern Ohio",
    "latitude": 39.191352,
    "longitude": -84.4612291,
    "address": "7162 Reading Rd., Ste. 600 ",
    "city": "CINCINNATI",
    "state": "OH",
    "zip_code": "45237",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5235",
    "name": "Catholic Charities Resource Center",
    "latitude": 40.6175019,
    "longitude": -80.5747222,
    "address": "600 E. Fourth Street",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5236",
    "name": "Steel Valley Outreach Center",
    "latitude": 41.1113265,
    "longitude": -80.64097977,
    "address": "801 Wick Ave.",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44505",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5237",
    "name": "SEOFB CSFP",
    "latitude": 39.53449987,
    "longitude": -82.39097747,
    "address": "1005 CIC Dr. ",
    "city": "Logan",
    "state": "OH",
    "zip_code": "43138",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5240",
    "name": "United Missionary Baptist Church",
    "latitude": 39.7674462,
    "longitude": -84.2283031,
    "address": "900 Lexington Ave",
    "city": "DAYTON",
    "state": "OH",
    "zip_code": "45402",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5242",
    "name": "Cobblestone Manor",
    "latitude": 39.8731345,
    "longitude": -83.0345766,
    "address": "1050 Lamplighter Dr.",
    "city": "GROVE CITY",
    "state": "OH",
    "zip_code": "43123",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5244",
    "name": "City Church Ventura",
    "latitude": 34.26607801,
    "longitude": -119.2068482,
    "address": "6360 Telephone Rd.",
    "city": "VENTURA",
    "state": "CA",
    "zip_code": "93004",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5245",
    "name": "City of Cleveland Heights - Office on Aging",
    "latitude": 41.51922733,
    "longitude": -81.57297125,
    "address": "1 Monticello Blvd",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44118",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5246",
    "name": "Warwick Assembly of God",
    "latitude": 37.04243396,
    "longitude": -76.42885365,
    "address": "1228 Todds Lane",
    "city": "Hampton",
    "state": "VA",
    "zip_code": "23666",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5247",
    "name": "City of Promise Church",
    "latitude": 39.34810358,
    "longitude": -84.53802362,
    "address": "1260 Hicks Blvd",
    "city": "FAIRFIELD",
    "state": "OH",
    "zip_code": "45014",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5249",
    "name": "Union Baptist",
    "latitude": 37.27739166,
    "longitude": -76.44432159,
    "address": "9254 GUINEA ROAD",
    "city": "HAYES",
    "state": "VA",
    "zip_code": "23072",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5250",
    "name": "Caring Neighbors",
    "latitude": 40.3781042,
    "longitude": -83.5897078,
    "address": "9609 County Road 2",
    "city": "WEST MANSFIELD",
    "state": "OH",
    "zip_code": "43358",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5251",
    "name": "Shelby Christian Outreach",
    "latitude": 40.87924503,
    "longitude": -82.66447705,
    "address": "39 Walnut Street",
    "city": "SHELBY",
    "state": "OH",
    "zip_code": "44875",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5252",
    "name": "It's a start",
    "latitude": 37.21419502,
    "longitude": -76.96838787,
    "address": "3224 SPRING GROVE ROAD",
    "city": "CLAREMONT",
    "state": "VA",
    "zip_code": "23899",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5258",
    "name": "Peter Maurin Center/North Hill",
    "latitude": 41.1103669,
    "longitude": -81.5102217,
    "address": "915 N. Main St",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44310",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5259",
    "name": "Clinton County Homeless Shelter",
    "latitude": 39.4449672,
    "longitude": -83.8359054,
    "address": "36 Gallup Ave",
    "city": "WILMINGTON",
    "state": "OH",
    "zip_code": "45177",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5260",
    "name": "NORTH MS PRIMARY HEALTH CARE",
    "latitude": 34.82192056,
    "longitude": -89.18691353,
    "address": "17136 MS 5",
    "city": "ASHLAND",
    "state": "MS",
    "zip_code": "38603",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5261",
    "name": "ACRFB Pop-Up Pantry (Holmes)",
    "latitude": 41.0731306,
    "longitude": -81.5360122,
    "address": "350 Opportunity Parkway",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44307",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5264",
    "name": "Carnegie Tower",
    "latitude": 41.500454,
    "longitude": -81.6237669,
    "address": "8920 Carnegie Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44106",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5265",
    "name": "Christ the King Vineyard Church",
    "latitude": 41.3976863,
    "longitude": -81.9578604,
    "address": "30635 Lorain Rd.",
    "city": "NORTH OLMSTED",
    "state": "OH",
    "zip_code": "44070",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5266",
    "name": "East Liverpool First Church of Nazarene",
    "latitude": 40.6220364,
    "longitude": -80.5766093,
    "address": "670 Walnut Street",
    "city": "EAST LIVERPOOL",
    "state": "OH",
    "zip_code": "43920",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5268",
    "name": "Bucky Cares",
    "latitude": 41.0322921,
    "longitude": -82.0115049,
    "address": "113 Harris St.",
    "city": "LODI",
    "state": "OH",
    "zip_code": "44254",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5269",
    "name": "The Roots Foundation",
    "latitude": 41.0357826,
    "longitude": -81.4951386,
    "address": "888 Eller Ave",
    "city": "AKRON",
    "state": "OH",
    "zip_code": "44306",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5270",
    "name": "MYCAP Senior Center",
    "latitude": 41.0948904,
    "longitude": -80.6561302,
    "address": "64 Ridge Ave.",
    "city": "YOUNGSTOWN",
    "state": "OH",
    "zip_code": "44502",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5272",
    "name": "Euclid Beach Villa",
    "latitude": 41.580652,
    "longitude": -81.5711836,
    "address": "125 E 156th St",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44110",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5276",
    "name": "Benjamin Rose - Gunning Park",
    "latitude": 41.43399011,
    "longitude": -81.81423291,
    "address": "16700 Puritas Ave",
    "city": "CLEVELAND",
    "state": "OH",
    "zip_code": "44135",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5278",
    "name": "Five Loaves",
    "latitude": 37.1254878,
    "longitude": -76.5337826,
    "address": "13813 Warwick Blvd",
    "city": "NEWPORT NEWS",
    "state": "VA",
    "zip_code": "23608",
    "source": "freshtrak"
  },
  {
    "id": "freshtrak-5284",
    "name": "Revelation Church",
    "latitude": 34.2735053,
    "longitude": -118.7857101,
    "address": "580 E. Easy St.",
    "city": "SIMI VALLEY",
    "state": "CA",
    "zip_code": "93065",
    "source": "freshtrak"
  }
]
